import React, { useState, useEffect, useCallback, useRef } from 'react';
import { confirmacaoDeExcluirLead, confirmacaoDeConverter, motivoDoServidor, valorEstimadoDoLead, totaisDoLead, trilhaDoLead, confirmacaoDeMover, confirmacaoDeGanho, EtapasDoFunil, ETAPAS_FIXAS, etapasDaResposta, etapasDaAssinaturaDe, statusDoSelect, temProximaAcao, atrasoDaProximaAcao, semCamposSoDeLeitura, fraseDaRecusaDoConcluir, AbaDoLead, abaDoLeadDaUrl, abaInicialDoLead, resumoDaFicha, seloDoContrato } from './utils/crm';
import { lerImpactoDaExclusao } from './utils/impactoDaExclusaoDoLead';
import { startRegistration } from '@simplewebauthn/browser';
import Login from './Login';
import S3RetentionSection from './components/S3RetentionSection';
import EnderecosDeAcesso from './components/clientes/EnderecosDeAcesso';
import { menuItems, adminItems, adminSecoes, filterMenuByPermission } from './config/menu';
import { sectionDaRota, rotaDaSection, podeVerPor, rotuloDaSection, tituloDaSection, deepLinkDaQuery, comParametro, semParametro, idDoParametro, trocarParametroNaUrl } from './config/rotas';
import { useLocation, useNavigate } from 'react-router-dom';
import { moduleAccessFor, canAccessModule, canWriteModule, canDeleteModule } from './utils/permissions';
import { agruparItensPorLocal, deveAgrupar, resumoPorPapel } from './utils/itensPorLocal';
import { RateioDoGrupo } from './utils/rateioDoGrupo';
import FaixaDoRateio from './components/FaixaDoRateio';
import LinhaDoItemMrr from './components/LinhaDoItemMrr';
import AvisosDoRateioNaAssinatura from './components/AvisosDoRateioNaAssinatura';
import { naturezaDoItem, origemDoValor, desencontrosDoRateio, NaturezaDoItem } from './utils/naturezaDoItem';
import CascaDeModal, { NumeroDaFaixa } from './components/shared/CascaDeModal';
import MaisAcoes from './components/shared/MaisAcoes';
import { badgeFor, TONE_BADGE, TONE_BORDER, TONE_SURFACE, TONE_TEXT } from './utils/statusColors';
import FichaDaAssinatura from './components/FichaDaAssinatura';
import { useConfirm, usePedirTexto, useConfirmarPerigo } from './components/shared/ConfirmDialog';
import { useAviso } from './components/shared/Aviso';
import { useRateio, lerRateio } from './hooks/useRateio';
import { productsService, clientsService, contractsService, contractAdjustmentsService, leadsService, cnpjService, activityLogService, clientPhonesService, clientEmailsService, clientContactsService, clientLocationsService, proposalsService, digitalContractsService, clientDDRsService, telecomCarriersService, systemService, permissionsService, invoicesService, fiscalService, expensesService, usersService, authService, notificationsApiService, procurementService, demandasService } from './services/api';
import { clearSession, addSessionLostHandler } from './services/authTokens';
import TrustedDevicesSection from './components/TrustedDevicesSection';
import ActiveSessionsSection from './components/ActiveSessionsSection';
import CollapsibleSection from './components/CollapsibleSection';
import ClaudeCostReportCard from './components/ClaudeCostReportCard';
import ProposalsTab from './components/ProposalsTab';
import ConfiguracaoDeFaturamento from './components/clientes/ConfiguracaoDeFaturamento';
import NotasDeEmpenho from './components/empenho/NotasDeEmpenho';
import LeadHistoryTab from './components/LeadHistoryTab';
import AditivosDoContratoTab from './components/AditivosDoContratoTab';
import NucleoPropostasTab from './components/NucleoPropostasTab';
import TemplateManager from './components/TemplateManager';
import ClientLocationsManager from './components/ClientLocationsManager';
import InvoicesTab from './components/InvoicesTab';
import CobrancaTab from './components/CobrancaTab';
import AwsReservationsTab from './components/AwsReservationsTab';
import Ec2MonitoringTab from './components/Ec2MonitoringTab';
import ConvocacaoWatcher from './components/ConvocacaoWatcher';
import ComprasNetInfraTab from './components/ComprasNetInfraTab';
import ComprasNetHealthDot from './components/ComprasNetHealthDot';
import OficiosTab from './components/OficiosTab';
import DemandasTab from './components/DemandasTab';
import MaterialsTab from './components/MaterialsTab';
import CorporateDocsTab from './components/CorporateDocsTab';
import PortabilityTermsTab from './components/PortabilityTermsTab';
import LicitacoesTab from './components/LicitacoesTab';
import CredentialsSettings from './components/CredentialsSettings';
import EtapasDoFunilSettings from './components/EtapasDoFunilSettings';
import IntegrationsTab from './components/IntegrationsTab';
import EmailAccountsTab from './components/EmailAccountsTab';
import EmailLogsTab from './components/EmailLogsTab';
import ComunicadosTab from './components/ComunicadosTab';
import FiscalTab from './components/FiscalTab';
import BoletosTab from './components/BoletosTab';
import RecebiveisTab from './components/RecebiveisTab';
import FinancialDashboardTab from './components/FinancialDashboardTab';
import ExpensesTab from './components/ExpensesTab';
import BankAccountsTab from './components/BankAccountsTab';
import CashFlowTab from './components/CashFlowTab';
import LoanContractsTab from './components/LoanContractsTab';
import ClientsTable from './components/ClientsTable';
import DDRsTable from './components/DDRsTable';
import PrestadorasTab from './components/PrestadorasTab';
import ContractsTable from './components/ContractsTable';
import ProductsTable from './components/ProductsTable';
import LeadsBoard from './components/LeadsBoard';
import versionInfo from './version.json';
import { fmtCNPJ, fmtPhone, maskCNPJ, maskPhone, fmtDate, fmtDateTime, getDaysUntil, getTodayStr, addYearsStr, formatNumeroCompraComAno, fmtMesCurto, getCurrentMonthStr } from './utils/formatters';
import { PARAMETRO_DA_FAIXA, ResumoDaFila } from './utils/filaDeCobranca';
import { mensagemDoErroDeCarga, opcaoAtualForaDaLista, useEstadoDaCarga, EstadoDaLista, A_PROPRIA_LISTA_DIZ_O_VAZIO, acaoPrincipal, acaoSecundaria, campo, campoSomenteLeitura, campoComEstado, falhaIgnoradaDeProposito } from './design';
import { ASSINATURA_GRAVADA } from './utils/avisoDeGravacao';
import { efeitoDaVigencia, somaVigente } from './utils/vigenciaItem';
import { itensComEmpenhoProprio } from './utils/empenhoPorItem';
import RodapeMrrDaAssinatura from './components/RodapeMrrDaAssinatura';
import { adjustmentVerificationMeta } from './utils/adjustmentVerification';
import { ADJUSTMENT_BASE_KIND_OPTIONS, baseKindMeta } from './utils/adjustments';
import { lerDependenciasAtivas, recusaSemDependencias } from './utils/dependenciasDoCliente';
import { nomeDeExibicao } from './utils/nomeDeExibicao';
import { lerContratoDigitalAssinado, recusaSemContratoDigital } from './utils/contratoDigitalDaProposta';
import { aplicarLeitura, BADGES_SEM_LEITURA, FONTES_SEM_LEITURA, BadgesFinanceiros, EstadoDasFontes } from './utils/badgesFinanceiros';
import { confirmacaoDeExcluirAssinatura } from './utils/exclusaoDaAssinatura';
import { lerRecusaDoDdr, fraseDoDuplicado, fraseDoLote, donoDoDdr, RecusaDoDdr } from './utils/recusaDoDdr';
import { porqueTravaPapelEAtivo, recusaDaEdicaoDoUsuario, confirmacaoDeDesativar, FRASE_DA_SENHA_NOVA, FRASE_DO_PERFIL, fraseDaDiferenca, confirmacaoDoPadraoDoPerfil, DIAS_DA_LIMPEZA_PADRAO, confirmacaoDaLimpeza, recusaDaLimpeza, PreviaDaLimpeza, porqueNaoExcluirProduto, resumoDoLote, Recusa } from './utils/administracao';
import ReajustesTab from './components/ReajustesTab';
import DashboardTab from './components/DashboardTab';
import { COMPANY } from './config/company';


const Icon = ({ name, className = 'w-5 h-5' }: { name: string; className?: string }) => {
  const icons: any = {
    package: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4' /></svg>,
    cloud: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z' /></svg>,
    x: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' /></svg>,
    dollar: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    user: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' /></svg>,
    users: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' /></svg>,
    building: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' /></svg>,
    phone: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' /></svg>,
    mail: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' /></svg>,
    calendar: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' /></svg>,
    clipboard: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' /></svg>,
    plus: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4v16m8-8H4' /></svg>,
    trash: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' /></svg>,
    search: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' /></svg>,
    edit: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' /></svg>,
    eye: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' /></svg>,
    logout: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' /></svg>,
    chart: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' /></svg>,
    alertCircle: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    shield: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' /></svg>,
    clock: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    bell: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' /></svg>,
    target: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' /></svg>,
    userPlus: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z' /></svg>,
    arrowRight: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M14 5l7 7m0 0l-7 7m7-7H3' /></svg>,
    chevronDown: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' /></svg>,
    chevronUp: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 15l7-7 7 7' /></svg>,
    chevronRight: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' /></svg>,
    list: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 10h16M4 14h16M4 18h16' /></svg>,
    menu: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' /></svg>,
    fileText: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' /></svg>,
    settings: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' /></svg>,
    mapPin: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 11a3 3 0 11-6 0 3 3 0 016 0z' /></svg>,
    check: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' /></svg>,
    upload: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12' /></svg>,
    download: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4' /></svg>,
    image: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z' /></svg>,
    briefcase: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' /></svg>,
    play: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    pen: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z' /></svg>,
    copy: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' /></svg>,
    save: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4' /></svg>,
    trendingUp: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' /></svg>,
    receipt: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z' /></svg>,
    home: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' /></svg>,
    key: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' /></svg>,
    server: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01' /></svg>,
    activity: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 10V3L4 14h7v7l9-11h-7z' /></svg>,
  };
  return icons[name] || null;
};

const fmt = (v: any) => { const n = parseFloat(String(v)); return isNaN(n) ? '0,00' : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

// Toast Notification Component
const Toast = ({ message, type, onClose }: { message: string; type: 'success' | 'error' | 'warning' | 'info'; onClose: () => void }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const colors = {
    success: 'bg-green-500 border-green-600',
    error: 'bg-red-500 border-red-600',
    warning: 'bg-yellow-500 border-yellow-600',
    info: 'bg-blue-500 border-blue-600',
  };

  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  return (
    <div className={`fixed bottom-4 right-4 z-[100] flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg text-white animate-slide-up ${colors[type]}`}>
      <span className="text-lg">{icons[type]}</span>
      <span className="font-medium">{message}</span>
      <button onClick={onClose} className="ml-2 hover:opacity-70">✕</button>
    </div>
  );
};

// Export to CSV function
const exportToCSV = (data: any[], filename: string, columns: { key: string; label: string }[]) => {
  const headers = columns.map(c => c.label).join(',');
  const rows = data.map(item =>
    columns.map(c => {
      const value = item[c.key];
      const strValue = value === null || value === undefined ? '' : String(value);
      return strValue.includes(',') || strValue.includes('"') ? `"${strValue.replace(/"/g, '""')}"` : strValue;
    }).join(',')
  );
  const csv = [headers, ...rows].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}_${getTodayStr()}.csv`;
  link.click();
};

const generatePassword = () => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const special = '@#$%&*!?';
  const all = upper + lower + numbers + special;
  let pwd = '';
  pwd += upper[Math.floor(Math.random() * upper.length)];
  pwd += lower[Math.floor(Math.random() * lower.length)];
  pwd += numbers[Math.floor(Math.random() * numbers.length)];
  pwd += special[Math.floor(Math.random() * special.length)];
  for (let i = 0; i < 8; i++) pwd += all[Math.floor(Math.random() * all.length)];
  return pwd.split('').sort(() => Math.random() - 0.5).join('');
};

const validatePassword = (pwd: string) => {
  if (pwd.length < 8) return 'Mínimo 8 caracteres';
  if (!/[A-Z]/.test(pwd)) return 'Precisa de letra maiúscula';
  if (!/[a-z]/.test(pwd)) return 'Precisa de letra minúscula';
  if (!/[0-9]/.test(pwd)) return 'Precisa de número';
  if (!/[@#$%&*!?]/.test(pwd)) return 'Precisa de caractere especial (@#$%&*!?)';
  return null;
};

/**
 * Foco do item do menu (21/10/2026, print do Heitor). O menu não tinha estilo de foco, então valia o anel do navegador
 * (`outline: auto`), desenhado POR FORA do botão: no item ativo, o lado esquerdo do anel caía em cima da barra de 3px e
 * da linha da árvore do submenu, e parecia cortado. Aparece quando o foco chega por teclado ou volta por programa (um
 * Esc que fecha o modal devolve o foco ao item). O anel agora é nosso, só no focus-visible e POR DENTRO do botão
 * (ring-inset): o clique de mouse segue sem anel, e o teclado continua vendo onde está.
 */
const FOCO_DO_MENU = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary';

const Sidebar = ({ section, setSection, user, collapsed, setCollapsed, financialBadges }: any) => {
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);

  // Regra de permissão: uma só, em src/utils/permissions.ts.
  const canAccessModule = moduleAccessFor(user);

  const toggleMenu = (menuId: string) => {
    setExpandedMenus(prev => prev.includes(menuId) ? prev.filter(id => id !== menuId) : [...prev, menuId]);
  };

  // Recursive check if any descendant is the active section
  const isDescendantActive = (item: any): boolean => {
    if (section === item.id) return true;
    if (item.children) return item.children.some((c: any) => isDescendantActive(c));
    return false;
  };

  // Auto-expand parent menus when section changes
  useEffect(() => {
    const findParents = (items: any[], targetId: string, parents: string[] = []): string[] | null => {
      for (const item of items) {
        if (item.id === targetId) return parents;
        if (item.children) {
          const result = findParents(item.children, targetId, [...parents, item.id]);
          if (result) return result;
        }
      }
      return null;
    };
    const allItems = [...menuItems, ...adminItems];
    const parents = findParents(allItems, section);
    if (parents && parents.length > 0) {
      setExpandedMenus(prev => {
        const newExpanded = [...prev];
        let changed = false;
        parents.forEach(p => { if (!newExpanded.includes(p)) { newExpanded.push(p); changed = true; } });
        return changed ? newExpanded : prev;
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const renderMenuItem = (item: any, isChild = false) => {
    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedMenus.includes(item.id);
    const isActive = isDescendantActive(item);

    if (hasChildren) {
      return (
        <div key={item.id}>
          <button
            onClick={() => toggleMenu(item.id)}
            className={`w-full flex items-center justify-between px-3 py-2.5 ${FOCO_DO_MENU} rounded-lg transition-all text-slate-200 ${
              isActive ? '' : 'hover:text-white hover:bg-central-elevado'
            }`}
            title={collapsed ? item.label : undefined}
          >
            <div className='flex items-center gap-3'>
              {/* O PAI de um item ativo não é o item ativo: ganha peso e ícone, nunca fundo nem barra. */}
              <Icon name={item.icon} className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-primary' : ''}`} />
              {!collapsed && <span className={`text-sm ${isActive ? 'font-medium' : 'font-normal'}`}>{item.label}</span>}
            </div>
            {!collapsed && <Icon name={isExpanded ? 'chevronUp' : 'chevronDown'} className='w-4 h-4' />}
          </button>
          {!collapsed && isExpanded && (
            <div className='ml-4 mt-1 space-y-1 border-l border-central-borda pl-2'>
              {item.children.map((child: any) => renderMenuItem(child, true))}
            </div>
          )}
        </div>
      );
    }

    const badgeMap: Record<string, { count: number | null; color: string; tooltip: string }> = {
      invoices: { count: financialBadges?.drafts || 0, color: 'bg-yellow-500/20 text-yellow-400', tooltip: 'Rascunhos no mês' },
      recebiveis: { count: financialBadges?.overdue || 0, color: 'bg-red-500/20 text-red-400', tooltip: 'Faturas vencidas' },
      boletos: { count: financialBadges?.boletosPending || 0, color: TONE_BADGE.warning, tooltip: 'Boletos pendentes de registro' },
      'fiscal-docs': { count: financialBadges?.fiscalErrors || 0, color: 'bg-red-500/20 text-red-400', tooltip: 'Notas com erro' },
      despesas: { count: financialBadges?.expOverdue || 0, color: 'bg-red-500/20 text-red-400', tooltip: 'Despesas vencidas' },
      demandas: { count: financialBadges?.demandasOpen === null ? null : (financialBadges?.demandasOpen || 0), color: TONE_BADGE.progress, tooltip: financialBadges?.demandasOpen === null ? 'Não consegui contar as demandas abertas' : 'Demandas abertas' },
    };
    const badge = badgeMap[item.id];

    // Item FILHO tem menos largura útil (recuo ml-4 + pl-2 do submenu): com
    // gap-3/px-3, "Grupos Econômicos" quebrava em duas linhas e o item ficava
    // mais alto que os vizinhos. gap-2/px-2 nos filhos devolve ~12px e mantém a
    // coluna de ícones alinhada entre eles; text-left deixa a quebra limpa, com
    // o ícone centralizado, se alguma fonte ainda não couber.
    return (
      <button
        key={item.id}
        onClick={() => setSection(item.id)}
        // O ativo é RETO (09/10/2026, moldura na casca da Central): a barra de 3px é o sinal, e o canto arredondado do
        // lado dela a dobrava, e o conjunto lia como uma caixa contornada. O inativo mantém o raio do hover.
        className={`w-full flex items-center ${isChild ? 'gap-2 px-2' : 'gap-3 px-3'} py-2.5 transition-all text-slate-200 border-l-[3px] ${FOCO_DO_MENU} ${
          section === item.id
            ? 'rounded-none bg-primary/10 border-primary'
            : 'rounded-lg border-transparent hover:text-white hover:bg-central-elevado'
        }`}
        title={collapsed ? item.label : undefined}
      >
        <Icon name={item.icon} className={`w-5 h-5 flex-shrink-0 ${section === item.id ? 'text-primary' : ''}`} />
        {!collapsed && <span className={`text-sm text-left ${section === item.id ? 'font-medium' : 'font-normal'}`}>{item.label}</span>}
        {!collapsed && badge && (badge.count === null || badge.count > 0) && (
          <span title={badge.count === null ? badge.tooltip : `${badge.count} ${badge.tooltip}`} className={`ml-auto px-1.5 py-0.5 text-[10px] font-bold rounded-full ${badge.color}`}>{badge.count === null ? '—' : badge.count}</span>
        )}
      </button>
    );
  };

  return (
    <aside className={`bg-central-cartao border-r border-central-borda flex flex-col transition-all duration-300 ${collapsed ? 'w-16' : 'w-56'}`}>
      <div className='h-16 flex items-center justify-between px-4 border-b border-central-borda'>
        {!collapsed && (
          <div className='flex items-center gap-2'>
            <img src='/ipcom-mark.svg' alt='IPCOM' className='w-8 h-8 object-contain' />
            <div>
              <h1 className='text-white font-bold text-sm'>IPCOM Hub</h1>
              <p className='text-central-texto-fraco text-xs'>Gestão Comercial</p>
            </div>
          </div>
        )}
        {/* Um degrau ABAIXO dos itens do menu de propósito: 12,02:1 contra 14,48:1. É chrome da
            barra, não item de menu. Antes ficava em slate-400 (6,96), o que lia como esquecimento
            e não como hierarquia, depois que os itens subiram. Ver guia §5b. */}
        <button onClick={() => setCollapsed(!collapsed)} className='p-1.5 text-slate-300 hover:text-white hover:bg-central-elevado rounded-lg'>
          <Icon name='menu' className='w-5 h-5' />
        </button>
      </div>

      <nav className='flex-1 p-2 space-y-1 overflow-y-auto'>
        <p className={`text-central-texto-fraco text-xs font-semibold uppercase px-3 py-2 ${collapsed ? 'hidden' : ''}`}>Principal</p>
        {/* Filtro recursivo e FAIL-CLOSED — ver src/config/menu.ts. Antes daqui
            só o pai era avaliado, e a única regra de filho era um `if` à mão que
            escondia Assinaturas de viewer; qualquer filho novo nascia visível
            para quem alcançasse o pai. Assinaturas virou filho com
            permission: 'contracts', como todos os outros. */}
        {filterMenuByPermission(menuItems, canAccessModule).map(item => renderMenuItem(item))}

        {/* A1 (26/10/2026, M1): o bloco admin em seções com título, como na Central. Seção sem item visível some. */}
        {user?.role === 'admin' && adminSecoes.map((secao) => {
          const itens = filterMenuByPermission(secao.itens, canAccessModule);
          if (itens.length === 0) return null;
          return (
            <div key={secao.titulo} data-secao-do-menu={secao.titulo}>
              <p className={`text-central-texto-fraco text-xs font-semibold uppercase px-3 py-2 mt-4 ${collapsed ? 'hidden' : ''}`}>{secao.titulo}</p>
              {itens.map(item => renderMenuItem(item))}
            </div>
          );
        })}
      </nav>
    </aside>
  );
};

const BillingManagementSystem = () => {
  // Confirmação e aviso do HUB no lugar de window.confirm/alert. Nomes `confirmar`
  // e `avisar` porque `confirm` e `aviso` já são variáveis locais neste arquivo.
  const confirmar = useConfirm();
  const confirmarPerigo = useConfirmarPerigo();
  const pedirTexto = usePedirTexto();
  const avisar = useAviso();
  const [isAuth, setIsAuth] = useState(false);
  const [user, setUser] = useState<any>(null);
  /**
   * A TELA VEM DA URL (14/10/2026, PR-C do plano das rotas aprovado pelo Heitor; mapa em config/rotas). Era
   * `useState('dashboard')`: o link não mudava, F5 voltava ao Dashboard, Voltar/Avançar não navegavam e não dava para
   * mandar o link de uma tela. Agora `section` é DERIVADO do pathname, e `setSection` NAVEGA (empilha histórico), com a
   * mesma assinatura: as chamadas e as props onNavigate não mudam.
   * ⛔ Permissão: o caminho só vale para tela que a pessoa vê pela MESMA árvore filtrada do menu; o resto cai no
   * dashboard. Com URL, o menu deixou de ser a única trava.
   */
  const location = useLocation();
  const navigate = useNavigate();
  const podeVer = podeVerPor(moduleAccessFor(user));
  const section = sectionDaRota(location.pathname, podeVer);
  const setSection = useCallback((s: string, opcoes?: { replace?: boolean }) => {
    navigate(rotaDaSection(s), { replace: !!opcoes?.replace });
  }, [navigate]);
  // O caminho CANÔNICO: pai sem tela, caminho desconhecido ou tela sem permissão viram o caminho da tela que de fato
  // abriu, com replace. ⛔ Só com login e usuário lidos: antes disso tudo pareceria "sem permissão", e o deep-link de quem
  // abriu um link deslogado seria jogado fora antes do login.
  useEffect(() => {
    if (!isAuth || !user) return;
    const canonico = rotaDaSection(section);
    if (location.pathname !== canonico) navigate({ pathname: canonico, search: location.search }, { replace: true });
  }, [isAuth, user, section, location.pathname, location.search, navigate]);
  // O título da aba diz a tela (favorito e histórico do navegador ficam legíveis).
  useEffect(() => {
    const rotulo = section === 'dashboard' ? null : rotuloDaSection(section);
    document.title = rotulo ? `${rotulo} · IPCOM Hub` : 'IPCOM Hub';
  }, [section]);
  // Grupo a abrir em Grupos Econômicos quando se chega pelo botão da ficha da assinatura.
  const [grupoParaAbrir, setGrupoParaAbrir] = useState<number | null>(null);
  // Pedido de abrir grupo vale para UMA chegada em Grupos Econômicos; sair da tela o limpa.
  useEffect(() => { if (section !== 'locations') setGrupoParaAbrir(null); }, [section]);
  // Deep-link: ?licItem=<id> (ex. link do alerta de convocação) → abre Monitorar
  // já com o detalhe do item. Lê 1x na montagem e limpa o param da URL.
  const [licDeepItemId, setLicDeepItemId] = useState<number | null>(null);
  // Deep-link: &adequar=1 junto do licItem (convocação de READEQUAÇÃO) → abre
  // Cadastrar com o editor da proposta + modal "Adequar ao lance final".
  const [licDeepAdequar, setLicDeepAdequar] = useState(false);
  // Deep-link: ?demanda=DEM-N → abre Demandas já no detalhe da demanda
  const [demandaDeepCode, setDemandaDeepCode] = useState<string | null>(null);
  // Os deep-links ANTIGOS por query (e-mail, Telegram, Agenda Google) seguem valendo: lidos 1x na montagem, viram o
  // caminho da tela com REPLACE (o Voltar não volta para o próprio link) e somem da query. Ver deepLinkDaQuery.
  useEffect(() => {
    const d = deepLinkDaQuery(window.location.search);
    if (!d) return;
    if (d.licItem != null) { setLicDeepItemId(d.licItem); setLicDeepAdequar(d.adequar); }
    if (d.demanda) setDemandaDeepCode(d.demanda);
    navigate({ pathname: rotaDaSection(d.section), search: d.resto }, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Guard global de drag&drop de ARQUIVO: sem isso, soltar um arquivo fora de uma
  // zona de upload faz o browser navegar/abrir o arquivo numa aba. Só age quando o
  // drag carrega Files (não interfere nos kanbans, que arrastam dados próprios).
  useEffect(() => {
    const hasFiles = (e: DragEvent) => Array.from(e.dataTransfer?.types || []).includes('Files');
    const onDragOver = (e: DragEvent) => { if (hasFiles(e)) e.preventDefault(); };
    const onDrop = (e: DragEvent) => { if (hasFiles(e)) e.preventDefault(); };
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('drop', onDrop);
    return () => {
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('drop', onDrop);
    };
  }, []);
  const [invoiceSearch, setInvoiceSearch] = useState('');
  /** B1 (30/10/2026): o selo de cobrança de Faturas abre a Cobrança na linha desta fatura. */
  const [focoDaCobranca, setFocoDaCobranca] = useState<string | null>(null);
  const [expenseSearch, setExpenseSearch] = useState('');
  // O termo que a busca global (ou o "ver DDRs" do cliente) leva para uma tela de busca PRÓPRIA (15/10/2026). Ia para o
  // `search` do App, que só a tela de Usuários lê: Clientes, Produtos, CRM e DDRs abriam sem filtro, e o termo aparecia
  // depois na busca de Usuários. A tela consome e limpa.
  const [buscaDaTela, setBuscaDaTela] = useState<{ section: string; termo: string } | null>(null);
  const buscaPara = (s: string) => (buscaDaTela?.section === s ? buscaDaTela.termo : undefined);
  const buscaConsumida = useCallback(() => setBuscaDaTela(null), []);
  const [bankFocusTx, setBankFocusTx] = useState<{ txId: number; bankAccountId: number; date: string } | null>(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [products, setProducts] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [contracts, setContracts] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [leads, setLeads] = useState<any[]>([]);
  const [proposals, setProposals] = useState<any[]>([]);
  const [clientLocations, setClientLocations] = useState<any[]>([]);
  const [clientDDRs, setClientDDRs] = useState<any[]>([]);
  const [ddrStats, setDdrStats] = useState<any>(null);
  const [telecomCarriers, setTelecomCarriers] = useState<any[]>([]);
  // A lista de prestadoras NÃO CARREGOU (08/10/2026). Antes, `getAll().catch(() => [])`: o formulário do DDR mostrava
  // "— Selecione —"/"padrão"/"— Não verificado —" para linhas que TÊM operadora, e a consulta da ABR mandava "cadastrar"
  // uma prestadora que existe. Nada se gravava errado (o id fica no estado), mas os campos afirmavam o falso.
  const [erroDasPrestadoras, setErroDasPrestadoras] = useState<string | null>(null);
  const recarregarPrestadoras = async () => {
    try {
      const c = await telecomCarriersService.getAll();
      setTelecomCarriers(Array.isArray(c) ? c : []);
      setErroDasPrestadoras(null);
    } catch (e) {
      setErroDasPrestadoras(mensagemDoErroDeCarga(e));
    }
  };
  /** A prestadora já escolhida é sempre opção do select, mesmo fora da lista carregada (ou com a lista sem carregar). */
  const opcaoDaPrestadoraAtual = (id: any, nome?: string | null) =>
    opcaoAtualForaDaLista(telecomCarriers, id, nome || `prestadora #${id}`, !!erroDasPrestadoras);
  const [showPrestadoras, setShowPrestadoras] = useState(false);
  const [loading, setLoading] = useState(true);
  // O estado da carga PRINCIPAL (o Promise.all do loadData), para o CRM dizer que não carregou em vez de mostrar o
  // funil vazio e os KPIs em R$ 0,00 (08/10/2026). Só o LeadsBoard o lê por enquanto; as outras cinco listas da mesma
  // carga seguem exatamente como antes (mesmo dado, mesmo momento, mesmo catch).
  const cargaPrincipal = useEstadoDaCarga();
  // A SEGUNDA carga do loadData (DDRs, stats e prestadoras), com catch próprio só com console.error. A lista de
  // Clientes lê dela os DDRs de cada cliente: sem o estado, "DDRs não carregaram" e "cliente sem DDR" eram a mesma tela
  // (08/10/2026, Fase 2 tela 3). Acompanha a MESMA promessa; não muda o que se lê nem quando.
  const cargaDosDdrs = useEstadoDaCarga();
  // Cargas que não são a principal (11/10/2026, medição do App): cada uma diz quando não leu. Antes, usuários e
  // configurações viviam no try de fora do loadData e calavam: "Nenhum usuario encontrado" com o "Novo" ao lado, e as
  // constantes do config/company mostradas (e gravadas pelo Salvar) como se fossem o cadastro da empresa.
  const cargaDosUsuarios = useEstadoDaCarga();
  const cargaDasConfiguracoes = useEstadoDaCarga();
  const cargaDasAutomacoes = useEstadoDaCarga();
  const cargaDoHistorico = useEstadoDaCarga();
  const [passkeysErro, setPasskeysErro] = useState<string | null>(null);
  const [cnlPreviewErro, setCnlPreviewErro] = useState<string | null>(null);
  const [filiaisErro, setFiliaisErro] = useState<string | null>(null);
  const [rateioErro, setRateioErro] = useState<string | null>(null);
  const [permissoesAoAbrir, setPermissoesAoAbrir] = useState<string[]>([]);
  const [diasDaLimpeza, setDiasDaLimpeza] = useState<number>(DIAS_DA_LIMPEZA_PADRAO);
  /**
   * ⛔ O cadastro do cliente é RELIDO ao abrir o modal (08/10/2026, Fase 2 tela 3b). O formulário nascia de `{ ...item }`
   * da LISTA, a foto tirada na carga do App, que podia ter horas. O Salvar gravava o cliente inteiro a partir dela, e
   * os e-mails e telefones eram apagados no servidor e recriados a partir do form: um e-mail incluído depois da carga
   * (outra sessão, a importação de e-mails financeiros) sumia no próximo Salvar. Agora o form nasce da leitura atual;
   * sem ela, o modal abre só leitura e o Salvar fica travado. A janela de corrida cai de "horas" para "o tempo do modal
   * aberto" (fechar de vez é versão/etag no backend).
   */
  const [leituraDoCliente, setLeituraDoCliente] = useState<{ estado: 'lendo' | 'ok' | 'falhou'; motivo?: string } | null>(null);
  const clienteSendoLido = useRef<number | null>(null);
  // A ASSINATURA, o mesmo padrão (09/10/2026): o modal abria da cópia da lista, e um Salvar gravava essa cópia por cima
  // do que outra tela tivesse gravado (o "Aplicar as cotas" da #398 era apagado assim). Agora relê ao abrir; leitura que
  // falha deixa o Salvar travado. E se a assinatura for gravada por outro caminho com o modal aberto, ele avisa e trava.
  const [leituraDaAssinatura, setLeituraDaAssinatura] = useState<{ estado: 'lendo' | 'ok' | 'falhou'; motivo?: string } | null>(null);
  const assinaturaSendoLida = useRef<number | null>(null);
  const assinaturaCarregada = useRef<any>(null);
  const [assinaturaMudouPorFora, setAssinaturaMudouPorFora] = useState(false);
  // O mesmo para o lead (09/10/2026): o modal relê o lead ao abrir e depois de cada proposta salva. Ver openModal.
  const [leituraDoLead, setLeituraDoLead] = useState<{ estado: 'lendo' | 'ok' | 'falhou'; motivo?: string } | null>(null);
  const leadSendoLido = useRef<number | null>(null);
  const [saving, setSaving] = useState(false);
  // Recusas do cadastro de DDR com quem já tem o número (backend #506): ficam no modal até o próximo salvar.
  const [recusasDoDdr, setRecusasDoDdr] = useState<RecusaDoDdr[]>([]);
  // O espelho do `saving` para o aviso de gravação: a gravação DESTE modal também dispara o aviso, e não é "por fora".
  const salvandoRef = useRef(false);
  salvandoRef.current = saving;
  const [consultingAbr, setConsultingAbr] = useState(false);
  const [search, setSearch] = useState('');
  const [allLocations, setAllLocations] = useState<any[]>([]);
  const [userFilter, setUserFilter] = useState<string>('Todos');
  const [companySettings, setCompanySettings] = useState<any>({
    companyName: COMPANY.name,
    tradeName: COMPANY.tradeName,
    cnpj: COMPANY.cnpj,
    address: COMPANY.street,
    city: COMPANY.city,
    state: COMPANY.state,
    zipCode: COMPANY.zipCode,
    phone: COMPANY.phone,
    whatsapp: COMPANY.whatsapp,
    email: COMPANY.email,
    website: COMPANY.website,
  });
  const [savingCompanySettings, setSavingCompanySettings] = useState(false);
  const [automations, setAutomations] = useState<any[]>([]);
  const [automationsLoading, setAutomationsLoading] = useState(false);
  const [editingRecipients, setEditingRecipients] = useState<Record<string, string>>({});
  const [modal, setModal] = useState<string | null>(null);
  const [editing, setEditing] = useState<any>(null);
  const [form, setForm] = useState<any>({});
  // Instâncias EC2 da conta, para o select do bloco de infraestrutura.
  // Carregadas só quando o modal de cliente abre — são 127 e não fazem falta
  // em nenhuma outra tela.
  const [ec2Instances, setEc2Instances] = useState<any[]>([]);
  const [erroDasInstancias, setErroDasInstancias] = useState<string | null>(null);
  // Instância gravada no cliente que não existe mais na conta AWS. Fica aqui, e
  // não dentro do modal, porque a barra de abas precisa do mesmo cálculo para
  // marcar a aba Infraestrutura — duas leituras da mesma verdade divergiriam.
  const infraTemAlerta =
    !!form?.ec2InstanceId &&
    ec2Instances.length > 0 &&
    !ec2Instances.some((i: any) => i.id === form.ec2InstanceId);
  // Prévia da derivação do número (cidade/UF/CNL/Área Local) pela base ANATEL/STFC,
  // exibida read-only no cadastro de DDR. null = ainda sem número resolvível.
  const [cnlPreview, setCnlPreview] = useState<{
    found: boolean; cnl: string | null; cnlLocalidade: string | null; cnlAreaTarifacao: string | null;
    city: string | null; state: string | null; areaLocal: string | null; areaLocalCodigo: string | null;
  } | null>(null);
  const [cnlPreviewLoading, setCnlPreviewLoading] = useState(false);
  // Busca do CNPJ do cliente final (Receita) no cadastro de DDR
  const [endClientCnpjLoading, setEndClientCnpjLoading] = useState(false);
  // true = editando a razão social do cliente final à mão (em vez do resumo read-only)
  const [endClientNameEdit, setEndClientNameEdit] = useState(false);
  // Aba ativa do modal de cliente: 'dados' (atual, com emails fiscais/telefones/endereço/etc.)
  // ou 'contatos' (nova seção de contatos de suporte/financeiro — não interfere no envio fiscal)
  const [clientModalTab, setClientModalTab] = useState<'dados' | 'faturamento' | 'infra' | 'contatos'>('dados');
  // Assinatura: produtos, contrato e consumo são três assuntos, e o de cima
  // (a lista de produtos) cresce com o cliente — numa assinatura de cinco
  // itens a data de início já nascia abaixo da dobra.
  const [contractModalTab, setContractModalTab] = useState<'produtos' | 'contrato' | 'consumo' | 'aditivos'>('produtos');
  // Itens em que o usuário pediu para ver os campos de vigência ainda vazios.
  // Fica FORA do item: tudo que está no item vai para o backend no Salvar.
  const [vigenciaAberta, setVigenciaAberta] = useState<Set<number>>(new Set());
  // Mesmo padrão da vigência: o campo de empenho do item só aparece em quem tem
  // ou em quem clicou "definir empenho".
  const [empenhoAberto, setEmpenhoAberto] = useState<Set<number>>(new Set());
  // Grupos de itens abertos no editor da assinatura (por local). Recolhidos por
  // padrão: a FESTVAL tem 78 itens em 37 grupos. Ver utils/itensPorLocal.
  const [gruposDeItensAbertos, setGruposDeItensAbertos] = useState<Set<string>>(new Set());
  // Linhas de item com a descrição aberta (a linha é enxuta; a descrição sai sob demanda).
  const [descricaoAberta, setDescricaoAberta] = useState<Set<number>>(new Set());
  // Desc % saiu da grade (zero em quase todo item): abre pelo ⋯ do item, como a vigência.
  const [descontoPctAberto, setDescontoPctAberto] = useState<Set<number>>(new Set());
  // Rateio do grupo do cliente da assinatura aberta (GET /clients/:id/rateio).
  // Só leitura: alimenta a faixa do topo, o selo por item e o rodapé.
  const [rateioDaAssinatura, setRateioDaAssinatura] = useState<RateioDoGrupo | null>(null);
  // Os produtos que o rateio do grupo divide. Decide o papel "rateado" (nunca o nome do item).
  const rateadosDaAssinatura = rateioDaAssinatura && rateioDaAssinatura.temRateio ? new Set<number>(rateioDaAssinatura.produtoIds || []) : null;
  // Vigência tirada de item que virou P&S, por posição no modal. Guardada para
  // AVISAR (a caixa some e ninguém desconfiaria) e para devolver se a pessoa
  // voltar o item para um produto recorrente: troca por engano não perde data.
  const [vigenciaGuardada, setVigenciaGuardada] = useState<Record<number, { vigenciaInicio?: string | null; vigenciaFim?: string | null }>>({});
  const [clientContacts, setClientContacts] = useState<any[]>([]);
  const [clientContactsLoading, setClientContactsLoading] = useState(false);
  const [clientContactDraft, setClientContactDraft] = useState<any>(null); // contato sendo editado/criado
  const [contractFromProposal, setContractFromProposal] = useState<{ clientId: number; proposal: any } | null>(null);
  const [inactivateClientModal, setInactivateClientModal] = useState<{ client: any; activeContracts: any[]; activeDDRs: any[] } | null>(null);
  const [processingInactivation, setProcessingInactivation] = useState(false);
  const [viewItems, setViewItems] = useState<any>(null);
  // Rateio do grupo do cliente da ficha (olho): a frase e o selo também na
  // CONSULTA, e não só na edição.
  // Uma leitura por grupo (hooks/useRateio): a ficha, a edição, as listas e os
  // painéis compartilham o mesmo cache.
  const clienteDaFicha: number | undefined = viewItems?.clientId;
  const { rateio: rateioDaFicha } = useRateio(clienteDaFicha);
  const [editLocationItems, setEditLocationItems] = useState<{contract: any; locationId: number | null; locationName: string} | null>(null);
  const [editLocationForm, setEditLocationForm] = useState<any[]>([]);
  const [signatureModal, setSignatureModal] = useState<any>(null);
  const [signatureForm, setSignatureForm] = useState({ signerEmail: '', signerName: '', signerCpf: '' });
  const [sendingSignature, setSendingSignature] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', new: '', confirm: '' });
  // MFA states
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [mfaSetupStep, setMfaSetupStep] = useState<'idle' | 'qr' | 'backup'>('idle');
  const [mfaQrDataUrl, setMfaQrDataUrl] = useState('');
  const [mfaSetupToken, setMfaSetupToken] = useState('');
  const [mfaSetupCode, setMfaSetupCode] = useState('');
  const [mfaBackupCodes, setMfaBackupCodes] = useState<string[]>([]);
  const [mfaDisableCode, setMfaDisableCode] = useState('');
  // Desativar MFA fica atrás de um clique: é a ação mais destrutiva do modal e
  // antes aparecia aberta, com o botão vermelho visível de cara.
  const [mfaDisableAberto, setMfaDisableAberto] = useState(false);
  const [trustedCount, setTrustedCount] = useState(0);
  const [sessionCount, setSessionCount] = useState(0);
  const [mfaLoading, setMfaLoading] = useState(false);

  // Passkey states
  const [passkeyCredentials, setPasskeyCredentials] = useState<any[]>([]);
  const [passkeyLoading, setPasskeyLoading] = useState(false);
  const [passkeyDeviceName, setPasskeyDeviceName] = useState('');
  const [suspendModal, setSuspendModal] = useState<any>(null);
  const [suspendForm, setSuspendForm] = useState({ reason: '', reactivationDate: '' });
  const [attachmentModal, setAttachmentModal] = useState<any>(null);
  const [uploadingAttachment, setUploadingAttachment] = useState(false);
  const [showGenerated, setShowGenerated] = useState('');
  const [leadTab, setLeadTab] = useState<AbaDoLead>('dados');
  // A aba inicial da ficha é decidida UMA vez por abertura (pela etapa, ou pelo `?ficha=` do link). Depois dela, ou do
  // primeiro clique do operador, a releitura do lead não troca a aba debaixo de quem está nela.
  const abaDoLeadDecidida = useRef<number | null>(null);
  const fichaPedida = useRef<AbaDoLead | null>(null);
  const [leadClientSearch, setLeadClientSearch] = useState('');
  const [leadClientResults, setLeadClientResults] = useState<any[]>([]);
  const [leadClientCache, setLeadClientCache] = useState<any[]>([]);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'warning' | 'info' } | null>(null);
  const [globalSearch, setGlobalSearch] = useState('');
  const [showGlobalSearch, setShowGlobalSearch] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  // Convocações recentes pro sino (cita IPCOM / ato de convocação). Poll 60s.
  const [convocacoes, setConvocacoes] = useState<any[]>([]);
  // IDs já vistos no sino (badge limpa ao abrir). localStorage separado do watcher.
  const [bellReadIds, setBellReadIds] = useState<Set<number>>(() => {
    try { return new Set(JSON.parse(localStorage.getItem('convocaBellRead') || '[]')); } catch { return new Set(); }
  });
  const unreadConvocacoes = convocacoes.filter((c: any) => !bellReadIds.has(c.id)).length;
  const markBellRead = () => {
    const next = new Set(bellReadIds);
    convocacoes.forEach((c: any) => next.add(c.id));
    setBellReadIds(next);
    try { localStorage.setItem('convocaBellRead', JSON.stringify(Array.from(next).slice(-500))); } catch { /* ignore */ }
  };
  useEffect(() => {
    if (!isAuth) return;
    let stop = false;
    const load = async () => {
      try {
        const list = await procurementService.getRecentConvocacoes();
        if (!stop) setConvocacoes(Array.isArray(list) ? list : []);
      } catch { /* ignore */ }
    };
    load();
    const iv = setInterval(load, 60000);
    return () => { stop = true; clearInterval(iv); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);
  // Derivação read-only do número no cadastro de DDR: quando há um número único
  // resolvível (edição, primeiro da lista, início da faixa ou primeiro colado),
  // busca cidade/UF/CNL/Área Local na base ANATEL/STFC pra exibir sem edição.
  useEffect(() => {
    if (modal !== 'ddr') { setCnlPreview(null); setEndClientNameEdit(false); return; }
    // Escolhe o número representativo do modo atual do form.
    let num = '';
    if (editing) num = form.phoneNumber || '';
    else if (form.ddrRangeMode) num = form.ddrRangeStart || '';
    else if (form.ddrPasteMode) {
      const first = (form.ddrPasteText || '').split(/[\n,;\s]+/).map((n: string) => n.replace(/\D/g, '')).find((n: string) => n.length >= 8);
      num = first || '';
    } else {
      const list = form.ddrList || [{ phoneNumber: form.phoneNumber || '' }];
      num = (list[0]?.phoneNumber || '').replace(/\D/g, '');
    }
    const d = String(num).replace(/\D/g, '');
    const is0800 = d.startsWith('0800') || d.startsWith('800');
    if (d.length !== 10 && !is0800) { setCnlPreview(null); setCnlPreviewLoading(false); return; }
    let cancel = false;
    setCnlPreviewLoading(true);
    const t = setTimeout(async () => {
      try {
        const p = await clientDDRsService.previewCnl(d);
        if (!cancel) { setCnlPreview(p); setCnlPreviewErro(null); }
      } catch (e) { if (!cancel) { setCnlPreview(null); setCnlPreviewErro(mensagemDoErroDeCarga(e)); } }
      finally { if (!cancel) setCnlPreviewLoading(false); }
    }, 350);
    return () => { cancel = true; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, editing, form.phoneNumber, form.ddrRangeMode, form.ddrRangeStart, form.ddrPasteMode, form.ddrPasteText, form.ddrList]);
  const [activityLog, setActivityLog] = useState<any[]>([]);
  const [permissionsModal, setPermissionsModal] = useState<any>(null);
  const [userPermissions, setUserPermissions] = useState<string[]>([]);
  const [groupedPermissions, setGroupedPermissions] = useState<Record<string, any[]>>({});
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  // Não null: a leitura das permissões falhou, e a tela não mostra nem grava nada (ver openPermissionsModal).
  const [erroDasPermissoes, setErroDasPermissoes] = useState<string | null>(null);
  const [savingPermissions, setSavingPermissions] = useState(false);
  // Aumento de recorrência previsto: soma das diferenças mensais das anualidades
  // pendentes. É o número do card de Reajustes, repetido aqui porque é o que o
  // Heitor olha primeiro de manhã. Não é o "em risco", que é o já perdido.
  const [mrrUplift, setMrrUplift] = useState<{ total: number; provisorio: number; erro?: string | null }>({ total: 0, provisorio: 0 });
  // Os números financeiros do menu, da faixa das telas financeiras e de "Recebimentos do Mês": por FONTE, e a que falha
  // mantém o último valor bom (utils/badgesFinanceiros). Um objeto só, atualizado por função: o loadBadges roda num
  // intervalo de 5 min e, lendo o estado da closure, aplicaria a leitura sobre a foto do primeiro render.
  const [painelFinanceiro, setPainelFinanceiro] = useState<{ badges: BadgesFinanceiros; fontes: EstadoDasFontes }>({ badges: BADGES_SEM_LEITURA, fontes: FONTES_SEM_LEITURA });
  const financialBadges = painelFinanceiro.badges;
  /** H1: o resumo da fila de cobrança, lido pela própria Cobrança junto com a lista. `null` = ainda não leu. */
  const [resumoDaCobranca, setResumoDaCobranca] = useState<ResumoDaFila | null>(null);
  const naCobranca = section === 'cobranca';
  // Sair da Cobrança esquece o resumo: na volta, a faixa diz "—" até a lista nova chegar, e não o número de antes.
  useEffect(() => { if (!naCobranca) setResumoDaCobranca(null); }, [naCobranca]);
  const fontesDosBadges = painelFinanceiro.fontes;
  // Número sem fonte é "—", nunca 0 (a fonte nunca respondeu).
  const qtdOuTraco = (v: number | null) => (v === null ? '—' : String(v));
  const reaisOuTraco = (v: number | null) => (v === null ? '—' : `R$ ${fmt(v)}`);
  // Hora da última leitura boa das fontes da faixa, para a marca "não atualizou" dizer de quando são os números.
  const ultimaLeituraBoa = [fontesDosBadges.faturas.lidoEm, fontesDosBadges.resumo.lidoEm].filter(Boolean).sort()[0] || null;
  // null = não consegui contar (o badge diz "—", não some como se fosse zero).
  const [demandasOpenCount, setDemandasOpenCount] = useState<number | null>(0);

  // Module display info (only UI labels and icons - permissions come from backend)
  const MODULE_DISPLAY: Record<string, { name: string; icon: string }> = {
    dashboard: { name: 'Dashboard', icon: 'home' },
    leads: { name: 'Leads/CRM', icon: 'users' },
    clients: { name: 'Clientes', icon: 'building' },
    products: { name: 'Produtos', icon: 'box' },
    contracts: { name: 'Contratos', icon: 'file-text' },
    invoices: { name: 'Faturas', icon: 'file-invoice' },
    proposals: { name: 'Propostas', icon: 'document' },
    materials: { name: 'Materiais', icon: 'folder' },
    oficios: { name: 'Ofícios', icon: 'mail' },
    templates: { name: 'Templates', icon: 'template' },
    reservations: { name: 'AWS Reservas', icon: 'cloud' },
    reports: { name: 'Relatórios', icon: 'chart' },
    users: { name: 'Usuários', icon: 'users' },
    settings: { name: 'Configurações', icon: 'settings' },
    financials: { name: 'Financeiro', icon: 'dollar-sign' },
  };

  // Financial visibility helpers
  // Admin and Vendedor can see financial values (vendedor only sees own clients due to filtering)
  const canViewFinancials = user?.role === 'admin' || user?.role === 'vendedor';
  const isViewer = user?.role === 'viewer';
  // Only Admin can see total/aggregate financial values (MRR Total, etc.)
  //
  // DIVERGÊNCIA CONSCIENTE, não esquecimento: esta regra é por ROLE, enquanto o
  // menu Financeiro e o loadBadges são por PERMISSÃO (`invoices`). Unificar em
  // canAccessModule('invoices') ALARGARIA o acesso — um não-admin com
  // invoices:view passaria a ver totais do Dashboard que hoje não vê — e esta
  // passada é de endurecimento: não pode terminar com ninguém vendo mais do que
  // via antes. Alargar, se for o caso, é decisão separada e consciente.
  const canViewFinancialTotals = user?.role === 'admin';

  // Show toast helper
  const showToast = useCallback((message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') => {
    setToast({ message, type });
  }, []);

  // Load activity logs from API
  const rodarHistorico = cargaDoHistorico.rodar;
  const loadActivityLogs = useCallback(async () => {
    await rodarHistorico(async () => {
      const logs = await activityLogService.getAll(100);
      setActivityLog(logs.map((log: any) => ({
        id: log.id,
        action: log.action,
        details: log.details,
        user: log.userName,
        timestamp: log.createdAt,
      })));
    });
  }, [rodarHistorico]);

  // Log activity helper - now calls API
  const logActivity = useCallback(async (action: string, details: string, entityType?: string, entityId?: number) => {
    try {
      await activityLogService.create({ actionText: action, details, entityType, entityId });
      // Reload logs to get the latest
      loadActivityLogs();
    } catch (e) {
      // Calava: a trilha perdia o registro e ninguém sabia.
      setToast({ message: `Não consegui registrar "${action}" no histórico: ${mensagemDoErroDeCarga(e)}.`, type: 'warning' });
    }
  }, [loadActivityLogs]);

  useEffect(() => {
    // Instant UI from localStorage (while cookie check happens)
    const u = localStorage.getItem('user');
    if (u) {
      const parsed = JSON.parse(u);
      if (!parsed.mfaSetupRequired) {
        setIsAuth(true); setUser(parsed);
      }
    }
    // Sessão perdida em qualquer aba (refresh recusado) volta todo mundo ao login.
    // É ESTE handler que derruba o `isAuth` e faz a tela cair no <Login/>. O
    // AuthContext inscreve o dele também; enquanto havia um slot único, o do
    // contexto (pai, efeito roda depois) apagava este e a tela ficava viva com a
    // sessão morta, respondendo "Unauthorized" em toda ação.
    const unsubscribeSessionLost = addSessionLostHandler(() => {
      setIsAuth(false); setUser(null); localStorage.removeItem('user');
    });
    // Verifica a sessão. O access token é obtido a partir do cookie httpOnly de
    // refresh — que é first-party, então funciona igual em Chrome e Safari.
    authService.getMe()
      .then((userData) => {
        if (userData?.mfaSetupRequired) {
          setIsAuth(false); setUser(null);
          localStorage.removeItem('user');
          clearSession();
          return;
        }
        setIsAuth(true); setUser(userData); localStorage.setItem('user', JSON.stringify(userData));
        authService.getMfaStatus().then(s => setMfaEnabled(s.mfaEnabled)).catch(() => {});
        authService.webauthnListCredentials().then((l: any) => { setPasskeyCredentials(l); setPasskeysErro(null); }, (e: any) => setPasskeysErro(mensagemDoErroDeCarga(e)));
      })
      .catch((error) => {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          setIsAuth(false); setUser(null); localStorage.removeItem('user');
          clearSession();
        }
      });

    return unsubscribeSessionLost;
  }, []);
  
  useEffect(() => {
    if (isAuth) {
      loadData();
      loadActivityLogs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, user]);

  /**
   * A4 (12/10/2026): as etapas do funil vêm do servidor (#409). 404 = backend sem a #409: as seis fixas, como sempre.
   * Outra falha: também as fixas, mas com o motivo, que o board diz (não fingir que leu).
   */
  const [funil, setFunil] = useState<EtapasDoFunil>(ETAPAS_FIXAS);
  useEffect(() => {
    if (!isAuth) return;
    let vivo = true;
    leadsService.getFunnelStages()
      .then((r: any) => { if (vivo) setFunil(etapasDaResposta(r)); })
      .catch((e: any) => { if (vivo) setFunil(e?.response?.status === 404 ? ETAPAS_FIXAS : { ...ETAPAS_FIXAS, erro: mensagemDoErroDeCarga(e) }); });
    return () => { vivo = false; };
  }, [isAuth]);
  const etapasDaAssinatura = etapasDaAssinaturaDe(funil);

  // Mesmo critério do menu Financeiro (src/config/menu.ts): quem não alcança o
  // módulo não busca os números. Antes daqui a chamada saía para TODO usuário
  // autenticado e o 403 caía no catch — o efeito visível não era um erro, era um
  // ZERO, justamente nos valores que esses papéis não devem ver. Zero enganoso é
  // pior que campo ausente.
  //
  // Booleano derivado (e não `user` cru) na dependência do efeito: o objeto muda
  // de identidade a cada getMe e remontaria o intervalo de 5 min à toa.
  const canLoadFinancialBadges = canAccessModule(user, 'invoices');
  // contract-adjustments é admin-only no backend (leitura e escrita). Mesmo
  // critério do item Reajustes no menu — uma regra só, em src/config/menu.ts.
  const canSeeReajustes = canAccessModule(user, 'reajustes');

  // Load financial badges
  useEffect(() => {
    // Os dois blocos abaixo têm gates independentes (financeiro e reajustes):
    // se nenhum dos dois se aplica, nem vale montar o intervalo de 5 min.
    if (!isAuth || (!canLoadFinancialBadges && !canSeeReajustes)) return;
    const loadBadges = async () => {
      if (!canLoadFinancialBadges) { await loadUplift(); return; }
        const currentMonth = (() => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}`; })();
        // Promise.allSettled, não Promise.all: as quatro chamadas caem em rotas
        // diferentes e com permissões diferentes no backend. Com `all`, um 403
        // em despesas derrubava as ONZE métricas do bloco — inclusive as de
        // faturas, que o usuário podia ter direito de ver. Cada uma responde por
        // si, e a que falha MANTÉM o último valor bom (era `?? 0`: a recarga que
        // falhava zerava os números e calava os badges do menu).
        // allSettled não rejeita, e o aplicarLeitura é puro: não há o que pegar aqui (era um catch que só logava).
        // O resumo de recebíveis são TOTAIS: só o admin pede (23/10/2026, totais só admin). Quem não é admin não chama a
        // rota, que fecha em ADMIN no backend, e a faixa não mostra os números dela.
        const [rInvoices, rSummary, rFiscal, rExp] = await Promise.allSettled([
          invoicesService.getAll(),
          canViewFinancialTotals ? invoicesService.getReceivablesSummary(currentMonth) : Promise.resolve(null),
          fiscalService.getDashboard(),
          expensesService.summary(currentMonth),
        ]);
        const agora = new Date().toISOString();
        setPainelFinanceiro((anterior) => aplicarLeitura(
          anterior.badges, anterior.fontes,
          { faturas: rInvoices, resumo: canViewFinancialTotals ? rSummary : undefined, fiscal: rFiscal, despesas: rExp },
          currentMonth, agora,
        ));
      await loadUplift();
    };
    // try/catch próprio: reajuste não pode derrubar os badges financeiros.
    // O gate é o MESMO do item Reajustes no menu (src/config/menu.ts):
    // contract-adjustments é admin-only no backend, e sem isto o 403 cairia no
    // catch e o "aumento previsto/mês" ficaria em zero com cara de dado real.
    const loadUplift = async () => {
      if (!canSeeReajustes) return;
      try {
        const pendentes = await contractAdjustmentsService.getAll({ pending: true });
        const lista = Array.isArray(pendentes) ? pendentes : [];
        const soma = (l: any[]) => l.reduce((s: number, a: any) => s + (Number(a.amountAfter) || 0) - (Number(a.amountBefore) || 0), 0);
        setMrrUplift({ total: soma(lista), provisorio: soma(lista.filter((a: any) => a.isProvisional)), erro: null });
      } catch (e) {
        // Era só log: o painel omitia o aumento como se fosse zero.
        setMrrUplift({ total: 0, provisorio: 0, erro: mensagemDoErroDeCarga(e) });
      }
    };
    loadBadges();
    const interval = setInterval(loadBadges, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isAuth, canLoadFinancialBadges, canSeeReajustes, canViewFinancialTotals]);

  // Badge de demandas abertas (try/catch próprio — não derruba os badges financeiros)
  const loadDemandasCount = useCallback(async () => {
    try {
      const res = await demandasService.countOpen();
      setDemandasOpenCount(res?.count || 0);
    } catch (e: any) {
      // Sem acesso ao módulo (403): sem badge, como sempre. Qualquer outra falha: "—", não 0 (era "nenhuma aberta").
      setDemandasOpenCount(e?.response?.status === 403 ? 0 : null);
    }
  }, []);

  useEffect(() => {
    if (!isAuth) return;
    loadDemandasCount();
    const interval = setInterval(loadDemandasCount, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isAuth, loadDemandasCount]);

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+K for global search
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setShowGlobalSearch(prev => !prev);
      }
      // ESC to close modals/dropdowns
      if (e.key === 'Escape') {
        setShowGlobalSearch(false);
        setShowNotifications(false);
        setGlobalSearch('');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Inicializar formulário de edição por localização
  useEffect(() => {
    if (editLocationItems) {
      const locationItems = (editLocationItems.contract.items || []).filter((i: any) => {
        if (editLocationItems.locationId === null) {
          return !i.locationId || i.locationId === null;
        }
        return i.locationId === editLocationItems.locationId;
      });
      setEditLocationForm(locationItems.map((i: any) => ({...i})));
    } else {
      setEditLocationForm([]);
    }
  }, [editLocationItems]);

  // ⛔ ASSINATURA GRAVADA EM OUTRA TELA (09/10/2026): a lista de assinaturas relê. O "Aplicar as cotas" (Grupos
  // Econômicos) grava os itens do contrato; sem isto a tela de Assinaturas seguia com a cópia de ANTES, o modal do
  // contrato abria dela, e um Salvar ali devolvia o item antigo, apagando a cota aplicada. O aviso sai do interceptor
  // do axios (utils/avisoDeGravacao) para toda escrita em /contracts, inclusive as desta tela, que já releem: reler de
  // novo é inofensivo.
  useEffect(() => {
    const reler = () => {
      contractsService.getAll().then(
        (co: any) => { if (Array.isArray(co)) setContracts(co); },
        falhaIgnoradaDeProposito('a releitura depois de uma escrita é cortesia: a lista que está na tela segue, e a próxima carga normal traz a nova'),
      );
    };
    window.addEventListener(ASSINATURA_GRAVADA, reler);
    return () => window.removeEventListener(ASSINATURA_GRAVADA, reler);
  }, []);

  const loadData = async () => {
    setLoading(true);
    const ehAdmin = user?.role === 'admin';
    // As leituras que não são a principal correm em paralelo e cada uma tem o seu estado (o `rodar` não lança).
    const paralelas = Promise.all([
      cargaDasConfiguracoes.rodar(async () => {
        const companyData = await systemService.getCompanySettings();
        if (companyData) setCompanySettings(companyData);
      }),
      ehAdmin ? cargaDasAutomacoes.rodar(async () => {
        const auts = await notificationsApiService.getAutomations();
        setAutomations(Array.isArray(auts) ? auts : []);
      }) : null,
      ehAdmin ? cargaDosUsuarios.rodar(async () => {
        const u = await usersService.getAll();
        setUsers(Array.isArray(u) ? u : []);
      }) : null,
    ]);
    await cargaPrincipal.rodar(async () => {
      const [p, c, co, l, loc, prop] = await Promise.all([productsService.getAll(), clientsService.getAll(), contractsService.getAll(), leadsService.getAll(), clientLocationsService.getAll(), proposalsService.getAll()]);
      const categoryOrder: Record<string, number> = { 'Cloud': 1, 'Telefonia': 2, 'Serviços': 3 };
      const sortedProducts = (Array.isArray(p) ? p : []).sort((a: any, b: any) => {
        const catA = categoryOrder[a.category] || 99;
        const catB = categoryOrder[b.category] || 99;
        if (catA !== catB) return catA - catB;
        return (a.code || '').localeCompare(b.code || '');
      });
      setProducts(sortedProducts);
      setClients(Array.isArray(c) ? c : []);
      setContracts(Array.isArray(co) ? co : []);
      setLeads(Array.isArray(l) ? l : []);
      setProposals(Array.isArray(prop) ? prop : []);
      setAllLocations(Array.isArray(loc) ? loc : []);
    });
    // DDRs + prestadoras (telecom carriers) p/ o dropdown Operadora Real
    await cargaDosDdrs.rodar(async () => {
      const [ddrs, stats, carriers] = await Promise.all([
        clientDDRsService.getAll(),
        clientDDRsService.getStats(),
        telecomCarriersService.getAll().then(
          (c: any) => ({ c, erro: null as string | null }),
          (e: any) => ({ c: null, erro: mensagemDoErroDeCarga(e) }),
        ),
      ]);
      setClientDDRs(Array.isArray(ddrs) ? ddrs : []);
      setDdrStats(stats);
      setErroDasPrestadoras(carriers.erro);
      if (!carriers.erro) setTelecomCarriers(Array.isArray(carriers.c) ? carriers.c : []);
    });
    await paralelas;
    setLoading(false);
  };

  /**
   * Depois de uma proposta salva na aba Propostas (09/10/2026). Trocava o form INTEIRO pelo lead do servidor: o que
   * estava sendo digitado em Dados, e ainda não salvo, sumia calado. E a releitura que falhava era só console.error, e o
   * form ficava velho, pronto para o Salvar gravar a cópia por cima. Agora entra só o que as propostas mudam no lead (os
   * valores estimados, que o backend recalcula, e a etapa e o fechamento), e só o campo que o SERVIDOR mudou desde a última
   * leitura: o que a pessoa mudou na tela e o servidor não, fica. A releitura que falha trava o Salvar e diz por quê.
   */
  // E4 (12/10/2026): com proposta viva, o valor estimado é a soma delas (o backend sobrescreve a cada escrita de proposta);
  // o campo livre dizia o contrário. A leitura carrega o lead que pediu; resposta de outro lead é descartada.
  const [propostasDoLead, setPropostasDoLead] = useState<{ leadId: number; lista: any[] | null; erro: string | null } | null>(null);
  const lerPropostasDoLead = async (leadId: number) => {
    setPropostasDoLead((a) => (a && a.leadId === leadId ? a : { leadId, lista: null, erro: null }));
    try {
      const r = await proposalsService.getByLead(leadId);
      setPropostasDoLead((a) => (a && a.leadId !== leadId ? a : { leadId, lista: Array.isArray(r) ? r : [], erro: null }));
    } catch (e) {
      setPropostasDoLead((a) => (a && a.leadId !== leadId ? a : { leadId, lista: null, erro: mensagemDoErroDeCarga(e) }));
    }
  };
  // A FICHA EM QUATRO ABAS (16/10/2026): o Contrato saiu do fim da aba Propostas para a aba dele, e o rótulo diz o estado
  // ("2/4 assinaturas") sem abrir a aba. Os contratos são lidos na abertura, como as propostas: decidem a aba inicial e o
  // rótulo. Leitura que falha não vira "0": o rótulo fica sem número. Com a aba aberta, o resumo vem da própria aba, que
  // relê depois de cada ação (gerar, enviar, cancelar), sem leitura a mais.
  const [contratosDoLead, setContratosDoLead] = useState<{ leadId: number; lista: any[] | null; erro: string | null } | null>(null);
  const [resumoDaAba, setResumoDaAba] = useState<{ leadId: number; propostas: any[]; contratos: any[] } | null>(null);
  const lerContratosDoLead = async (leadId: number) => {
    setContratosDoLead((a) => (a && a.leadId === leadId ? a : { leadId, lista: null, erro: null }));
    try {
      const r = await digitalContractsService.getByLead(leadId);
      setContratosDoLead((a) => (a && a.leadId !== leadId ? a : { leadId, lista: Array.isArray(r) ? r : [], erro: null }));
    } catch (e) {
      setContratosDoLead((a) => (a && a.leadId !== leadId ? a : { leadId, lista: null, erro: mensagemDoErroDeCarga(e) }));
    }
  };
  useEffect(() => {
    if (modal === 'lead' && editing?.id) { lerPropostasDoLead(Number(editing.id)); lerContratosDoLead(Number(editing.id)); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, editing?.id]);
  // A aba inicial pela etapa, depois de ler o lead (a etapa do servidor) e os contratos (há contrato?).
  useEffect(() => {
    if (modal !== 'lead' || !editing?.id) return;
    const id = Number(editing.id);
    if (abaDoLeadDecidida.current === id || leituraDoLead?.estado !== 'ok') return;
    if (!contratosDoLead || contratosDoLead.leadId !== id || (contratosDoLead.lista === null && !contratosDoLead.erro)) return;
    abaDoLeadDecidida.current = id;
    const temContrato = contratosDoLead.lista ? contratosDoLead.lista.some((c: any) => c?.status !== 'Cancelado') : null;
    setLeadTab(abaInicialDoLead(editing.status, funil, temContrato));
  }, [modal, editing?.id, editing?.status, leituraDoLead?.estado, contratosDoLead, funil]);
  // A aba aberta vai para o endereço da ficha (`?ficha=`), na entrada que a casca empilhou: o link e o F5 voltam nela, e
  // fechar tira junto. Dados não vai para a URL.
  useEffect(() => {
    if (modal !== 'lead' || !editing?.id) return;
    trocarParametroNaUrl('ficha', leadTab === 'dados' ? null : leadTab);
  }, [modal, editing?.id, leadTab]);

  const refreshLeadData = async () => {
    await loadData();
    if (editing && modal === 'lead') lerPropostasDoLead(Number(editing.id));
    if (editing && modal === 'lead') {
      const base = editing;
      await lerLead(Number(editing.id), (atual) => setForm((f: any) => {
        const novo = { ...f };
        for (const c of ['estimatedValue', 'estimatedValuePS', 'status', 'wonAt', 'lostAt', 'lostReason', 'updatedAt', 'lastActivityAt']) {
          if (atual[c] !== base[c]) novo[c] = atual[c];
        }
        return novo;
      }));
    }
  };

  const handleLogin = async (u: any) => {
    localStorage.setItem('user', JSON.stringify(u));
    setUser(u);
    setIsAuth(true);
    // Reload user-specific data (passkeys, MFA status)
    authService.getMfaStatus().then(s => setMfaEnabled(s.mfaEnabled)).catch(() => {});
    authService.webauthnListCredentials().then((l: any) => { setPasskeyCredentials(l); setPasskeysErro(null); }, (e: any) => { setPasskeyCredentials([]); setPasskeysErro(mensagemDoErroDeCarga(e)); });
    // O access token já está em memória (guardado pelo authService no login), então
    // não há mais espera por cookie: a chamada abaixo já sai autenticada.
    logActivity('Login', 'no sistema', 'system');
  };
  const handleLogout = async () => {
    await logActivity('Logout', 'do sistema', 'system');
    try { await authService.logout(); } catch { /* ignore */ }
    localStorage.removeItem('user');
    setIsAuth(false);
    setUser(null);
    setPasskeyCredentials([]);
    setMfaEnabled(false);
  };

  // MRR da assinatura = soma dos itens RECORRENTES que valem HOJE. A tela e o
  // Salvar usam esta mesma função: antes, cada edição somava todos os itens
  // MRR, inclusive o que só começa depois (Sorriso, 114: R$ 999,00 a partir
  // de 03/11), e o Salvar gravava R$ 6.371,79 como MRR de um contrato que
  // cobra R$ 5.372,79. Tela e banco não podem discordar do mesmo número.
  // Depois de trocar o produto do item `idx`: vigência é conceito de MRR (o
  // backend a ignora em P&S, sem log). Item que vira P&S larga as datas, que
  // ficam guardadas e avisadas; item que volta a MRR recebe-as de volta.
  const ajustarVigenciaNaTroca = (newItems: any[], idx: number) => {
    const it = newItems[idx];
    if (it.type !== 'MRR' && (it.vigenciaInicio || it.vigenciaFim)) {
      const { vigenciaInicio, vigenciaFim, ...resto } = it;
      newItems[idx] = resto;
      setVigenciaGuardada({ ...vigenciaGuardada, [idx]: { vigenciaInicio: vigenciaInicio || null, vigenciaFim: vigenciaFim || null } });
    } else if (it.type === 'MRR' && vigenciaGuardada[idx]) {
      newItems[idx] = { ...it, ...vigenciaGuardada[idx] };
      const resto = { ...vigenciaGuardada };
      delete resto[idx];
      setVigenciaGuardada(resto);
    }
  };

  const mrrVigenteDosItens = (items: any[]) => somaVigente((items || []).filter((i: any) => { const pr = products.find((x: any) => Number(x.id) === Number(i.productId)); const iType = i.type || pr?.type || 'MRR'; return iType === 'MRR'; }), getTodayStr());

  /** O formulário do cliente a partir de um cadastro (ou vazio, para cliente novo). */
  const formDoCliente = (item: any) => {
    const phones = item?.phones?.length > 0 ? item.phones : (item?.phone ? [{ phone: item.phone, type: 'Comercial', isPrimary: true }] : [{ phone: '', type: 'Comercial', isPrimary: true }]);
    const emails = item?.emails?.length > 0 ? item.emails : (item?.emailFinancial ? [{ email: item.emailFinancial, type: 'Financeiro', isPrimary: true }] : [{ email: '', type: 'Financeiro', isPrimary: true }]);
    const formattedCnpj = item?.cnpj ? maskCNPJ(item.cnpj) : '';
    const defaultCdrStatusFilter = ['ATENDIDA', 'OCUPADO', 'NAO ATENDIDA', 'FALHA'];
    const cdrStatusFilter = item?.cdrStatusFilter?.length > 0 ? item.cdrStatusFilter : defaultCdrStatusFilter;
    return item ? { ...item, cnpj: formattedCnpj, phones, emails, cdrStatusFilter } : { name: '', tradeName: '', companyName: '', cnpj: '', dueDay: '', phones: [{ phone: '', type: 'Comercial', isPrimary: true }], emails: [{ email: '', type: 'Financeiro', isPrimary: true }], segment: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: '', zipCode: '', municipalCode: '', status: 'Ativo', cdrStatusFilter: defaultCdrStatusFilter };
  };

  /** Por que o Salvar do cliente está travado (ou undefined): o form não é o cadastro atual. */
  const porqueClienteTravado = modal === 'client' && editing && leituraDoCliente && leituraDoCliente.estado !== 'ok'
    ? (leituraDoCliente.estado === 'lendo'
      ? 'Lendo o cadastro atual do cliente…'
      : `Não consegui ler o cadastro atual deste cliente (${leituraDoCliente.motivo}). O que está na tela é a cópia da lista${cargaPrincipal.atualizadoEm ? `, de ${fmtDateTime(cargaPrincipal.atualizadoEm)}` : ''}: salvar agora gravaria essa cópia por cima do cadastro. Feche e abra de novo para tentar.`)
    : undefined;

  /** Por que o Salvar da assinatura está travado (ou undefined): o form não é a assinatura atual. */
  const porqueAssinaturaTravada = modal === 'contract' && editing
    ? (leituraDaAssinatura && leituraDaAssinatura.estado !== 'ok'
      ? (leituraDaAssinatura.estado === 'lendo'
        ? 'Lendo a assinatura atual…'
        : `Não consegui ler a assinatura atual (${leituraDaAssinatura.motivo}). O que está na tela é a cópia da lista: salvar agora gravaria essa cópia por cima da assinatura. Feche e abra de novo para tentar.`)
      : assinaturaMudouPorFora
        ? 'Esta assinatura foi gravada por outro caminho depois que este modal abriu. Salvar agora gravaria por cima do que foi gravado: recarregue antes.'
        : undefined)
    : undefined;

  // Com o modal da assinatura aberto, uma gravação por FORA (outra tela, outra aba de ação) é conferida: relê e compara
  // com a que o modal carregou. A gravação deste próprio modal também dispara o aviso, e é ignorada (salvandoRef).
  useEffect(() => {
    if (modal !== 'contract' || !editing?.id) return;
    const id = Number(editing.id);
    const marca = (c: any) => c?.updatedAt ?? JSON.stringify([c?.items, c?.mrr, c?.status]);
    const conferir = () => {
      if (salvandoRef.current) return;
      contractsService.getById(id).then(
        (atual: any) => {
          if (assinaturaSendoLida.current !== id || !assinaturaCarregada.current) return;
          if (marca(atual) !== marca(assinaturaCarregada.current)) setAssinaturaMudouPorFora(true);
        },
        falhaIgnoradaDeProposito('conferir a gravação por fora é cortesia: sem ela o modal segue como está, e o Salvar continua o de antes'),
      );
    };
    window.addEventListener(ASSINATURA_GRAVADA, conferir);
    return () => window.removeEventListener(ASSINATURA_GRAVADA, conferir);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, editing?.id]);

  /** Por que o Salvar do lead está travado (ou undefined): o form não é o lead atual. */
  const porqueLeadTravado = modal === 'lead' && editing && leituraDoLead && leituraDoLead.estado !== 'ok'
    ? (leituraDoLead.estado === 'lendo'
      ? 'Lendo o lead atual…'
      : `Não consegui ler o lead atual (${leituraDoLead.motivo}). O que está na tela é uma cópia que pode estar desatualizada: salvar agora gravaria essa cópia por cima do lead. Feche e abra de novo para tentar.`)
    : undefined;

  /**
   * Relê o lead (09/10/2026). O Salvar do lead faz PUT do form INTEIRO, e o backend aplica tudo por cima do registro: com o
   * form vindo da cópia do board, o que outra pessoa mudou desde a carga era sobrescrito. Até a resposta (e se ela falhar)
   * o Salvar fica travado. Uma resposta que chega depois de o modal fechar, ou de outro lead abrir, não toca em nada.
   * `aplicar` decide o que fazer com o lead lido: na abertura, ele vira o form; depois de uma proposta, entra só o que mudou.
   */
  const lerLead = (id: number, aplicar: (atual: any) => void) => {
    leadSendoLido.current = id;
    setLeituraDoLead({ estado: 'lendo' });
    return leadsService.getById(id).then(
      (atual: any) => {
        if (leadSendoLido.current !== id) return;
        if (!atual || typeof atual !== 'object' || Number(atual.id) !== id) {
          setLeituraDoLead({ estado: 'falhou', motivo: 'a resposta não trouxe este lead' });
          return;
        }
        aplicar(atual);
        setEditing(atual);
        setLeituraDoLead({ estado: 'ok' });
      },
      (e: any) => {
        if (leadSendoLido.current !== id) return;
        setLeituraDoLead({ estado: 'falhou', motivo: mensagemDoErroDeCarga(e) });
      },
    );
  };

  // O formulário como ABRIU (09/10/2026), para o Esc da casca saber se há edição não salva. Gravado nos mesmos pontos
  // em que o openModal (e a releitura do cliente) preenche o `form`: o que o operador mudou é a diferença entre os dois.
  const [formAoAbrir, setFormAoAbrir] = useState<any>(null);
  const temEdicaoNaoSalva = () => JSON.stringify(form) !== JSON.stringify(formAoAbrir);

  /** O form do modal da assinatura, a partir de uma assinatura (da lista ou relida) ou vazio (nova). */
  const formDaAssinatura = (item: any) => {
    // Parse items if they come as string from backend and ensure productId is number
    const rawItems = item ? (typeof item.items === 'string' ? JSON.parse(item.items || '[]') : (item.items || [])) : [];
    const parsedItems = rawItems.map((i: any) => ({
      ...i,
      productId: Number(i.productId) || 0,
      quantity: Number(i.quantity) || 1,
      unitValue: Number(i.unitValue) || 0,
      discount: Number(i.discount) || 0,
      totalValue: Number(i.totalValue) || 0,
      // Garantir que detailedDescription tenha a descrição do produto
      detailedDescription: i.detailedDescription || i.description || '',
    }));
    return item ? { ...item, items: parsedItems, startDate: item.contractStartDate || item.startDate || '', endDate: item.contractEndDate || item.endDate || '', contractNumber: item.contractNumber || '', empenhoNumber: item.empenhoNumber || '', paymentMethod: item.paymentMethod || '' } : { clientId: 0, items: [], mrr: 0, status: 'Ativo', autoRenew: true, adjustmentIndex: 'IPCA', notes: '', startDate: getTodayStr(), nextAdjustmentDate: addYearsStr(getTodayStr(), 1), contractNumber: '', empenhoNumber: '', paymentMethod: '' };
  };

  /** Relê a assinatura atual e põe no modal (ao abrir, e no "Recarregar"). Resposta velha não sobrescreve nada. */
  const lerAssinatura = (id: number) => {
    assinaturaSendoLida.current = id;
    setLeituraDaAssinatura({ estado: 'lendo' });
    contractsService.getById(id).then(
      (atual: any) => {
        if (assinaturaSendoLida.current !== id) return;
        if (!atual || typeof atual !== 'object' || Number(atual.id) !== id) {
          setLeituraDaAssinatura({ estado: 'falhou', motivo: 'a resposta não trouxe esta assinatura' });
          return;
        }
        assinaturaCarregada.current = atual;
        setEditing(atual);
        const f = formDaAssinatura(atual);
        setForm(f);
        setFormAoAbrir(f);
        setAssinaturaMudouPorFora(false);
        setLeituraDaAssinatura({ estado: 'ok' });
      },
      (e: any) => {
        if (assinaturaSendoLida.current !== id) return;
        setLeituraDaAssinatura({ estado: 'falhou', motivo: mensagemDoErroDeCarga(e) });
      },
    );
  };

  const openModal = (type: string, item: any = null) => {
    setModal(type); setEditing(item);
    // Abrir sempre em Dados: a aba é estado da tela, não do cliente, e abrir um
    // cadastro direto em Infraestrutura esconde o nome de quem se está editando.
    if (type === 'client') setClientModalTab('dados');
    if (type === 'contract') { setContractModalTab('produtos'); setVigenciaAberta(new Set()); setEmpenhoAberto(new Set()); setVigenciaGuardada({}); }
    // Só o modal de cliente usa a lista de instâncias, e só na primeira vez.
    if (type === 'client' && ec2Instances.length === 0) {
      clientsService.listEc2Instances().then(
        (l: any) => { setEc2Instances(Array.isArray(l) ? l : []); setErroDasInstancias(null); },
        (e: any) => { setEc2Instances([]); setErroDasInstancias(mensagemDoErroDeCarga(e)); },
      );
    }
    if (type === 'product') setForm(item || { type: 'MRR', code: '', name: '', description: '', category: '', recurrence: 'Mensal', value: 0, cost: 0, status: true });
    else if (type === 'client') {
      setForm(formDoCliente(item));
      setFormAoAbrir(formDoCliente(item));
      if (item?.id) {
        // Relê o cadastro atual; até a resposta (e se ela falhar) o Salvar fica travado. Uma resposta que chega depois de
        // o modal fechar, ou de outro cliente abrir, não sobrescreve nada.
        const id = Number(item.id);
        clienteSendoLido.current = id;
        setLeituraDoCliente({ estado: 'lendo' });
        clientsService.getById(id).then(
          (atual: any) => {
            if (clienteSendoLido.current !== id) return;
            if (!atual || typeof atual !== 'object' || Number(atual.id) !== id) {
              setLeituraDoCliente({ estado: 'falhou', motivo: 'a resposta não trouxe este cliente' });
              return;
            }
            setEditing(atual);
            setForm(formDoCliente(atual));
            setFormAoAbrir(formDoCliente(atual));
            setLeituraDoCliente({ estado: 'ok' });
          },
          (e: any) => {
            if (clienteSendoLido.current !== id) return;
            setLeituraDoCliente({ estado: 'falhou', motivo: mensagemDoErroDeCarga(e) });
          },
        );
      } else {
        clienteSendoLido.current = null;
        setLeituraDoCliente(null);
      }
    }
    else if (type === 'contract') {
      const contractData = formDaAssinatura(item);
      setForm(contractData);
      setFormAoAbrir(contractData);
      setAssinaturaMudouPorFora(false);
      assinaturaCarregada.current = item || null;
      if (item?.id) lerAssinatura(Number(item.id));
      else { assinaturaSendoLida.current = null; setLeituraDaAssinatura(null); }
      setGruposDeItensAbertos(new Set());
      setDescricaoAberta(new Set());
      setDescontoPctAberto(new Set());
      setRateioDaAssinatura(null);
      // Falha ao ler o rateio não pode travar o editor: sem ele, só não há faixa nem selo.
      setRateioErro(null);
      setFiliaisErro(null);
      if (item?.clientId) lerRateio(item.clientId).then(setRateioDaAssinatura, (e: any) => { setRateioDaAssinatura(null); setRateioErro(mensagemDoErroDeCarga(e)); });
      if (item?.clientId) { clientLocationsService.getByClient(item.clientId).then((locs: any) => setClientLocations(locs || []), (e: any) => { setClientLocations([]); setFiliaisErro(mensagemDoErroDeCarga(e)); }); } else { setClientLocations([]); }
    }
    else if (type === 'user') setForm(item ? { ...item, password: '' } : { name: '', email: '', password: '', role: 'viewer', isActive: true });
    else if (type === 'lead') {
      setForm(item || { companyName: '', tradeName: '', cnpj: '', address: '', contactName: '', email: '', phone: '', position: '', source: 'Outro', status: 'Novo', estimatedValue: 0, estimatedValuePS: 0, notes: '' });
      // O `?ficha=` do link vence a regra da etapa; sem ele, a aba é decidida quando o lead e os contratos chegam.
      const pedida = item?.id ? fichaPedida.current : null;
      fichaPedida.current = null;
      abaDoLeadDecidida.current = pedida ? Number(item.id) : null;
      setLeadTab(pedida || 'dados');
      setResumoDaAba(null);
      if (item?.id) lerLead(Number(item.id), (atual) => setForm(atual));
      else { leadSendoLido.current = null; setLeituraDoLead(null); }
    }
    if (type === 'ddr') setRecusasDoDdr([]);
    if (type === 'ddr') setForm(item ? { ...item } : { clientId: 0, phoneNumber: '', city: '', state: '', carrier: 'TIP', carrierId: null, hostCarrier: '', hostCarrierId: null, technology: 'Trunk', techPrefix: '', channels: '', status: 'Ativo', contractNumber: '', appUrl: '', notes: '' });
  };
  // O QUE ESTÁ ABERTO, NA URL (15/10/2026): a ficha leva "?cliente=<id>" / "?lead=<id>" enquanto está aberta (o
  // `endereco` da casca), e o F5 ou o link colado reabre. Lido UMA vez, já com login e usuário: tira o parâmetro da
  // entrada de baixo (replace), senão fechar a ficha voltaria para uma URL que a reabre. Sem permissão da tela, ignorado.
  const ABERTOS_NA_URL: Array<{ chave: string; modal: string; tela: string }> = [
    { chave: 'cliente', modal: 'client', tela: 'clients' },
    { chave: 'lead', modal: 'lead', tela: 'leads' },
  ];
  const abertoDaUrlLido = useRef(false);
  useEffect(() => {
    if (!isAuth || !user || abertoDaUrlLido.current) return;
    abertoDaUrlLido.current = true;
    const achado = ABERTOS_NA_URL.map((a) => ({ ...a, id: idDoParametro(window.location.search, a.chave) })).find((a) => a.id != null);
    if (!achado) return;
    let resto = window.location.search;
    for (const a of ABERTOS_NA_URL) resto = semParametro(resto, a.chave);
    // A aba da ficha do lead (`?ficha=`) sai da entrada de baixo junto com o `?lead=` e vai para a da casca.
    if (achado.chave === 'lead') fichaPedida.current = abaDoLeadDaUrl(new URLSearchParams(window.location.search).get('ficha'));
    resto = semParametro(resto, 'ficha');
    navigate({ pathname: window.location.pathname, search: resto }, { replace: true });
    if (podeVer(achado.tela)) openModal(achado.modal, { id: achado.id });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, user]);

  const closeModal = () => { clienteSendoLido.current = null; setLeituraDoCliente(null); assinaturaSendoLida.current = null; assinaturaCarregada.current = null; setLeituraDaAssinatura(null); setAssinaturaMudouPorFora(false); leadSendoLido.current = null; setLeituraDoLead(null); setRateioDaAssinatura(null); setModal(null); setEditing(null); setForm({}); setLeadTab('dados'); setClientLocations([]); setClientModalTab('dados'); setContractModalTab('produtos'); setClientContacts([]); setClientContactDraft(null); };

  // Carrega contatos do cliente quando a aba "Contatos" é aberta no modal de cliente.
  // ⛔ A carga dos contatos vira estado (08/10/2026, Fase 2 tela 3b): o catch dava um toast e a aba seguia com
  // "Nenhum contato cadastrado. Use Adicionar", afirmando o vazio e convidando a duplicar.
  const cargaDosContatos = useEstadoDaCarga();
  const loadClientContacts = async (clientId: number) => {
    setClientContactsLoading(true);
    setClientContacts([]);
    await cargaDosContatos.rodar(async () => {
      const data = await clientContactsService.getByClient(clientId);
      setClientContacts(Array.isArray(data) ? data : []);
    });
    setClientContactsLoading(false);
  };

  const saveClientContact = async (draft: any, clientId: number) => {
    try {
      const payload = {
        clientId,
        nome: (draft.nome || '').trim(),
        email: (draft.email || '').trim() || undefined,
        telefone: (draft.telefone || '').replace(/\D/g, '') || undefined,
        type: draft.type || 'Suporte',
        principal: !!draft.principal,
      };
      if (!payload.nome) {
        showToast('Nome é obrigatório', 'warning');
        return;
      }
      if (draft.id) {
        await clientContactsService.update(draft.id, payload);
      } else {
        await clientContactsService.create(payload);
      }
      setClientContactDraft(null);
      await loadClientContacts(clientId);
      showToast('Contato salvo!', 'success');
    } catch (e: any) {
      showToast(e?.response?.data?.message || 'Erro ao salvar contato', 'error');
    }
  };

  const removeClientContact = async (id: number, clientId: number) => {
    if (!(await confirmar({ title: 'Remover este contato?', danger: true, confirmLabel: 'Remover' }))) return;
    try {
      await clientContactsService.delete(id);
      await loadClientContacts(clientId);
      showToast('Contato removido', 'success');
    } catch (e) {
      showToast('Erro ao remover contato', 'error');
    }
  };

  // Permissions modal functions
  // ⛔ FALHA FECHADA (07/10/2026). Antes, se a leitura das permissões do usuário falhava, a tela carregava os PADRÕES
  // DO PAPEL e os mostrava como se fossem as permissões dele; "Salvar" gravava o padrão por cima das permissões
  // customizadas reais. E se a lista de permissões existentes falhava, a tela dizia "Nenhuma permissao encontrada",
  // oferecia o seed e deixava "Salvar" gravar a lista VAZIA. O backend devolve [] para o usuário sem permissão própria
  // (nunca null): o ramo dos padrões só era alcançado por FALHA. Agora qualquer falha da leitura vira erro na tela, e
  // nada se mostra como permissão lida nem se grava até a leitura dar certo. Padrão do papel só pelo botão explícito.
  const openPermissionsModal = async (targetUser: any) => {
    setPermissionsModal(targetUser);
    setLoadingPermissions(true);
    setErroDasPermissoes(null);
    setUserPermissions([]);
    setGroupedPermissions({});
    try {
      const [perms, grouped] = await Promise.all([
        permissionsService.getByUser(targetUser.id),
        permissionsService.getGrouped(),
      ]);
      if (!Array.isArray(perms)) throw new Error('o servidor não devolveu a lista de permissões do usuário');
      setGroupedPermissions(grouped || {});
      setUserPermissions(perms.map((p: any) => p.code || p));
      setPermissoesAoAbrir(perms.map((p: any) => p.code || p));
    } catch (e) {
      setErroDasPermissoes(mensagemDoErroDeCarga(e));
    }
    setLoadingPermissions(false);
  };

  const closePermissionsModal = () => {
    setPermissionsModal(null);
    setErroDasPermissoes(null);
    setUserPermissions([]);
    setGroupedPermissions({});
  };

  const togglePermission = (code: string) => {
    setUserPermissions(prev =>
      prev.includes(code)
        ? prev.filter(p => p !== code)
        : [...prev, code]
    );
  };

  const toggleModulePermissions = (moduleName: string) => {
    const modulePerms = (groupedPermissions[moduleName] || []).map((p: any) => p.code);
    const allEnabled = modulePerms.every((p: string) => userPermissions.includes(p));
    if (allEnabled) {
      setUserPermissions(prev => prev.filter(p => !modulePerms.includes(p)));
    } else {
      setUserPermissions(prev => Array.from(new Set([...prev, ...modulePerms])));
    }
  };

  const applyDefaultPermissions = async () => {
    if (!permissionsModal) return;
    setLoadingPermissions(true);
    try {
      const defaults = await permissionsService.getDefaultsForRole(permissionsModal.role);
      const padrao: string[] = defaults.permissions || [];
      // D8: trocava as personalizadas pelo padrão sem dizer que substituía.
      if (!(await confirmar(confirmacaoDoPadraoDoPerfil(permissionsModal.name, userPermissions, padrao)))) { setLoadingPermissions(false); return; }
      setUserPermissions(padrao);
    } catch (e) {
      showToast(`Não consegui ler o padrão do perfil: ${mensagemDoErroDeCarga(e)}`, 'error');
    }
    setLoadingPermissions(false);
  };

  const savePermissions = async () => {
    if (!permissionsModal || erroDasPermissoes) return;
    setSavingPermissions(true);
    try {
      await permissionsService.assignToUser(permissionsModal.id, userPermissions);
      showToast('Permissões salvas com sucesso', 'success');
      closePermissionsModal();
    } catch {
      showToast('Erro ao salvar permissões', 'error');
    }
    setSavingPermissions(false);
  };

  const runPermissionsSeed = async () => {
    setLoadingPermissions(true);
    try {
      const result = await permissionsService.seed();
      showToast(`Seed executado: ${result.created} criadas, ${result.existing} existentes`, 'success');
      // Reload permissions
      const grouped = await permissionsService.getGrouped();
      setGroupedPermissions(grouped);
    } catch (err: any) {
      showToast(err?.response?.data?.message || 'Erro ao executar seed', 'error');
    }
    setLoadingPermissions(false);
  };

  const [applyingDefaultsRole, setApplyingDefaultsRole] = useState<string | null>(null);

  const applyDefaultsToAllUsersOfRole = async (role: string, roleName: string) => {
    if (!(await confirmar({ title: `Aplicar permissões padrão a TODOS os usuários com perfil "${roleName}"?`, consequence: 'As permissões atuais desses usuários são substituídas pelo padrão do perfil.', confirmLabel: 'Aplicar' }))) return;
    setApplyingDefaultsRole(role);
    try {
      const result = await permissionsService.applyDefaultsToRole(role);
      showToast(`Permissões aplicadas a ${result.updated} usuários: ${result.users.join(', ')}`, 'success');
    } catch (err: any) {
      showToast(err?.response?.data?.message || 'Erro ao aplicar permissões', 'error');
    }
    setApplyingDefaultsRole(null);
  };

  const save = async () => {
    setSaving(true);
    try {
      let result;
      const action = editing ? 'Atualizou' : 'Criou';
      if (modal === 'product') {
        // As faixas têm rota própria: o PUT do produto não as toca (o backend as ignora).
        const { priceTiers, ...productFields } = form;
        result = editing ? await productsService.update(editing.id, productFields) : await productsService.create(productFields);
        if (Array.isArray(priceTiers) && (editing || priceTiers.length > 0)) {
          await productsService.updatePriceTiers(result.id, priceTiers.map((t: any) => ({ minQuantity: Number(t.minQuantity) || 1, unitPrice: Number(t.unitPrice) || 0 })));
        }
        logActivity(action, `produto: ${form.name || 'Novo produto'}`);
      }
      else if (modal === 'client') {
        // O NF Manual saiu (04/11/2026): o cliente carregado antes de a coluna sumir ainda o traz, e ele não volta ao servidor.
        const { phones, emails, manualFiscalEmission: _nfManual, ...clientFields } = form;
        // Vencimento obrigatório: Dia Venc. (1–31) OU Prazo em dias — decisão 16/06
        // (sem default) + 02/07 (prazo em dias substitui o dia fixo quando preenchido).
        const dueDayNum = parseInt(form.dueDay);
        const paymentTermDaysNum = parseInt(form.paymentTermDays);
        const hasPrazo = paymentTermDaysNum > 0;
        if (!hasPrazo && (!dueDayNum || dueDayNum < 1 || dueDayNum > 31)) {
          showToast('Informe o Dia de Vencimento (1–31) ou um Prazo em dias — um dos dois é obrigatório.', 'warning');
          setSaving(false);
          return;
        }
        const financialEmail = emails?.find((e: any) => e.type === 'Financeiro')?.email || '';
        const clientData = { ...clientFields, dueDay: hasPrazo ? null : dueDayNum, paymentTermDays: hasPrazo ? paymentTermDaysNum : null, dueMonthOffset: hasPrazo ? 0 : (parseInt(form.dueMonthOffset) || 0), emailFinancial: financialEmail, phone: phones?.[0]?.phone || '', emailDeliveryType: form.emailDeliveryType || 'nf_fatura_boleto', includeXmlInEmail: form.includeXmlInEmail || false, zipFiscalAttachments: form.zipFiscalAttachments || false, splitFiscalInvoices: form.splitFiscalInvoices || false, approvalDeferredDay: form.approvalDeferredDay ?? null, approvalDeferredReason: form.approvalDeferredReason?.trim() || null };

        // Verificar se está inativando o cliente
        if (editing && form.status === 'Inativo' && editing.status !== 'Inativo') {
          // ⛔ Contratos e DDRs ativos lidos NO SERVIDOR, não da memória (08/10/2026). A lista de DDRs da memória vem de
          // uma carga que falha calada: com ela vazia, o cliente era inativado sem pergunta e os DDRs ficavam Ativos.
          // Sem a leitura, não inativa (utils/dependenciasDoCliente).
          const dependencias = await lerDependenciasAtivas(editing.id);
          if ('motivo' in dependencias) {
            showToast(recusaSemDependencias(nomeDeExibicao(editing, 'o cliente'), dependencias.motivo), 'error');
            setSaving(false);
            return;
          }
          const clientContracts = dependencias.contratos;
          const clientActiveDDRs = dependencias.ddrs;

          if (clientContracts.length > 0 || clientActiveDDRs.length > 0) {
            // Tem contratos ou DDRs ativos - mostrar modal de confirmação
            setInactivateClientModal({
              client: { ...editing, ...clientData },
              activeContracts: clientContracts,
              activeDDRs: clientActiveDDRs
            });
            setSaving(false);
            return; // Não salva ainda - aguarda confirmação
          }
        }

        result = editing ? await clientsService.update(editing.id, clientData) : await clientsService.create(clientData);
        const clientId = result?.id || editing?.id;
        if (clientId) {
          // Apaga o que está no servidor AGORA e recria a partir do formulário.
          //
          // ⛔ A lista tem que vir do servidor, não de `editing`. `editing` é a
          // foto do cliente de quando o modal abriu: salvando duas vezes sem
          // fechar a tela, o segundo save tentava apagar ids que o primeiro já
          // tinha apagado, os DELETE voltavam 404, o `catch {}` engolia os três
          // em silêncio e os novos eram criados POR CIMA dos que já estavam lá.
          // Foi assim que a FARMACIA DOS TRABALHADORES (cliente 320) ficou com o
          // mesmo e-mail três vezes em 23/09/2026 — e o modal de envio de fatura
          // não deduplica, então mandaria a mesma fatura três vezes ao cliente.
          //
          // ⛔ E a falha do DELETE NÃO pode ser engolida: se a limpeza não
          // aconteceu, recriar duplica. Sem try/catch aqui de propósito — o erro
          // sobe para o catch do handleSave e o usuário vê, em vez de receber um
          // "salvo com sucesso" que deixou lixo para trás.
          if (editing) {
            const [telefonesAtuais, emailsAtuais] = await Promise.all([
              clientPhonesService.getByClient(clientId),
              clientEmailsService.getByClient(clientId),
            ]);
            await Promise.all([
              ...(Array.isArray(telefonesAtuais) ? telefonesAtuais : []).map((p: any) => clientPhonesService.delete(p.id)),
              ...(Array.isArray(emailsAtuais) ? emailsAtuais : []).map((e: any) => clientEmailsService.delete(e.id)),
            ]);
          }
          // Create new phones
          for (const p of (phones || [])) { if (p.phone?.trim()) { await clientPhonesService.create({ clientId, phone: p.phone, type: p.type || 'Comercial', isPrimary: p.isPrimary || false }); } }
          // Create new emails
          for (const e of (emails || [])) { if (e.email?.trim()) { await clientEmailsService.create({ clientId, email: e.email, type: e.type || 'Geral', isPrimary: e.isPrimary || false }); } }
        }
        logActivity(action, `cliente: ${nomeDeExibicao(form, 'Novo cliente')}`);
      }
      else if (modal === 'contract') {
        // Filtrar apenas itens válidos (objetos com productId válido, não arrays vazios)
        const cleanItems = (form.items || [])
          .filter((i: any) => i && typeof i === 'object' && !Array.isArray(i) && i.productId && Number(i.productId) > 0)
          .map((i: any) => {
            // Buscar dados atualizados do produto do catálogo
            const prod = products.find((p: any) => Number(p.id) === Number(i.productId));
            // ⛔ `...i` PRIMEIRO, e só depois o que a tela edita. Esta lista era
            // montada do zero, com os campos que a tela conhecia: tudo que o
            // backend gravou e não estava nela sumia no próximo Salvar, com o PUT
            // respondendo 200. Foi o que ameaçou a vigência do item (Sorriso,
            // contrato 114: R$ 999,00 que só existe a partir de 03/11/2026 seria
            // cobrado cheio já em outubro). Campo novo do backend sobrevive por
            // padrão; é o mesmo modo de falha do `parseItems` do lado de lá.
            return {
              ...i,
              productId: Number(i.productId),
              productCode: prod?.code || i.productCode || '',
              name: prod?.name || i.name || '',
              description: i.description || prod?.description || '',
              detailedDescription: i.detailedDescription || prod?.description || '',
              type: prod?.type || i.type || 'MRR',
              quantity: Number(i.quantity) || 1,
              unitValue: Number(i.unitValue) || 0,
              discount: Number(i.discount) || 0,
              totalValue: Number(i.totalValue) || 0,
              observation: i.observation || '',
              installments: Number(i.installments) || 0,
              paidInstallments: Number(i.paidInstallments) || 0,
              locationId: i.locationId || null,
              locationName: i.locationName || '',
              locationCnpj: i.locationCnpj || '',
              ...(i.discountTargetProductId ? { discountTargetProductId: Number(i.discountTargetProductId) } : {})
            };
          });
        const payload = { ...form, items: cleanItems, mrr: mrrVigenteDosItens(cleanItems), contractStartDate: form.startDate || form.contractStartDate, contractEndDate: form.endDate || form.contractEndDate || null };
        result = editing ? await contractsService.update(editing.id, payload) : await contractsService.create(payload);
        logActivity(action, `contrato #${editing?.id || 'novo'}`);
      }
      else if (modal === 'user') {
        const recusa = editing ? recusaDaEdicaoDoUsuario(editing, form, user, users) : null;
        if (recusa) { avisar(`Não salvei: ${recusa}`, 'warning'); setSaving(false); return; }
        const p = {...form};
        if (editing) {
          if (!p.password) delete p.password;
          delete p.sendWelcomeEmail;
          result = await usersService.update(editing.id, p);
        } else {
          if (!p.password) delete p.password; // backend generates temp password
          result = await usersService.create(p);
          if (result.tempPassword) {
            setShowGenerated(result.tempPassword);
          }
        }
        logActivity(action, `usuário: ${form.name || 'Novo usuário'}`);
      }
      else if (modal === 'lead') {
        const missing: string[] = [];
        if (!form.contactName?.trim()) missing.push('Nome do Contato');
        if (!form.email?.trim()) missing.push('Email');
        if (missing.length) { avisar(`Preencha os campos obrigatórios:\n• ${missing.join('\n• ')}`, 'warning'); setSaving(false); return; }
        // A trava do botão é a primeira linha; esta é a segunda, para qualquer caminho que chame o salvar.
        if (porqueLeadTravado) { avisar(`Não salvei: ${porqueLeadTravado}`, 'warning'); setSaving(false); return; }
        // ⛔ A ETAPA vai pelo PATCH /status, nunca pelo PUT (09/10/2026). Pelo PUT, Perdido passava sem motivo (o PATCH
        // exige desde 06/07) e o log dizia só "Lead atualizado", sem de→para: a mudança de etapa feita no modal (barra do
        // funil, select Status, Marcar Ganho/Perdido) não deixava rastro de etapa. O PUT leva o resto, sem status: assim
        // ele também não devolve a etapa que outra pessoa mudou no board depois da leitura.
        const etapaAtual = editing ? editing.status : 'Novo';
        const novaEtapa = form.status || 'Novo';
        let motivo: string | undefined;
        if (novaEtapa !== etapaAtual && novaEtapa === 'Perdido') {
          const jaTem = String(form.lostReason || '').trim();
          const r = jaTem || await pedirTexto({
            title: 'Marcar como perdido?',
            message: 'Motivos comuns: preço, concorrência, timing, sem resposta, sem orçamento.',
            label: 'Motivo da perda',
            placeholder: 'Ex.: preço acima do concorrente',
            confirmLabel: 'Marcar perdido',
            obrigatorio: true,
          });
          if (r === null) { setSaving(false); return; }
          motivo = r;
        }
        const { status: _status, lostReason: _motivo, ...campos } = form;
        // B1: o nextActionDoneAt é só de leitura (fora do DTO na #411); concluir é o PATCH próprio.
        result = editing ? await leadsService.update(editing.id, semCamposSoDeLeitura(campos)) : await leadsService.create({ ...semCamposSoDeLeitura(campos), status: 'Novo' });
        if (novaEtapa !== etapaAtual && result?.id) result = await leadsService.updateStatus(result.id, novaEtapa, motivo);
        // ⛔ Criar lead FECHAVA o modal, e as abas que dependem do id
        // (Propostas, Histórico) ficavam marcadas "salve primeiro".
        // Ou seja: o único jeito de chegar nelas era salvar, ser expulso da
        // tela, achar o card no board e abrir o lead de novo — para continuar
        // exatamente de onde você estava. Salvar é o que LIBERA as abas, então
        // era justamente a hora errada de fechar.
        //
        // Agora o modal vira modo edição no lugar: mesmo lead, abas liberadas,
        // sem sair da tela. Editar um lead existente continua fechando ao
        // salvar — ali nada é liberado pelo save, e "Salvar" já significa
        // "terminei" há tempo demais para mudar de sentido.
        if (!editing && result?.id) {
          setEditing(result);
          setForm((f: any) => ({ ...f, ...result }));
          await loadData();
          showToast('Lead criado — Propostas e Histórico liberados', 'success');
          setSaving(false);
          return;
        }
      }
      else if (modal === 'ddr') {
        // Remove client object from form (it's a relation, not a field)
        const { client, ...ddrData } = form;
        result = editing ? await clientDDRsService.update(editing.id, ddrData) : await clientDDRsService.create(ddrData);
        logActivity(action, `DDR: ${form.phoneNumber || 'Novo DDR'}`);
      }
      if (result?.error) { avisar(result.error, 'error'); setSaving(false); return; }
      // ⛔ Antes: `await loadData()` — que rebaixa a base INTEIRA, incluindo
      // `GET /client-ddrs` com 5.853 linhas e 16 MB. Salvar um toggle de cliente
      // custava esse download, e era isso que fazia o botão ficar em "Salvando..."
      // por segundos. O backend devolve o registro salvo; basta trocá-lo na lista
      // que já está em memória. Sem `result.id` (formato inesperado) cai no
      // recarregamento completo, que é o comportamento antigo.
      const colecao: Record<string, [any[], React.Dispatch<React.SetStateAction<any[]>>]> = {
        product: [products, setProducts],
        client: [clients, setClients],
        contract: [contracts, setContracts],
        lead: [leads, setLeads],
        ddr: [clientDDRs, setClientDDRs],
      };
      const alvo = colecao[modal];
      if (alvo && result?.id) {
        const [lista, setLista] = alvo;
        setLista(editing
          ? lista.map((x: any) => (x.id === result.id ? { ...x, ...result } : x))
          : [...lista, result]);
        // Os contadores do topo da tela de DDRs vêm de outro endpoint, e são 1 KB.
        if (modal === 'ddr') clientDDRsService.getStats().then(setDdrStats).catch(() => {});
      } else {
        await loadData();
      }
      closeModal();
    } catch (e: any) {
      console.error(e);
      const errorData = e?.response?.data?.message;
      const errorMsg = Array.isArray(errorData) ? errorData.join('\n') : (errorData || e?.message || '');
      if (errorMsg.includes('clients_cnpj_key') || errorMsg.includes('duplicate key')) {
        avisar('CNPJ já cadastrado!\n\nJá existe um cliente com este CNPJ no sistema.\nBusque pelo CNPJ na lista de clientes para editar.', 'error');
      } else {
        avisar(`Erro ao salvar${errorMsg ? ':\n' + errorMsg : ''}`, 'error');
      }
    }
    setSaving(false);
  };

  // Confirmar inativação do cliente (cancelar contratos e marcar DDRs como inativos)
  const confirmInactivateClient = async () => {
    if (!inactivateClientModal) return;
    setProcessingInactivation(true);
    try {
      const { client, activeContracts, activeDDRs } = inactivateClientModal;
      const today = getTodayStr();

      // 1. Cancelar todos os contratos ativos
      for (const contract of activeContracts) {
        await contractsService.update(contract.id, {
          ...contract,
          status: 'Cancelado',
          contractEndDate: today,
          notes: (contract.notes || '') + `\n[${new Date().toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}] Cancelado automaticamente - Cliente inativado`
        });
      }

      // 2. Marcar DDRs como inativos
      for (const ddr of activeDDRs) {
        await clientDDRsService.update(ddr.id, { ...ddr, status: 'Inativo' });
      }

      // 3. Salvar cliente como inativo
      // ⛔ Pela linha da lista (D2, 12/10/2026) não há ficha aberta: o `form` está vazio, e montar o cliente a partir
      // dele apagaria telefone e e-mail financeiro. Dali vai SÓ o status (o servidor faz Object.assign do que chega).
      const { phones, emails, ...clientFields } = form;
      if (editing) {
        const financialEmail = emails?.find((e: any) => e.type === 'Financeiro')?.email || '';
        const clientData = { ...clientFields, dueDay: parseInt(form.dueDay) || (parseInt(form.paymentTermDays) > 0 ? null : 10), emailFinancial: financialEmail, phone: phones?.[0]?.phone || '', status: 'Inativo' };
        await clientsService.update(client.id || editing?.id, clientData);
      } else {
        await clientsService.update(client.id, { status: 'Inativo' });
      }

      // 4. Atualizar phones/emails se necessário
      const clientId = client.id || editing?.id;
      if (clientId && editing) {
        // Mesma regra do handleSave: a lista vem do servidor, não de `editing`,
        // e a falha do DELETE sobe em vez de virar duplicata silenciosa.
        const [telefonesAtuais, emailsAtuais] = await Promise.all([
          clientPhonesService.getByClient(clientId),
          clientEmailsService.getByClient(clientId),
        ]);
        await Promise.all([
          ...(Array.isArray(telefonesAtuais) ? telefonesAtuais : []).map((p: any) => clientPhonesService.delete(p.id)),
          ...(Array.isArray(emailsAtuais) ? emailsAtuais : []).map((e: any) => clientEmailsService.delete(e.id)),
        ]);
        for (const p of (phones || [])) { if (p.phone?.trim()) { await clientPhonesService.create({ clientId, phone: p.phone, type: p.type || 'Comercial', isPrimary: p.isPrimary || false }); } }
        for (const e of (emails || [])) { if (e.email?.trim()) { await clientEmailsService.create({ clientId, email: e.email, type: e.type || 'Geral', isPrimary: e.isPrimary || false }); } }
      }

      logActivity('Inativou', `cliente: ${nomeDeExibicao(client)} (${activeContracts.length} contratos cancelados, ${activeDDRs.length} DDRs inativados)`);
      showToast(`Cliente inativado! ${activeContracts.length} contrato(s) cancelado(s), ${activeDDRs.length} DDR(s) inativado(s).`, 'success');

      await loadData();
      closeModal();
      setInactivateClientModal(null);
    } catch (error: any) {
      console.error('Erro ao inativar cliente:', error);
      showToast('Erro ao inativar cliente: ' + (error.response?.data?.message || error.message), 'error');
    }
    setProcessingInactivation(false);
  };

  // Exclusão pelo useConfirm (antes: ConfirmModal próprio do App). O texto dizia
  // "usuário" para lead e DDR; agora cada tipo tem o próprio rótulo e o nome do
  // registro aparece em destaque.
  const ROTULO_DA_EXCLUSAO: Record<string, string> = { product: 'produto', client: 'cliente', contract: 'assinatura', user: 'usuário', lead: 'lead', ddr: 'DDR' };
  // D5 (11/10/2026): excluir usuário era hard delete (some a pessoa e o vínculo com a trilha). Desativar corta o acesso
  // na hora e guarda o histórico.
  const desativarUsuario = async (u: any) => {
    const motivo = porqueTravaPapelEAtivo(u, user, users);
    if (motivo) { avisar(motivo, 'warning'); return; }
    if (!(await confirmar(confirmacaoDeDesativar(u)))) return;
    try {
      await usersService.update(u.id, { isActive: false });
      logActivity('Desativou', `usuário: ${u.name}`);
      await loadData();
    } catch (e) {
      avisar(`Não consegui desativar ${u.name}: ${mensagemDoErroDeCarga(e)}.`, 'error');
    }
  };

  /**
   * Inativar pela linha da Lista de Clientes (D2, 12/10/2026). Mesmo caminho da ficha: as dependências ativas são lidas
   * NO SERVIDOR (sem a leitura, não inativa); com contrato ou DDR ativo abre o mesmo modal que cancela e inativa; sem
   * nenhum, confirma e grava só o status.
   */
  const inativarDaLista = async (c: any) => {
    const nome = nomeDeExibicao(c, 'o cliente');
    const dependencias = await lerDependenciasAtivas(c.id);
    if ('motivo' in dependencias) { avisar(recusaSemDependencias(nome, dependencias.motivo), 'error'); return; }
    if (dependencias.contratos.length > 0 || dependencias.ddrs.length > 0) {
      setInactivateClientModal({ client: c, activeContracts: dependencias.contratos, activeDDRs: dependencias.ddrs });
      return;
    }
    if (!(await confirmar({
      title: `Inativar ${nome}?`,
      message: 'Nenhuma assinatura nem DDR ativo.',
      consequence: 'O cliente passa a Inativo e sai do filtro de ativos. Dá para reativar pela ficha, no campo Status.',
      confirmLabel: 'Inativar',
    }))) return;
    try {
      await clientsService.update(c.id, { status: 'Inativo' });
      logActivity('Inativou', `cliente: ${nome} (pela lista; sem assinatura nem DDR ativo)`);
      avisar(`${nome} inativado.`, 'success');
      await loadData();
    } catch (e) {
      avisar(`Não consegui inativar ${nome}: ${mensagemDoErroDeCarga(e)}.`, 'error');
    }
  };

  const setDelConfirm = async (pedido: { type: string; item: any } | null) => {
    if (!pedido) return;
    const { type, item } = pedido;
    // D12: o servidor não confere se o produto está em alguma assinatura (contracts.items é jsonb, sem FK).
    if (type === 'product') {
      const emUso = porqueNaoExcluirProduto(item.id, contracts);
      if (emUso) { avisar(`Não excluí ${item.name}: ${emUso}`, 'warning'); return; }
    }
    const names: Record<string, string> = { product: item.name, client: nomeDeExibicao(item), contract: `#${item.id}`, user: item.name, lead: item.companyName || item.tradeName, ddr: item.phoneNumber };
    let ok: boolean;
    if (type === 'lead') {
      // P2 (11/10/2026): o confirm era "Deseja excluir X?"; as propostas ficam órfãs com o link aberto e o briefing some.
      const c: any = confirmacaoDeExcluirLead(names.lead || `#${item.id}`, await lerImpactoDaExclusao(item.id));
      if (c.recusa) { avisar(c.recusa, 'error'); return; }
      ok = await confirmar(c);
    } else if (type === 'contract') {
      // Assinatura: o confirm nomeia o cliente e diz o que acontece com as faturas e as anualidades, lidas na hora
      // (utils/exclusaoDaAssinatura). Leitura que falha vira "não consegui conferir", nunca "nenhuma".
      const cli = clients.find((c: any) => c.id === item.clientId);
      const [fat, anu] = await Promise.allSettled([
        invoicesService.getByClient(item.clientId),
        contractAdjustmentsService.getByContract(item.id),
      ]);
      const lista = (r: PromiseSettledResult<any>) => (r.status === 'fulfilled' ? (Array.isArray(r.value) ? r.value : r.value?.data) : null);
      const faturas = lista(fat);
      const anualidades = lista(anu);
      const c = confirmacaoDeExcluirAssinatura({
        id: item.id,
        cliente: cli ? nomeDeExibicao(cli) : null,
        faturas: Array.isArray(faturas) ? faturas.filter((f: any) => f.contractId === item.id).length : null,
        anualidades: Array.isArray(anualidades) ? anualidades.length : null,
      });
      ok = await confirmar({ title: c.titulo, message: c.mensagem, danger: true, confirmLabel: 'Excluir', cancelLabel: 'Voltar' });
    } else {
      ok = await confirmar({
        title: `Excluir ${ROTULO_DA_EXCLUSAO[type] || 'registro'}?`,
        message: type === 'product'
          ? <>Nenhuma assinatura usa <strong className='text-white'>{names[type]}</strong>. Excluir apaga o produto e as faixas de preço.</>
          : <>Deseja excluir <strong className='text-white'>{names[type] || `#${item.id}`}</strong>?</>,
        danger: true,
        confirmLabel: 'Excluir',
      });
    }
    if (!ok) return;
    try {
      if (type === 'product') await productsService.delete(item.id);
      if (type === 'client') await clientsService.delete(item.id);
      if (type === 'contract') await contractsService.delete(item.id);
      if (type === 'user') await usersService.delete(item.id);
      if (type === 'lead') await leadsService.delete(item.id);
      if (type === 'ddr') await clientDDRsService.delete(item.id);
      logActivity('Excluiu', `${type}: ${names[type] || item.id}`);
      await loadData();
    } catch (e) {
      // A falha diz o motivo do servidor (era só "Erro"): a assinatura com fatura, por exemplo, o banco recusa.
      avisar(`Não consegui excluir ${ROTULO_DA_EXCLUSAO[type] || 'o registro'} ${names[type] || `#${item.id}`}: ${mensagemDoErroDeCarga(e)}.`, 'error');
    }
  };

  /**
   * A1 e A3 (12/10/2026, bloco A da revisão, aprovado pelo Heitor): a trilha de etapas e o ⋯ do selo GRAVAM NA HORA,
   * pelo PATCH /status (o mesmo do board, que registra de→para no histórico), depois de perguntar. Gravado, a ficha
   * acompanha: editing e form passam a ter o status do servidor, para o Salvar não mover de novo.
   */
  const [congelandoLead, setCongelandoLead] = useState<{ reason: string; frozenUntil: string } | null>(null);
  const nomeDoLead = (l: any) => l?.tradeName || l?.companyName || l?.name || 'o lead';
  const aplicarStatusNaFicha = (atualizado: any) => {
    setEditing((e: any) => (e ? { ...e, ...atualizado } : e));
    setForm((f: any) => ({ ...f, status: atualizado.status, lostReason: atualizado.lostReason ?? f.lostReason }));
    updateLeadLocal(atualizado);
  };
  const gravarStatusDoLead = async (status: string, lostReason?: string) => {
    if (!editing) return;
    try {
      const atualizado = await leadsService.updateStatus(editing.id, status, lostReason);
      aplicarStatusNaFicha({ id: editing.id, ...atualizado, status: atualizado?.status || status });
      avisar(`${nomeDoLead(editing)}: ${status}.`, 'success');
    } catch (e) {
      avisar(`Não mudei a etapa de ${nomeDoLead(editing)}: ${motivoDoServidor(e)}`, 'error');
    }
  };
  const moverEtapaDoLead = async (para: string) => {
    if (!editing || editing.status === para) return;
    if (!(await confirmar(confirmacaoDeMover(nomeDoLead(editing), editing.status || 'Novo', para)))) return;
    await gravarStatusDoLead(para);
  };
  const marcarGanhoDoLead = async () => {
    if (!editing || !(await confirmar(confirmacaoDeGanho(nomeDoLead(editing))))) return;
    await gravarStatusDoLead('Ganho');
  };
  const marcarPerdidoDoLead = async () => {
    if (!editing) return;
    const reason = await pedirTexto({
      title: 'Marcar como perdido?',
      message: 'Motivos comuns: preço, concorrência, timing, sem resposta, sem orçamento.',
      label: 'Motivo da perda',
      placeholder: 'Ex.: preço acima do concorrente',
      confirmLabel: 'Marcar perdido',
      obrigatorio: true,
    });
    if (reason === null) return;
    await gravarStatusDoLead('Perdido', reason);
  };
  const congelarDaFicha = async () => {
    if (!editing || !congelandoLead) return;
    try {
      const res = await leadsService.freeze(editing.id, {
        frozenUntil: congelandoLead.frozenUntil || undefined,
        reason: congelandoLead.reason || undefined,
      });
      aplicarStatusNaFicha({ id: editing.id, ...res, status: res?.status || 'Congelado' });
      avisar('❄ Lead congelado', 'success');
      setCongelandoLead(null);
    } catch (e) {
      avisar(`Não congelei ${nomeDoLead(editing)}: ${motivoDoServidor(e)}`, 'error');
    }
  };

  /** B1 (#411): concluir a próxima ação (carimba a data e limpa texto e prazo no servidor) e a ficha acompanha. */
  const concluirProximaAcao = async (lead: any) => {
    try {
      const atualizado = await leadsService.concluirProximaAcao(lead.id);
      const novo = { id: lead.id, ...atualizado };
      updateLeadLocal(novo);
      if (editing?.id === lead.id) {
        setEditing((e: any) => (e ? { ...e, ...novo } : e));
        setForm((fm: any) => ({ ...fm, nextActionText: novo.nextActionText ?? null, nextActionAt: novo.nextActionAt ?? null, nextActionDoneAt: novo.nextActionDoneAt ?? null }));
      }
      avisar(`Próxima ação de ${lead.tradeName || lead.companyName || 'o lead'} concluída.`, 'success');
    } catch (e) {
      avisar(`Não concluí: ${fraseDaRecusaDoConcluir(e)}`, 'error');
    }
  };

  const updateLeadStatus = async (id: number, status: string, lostReason?: string) => {
    try {
      const updated = await leadsService.updateStatus(id, status, lostReason);
      setLeads((prev: any[]) => prev.map((l: any) => l.id === id ? { ...l, ...updated } : l));
    } catch (e: any) {
      console.error(e);
      showToast(e?.response?.data?.message || 'Erro ao atualizar status do lead', 'error');
    }
  };

  const updateLeadLocal = (lead: any) => setLeads((prev: any[]) => prev.map((l: any) => l.id === lead.id ? { ...l, ...lead } : l));
  const removeLeadLocal = (id: number) => setLeads((prev: any[]) => prev.filter((l: any) => l.id !== id));

  const changePassword = async () => {
    const { current, new: newPwd, confirm } = passwordForm;
    if (!current || !newPwd || !confirm) { avisar('Preencha todos os campos', 'warning'); return; }
    if (newPwd !== confirm) { avisar('As senhas não coincidem', 'warning'); return; }
    const pwdError = validatePassword(newPwd);
    if (pwdError) { avisar(pwdError, 'error'); return; }
    setSaving(true);
    try {
      await authService.changePassword({ currentPassword: current, newPassword: newPwd });
      avisar('Senha alterada com sucesso!', 'success'); setProfileModal(false); setPasswordForm({ current: '', new: '', confirm: '' });
    } catch (e: any) {
      console.error(e);
      avisar(e.response?.data?.message || 'Erro ao alterar senha', 'error');
    }
    setSaving(false);
  };

  // MFA handlers
  const handleMfaSetup = async () => {
    setMfaLoading(true);
    try {
      const data = await authService.setupMfa();
      if (data.error) { avisar(data.error, 'error'); return; }
      setMfaQrDataUrl(data.qrDataUrl);
      setMfaSetupToken(data.setupToken);
      setMfaSetupStep('qr');
      setMfaSetupCode('');
    } catch (e: any) {
      avisar(e.response?.data?.message || 'Erro ao iniciar configuracao MFA', 'error');
    }
    setMfaLoading(false);
  };

  const handleMfaSetupVerify = async () => {
    if (mfaSetupCode.length !== 6) return;
    setMfaLoading(true);
    try {
      const data = await authService.verifyMfaSetup(mfaSetupToken, mfaSetupCode);
      setMfaBackupCodes(data.backupCodes);
      setMfaEnabled(true);
      setMfaSetupStep('backup');
    } catch (e: any) {
      avisar(e.response?.data?.message || 'Codigo invalido', 'error');
    }
    setMfaLoading(false);
  };

  const handleMfaDisable = async () => {
    if (!mfaDisableCode) return;
    setMfaLoading(true);
    try {
      await authService.disableMfa(mfaDisableCode);
      setMfaEnabled(false);
      setMfaDisableCode('');
      avisar('MFA desativado com sucesso', 'success');
    } catch (e: any) {
      avisar(e.response?.data?.message || 'Codigo invalido', 'error');
    }
    setMfaLoading(false);
  };

  // Passkey handlers
  const handlePasskeyRegister = async () => {
    setPasskeyLoading(true);
    try {
      const options = await authService.webauthnRegisterBegin();
      const regResp = await startRegistration({ optionsJSON: options });
      await authService.webauthnRegisterComplete(JSON.stringify(regResp), passkeyDeviceName || undefined);
      setPasskeyDeviceName('');
      const creds = await authService.webauthnListCredentials();
      setPasskeyCredentials(creds);
      avisar('Passkey registrada com sucesso!', 'success');
    } catch (err: any) {
      if (err.name === 'NotAllowedError') {
        avisar('Registro cancelado ou nao permitido pelo navegador', 'warning');
      } else {
        avisar(err.response?.data?.message || 'Erro ao registrar passkey', 'error');
      }
    }
    setPasskeyLoading(false);
  };

  const handlePasskeyDelete = async (id: number) => {
    if (!(await confirmar({ title: 'Remover esta passkey?', danger: true, confirmLabel: 'Remover', consequence: 'O dispositivo deixa de entrar sem senha.' }))) return;
    try {
      await authService.webauthnDeleteCredential(id);
      setPasskeyCredentials((prev) => prev.filter((c) => c.id !== id));
    } catch (err: any) {
      avisar(err.response?.data?.message || 'Erro ao remover passkey', 'error');
    }
  };

  /**
   * Desativa o MFA de um usuário, inclusive o SEU.
   *
   * O botão ficava escondido na própria linha (`u.id !== user?.id`), com a
   * intenção boa de evitar que o admin se trancasse. Só que o backend nunca teve
   * essa restrição, e o esconderijo cobrou caro em 28/09/2026: o Heitor perdeu a
   * entrada do autenticador e os códigos de backup, e o único caminho que
   * sobrou foi outro agente rodar o `disableMfa` no servidor. Com o botão à
   * mão, era um clique.
   *
   * Trancar não é o risco que parecia: o gate do MFA (DEM-95) manda quem está
   * com `mfaEnabled=false` para a tela de CADASTRO em vez de recusar o login.
   * O risco real é outro, e é o que a confirmação precisa dizer — medido no
   * `disableMfa` do backend: ele apaga segredo e códigos de backup, REVOGA os
   * dispositivos confiáveis e sobe o `tokenVersion`. Na própria conta isso
   * derruba a sessão no ato.
   */
  const handleAdminDisableMfa = async (alvo: any) => {
    const ehVoce = alvo?.id === user?.id;
    const aviso = ehVoce
      ? 'Desativar o SEU proprio MFA?\n\n'
        + '• Voce sai de todos os dispositivos agora, inclusive desta aba\n'
        + '• O autenticador e os codigos de backup atuais param de valer\n'
        + '• No proximo login voce cai direto na tela de cadastro do MFA\n\n'
        + 'Tenha o celular em maos antes de continuar.'
      : `Desativar o MFA de ${alvo?.name || 'este usuario'}?\n\n`
        + 'Ele perde o autenticador e os codigos de backup atuais, sai de todos '
        + 'os dispositivos, e cadastra de novo no proximo login.';
    if (!(await confirmar({ title: ehVoce ? 'Desativar o SEU próprio MFA?' : `Desativar o MFA de ${alvo?.name || 'este usuário'}?`, message: aviso, danger: true, confirmLabel: 'Desativar MFA' }))) return;
    try {
      await authService.adminDisableMfa(alvo.id);
      // Na própria conta a sessão já morreu no servidor: qualquer chamada
      // seguinte responderia 401. Sair pela porta é melhor que descobrir isso
      // pelo primeiro request que falhar.
      if (ehVoce) {
        avisar('MFA desativado. Entre de novo para cadastrar.', 'success');
        await handleLogout();
        return;
      }
      avisar('MFA desativado', 'success');
      await loadData();
    } catch (e: any) {
      avisar(e.response?.data?.message || 'Erro ao desativar MFA', 'error');
    }
  };

  // Upload de anexos da assinatura — compartilhado entre o input de arquivo e o
  // drop na zona (drag&drop). Lê categoria/filial dos selects do modal.
  const uploadContractAttachmentFiles = async (files: File[]) => {
    if (!attachmentModal || files.length === 0) return;
    files.filter((f) => f.size > 20 * 1024 * 1024).forEach((f) => setToast({ message: `${f.name}: muito grande. Máximo 20MB`, type: 'error' }));
    const validFiles = files.filter((f) => f.size <= 20 * 1024 * 1024);
    if (validFiles.length === 0) return;
    const selectedCategory = (document.getElementById('attachment-category-select') as HTMLSelectElement)?.value || 'outro';
    const locSelect = document.getElementById('attachment-location-select') as HTMLSelectElement;
    const selectedLocationId = selectedCategory === 'portabilidade' && locSelect?.value ? Number(locSelect.value) : undefined;
    const selectedLocation = selectedLocationId
      ? (allLocations || []).filter((l: any) => l.clientId === attachmentModal.clientId).find((l: any) => l.id === selectedLocationId)
      : undefined;
    setUploadingAttachment(true);
    try {
      for (const file of validFiles) {
        const base64 = await new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result as string);
          reader.readAsDataURL(file);
        });
        await contractsService.addAttachment(attachmentModal.id, {
          filename: file.name,
          fileBase64: base64,
          description: '',
          uploadedBy: user?.name || 'Sistema',
          category: selectedCategory,
          locationId: selectedLocationId,
          locationCode: selectedLocation?.code,
        } as any);
      }
      setToast({ message: validFiles.length > 1 ? `${validFiles.length} anexos adicionados!` : 'Anexo adicionado!', type: 'success' });
      loadData();
      const updated = await contractsService.getAll();
      const refreshedContract = updated.find((c: any) => c.id === attachmentModal.id);
      if (refreshedContract) setAttachmentModal(refreshedContract);
    } catch (err: any) {
      setToast({ message: err.response?.data?.message || 'Erro ao adicionar anexo', type: 'error' });
    } finally {
      setUploadingAttachment(false);
    }
  };

  if (!isAuth) return <Login onLogin={handleLogin} />;

  const totalMRR = contracts.filter((c: any) => c.status === 'Ativo').reduce((s: number, c: any) => s + (parseFloat(String(c.mrr)) || 0), 0);
  const activeClients = clients.filter((c: any) => c.status === 'Ativo').length;
  const activeProducts = products.filter((p: any) => p.status).length;
  const activeContracts = contracts.filter((c: any) => c.status === 'Ativo').length;
  const getClientMRR = (id: number) => contracts.filter((c: any) => c.clientId === id && c.status === 'Ativo').reduce((s: number, c: any) => s + (parseFloat(String(c.mrr)) || 0), 0);
  // Booleano ÚNICO por role, de quando a tela toda tinha a mesma regra. Continua
  // valendo para o que não foi auditado; os módulos que o backend fechou passam
  // pelos canWrite*/canDelete* abaixo (ver src/utils/permissions.ts).
  const canEdit = user?.role === 'admin' || user?.role === 'editor';
  // Escrita por módulo, espelhando os @Roles do backend.
  const canEditProducts = canWriteModule(user, 'products');
  const canEditDDRs = canWriteModule(user, 'ddrs');
  const canEditContracts = canWriteModule(user, 'contracts');
  const canEditInvoices = canWriteModule(user, 'invoices');
  const canEditClients = canWriteModule(user, 'clients');
  const canDeleteClients = canDeleteModule(user, 'clients');
  const canEditReajustes = canWriteModule(user, 'reajustes');

  const filteredUsers = users.filter((u: any) => (u.name || '').toLowerCase().includes(search.toLowerCase()));

  // A4: as etapas ativas do servidor (ou as seis fixas) e os desfechos de sempre.
  const leadStatuses = statusDoSelect(funil);
  const leadSources = ['Site', 'Indicação', 'LinkedIn', 'Telefone', 'Email', 'Evento', 'Outro'];

  return (
    <div className='h-screen bg-central-fundo flex'>
      <ConvocacaoWatcher onOpen={(itemId) => { setLicDeepItemId(itemId); setSection('lic-monitorar'); }} />
      <Sidebar section={section} setSection={setSection} user={user} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} financialBadges={{ ...financialBadges, demandasOpen: demandasOpenCount }} />

      <div className='flex-1 flex flex-col overflow-hidden'>
        <header className='h-16 bg-central-cartao border-b border-central-borda flex items-center justify-between px-6'>
          <div className='flex items-center gap-4'>
            {(() => {
              const financialSections: Record<string, string> = { 'resumo-financeiro': 'Resumo Financeiro', recebiveis: 'Contas a Receber', invoices: 'Faturas', cobranca: 'Cobrança', fiscal: 'Notas Fiscais (NFS-e / NFCom)', boletos: 'Boletos / Sicredi' };
              const clientSections: Record<string, string> = { clients: 'Lista', locations: 'Grupos Econômicos', ddrs: 'Controle de DDRs', contracts: 'Assinaturas' };
              const adminSections: Record<string, string> = { oficios: 'Ofícios', materials: 'Materiais' };
              const simpleSections: Record<string, string> = { dashboard: 'Dashboard', leads: 'Pipeline de Vendas', products: 'Produtos', templates: 'Templates', 'nucleo-propostas': 'Núcleo de propostas', users: 'Usuários', settings: 'Configurações', reports: 'Relatórios' };
              const infraSections: Record<string, string> = { 'aws-reservations': 'Reservas AWS', 'ec2-monitoring': 'Monitor EC2', 'comprasnet-sessao': 'Sessão ComprasNet' };

              if (financialSections[section]) {
                return (
                  <div className='flex items-center gap-2'>
                    <button onClick={() => setSection('resumo-financeiro')} className='text-central-texto-fraco hover:text-central-texto font-semibold transition-colors'>Financeiro</button>
                    <Icon name='chevronRight' className='w-4 h-4 text-central-texto-fraco' />
                    <h2 className='text-white font-semibold'>{financialSections[section]}</h2>
                  </div>
                );
              }
              if (clientSections[section]) {
                return (
                  <div className='flex items-center gap-2'>
                    <button onClick={() => setSection('clients')} className='text-central-texto-fraco hover:text-central-texto font-semibold transition-colors'>Clientes</button>
                    <Icon name='chevronRight' className='w-4 h-4 text-central-texto-fraco' />
                    <h2 className='text-white font-semibold'>{clientSections[section]}</h2>
                  </div>
                );
              }
              if (infraSections[section]) {
                return (
                  <div className='flex items-center gap-2'>
                    <button onClick={() => setSection('aws-reservations')} className='text-central-texto-fraco hover:text-central-texto font-semibold transition-colors'>Infraestrutura</button>
                    <Icon name='chevronRight' className='w-4 h-4 text-central-texto-fraco' />
                    <h2 className='text-white font-semibold'>{infraSections[section]}</h2>
                  </div>
                );
              }
              if (adminSections[section]) {
                return (
                  <div className='flex items-center gap-2'>
                    <button onClick={() => setSection('oficios')} className='text-central-texto-fraco hover:text-central-texto font-semibold transition-colors'>Administrativo</button>
                    <Icon name='chevronRight' className='w-4 h-4 text-central-texto-fraco' />
                    <h2 className='text-white font-semibold'>{adminSections[section]}</h2>
                  </div>
                );
              }
              if (simpleSections[section]) return <h2 className='text-white font-semibold'>{simpleSections[section]}</h2>;
              // Fora dos mapas acima, o caminho do MENU ("Licitações › Monitorar"): antes saía o id cru da tela.
              const titulo = tituloDaSection(section, podeVer);
              if (titulo.pai && titulo.rotulo) {
                return (
                  <div className='flex items-center gap-2' data-titulo-da-barra>
                    {titulo.destinoDoPai
                      ? <button onClick={() => setSection(titulo.destinoDoPai!)} className='text-central-texto-fraco hover:text-central-texto font-semibold transition-colors'>{titulo.pai}</button>
                      : <span className='text-central-texto-fraco font-semibold'>{titulo.pai}</span>}
                    <Icon name='chevronRight' className='w-4 h-4 text-central-texto-fraco' />
                    <h2 className='text-white font-semibold'>{titulo.rotulo}</h2>
                  </div>
                );
              }
              return <h2 className='text-white font-semibold' data-titulo-da-barra>{titulo.rotulo || section}</h2>;
            })()}
          </div>
          <div className='flex items-center gap-2'>
            {/* Global Search */}
            <div className='relative'>
              <button onClick={() => setShowGlobalSearch(!showGlobalSearch)} className='p-2 text-slate-400 hover:text-white hover:bg-central-elevado rounded-lg' title='Buscar (Ctrl+K)'>
                <Icon name='search' className='w-5 h-5' />
              </button>
              {showGlobalSearch && (
                <div className='absolute right-0 top-12 w-96 bg-central-cartao border border-central-borda rounded-xl shadow-2xl overflow-hidden z-50'>
                  <div className='p-3 border-b border-central-borda'>
                    <input type='text' placeholder='Buscar em todo o sistema...' value={globalSearch} onChange={e => setGlobalSearch(e.target.value)} autoFocus className='w-full px-3 py-2 bg-central-elevado border border-central-borda rounded-lg text-white placeholder-slate-500 focus:border-primary' />
                  </div>
                  {globalSearch && (
                    <div className='max-h-80 overflow-y-auto'>
                      {/* Clients Results */}
                      {clients.filter((c: any) => (c.name || c.tradeName || '')?.toLowerCase().includes(globalSearch.toLowerCase()) || c.cnpj?.includes(globalSearch)).slice(0, 3).map((c: any) => (
                        <button key={`client-${c.id}`} onClick={() => { setSection('clients'); setBuscaDaTela({ section: 'clients', termo: c.name || c.tradeName }); setShowGlobalSearch(false); setGlobalSearch(''); }} className='w-full px-4 py-3 flex items-center gap-3 hover:bg-central-elevado text-left'>
                          <div className='p-2 bg-green-500/20 rounded-lg'><Icon name='users' className='w-4 h-4 text-green-400' /></div>
                          <div><p className='text-white font-medium'>{c.name || c.tradeName}</p><p className='text-xs text-slate-500'>Cliente • {fmtCNPJ(c.cnpj)}</p></div>
                        </button>
                      ))}
                      {/* Products Results */}
                      {products.filter((p: any) => p.name?.toLowerCase().includes(globalSearch.toLowerCase()) || p.code?.toLowerCase().includes(globalSearch.toLowerCase())).slice(0, 3).map((p: any) => (
                        <button key={`product-${p.id}`} onClick={() => { setSection('products'); setBuscaDaTela({ section: 'products', termo: p.name }); setShowGlobalSearch(false); setGlobalSearch(''); }} className='w-full px-4 py-3 flex items-center gap-3 hover:bg-central-elevado text-left'>
                          <div className='p-2 bg-blue-500/20 rounded-lg'><Icon name='package' className='w-4 h-4 text-blue-400' /></div>
                          <div><p className='text-white font-medium'>{p.name}</p><p className='text-xs text-slate-500'>Produto • {p.code}</p></div>
                        </button>
                      ))}
                      {/* Leads Results */}
                      {leads.filter((l: any) => l.companyName?.toLowerCase().includes(globalSearch.toLowerCase()) || l.tradeName?.toLowerCase().includes(globalSearch.toLowerCase())).slice(0, 3).map((l: any) => (
                        <button key={`lead-${l.id}`} onClick={() => { setSection('leads'); setBuscaDaTela({ section: 'leads', termo: l.companyName || l.tradeName }); setShowGlobalSearch(false); setGlobalSearch(''); }} className='w-full px-4 py-3 flex items-center gap-3 hover:bg-central-elevado text-left'>
                          <div className='p-2 bg-purple-500/20 rounded-lg'><Icon name='userPlus' className='w-4 h-4 text-purple-400' /></div>
                          <div><p className='text-white font-medium'>{l.companyName || l.tradeName}</p><p className='text-xs text-slate-500'>Lead • {l.status}</p></div>
                        </button>
                      ))}
                      {clients.filter((c: any) => (c.name || c.tradeName || '')?.toLowerCase().includes(globalSearch.toLowerCase())).length === 0 &&
                       products.filter((p: any) => p.name?.toLowerCase().includes(globalSearch.toLowerCase())).length === 0 &&
                       leads.filter((l: any) => l.companyName?.toLowerCase().includes(globalSearch.toLowerCase())).length === 0 && (
                        <div className='px-4 py-8 text-center text-slate-500'>Nenhum resultado encontrado</div>
                      )}
                    </div>
                  )}
                  <div className='p-2 bg-central-elevado text-xs text-slate-500 text-center'>Pressione ESC para fechar</div>
                </div>
              )}
            </div>

            {/* Notifications */}
            <div className='relative'>
              <button onClick={() => { const opening = !showNotifications; setShowNotifications(opening); if (opening) markBellRead(); }} className='p-2 text-slate-400 hover:text-white hover:bg-central-elevado rounded-lg relative'>
                <Icon name='bell' className='w-5 h-5' />
                {(() => {
                  const adjustments = contracts.filter((c: any) => c.status === 'Ativo' && c.nextAdjustmentDate && getDaysUntil(c.nextAdjustmentDate) !== null && (getDaysUntil(c.nextAdjustmentDate) as number) <= 30).length;
                  const expiring = contracts.filter((c: any) => c.status === 'Ativo' && c.endDate && getDaysUntil(c.endDate) !== null && (getDaysUntil(c.endDate) as number) <= 30 && (getDaysUntil(c.endDate) as number) > 0).length;
                  const total = adjustments + expiring + unreadConvocacoes;
                  return total > 0 ? <span className='absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center'>{total}</span> : null;
                })()}
              </button>
              {showNotifications && (
                <div className='absolute right-0 top-12 w-80 bg-central-cartao border border-central-borda rounded-xl shadow-2xl overflow-hidden z-50'>
                  <div className='p-3 border-b border-central-borda flex items-center justify-between'>
                    <h3 className='font-semibold text-white'>Notificações</h3>
                    <button onClick={() => setShowNotifications(false)} className='text-slate-400 hover:text-white'>✕</button>
                  </div>
                  <div className='max-h-80 overflow-y-auto'>
                    {convocacoes.slice(0, 8).map((cv: any) => (
                      <div
                        key={`cv-${cv.id}`}
                        onClick={() => { setLicDeepItemId(cv.itemId); setSection('lic-monitorar'); setShowNotifications(false); }}
                        className='px-4 py-3 border-b border-central-borda hover:bg-central-elevado cursor-pointer bg-rose-950/30'
                      >
                        <div className='flex items-start gap-3'>
                          <div className='p-2 bg-rose-500/20 rounded-lg'>🔴</div>
                          <div className='min-w-0'>
                            <p className='text-sm text-rose-200 font-semibold'>
                              Convocação{cv.mentionsIpcom ? ' — IPCOM' : ''}
                            </p>
                            <p className='text-xs text-slate-400'>
                              {formatNumeroCompraComAno(cv.numeroCompra || '?', cv.anoCompra)}{cv.codigoUnidade ? ` · UASG ${cv.codigoUnidade}` : ''}
                            </p>
                            <p className='text-xs text-slate-300 mt-0.5 line-clamp-2'>{(cv.messageText || '').slice(0, 120)}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                    {contracts.filter((c: any) => c.status === 'Ativo' && c.nextAdjustmentDate && getDaysUntil(c.nextAdjustmentDate) !== null && (getDaysUntil(c.nextAdjustmentDate) as number) <= 30).slice(0, 5).map((c: any) => {
                      const cl = clients.find((x: any) => x.id === c.clientId);
                      const days = getDaysUntil(c.nextAdjustmentDate);
                      return (
                        <div key={`adj-${c.id}`} className='px-4 py-3 border-b border-central-borda hover:bg-central-elevado'>
                          <div className='flex items-start gap-3'>
                            <div className='p-2 bg-yellow-500/20 rounded-lg'><Icon name='clock' className='w-4 h-4 text-yellow-400' /></div>
                            <div>
                              <p className='text-sm text-white font-medium'>Reajuste em {days} dias</p>
                              <p className='text-xs text-slate-400'>{cl?.name || cl?.tradeName || cl?.companyName} • {c.adjustmentIndex}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {contracts.filter((c: any) => c.status === 'Ativo' && c.endDate && getDaysUntil(c.endDate) !== null && (getDaysUntil(c.endDate) as number) <= 30 && (getDaysUntil(c.endDate) as number) > 0).slice(0, 5).map((c: any) => {
                      const cl = clients.find((x: any) => x.id === c.clientId);
                      const days = getDaysUntil(c.endDate);
                      return (
                        <div key={`exp-${c.id}`} className='px-4 py-3 border-b border-central-borda hover:bg-central-elevado'>
                          <div className='flex items-start gap-3'>
                            <div className='p-2 bg-red-500/20 rounded-lg'><Icon name='alertCircle' className='w-4 h-4 text-red-400' /></div>
                            <div>
                              <p className='text-sm text-white font-medium'>Assinatura vence em {days} dias</p>
                              <p className='text-xs text-slate-400'>{cl?.name || cl?.tradeName || cl?.companyName}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {convocacoes.length === 0 && contracts.filter((c: any) => c.status === 'Ativo' && ((c.nextAdjustmentDate && getDaysUntil(c.nextAdjustmentDate) !== null && (getDaysUntil(c.nextAdjustmentDate) as number) <= 30) || (c.endDate && getDaysUntil(c.endDate) !== null && (getDaysUntil(c.endDate) as number) <= 30 && (getDaysUntil(c.endDate) as number) > 0))).length === 0 && (
                      <div className='px-4 py-8 text-center text-slate-500'>Nenhuma notificação</div>
                    )}
                  </div>
                  <button onClick={() => { setSection('dashboard'); setShowNotifications(false); }} className='w-full p-3 text-center text-sm text-slate-300 hover:text-white hover:bg-central-elevado border-t border-central-borda'>Ver todos os alertas</button>
                </div>
              )}
            </div>

            {/* Saúde da sessão do ComprasNet */}
            <ComprasNetHealthDot onClick={() => setSection('comprasnet-infra')} />
            {/* O botão de tema (sol/lua) saiu (09/10/2026, decisão do Heitor): o estado que ele trocava não era lido por
                nada, e o Hub não mudava de tema. O Hub é escuro; tema claro é etapa futura, sem botão até existir. O valor
                'theme' que ficou no localStorage de quem clicou só deixa de ser lido. */}

            <div className='h-8 w-px bg-central-borda'></div>
            <button onClick={() => { setProfileModal(true); setPasswordForm({ current: '', new: '', confirm: '' }); }} className='flex items-center gap-3 px-3 py-2 text-slate-300 hover:bg-central-elevado rounded-lg'>
              <div className='w-8 h-8 rounded-full bg-gradient-to-br from-slate-500 to-slate-600 flex items-center justify-center'>
                <span className='text-white font-medium text-sm'>{user?.name?.charAt(0).toUpperCase()}</span>
              </div>
              <span className='text-sm font-medium hidden md:block'>{user?.name}</span>
            </button>
            <button onClick={handleLogout} className='p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg' title='Sair'>
              <Icon name='logout' className='w-5 h-5' />
            </button>
          </div>
        </header>

        {['resumo-financeiro', 'recebiveis', 'invoices', 'cobranca', 'fiscal-docs', 'fiscal-certs', 'fiscal-monitor', 'boletos'].includes(section) && (
          <div className='bg-central-elevado border-b border-central-borda px-6 py-2 flex items-center gap-4 text-xs'>
            <span className='text-central-texto-fraco'><span className='text-blue-400 font-semibold' data-faixa-fin='rascunhos'>{qtdOuTraco(financialBadges.drafts)}</span> rascunhos{naCobranca ? ` de ${fmtMesCurto(getCurrentMonthStr())}` : ''}</span>
            {/* Vencidas, a receber e recebido vêm do resumo de recebíveis, que é de totais: só para o admin (23/10/2026). */}
            {canViewFinancialTotals && <>
            <span className='text-central-borda'>|</span>
            {/* H1 (02/11/2026): na Cobrança, vencidas e a receber vêm do resumo da MESMA consulta da lista (a tela o lê junto
                com ela), e o rótulo diz o recorte. O resumo de recebíveis é por competência do mês: no dia 2, sem fatura de
                novembro, dizia 0 vencidas ao lado de 39 na lista. As outras telas seguem com ele. */}
            <span className='text-central-texto-fraco'><span className='text-red-400 font-semibold' data-faixa-fin='vencidas'>{naCobranca ? qtdOuTraco(resumoDaCobranca?.vencidas.count ?? null) : qtdOuTraco(financialBadges.overdue)}</span> vencidas{naCobranca ? ' (todas)' : ''}</span>
            <span className='text-central-borda'>|</span>
            <span className='text-central-texto-fraco'><span className='text-green-400 font-semibold' data-faixa-fin='a-receber'>{naCobranca ? reaisOuTraco(resumoDaCobranca?.aReceber.value ?? null) : reaisOuTraco(financialBadges.totalOpen)}</span> a receber{naCobranca ? ' (todas)' : ''}</span>
            <span className='text-central-borda'>|</span>
            <span className='text-central-texto-fraco'><span className='text-emerald-400 font-semibold' data-faixa-fin='recebido'>{reaisOuTraco(financialBadges.totalReceived)}</span> recebido no mês</span>
            </>}
            {(fontesDosBadges.faturas.erro || fontesDosBadges.resumo.erro) && (
              <span className='text-amber-300' role='status' data-faixa-fin='nao-atualizou' title={fontesDosBadges.resumo.erro || fontesDosBadges.faturas.erro || ''}>
                · não atualizou{ultimaLeituraBoa ? `; números de ${fmtDateTime(ultimaLeituraBoa)}` : ''}
              </span>
            )}
          </div>
        )}

        <main className='flex-1 overflow-auto p-6'>
          {section === 'dashboard' && (
            <DashboardTab
              contracts={contracts}
              clients={clients}
              leads={leads}
              products={products}
              totalMRR={totalMRR}
              activeContracts={activeContracts}
              activeClients={activeClients}
              activeProducts={activeProducts}
              canViewFinancialTotals={canViewFinancialTotals}
              isViewer={isViewer}
              canSeeReajustes={canSeeReajustes}
              getClientMRR={getClientMRR}
              leadStatuses={leadStatuses}
              mrrUplift={mrrUplift}
              setSection={setSection}
              onAbrirCobranca={(faixa) => navigate({ pathname: rotaDaSection('cobranca'), search: faixa ? `?${PARAMETRO_DA_FAIXA}=${faixa}` : '' })}
              carga={cargaPrincipal}
              onTentarDeNovo={loadData}
              Icon={Icon}
            />
          )}

          {section === 'templates' && <TemplateManager />}
          {section === 'nucleo-propostas' && <NucleoPropostasTab />}

          {section === 'email-comunicados' && <ComunicadosTab />}

          {section === 'email-contas' && <EmailAccountsTab />}

          {section === 'email-logs' && <EmailLogsTab />}

          {section === 'email-automacoes' && user?.role === 'admin' && (
            <div className='space-y-6'>
              {/* Automações de Email */}
              <div className='bg-slate-900 rounded-xl border border-slate-800 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                  <div className='p-2 bg-emerald-500/10 rounded-lg'>
                    <Icon name='clock' className='w-5 h-5 text-emerald-400' />
                  </div>
                  <div>
                    <h3 className='text-white font-semibold'>Automações de Email</h3>
                    <p className='text-slate-400 text-sm'>Ative/desative e configure destinatários de cada automação</p>
                  </div>
                </div>
                <div className='p-6 space-y-6'>
                  {automationsLoading ? (
                    <p className='text-slate-400 text-sm'>Carregando automações...</p>
                  ) : cargaDasAutomacoes.estado === 'erro' && cargaDasAutomacoes.atualizadoEm === null ? (
                    <p role='alert' className={`text-sm ${TONE_TEXT.danger}`}>Não consegui carregar as automações: {cargaDasAutomacoes.erro}. Não é que não haja nenhuma.</p>
                  ) : automations.length === 0 ? (
                    <p className='text-slate-400 text-sm'>Nenhuma automação encontrada. As automações são criadas automaticamente pelo backend.</p>
                  ) : (
                    (() => {
                      const moduleColors: Record<string, { label: string; color: string; iconBg: string }> = {
                        comercial: { label: 'Comercial', color: 'text-orange-400', iconBg: 'bg-orange-500/10' },
                        faturamento: { label: 'Faturamento', color: 'text-green-400', iconBg: 'bg-green-500/10' },
                        financeiro: { label: 'Financeiro', color: 'text-red-400', iconBg: 'bg-red-500/10' },
                        licitacoes: { label: 'Licitações', color: 'text-blue-400', iconBg: 'bg-blue-500/10' },
                        sistema: { label: 'Sistema', color: 'text-slate-400', iconBg: 'bg-slate-500/10' },
                      };
                      const grouped = automations.reduce((acc: Record<string, any[]>, a: any) => {
                        if (!acc[a.module]) acc[a.module] = [];
                        acc[a.module].push(a);
                        return acc;
                      }, {});
                      const moduleOrder = ['comercial', 'faturamento', 'financeiro', 'licitacoes', 'sistema'];
                      return moduleOrder.filter(m => grouped[m]).map((mod, mi) => (
                        <div key={mod}>
                          {mi > 0 && <div className='border-t border-slate-800 mb-6' />}
                          <h4 className={`text-xs font-semibold ${moduleColors[mod]?.color || 'text-slate-400'} uppercase tracking-wider mb-3`}>{moduleColors[mod]?.label || mod}</h4>
                          <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                            {grouped[mod].map((a: any) => {
                              const triggerLabel = a.trigger === 'cron' ? (a.schedule || 'Agendado') : a.trigger === 'event' ? 'Quando evento ocorre' : 'Manual';
                              const hasCustomRecipients = !!a.recipientEmails;
                              const purposeToSettingsKey: Record<string, string> = {
                                notificacoes: 'notificationEmailsProposalApproved',
                                contratos: 'notificationEmailsContractSigned',
                                financeiro: 'notificationEmailsFinanceiro',
                                licitacoes: 'notificationEmailsLicitacoes',
                                sistema: 'notificationEmailsSistema',
                              };
                              const isClientEmail = a.emailPurpose === 'faturas';
                              const groupDefault = companySettings[purposeToSettingsKey[a.emailPurpose] || ''] || '';
                              const placeholderText = groupDefault ? `${groupDefault} (padrão)` : 'email1@empresa.com, email2@empresa.com';
                              return (
                                <div key={a.key} className={`rounded-lg p-4 border transition-all ${a.enabled ? hasCustomRecipients ? 'bg-slate-800/50 border-emerald-500/30' : 'bg-slate-800/50 border-slate-700/50' : 'bg-slate-800/20 border-slate-800/30 opacity-60'}`}>
                                  <div className='flex items-start gap-3'>
                                    <div className={`w-8 h-8 rounded-lg ${moduleColors[mod]?.iconBg || 'bg-slate-500/10'} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                                      <Icon name={a.trigger === 'cron' ? 'clock' : 'mail'} className={`w-4 h-4 ${moduleColors[mod]?.color || 'text-slate-400'}`} />
                                    </div>
                                    <div className='flex-1 min-w-0'>
                                      <div className='flex items-center gap-2 mb-0.5'>
                                        <p className='text-sm font-medium text-white'>{a.name}</p>
                                        <button
                                          onClick={async () => {
                                            try {
                                              const updated = await notificationsApiService.updateAutomation(a.key, { enabled: !a.enabled });
                                              setAutomations(prev => prev.map(x => x.key === a.key ? updated : x));
                                            } catch (e) { console.error('Erro ao atualizar:', e); avisar('Erro ao atualizar automação', 'error'); }
                                          }}
                                          className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors flex-shrink-0 ${a.enabled ? 'bg-emerald-500' : 'bg-slate-600'}`}
                                          title={a.enabled ? 'Desativar' : 'Ativar'}
                                        >
                                          <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${a.enabled ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} />
                                        </button>
                                      </div>
                                      <p className='text-xs text-slate-400 mt-0.5'>{a.description}</p>
                                      <div className='flex flex-wrap gap-1.5 mt-2'>
                                        <span className='px-2 py-0.5 text-[10px] font-medium rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/20'>{triggerLabel}</span>
                                        {a.emailPurpose && <span className='px-2 py-0.5 text-[10px] font-medium rounded-full bg-purple-500/10 text-purple-400 border border-purple-500/20'>{a.emailPurpose}</span>}
                                      </div>
                                      {/* Destinatários */}
                                      <div className='mt-3'>
                                        {isClientEmail ? (
                                          <div className='w-full px-3 py-1.5 bg-slate-700/30 border border-slate-600/30 text-slate-400 text-xs rounded-lg italic'>
                                            Enviado para o email financeiro do cliente
                                          </div>
                                        ) : (
                                          <input
                                            type='text'
                                            value={editingRecipients[a.key] !== undefined ? editingRecipients[a.key] : (a.recipientEmails || '')}
                                            onChange={e => setEditingRecipients(prev => ({...prev, [a.key]: e.target.value}))}
                                            onFocus={() => {
                                              if (editingRecipients[a.key] === undefined) {
                                                setEditingRecipients(prev => ({...prev, [a.key]: a.recipientEmails || ''}));
                                              }
                                            }}
                                            onBlur={async () => {
                                              const val = editingRecipients[a.key];
                                              if (val === undefined) return;
                                              if (val === (a.recipientEmails || '')) {
                                                setEditingRecipients(prev => { const n = {...prev}; delete n[a.key]; return n; });
                                                return;
                                              }
                                              try {
                                                const updated = await notificationsApiService.updateAutomation(a.key, { recipientEmails: val });
                                                setAutomations(prev => prev.map(x => x.key === a.key ? updated : x));
                                              } catch (e) {
                                                // D10: calava, e o campo voltava ao valor antigo; o aviso seguia indo para os de antes.
                                                // Agora diz, e o texto digitado fica no campo para tentar de novo.
                                                avisar(`Não salvei os destinatários de "${a.name || a.key}": ${mensagemDoErroDeCarga(e)}. O texto ficou no campo.`, 'error');
                                                return;
                                              }
                                              setEditingRecipients(prev => { const n = {...prev}; delete n[a.key]; return n; });
                                            }}
                                            placeholder={placeholderText}
                                            className={`w-full px-3 py-1.5 text-xs rounded-lg placeholder-slate-500 ${campoComEstado(hasCustomRecipients && 'border-emerald-500/30')}`}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ));
                    })()
                  )}
                </div>
              </div>
            </div>
          )}

          {section === 'invoices' && <InvoicesTab initialSearch={invoiceSearch} onSearchConsumed={() => setInvoiceSearch('')} canEdit={canEditInvoices} onVerNaCobranca={(code) => { setFocoDaCobranca(code); setSection('cobranca'); }} onAbrirCobranca={() => setSection('cobranca')} />}

          {['fiscal-docs', 'fiscal-certs', 'fiscal-monitor'].includes(section) && (
            <FiscalTab subView={{ 'fiscal-docs': 'documents', 'fiscal-certs': 'certificates', 'fiscal-monitor': 'monitoring' }[section] || 'documents'} />
          )}

          {section === 'boletos' && <BoletosTab canEdit={canEditInvoices} />}

          {section === 'cobranca' && <CobrancaTab onResumo={setResumoDaCobranca} onAbrirFatura={(code) => { setInvoiceSearch(code); setSection('invoices'); }} onAbrirOficios={() => setSection('oficios')} foco={focoDaCobranca} onFocoConsumido={() => setFocoDaCobranca(null)} />}

          {section === 'resumo-financeiro' && <FinancialDashboardTab contracts={contracts} clients={clients} onNavigate={(s) => setSection(s)} contratosLidos={cargaPrincipal.atualizadoEm !== null} />}

          {section === 'recebiveis' && <RecebiveisTab
            onNavigate={(s: string, search?: string) => { if (search) setInvoiceSearch(search); setSection(s); }}
            onFocusBankTx={(focus) => { setBankFocusTx(focus); setSection('contas-bancarias'); }}
            canEdit={canEditInvoices}
          />}

          {section === 'despesas' && <ExpensesTab initialSearch={expenseSearch} onSearchConsumed={() => setExpenseSearch('')} />}

          {section === 'contas-bancarias' && <BankAccountsTab
            onNavigate={(s: string, search?: string) => {
              if (search) {
                if (s === 'despesas') setExpenseSearch(search);
                else setInvoiceSearch(search);
              }
              setSection(s);
            }}
            initialFocusTx={bankFocusTx}
            onFocusConsumed={() => setBankFocusTx(null)}
          />}

          {section === 'fluxo-caixa' && <CashFlowTab />}

          {/* Mesmo mecanismo que o extrato bancário já usa para navegar até uma
              despesa: o número do contrato vira a busca da tela de Despesas. */}
          {section === 'emprestimos' && <LoanContractsTab
            onOpenExpenses={(contractNumber: string) => { setExpenseSearch(contractNumber); setSection('despesas'); }}
          />}

          {['lic-encontrar', 'lic-cadastrar', 'lic-monitorar', 'lic-documentos', 'lic-acessos', 'lic-disputar'].includes(section) && (
            <LicitacoesTab subView={{ 'lic-encontrar': 'items', 'lic-cadastrar': 'proposals', 'lic-monitorar': 'monitoring', 'lic-documentos': 'documents', 'lic-acessos': 'portals', 'lic-disputar': 'disputes' }[section] || 'items'} onNavigate={setSection} openItemId={licDeepItemId} openAdequar={licDeepAdequar} />
          )}



          {section === 'materials' && <MaterialsTab />}

          {section === 'docs-societarios' && <CorporateDocsTab user={user} />}

          {section === 'reajustes' && (
            <ReajustesTab
              user={user}
              canEdit={canEditReajustes}
              showToast={showToast}
              onOpenContracts={() => setSection('contracts')}
              onEditContract={(c) => openModal('contract', c)}
              onOpenOficios={() => setSection('oficios')}
            />
          )}

          {section === 'oficios' && <OficiosTab />}
          {section === 'demandas' && <DemandasTab onOpenCountChange={loadDemandasCount} deepCode={demandaDeepCode} />}

          {section === 'portabilidade' && <PortabilityTermsTab />}

          {section === 'aws-reservations' && (user?.role === 'admin' || user?.permissions?.some((p: any) => p.code === 'reservations:view')) && <AwsReservationsTab />}

          {section === 'ec2-monitoring' && user?.role === 'admin' && <Ec2MonitoringTab />}

          {/* Automação ComprasNet: 3 abas (Ao vivo / Sessão & Uptime / Custos) — ComprasNetSessionHistory agora vive dentro do ComprasNetInfraTab */}
          {section === 'comprasnet-infra' && user?.role === 'admin' && <ComprasNetInfraTab showToast={showToast} />}

          {section === 'locations' && <ClientLocationsManager abrirGrupo={grupoParaAbrir} onEditarCliente={(c) => openModal('client', c)} cadastroAberto={modal === 'client'} />}

          {section === 'ddrs' && (
            <DDRsTable
              initialSearch={buscaPara('ddrs')}
              onSearchConsumed={buscaConsumida}
              clientDDRs={clientDDRs}
              ddrStats={ddrStats}
              canEdit={canEditDDRs}
              loading={loading}
              onEdit={(d) => openModal('ddr', d)}
              onDelete={(d) => setDelConfirm({type:'ddr',item:d})}
              onImportDone={loadData}
              showToast={showToast}
              Icon={Icon}
              onOpenPrestadoras={() => setShowPrestadoras(true)}
              carga={cargaDosDdrs}
              onRecarregar={loadData}
              clientes={clients}
            />
          )}

          {showPrestadoras && (
            // Moldura da lista de prestadoras: fecha ao clicar fora e recarrega, como já era.
            <CascaDeModal
              largura='lg'
              fecharAoClicarFora
              titulo='Prestadoras'
              onClose={() => { setShowPrestadoras(false); loadData(); }}
              corpoClassName='p-4'
            >
              <PrestadorasTab canEdit={canEdit} ddrs={cargaDosDdrs.atualizadoEm !== null ? clientDDRs : null} showToast={showToast} Icon={Icon} />
            </CascaDeModal>
          )}

          {section === 'leads' && (
            <LeadsBoard
              initialSearch={buscaPara('leads')}
              onSearchConsumed={buscaConsumida}
              leads={leads}
              canEdit={canEdit}
              loading={loading}
              carga={cargaPrincipal}
              onEdit={(l) => openModal('lead', l)}
              onStatusChange={updateLeadStatus}
              onLoadData={loadData}
              onLeadUpdate={updateLeadLocal}
              onLeadRemove={removeLeadLocal}
              showToast={showToast}
              Icon={Icon}
              propostas={proposals}
              funil={funil}
              onConcluirProximaAcao={concluirProximaAcao}
            />
          )}
          {section === 'products' && (
            <ProductsTable
              initialSearch={buscaPara('products')}
              onSearchConsumed={buscaConsumida}
              products={products}
              contracts={contracts}
              activeProducts={activeProducts}
              canEdit={canEditProducts}
              loading={loading}
              onEdit={(p) => openModal('product', p)}
              onDelete={(p) => setDelConfirm({type:'product',item:p})}
              onDuplicate={(p) => { setModal('product'); setEditing(null); setForm({ ...p, id: undefined, code: p.code + '-COPIA', name: p.name + ' (Cópia)' }); }}
              Icon={Icon}
            />
          )}

          {section === 'clients' && (
            <ClientsTable
              clients={clients}
              contracts={contracts}
              clientDDRs={clientDDRs}
              carga={cargaPrincipal}
              cargaDosDdrs={cargaDosDdrs}
              onTentarDeNovo={loadData}
              canEdit={canEditClients}
              canDelete={canDeleteClients}
              canViewFinancials={canViewFinancials}
              canViewFinancialTotals={canViewFinancialTotals}
              loading={loading}
              onEdit={(c) => openModal('client', c)}
              onDelete={(c) => setDelConfirm({type:'client',item:c})}
              onInativar={canEditClients ? inativarDaLista : undefined}
              onNavigateDDRs={(name) => { setSection('ddrs'); setBuscaDaTela({ section: 'ddrs', termo: name }); }}
              initialSearch={buscaPara('clients')}
              onSearchConsumed={buscaConsumida}
              Icon={Icon}
            />
          )}

          {section === 'contracts' && (
            <ContractsTable
              contracts={contracts}
              clients={clients}
              products={products}
              allLocations={allLocations}
              activeContracts={activeContracts}
              canEdit={canEditContracts}
              canViewFinancials={canViewFinancials}
              canViewFinancialTotals={canViewFinancialTotals}
              loading={loading}
              carga={cargaPrincipal}
              onTentarDeNovo={loadData}
              onEdit={(c) => openModal('contract', c)}
              onDelete={(c) => setDelConfirm({type:'contract',item:c})}
              onViewItems={(c) => setViewItems(c)}
              onAttachments={(c) => setAttachmentModal(c)}
              onEditLocationItems={(data) => setEditLocationItems(data)}
              Icon={Icon}
            />
          )}

          {section === 'users' && user?.role === 'admin' && (() => {
            const userStats = {
              total: users.length,
              active: users.filter((u: any) => u.isActive).length,
              inactive: users.filter((u: any) => !u.isActive).length,
              admins: users.filter((u: any) => u.role === 'admin').length,
              editors: users.filter((u: any) => u.role === 'editor').length,
              vendedores: users.filter((u: any) => u.role === 'vendedor').length,
              viewers: users.filter((u: any) => u.role === 'viewer').length,
            };
            // D3: os números são da lista; sem a lista, "—".
            const temUsuarios = cargaDosUsuarios.atualizadoEm !== null;
            const n = (v: number) => (temUsuarios ? v : '—');
            const filteredByRole = userFilter === 'Todos' ? filteredUsers
              : userFilter === 'Ativos' ? filteredUsers.filter((u: any) => u.isActive)
              : userFilter === 'Inativos' ? filteredUsers.filter((u: any) => !u.isActive)
              : userFilter === 'Admins' ? filteredUsers.filter((u: any) => u.role === 'admin')
              : userFilter === 'Suporte' ? filteredUsers.filter((u: any) => u.role === 'editor')
              : userFilter === 'Vendedores' ? filteredUsers.filter((u: any) => u.role === 'vendedor')
              : filteredUsers.filter((u: any) => u.role === 'viewer');
            return (
            <div className='space-y-4'>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4'>
                <div className='bg-slate-800/50 rounded-xl p-4 border border-slate-700'>
                  <div className='flex items-center justify-between'>
                    <div>
                      <p className='text-sm text-slate-400'>Total</p>
                      <p className='text-2xl font-bold text-white mt-1' data-kpi='usuarios'>{n(userStats.total)}</p>
                      <p className='text-xs text-slate-500 mt-1'><span className='text-green-400'>{n(userStats.active)}</span> ativos • <span className='text-red-400'>{n(userStats.inactive)}</span> inativos</p>
                    </div>
                    
                  </div>
                </div>
                <div className='bg-slate-800/50 rounded-xl p-4 border border-slate-700'><div className='flex items-center justify-between'><div><p className='text-sm text-slate-400'>Admins</p><p className='text-2xl font-bold text-red-400 mt-1'>{n(userStats.admins)}</p></div></div></div>
                <div className='bg-slate-800/50 rounded-xl p-4 border border-slate-700'><div className='flex items-center justify-between'><div><p className='text-sm text-slate-400'>Suporte</p><p className={`text-2xl font-bold ${TONE_TEXT.progress} mt-1`}>{n(userStats.editors)}</p></div></div></div>
                <div className='bg-slate-800/50 rounded-xl p-4 border border-slate-700'><div className='flex items-center justify-between'><div><p className='text-sm text-slate-400'>Vendedores</p><p className={`text-2xl font-bold ${TONE_TEXT.info} mt-1`}>{n(userStats.vendedores)}</p></div></div></div>
                <div className='bg-slate-800/50 rounded-xl p-4 border border-slate-700'><div className='flex items-center justify-between'><div><p className='text-sm text-slate-400'>Viewers</p><p className='text-2xl font-bold text-slate-400 mt-1'>{n(userStats.viewers)}</p></div></div></div>
              </div>

              <div className='bg-slate-800/50 rounded-xl border border-slate-700 p-4'>
                <div className='flex flex-col md:flex-row gap-4'>
                  <div className='relative flex-1'>
                    <Icon name='search' className='absolute left-3 top-3 w-5 h-5 text-slate-500' />
                    <input type='text' placeholder='Buscar por nome...' value={search} onChange={e => setSearch(e.target.value)} className={`w-full pl-10 pr-4 py-2.5 placeholder-slate-500 rounded-lg ${campo}`} />
                  </div>
                  <div className='flex gap-2 flex-wrap'>
                    {['Todos', 'Ativos', 'Inativos', 'Admins', 'Suporte', 'Vendedores', 'Viewers'].map(filter => (
                      <button key={filter} onClick={() => setUserFilter(filter)} className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${userFilter === filter ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:text-white'}`}>{filter}</button>
                    ))}
                  </div>
                  {cargaDosUsuarios.estado === 'pronto' && <button onClick={() => openModal('user')} className='flex items-center gap-2 px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium whitespace-nowrap'><Icon name='plus' className='w-5 h-5' />Novo</button>}
                </div>
              </div>

              <EstadoDaLista carga={cargaDosUsuarios} temDados={temUsuarios} oQue='os usuários' onTentarDeNovo={loadData} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
                <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                  <table className='w-full'>
                    <thead className='bg-slate-800/80 border-b border-slate-700'>
                      <tr>
                        <th className='px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase'>Usuario</th>
                        <th className='px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase'>Email</th>
                        <th className='px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase'>Perfil</th>
                        <th className='px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase'>Status</th>
                        <th className='px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase'>MFA</th>
                        <th className='px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase'>Ultimo Acesso</th>
                        <th className='px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase'>Acoes</th>
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-slate-800'>
                      {filteredByRole.length === 0 ? <tr><td colSpan={7} className='px-6 py-12 text-center text-slate-500'>Nenhum usuario encontrado</td></tr> : filteredByRole.map((u: any) => (
                        <tr key={u.id} className='hover:bg-slate-800/50'>
                          <td className='px-6 py-4'>
                            <div className='flex items-center gap-3'>
                              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${u.role === 'admin' ? 'bg-gradient-to-br from-red-500 to-red-600' : u.role === 'editor' ? 'bg-gradient-to-br from-blue-500 to-blue-600' : u.role === 'vendedor' ? 'bg-gradient-to-br from-purple-500 to-purple-600' : 'bg-gradient-to-br from-slate-500 to-slate-600'}`}>
                                <span className='text-white font-medium'>{u.name?.charAt(0).toUpperCase()}</span>
                              </div>
                              <div>
                                <p className='font-medium text-white'>{u.name}</p>
                                {u.id === user?.id && <span className='text-xs text-slate-400'>(Voce)</span>}
                              </div>
                            </div>
                          </td>
                          <td className='px-6 py-4 text-sm text-slate-400'>{u.email}</td>
                          <td className='px-6 py-4 text-center'>
                            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${u.role === 'admin' ? 'bg-red-500/20 text-red-400' : u.role === 'editor' ? TONE_BADGE.progress : u.role === 'vendedor' ? TONE_BADGE.info : 'bg-slate-700 text-slate-400'}`}>
                              {u.role === 'admin' ? 'Admin' : u.role === 'editor' ? 'Suporte' : u.role === 'vendedor' ? 'Vendedor' : 'Viewer'}
                            </span>
                          </td>
                          <td className='px-6 py-4 text-center'>
                            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${u.isActive ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>{u.isActive ? 'Ativo' : 'Inativo'}</span>
                          </td>
                          <td className='px-6 py-4 text-center'>
                            {u.mfaEnabled ? (
                              <div className='flex items-center justify-center gap-1'>
                                <span className='px-2 py-0.5 rounded-full text-xs font-medium bg-green-500/20 text-green-400'>Ativo</span>
                                {/* A1 (26/10/2026): desligar o MFA de alguém é ação de segurança; deixou de ser um "×" de 12 px com cara de enfeite. */}
                                <button onClick={() => handleAdminDisableMfa(u)} data-desligar-mfa className='ml-1 px-2 py-0.5 rounded border border-danger bg-transparent text-red-400 hover:bg-danger/10 text-[11px] font-medium' title={u.id === user?.id ? 'Desativar o seu MFA (derruba a sessao; o proximo login pede cadastro)' : 'Desativar MFA'}>Desligar</button>
                              </div>
                            ) : <span className='text-xs text-slate-600'>—</span>}
                          </td>
                          <td className='px-6 py-4 text-center text-sm text-slate-500'>{u.lastLogin ? fmtDate(u.lastLogin) : '—'}</td>
                          <td className='px-6 py-4'>
                            <div className='flex items-center justify-center gap-1'>
                              <button onClick={() => openModal('user', u)} className='p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg' title='Editar'><Icon name='edit' className='w-4 h-4' /></button>
                              <button onClick={() => openPermissionsModal(u)} className='p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg' title='Permissoes'><Icon name='shield' className='w-4 h-4' /></button>
                              {/* D5: Desativar no lugar de Excluir (hard delete). Fica fora da própria linha e do último admin. */}
                              {u.isActive && !porqueTravaPapelEAtivo(u, user, users) && <button onClick={() => desativarUsuario(u)} className='p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg' title='Desativar (perde o acesso na hora; o histórico fica)'><Icon name='ban' className='w-4 h-4' /></button>}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </EstadoDaLista>

              {permissionsModal && (
                // Seleção de permissões: não fecha ao clicar fora (como já era). O perfil
                // vira selo do mapa (Vendedor saía em laranja, que não é tom de valor).
                <CascaDeModal
                  largura='lg'
                  titulo={`Permissões de ${permissionsModal.name}`}
                  selos={
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${permissionsModal.role === 'admin' ? TONE_BADGE.danger : permissionsModal.role === 'editor' ? TONE_BADGE.progress : permissionsModal.role === 'vendedor' ? TONE_BADGE.info : TONE_BADGE.neutral}`}>
                      {permissionsModal.role === 'admin' ? 'Admin' : permissionsModal.role === 'editor' ? 'Suporte' : permissionsModal.role === 'vendedor' ? 'Vendedor' : 'Viewer'}
                    </span>
                  }
                  onClose={closePermissionsModal}
                  topo={
                    <div className='px-5 py-3 border-b border-central-borda bg-central-elevado/50 flex items-center justify-between'>
                      <p className='text-sm text-slate-400' data-permissoes-ativas>{erroDasPermissoes ? '—' : userPermissions.length} permissões ativas</p>
                      <button onClick={applyDefaultPermissions} disabled={loadingPermissions || !!erroDasPermissoes} className='px-3 py-1.5 text-sm bg-slate-700 text-slate-300 rounded-lg hover:bg-slate-600 disabled:opacity-50'>Aplicar Padrão do Perfil</button>
                    </div>
                  }
                  corpoClassName='p-5'
                  rodape={
                    <>
                      {!erroDasPermissoes && !loadingPermissions && <p className='basis-full text-xs text-slate-400' data-testid='diferenca-das-permissoes'>{fraseDaDiferenca(permissoesAoAbrir, userPermissions)}</p>}
                      <button onClick={closePermissionsModal} disabled={savingPermissions} className='flex-1 px-6 py-3 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'>Cancelar</button>
                      <button onClick={savePermissions} disabled={savingPermissions || loadingPermissions || !!erroDasPermissoes} className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{savingPermissions ? 'Salvando...' : 'Salvar Permissões'}</button>
                    </>
                  }
                >
                      {loadingPermissions ? <div className='text-center py-12 text-slate-500'>Carregando...</div> : erroDasPermissoes ? (
                        <div role='alert' className={`my-4 px-4 py-4 rounded-lg border border-red-600/50 text-sm ${TONE_BADGE.danger}`} data-permissoes='erro'>
                          <div className='font-semibold'>Não consegui ler as permissões de {permissionsModal.name}.</div>
                          <div className='mt-1 text-red-200/90'>{erroDasPermissoes}</div>
                          <div className='mt-1 text-red-200/70 text-xs'>Nada foi alterado. Enquanto a leitura não der certo, a tela não mostra nem salva permissão nenhuma: salvar agora gravaria um palpite por cima das permissões reais.</div>
                          <button onClick={() => openPermissionsModal(permissionsModal)} className='mt-3 px-2.5 py-1 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 text-xs font-medium'>Tentar de novo</button>
                        </div>
                      ) : Object.keys(groupedPermissions).length === 0 ? (
                        <div className='text-center py-12'>
                          <Icon name='database' className='w-12 h-12 text-slate-600 mx-auto mb-4' />
                          <p className='text-slate-400 mb-4'>Nenhuma permissao encontrada.</p>
                          <button onClick={runPermissionsSeed} className='px-4 py-2 bg-slate-700 text-slate-200 rounded-lg hover:bg-slate-600 font-medium'>Executar Seed de Permissões</button>
                        </div>
                      ) : (
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                          {Object.entries(groupedPermissions)
                          .filter(([moduleKey]) => {
                            // Hide irrelevant modules for viewer profile
                            if (permissionsModal.role === 'viewer') {
                              const viewerHiddenModules = ['leads', 'contracts', 'invoices', 'proposals', 'materials', 'oficios', 'templates', 'reservations', 'reports', 'financials', 'fiscal', 'users', 'settings'];
                              return !viewerHiddenModules.includes(moduleKey);
                            }
                            return true;
                          })
                          .map(([moduleKey, modulePerms]) => {
                            const displayInfo = MODULE_DISPLAY[moduleKey] || { name: moduleKey, icon: 'folder' };
                            const enabledCount = modulePerms.filter((p: any) => userPermissions.includes(p.code)).length;
                            const allEnabled = enabledCount === modulePerms.length;
                            return (
                              <div key={moduleKey} className='bg-central-elevado rounded-lg border border-central-borda overflow-hidden'>
                                <div className='p-3 bg-slate-700/50 border-b border-slate-700 flex items-center justify-between'>
                                  <div className='flex items-center gap-2'>
                                    <Icon name={displayInfo.icon as any} className='w-4 h-4 text-slate-400' />
                                    <span className='text-sm font-medium text-white'>{displayInfo.name}</span>
                                  </div>
                                  <button onClick={() => toggleModulePermissions(moduleKey)} className={`px-2 py-0.5 text-xs rounded ${allEnabled ? TONE_BADGE.open : enabledCount > 0 ? TONE_BADGE.warning : 'bg-slate-600 text-slate-400'}`}>{enabledCount}/{modulePerms.length}</button>
                                </div>
                                <div className='p-2 space-y-1'>
                                  {modulePerms.map((perm: any) => (
                                    <label key={perm.code} className='flex items-center gap-2 p-1.5 rounded hover:bg-slate-700 cursor-pointer'>
                                      <input type='checkbox' checked={userPermissions.includes(perm.code)} onChange={() => togglePermission(perm.code)} className='w-4 h-4 rounded bg-slate-700 border-slate-600 accent-primary focus:ring-primary' />
                                      <span className='text-xs text-slate-300'>{perm.name}</span>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                </CascaDeModal>
              )}
            </div>
          );
          })()}

          {section === 'reports' && user?.role === 'admin' && (() => {
            // Dados para relatórios
            const mrrByMonth: { month: string; value: number }[] = [];
            const currentDate = new Date();
            for (let i = 5; i >= 0; i--) {
              const d = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
              const monthName = d.toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' });
              const activeInMonth = contracts.filter((c: any) => {
                const startDate = new Date(c.startDate);
                return c.status === 'Ativo' && startDate <= d;
              });
              const mrrValue = activeInMonth.reduce((s: number, c: any) => s + (parseFloat(String(c.mrr)) || 0), 0);
              mrrByMonth.push({ month: monthName, value: mrrValue });
            }
            const maxMRR = Math.max(...mrrByMonth.map(m => m.value), 1);

            // Funil de vendas
            const funnelData = leadStatuses.map(status => ({
              status,
              count: leads.filter((l: any) => l.status === status).length,
              value: leads.filter((l: any) => l.status === status).reduce((s: number, l: any) => s + (parseFloat(l.estimatedValue) || 0), 0)
            }));

            // Top produtos
            const productUsage: { [key: number]: { product: any; count: number; revenue: number } } = {};
            contracts.forEach((c: any) => {
              const items = typeof c.items === 'string' ? JSON.parse(c.items || '[]') : (c.items || []);
              items.forEach((item: any) => {
                if (item.productId) {
                  if (!productUsage[item.productId]) {
                    const prod = products.find((p: any) => Number(p.id) === Number(item.productId));
                    productUsage[item.productId] = { product: prod, count: 0, revenue: 0 };
                  }
                  productUsage[item.productId].count++;
                  productUsage[item.productId].revenue += item.totalValue || 0;
                }
              });
            });
            const topProducts = Object.values(productUsage).sort((a, b) => b.revenue - a.revenue).slice(0, 5);

            // D13: os números saem da carga principal; sem ela, o relatório dizia R$ 0 e zeros com cara de dado.
            if (cargaPrincipal.atualizadoEm === null) {
              return (
                <EstadoDaLista carga={cargaPrincipal} temDados={false} oQue='os dados dos relatórios' onTentarDeNovo={loadData} vazio={null}>
                  {null}
                </EstadoDaLista>
              );
            }

            return (
            <div className='space-y-6'>
              {/* Header com exportação */}
              <div className='flex items-center justify-between'>
                <div>
                  <h3 className='text-lg font-semibold text-white'>Relatórios e Análises</h3>
                  <p className='text-slate-400 text-sm'>Métricas e indicadores do sistema</p>
                </div>
                <div className='flex gap-2'>
                  <button onClick={() => { exportToCSV(clients, 'clientes', [{ key: 'tradeName', label: 'Nome Fantasia' }, { key: 'companyName', label: 'Razão Social' }, { key: 'cnpj', label: 'CNPJ' }, { key: 'emailFinancial', label: 'Email' }, { key: 'phone', label: 'Telefone' }, { key: 'status', label: 'Status' }]); showToast('Clientes exportados com sucesso!', 'success'); }} className='px-4 py-2 bg-slate-700 text-slate-200 rounded-lg hover:bg-slate-600 text-sm font-medium'>
                    📥 Exportar Clientes
                  </button>
                  <button onClick={() => { exportToCSV(contracts.map((c: any) => ({ ...c, clientName: nomeDeExibicao(clients.find((cl: any) => cl.id === c.clientId)) })), 'contratos', [{ key: 'id', label: 'ID' }, { key: 'clientName', label: 'Cliente' }, { key: 'mrr', label: 'MRR' }, { key: 'status', label: 'Status' }, { key: 'startDate', label: 'Início' }, { key: 'endDate', label: 'Fim' }]); showToast('Contratos exportados com sucesso!', 'success'); }} className='px-4 py-2 bg-slate-700 text-slate-200 rounded-lg hover:bg-slate-600 text-sm font-medium'>
                    📥 Exportar Assinaturas
                  </button>
                  <button onClick={() => { exportToCSV(products, 'produtos', [{ key: 'code', label: 'Código' }, { key: 'name', label: 'Nome' }, { key: 'type', label: 'Tipo' }, { key: 'value', label: 'Valor' }, { key: 'status', label: 'Ativo' }]); showToast('Produtos exportados com sucesso!', 'success'); }} className='px-4 py-2 bg-slate-700 text-slate-200 rounded-lg hover:bg-slate-600 text-sm font-medium'>
                    📥 Exportar Produtos
                  </button>
                </div>
              </div>

              {/* Gráfico de Evolução do MRR */}
              <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                  <div className='p-2 bg-green-500/10 rounded-lg'>
                    <Icon name='chart' className='w-5 h-5 text-green-400' />
                  </div>
                  <div>
                    <h3 className='text-white font-semibold'>Evolução do MRR</h3>
                    <p className='text-slate-400 text-sm'>Últimos 6 meses</p>
                  </div>
                </div>
                <div className='p-6'>
                  <div className='flex items-end gap-4 h-48'>
                    {mrrByMonth.map((m, i) => (
                      <div key={i} className='flex-1 flex flex-col items-center'>
                        <div className='w-full bg-slate-800 rounded-t-lg relative' style={{ height: '160px' }}>
                          <div className='absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-500 to-green-400 rounded-t-lg transition-all' style={{ height: `${(m.value / maxMRR) * 100}%` }}></div>
                        </div>
                        <p className='text-xs text-slate-400 mt-2'>{m.month}</p>
                        <p className='text-xs text-green-400 font-medium'>R$ {fmt(m.value)}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
                {/* Funil de Vendas */}
                <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                  <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                    <div className='p-2 bg-purple-500/10 rounded-lg'>
                      <Icon name='userPlus' className='w-5 h-5 text-purple-400' />
                    </div>
                    <div>
                      <h3 className='text-white font-semibold'>Funil de Vendas</h3>
                      <p className='text-slate-400 text-sm'>Distribuição de leads por estágio</p>
                    </div>
                  </div>
                  <div className='p-6 space-y-3'>
                    {funnelData.map((item, idx) => {
                      const width = funnelData[0].count > 0 ? Math.max((item.count / funnelData[0].count) * 100, 10) : 10;
                      const colors = ['bg-slate-500', 'bg-blue-500', 'bg-purple-500', 'bg-yellow-500', 'bg-green-500', 'bg-red-500'];
                      return (
                        <div key={item.status} className='flex items-center gap-3'>
                          <div className='w-24 text-sm text-slate-400'>{item.status}</div>
                          <div className='flex-1 h-8 bg-slate-800 rounded-lg overflow-hidden relative' style={{ width: `${width}%` }}>
                            <div className={`h-full ${colors[idx]} rounded-lg flex items-center justify-center`}>
                              <span className='text-xs font-medium text-white'>{item.count} • R$ {fmt(item.value)}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Top Produtos */}
                <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                  <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                    <div className='p-2 bg-blue-500/10 rounded-lg'>
                      <Icon name='package' className='w-5 h-5 text-blue-400' />
                    </div>
                    <div>
                      <h3 className='text-white font-semibold'>Top 5 Produtos</h3>
                      <p className='text-slate-400 text-sm'>Por receita em assinaturas</p>
                    </div>
                  </div>
                  <div className='p-4'>
                    {topProducts.length === 0 ? (
                      <p className='text-slate-500 text-center py-8'>Nenhum dado disponível</p>
                    ) : (
                      <div className='space-y-3'>
                        {topProducts.map((item, idx) => (
                          <div key={idx} className='flex items-center gap-3 p-3 bg-slate-800 rounded-lg'>
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${idx === 0 ? 'bg-yellow-500/20 text-yellow-400' : 'bg-slate-700 text-slate-400'}`}>
                              {idx + 1}
                            </div>
                            <div className='flex-1'>
                              <p className='font-medium text-white'>{item.product?.name || 'Produto'}</p>
                              <p className='text-xs text-slate-500'>{item.count} assinaturas</p>
                            </div>
                            <div className='text-right'>
                              <p className='font-semibold text-green-400'>R$ {fmt(item.revenue)}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Histórico de Atividades */}
              <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center justify-between'>
                  <div className='flex items-center gap-3'>
                    <div className='p-2 bg-slate-700/50 rounded-lg'>
                      <Icon name='clock' className='w-5 h-5 text-slate-300' />
                    </div>
                    <div>
                      <h3 className='text-white font-semibold'>Histórico de Atividades</h3>
                      <p className='text-slate-400 text-sm'>Últimas ações no sistema</p>
                    </div>
                  </div>
                  {/* D1 (11/10/2026): o "Limpar histórico" (TRUNCATE da trilha de todos, num clique e sem confirm) saiu. No
                      lugar, apagar o que é mais velho que N dias, pelo /cleanup, com confirm e a data de corte. */}
                  <div className='flex items-center gap-2 text-sm text-slate-400'>
                    <span>Apagar registros com mais de</span>
                    <input type='number' min={30} value={diasDaLimpeza} onChange={(e) => setDiasDaLimpeza(Math.max(30, parseInt(e.target.value, 10) || 30))} aria-label='Dias do histórico a manter' className={`w-20 px-2 py-1 ${campo} rounded`} />
                    <span>dias</span>
                    {/* A1 (26/10/2026): o servidor exige, desde 12/10, o número da prévia (`confirmar`), e a tela não mandava: o
                        botão tomava 409 sempre. Agora conta antes, mostra quantos saem e manda esse número. Destrutivo
                        contornado, como os outros. */}
                    <button
                      data-apagar-antigos
                      onClick={async () => {
                        let previa: PreviaDaLimpeza;
                        try { previa = await activityLogService.cleanupPreview(diasDaLimpeza); } catch (e) { showToast(`Não consegui contar o que sai: ${mensagemDoErroDeCarga(e)}`, 'error'); return; }
                        if (!(Number(previa?.aApagar) > 0)) { showToast(`Nada a apagar: nenhum registro anterior a ${fmtDate(previa?.corteISO)}.`, 'info'); return; }
                        if (!(await confirmarPerigo(confirmacaoDaLimpeza(previa)))) return;
                        try {
                          const r = await activityLogService.cleanup(diasDaLimpeza, previa.aApagar);
                          showToast(`${Number(r?.deleted) || 0} registro(s) anteriores a ${fmtDate(previa.corteISO)} apagado(s).`, 'info');
                          loadActivityLogs();
                        } catch (e: any) {
                          showToast(recusaDaLimpeza(e) || `Não consegui apagar: ${mensagemDoErroDeCarga(e)}`, 'error');
                        }
                      }}
                      className='px-2.5 py-1 rounded border border-danger bg-transparent text-red-400 hover:bg-danger/10 text-xs font-medium'
                    >
                      Apagar antigos…
                    </button>
                  </div>
                </div>
                <div className='max-h-64 overflow-y-auto'>
                  <EstadoDaLista carga={cargaDoHistorico} temDados={cargaDoHistorico.atualizadoEm !== null} oQue='o histórico de atividades' onTentarDeNovo={loadActivityLogs} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
                  {activityLog.length === 0 ? (
                    <p className='text-slate-500 text-center py-8'>Nenhuma atividade registrada</p>
                  ) : (
                    <div className='divide-y divide-slate-800'>
                      {activityLog.slice(0, 20).map((log: any) => (
                        <div key={log.id} className='px-4 py-3 flex items-center gap-3'>
                          <div className='w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center'>
                            <span className='text-xs font-medium text-slate-400'>{log.user?.charAt(0)}</span>
                          </div>
                          <div className='flex-1'>
                            <p className='text-sm text-white'><span className='font-medium'>{log.action}</span> {log.details}</p>
                            <p className='text-xs text-slate-500'>{log.user} • {fmtDateTime(log.timestamp)}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  </EstadoDaLista>
                </div>
              </div>
            </div>
          );
          })()}

          {section === 'integrations' && user?.role === 'admin' && (
            <IntegrationsTab />
          )}

          {section === 'settings' && user?.role === 'admin' && (
            <div className='space-y-6'>
              {/* Dados da Empresa */}
              <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                  <div className='p-2 bg-slate-700/50 rounded-lg'>
                    <Icon name='building' className='w-5 h-5 text-slate-300' />
                  </div>
                  <div>
                    <h3 className='text-white font-semibold'>Dados da Empresa</h3>
                    <p className='text-slate-400 text-sm'>Informações que aparecerão nas propostas e assinaturas</p>
                  </div>
                </div>
                <div className='p-6'>
                  {/* D2 (11/10/2026): o estado nasce com as constantes do config/company; sem a leitura, a tela as mostrava como
                      o cadastro e o Salvar as gravava por cima do real. O form só aparece com a leitura. */}
                  <EstadoDaLista carga={cargaDasConfiguracoes} temDados={cargaDasConfiguracoes.atualizadoEm !== null} oQue='as configurações da empresa' onTentarDeNovo={loadData} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Razão Social</label>
                      <input type='text' value={companySettings.companyName} onChange={e => setCompanySettings({...companySettings, companyName: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Nome Fantasia</label>
                      <input type='text' value={companySettings.tradeName} onChange={e => setCompanySettings({...companySettings, tradeName: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                  </div>
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-4'>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>CNPJ</label>
                      <input type='text' value={companySettings.cnpj} onChange={e => setCompanySettings({...companySettings, cnpj: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Telefone</label>
                      <input type='text' value={companySettings.phone} onChange={e => setCompanySettings({...companySettings, phone: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>WhatsApp</label>
                      <input type='text' value={companySettings.whatsapp} onChange={e => setCompanySettings({...companySettings, whatsapp: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                  </div>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Email</label>
                      <input type='email' value={companySettings.email} onChange={e => setCompanySettings({...companySettings, email: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Website</label>
                      <input type='text' value={companySettings.website} onChange={e => setCompanySettings({...companySettings, website: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                  </div>
                  <div className='mb-4'>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Endereço</label>
                    <input type='text' value={companySettings.address} onChange={e => setCompanySettings({...companySettings, address: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                  </div>
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-6'>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Cidade</label>
                      <input type='text' value={companySettings.city} onChange={e => setCompanySettings({...companySettings, city: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>Estado</label>
                      <input type='text' value={companySettings.state} onChange={e => setCompanySettings({...companySettings, state: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} maxLength={2} />
                    </div>
                    <div>
                      <label className='block text-sm font-medium text-slate-300 mb-1'>CEP</label>
                      <input type='text' value={companySettings.zipCode} onChange={e => setCompanySettings({...companySettings, zipCode: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                  </div>
                  <button
                    onClick={async () => {
                      setSavingCompanySettings(true);
                      try {
                        await systemService.updateCompanySettings(companySettings);
                        avisar('Configurações salvas com sucesso!', 'success');
                      } catch (e) {
                        avisar(`Não salvei as configurações: ${mensagemDoErroDeCarga(e)}`, 'error');
                      }
                      setSavingCompanySettings(false);
                    }}
                    disabled={savingCompanySettings || cargaDasConfiguracoes.estado !== 'pronto'}
                    className='px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'
                  >
                    {savingCompanySettings ? 'Salvando...' : 'Salvar Configurações'}
                  </button>
                  </EstadoDaLista>
                </div>
              </div>

              {/* Informações do Sistema */}
              <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                  <div className='p-2 bg-blue-500/10 rounded-lg'>
                    <Icon name='settings' className='w-5 h-5 text-blue-400' />
                  </div>
                  <div>
                    <h3 className='text-white font-semibold'>Informações do Sistema</h3>
                    <p className='text-slate-400 text-sm'>Versão e dados técnicos</p>
                  </div>
                </div>
                <div className='p-6'>
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                    <div className='bg-slate-800 rounded-lg p-4'>
                      <p className='text-sm text-slate-400'>Versão</p>
                      <p className='text-xl font-bold text-white mt-1'>{versionInfo.version}</p>
                      <p className='text-xs text-slate-500 mt-1'>Build {versionInfo.commitHash} • {versionInfo.buildDate}</p>
                    </div>
                    <div className='bg-slate-800 rounded-lg p-4'>
                      <p className='text-sm text-slate-400'>Usuário Logado</p>
                      <p className='text-xl font-bold text-white mt-1'>{user?.name}</p>
                      <p className='text-xs text-slate-500 mt-1'>{user?.email}</p>
                    </div>
                    <div className='bg-slate-800 rounded-lg p-4'>
                      <p className='text-sm text-slate-400'>Perfil</p>
                      <p className='text-xl font-bold text-red-400 mt-1'>Administrador</p>
                      <p className='text-xs text-slate-500 mt-1'>Acesso total</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Custo Claude API — o número já existia, mas só na tela de
                  Automação (infraestrutura). Quem abre Relatórios é quem decide
                  orçamento e não vai caçar gasto de API dentro de um painel de
                  sessão e proxy. Soma as duas fontes: banco (edital/proposta) e
                  serviço de automação (captcha). */}
              <ClaudeCostReportCard />

              {/* Estatísticas do Sistema */}
              <div className='bg-slate-800/50 rounded-xl border border-slate-700 overflow-hidden'>
                <div className='p-4 border-b border-slate-800 flex items-center gap-3'>
                  <div className='p-2 bg-green-500/10 rounded-lg'>
                    <Icon name='chart' className='w-5 h-5 text-green-400' />
                  </div>
                  <div>
                    <h3 className='text-white font-semibold'>Estatísticas do Sistema</h3>
                    <p className='text-slate-400 text-sm'>Resumo geral dos dados cadastrados</p>
                  </div>
                </div>
                <div className='p-6'>
                  <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                    <div className='bg-slate-800 rounded-lg p-4 text-center'>
                      <p className='text-3xl font-bold text-white'>{clients.length}</p>
                      <p className='text-sm text-slate-400 mt-1'>Clientes</p>
                    </div>
                    <div className='bg-slate-800 rounded-lg p-4 text-center'>
                      <p className='text-3xl font-bold text-white'>{contracts.length}</p>
                      <p className='text-sm text-slate-400 mt-1'>Assinaturas</p>
                    </div>
                    <div className='bg-slate-800 rounded-lg p-4 text-center'>
                      <p className='text-3xl font-bold text-white'>{products.length}</p>
                      <p className='text-sm text-slate-400 mt-1'>Produtos</p>
                    </div>
                    <div className='bg-slate-800 rounded-lg p-4 text-center'>
                      <p className='text-3xl font-bold text-white'>{leads.length}</p>
                      <p className='text-sm text-slate-400 mt-1'>Leads</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* A4 (12/10/2026): as etapas do funil, editáveis com a #409 do backend. Gravou, o board e a ficha releem. */}
              <EtapasDoFunilSettings onSalvo={setFunil} />

              {/* Credenciais e Integrações */}
              <CredentialsSettings />
            </div>
          )}
        </main>
      </div>

      {modal === 'ddr' && (() => {
        const selectedClient = clients.find((c: any) => c.id === form.clientId);
        /**
         * Cada linha pode ter FORNECEDOR, TECNOLOGIA, OPERADORA REAL e CLIENTE
         * FINAL próprios.
         * Vazio = usa o padrão escolhido lá embaixo. A localização não entra aqui
         * porque é derivada do próprio número pelo backend (applyCnl), número a
         * número: a prévia na tela é só do primeiro.
         */
        /**
         * CLIENTE FINAL NÃO É CLIENTE DA BASE. É o cliente do nosso cliente (o
         * número está hospedado em nome dele na operadora), e cadastrá-lo como
         * cliente sujaria a lista, o contador de "sem assinatura" e o MRR. Hoje
         * 3 dos 8 clientes finais em uso não estão na base, e é assim mesmo.
         *
         * Então a linha escolhe entre os clientes finais JÁ USADOS em outros DDRs
         * e, como conveniência, os clientes da base (às vezes o final é um cliente
         * nosso, como CIUENP e SAMU FRONTEIRA). Cliente final NOVO entra pelo
         * campo do formulário, que consulta a Receita uma vez e vale para a leva.
         */
        const finaisUsados = (() => {
          const mapa = new Map<string, { nome: string; cnpj: string }>();
          for (const d of (clientDDRs || [])) {
            const nome = String((d as any).endClientName || '').trim();
            if (!nome) continue;
            const cnpj = String((d as any).endClientCnpj || '').trim();
            const chave = (cnpj || nome).toLowerCase();
            if (!mapa.has(chave)) mapa.set(chave, { nome, cnpj });
          }
          return Array.from(mapa.values()).sort((a, b) => a.nome.localeCompare(b.nome));
        })();

        const ddrList: Array<{phoneNumber: string; carrierId?: any; hostCarrierId?: any; endClient?: string}> =
          form.ddrList || [{phoneNumber: form.phoneNumber || ''}];
        const isRangeMode = form.ddrRangeMode || false;
        const isPasteMode = form.ddrPasteMode || false;
        // Colunas por linha ficam ESCONDIDAS por padrão. Com elas sempre visíveis,
        // fornecedor, operadora real e cliente final apareciam duas
        // vezes na mesma tela (na linha e no bloco de baixo) e a tela parecia
        // duplicada. O caso comum é tudo igual; o misto é a exceção e pede o
        // clique.
        const porLinha = form.ddrPorLinha || false;
        const ddrPasteText: string = form.ddrPasteText || '';
        const rangeStart = form.ddrRangeStart || '';
        const rangeEnd = form.ddrRangeEnd || '';

        const calculateRangeCount = () => {
          if (!rangeStart || !rangeEnd) return 0;
          const start = parseInt(rangeStart);
          const end = parseInt(rangeEnd);
          if (isNaN(start) || isNaN(end) || end < start) return 0;
          return end - start + 1;
        };
        const rangeCount = calculateRangeCount();

        const saveDDRs = async () => {
          setSaving(true);
          setRecusasDoDdr([]);
          // As recusas que dizem quem já tem o número (#506) viram o bloco do topo do modal, com "Abrir DDR #id".
          const comDono: RecusaDoDdr[] = [];
          const anotar = (e: any, numero: string) => { const r = lerRecusaDoDdr(e, numero); if (r) comDono.push(r); };
          try {
            // Limpa campos extras do form antes de enviar
            const { ddrList: _dl, ddrRangeMode: _drm, ddrRangeStart: _drs, ddrRangeEnd: _dre, ddrPasteMode: _dpm, ddrPasteText: _dpt, ddrPorLinha: _dpl, ...cleanForm } = form;
            if (editing) {
              await clientDDRsService.update(editing.id, cleanForm);
              setToast({ message: 'DDR atualizado com sucesso!', type: 'success' });
            } else if (isPasteMode && ddrPasteText.trim()) {
              const pasteNumbers = ddrPasteText
                .split(/[\n,;\s]+/)
                .map(n => n.replace(/\D/g, '').trim())
                .filter(n => n.length >= 8);
              if (pasteNumbers.length === 0) { setToast({ message: 'Nenhum número válido encontrado', type: 'error' }); setSaving(false); return; }
              if (pasteNumbers.length > 1000) { setToast({ message: 'Máximo de 1000 DDRs por vez', type: 'error' }); setSaving(false); return; }
              let created = 0;
              const recusas: Recusa[] = [];
              for (const num of pasteNumbers) {
                try {
                  await clientDDRsService.create({ ...cleanForm, phoneNumber: num });
                  created++;
                } catch (e) { recusas.push({ numero: num, motivo: mensagemDoErroDeCarga(e) }); anotar(e, num); }
              }
              setRecusasDoDdr(comDono);
              // D9: dizia "N DDRs criados com sucesso!" (até com 0), fechava o modal e os recusados sumiam.
              const resumo = resumoDoLote(created, recusas);
              setToast({ message: resumo.mensagem, type: resumo.tom });
              if (recusas.length > 0) {
                setForm((f: any) => ({ ...f, ddrPasteText: recusas.map((r) => r.numero).join('\n') }));
                if (created > 0) loadData();
                setSaving(false);
                return;
              }
            } else if (isRangeMode && rangeStart && rangeEnd) {
              const start = parseInt(rangeStart);
              const end = parseInt(rangeEnd);
              if (end < start) { setToast({ message: 'Número final deve ser maior que inicial', type: 'error' }); setSaving(false); return; }
              if (end - start > 999) { setToast({ message: 'Máximo de 1000 DDRs por vez', type: 'error' }); setSaving(false); return; }
              const { ddrList: _ignore, ddrRangeMode: _m, ddrRangeStart: _s, ddrRangeEnd: _e, ddrPorLinha: _pl, phoneNumber: _p, ...baseData } = form;
              const result = await clientDDRsService.bulkCreate(baseData, start, end);
              const pedidos = end - start + 1;
              const criados = Number(result?.created) || 0;
              setToast({
                message: criados === pedidos ? `${criados} DDRs criados.` : `${criados} de ${pedidos} DDRs criados; o servidor recusou ${pedidos - criados} (já existentes ou inválidos).`,
                type: criados === pedidos ? 'success' : criados === 0 ? 'error' : 'warning',
              });
            } else {
              const numbers = ddrList.filter(d => d.phoneNumber.trim());
              if (numbers.length === 0) { setToast({ message: 'Informe ao menos um número DDR', type: 'error' }); setSaving(false); return; }
              let created = 0;
              const recusas: Recusa[] = [];
              const linhasRecusadas: typeof numbers = [];
              const ENUMV = ['TIP','ALGAR','SYSSVOIP','DATORA','VIVO','CLARO','OI'];
              for (const ddr of numbers) {
                try {
                  // O que a linha define vence o padrão do formulário — e só
                  // quando o modo "valores diferentes por linha" está ligado, para
                  // uma escolha esquecida na linha não vazar depois de desligar.
                  const linha: any = { ...cleanForm, phoneNumber: ddr.phoneNumber };
                  if (!porLinha) { await clientDDRsService.create(linha); created++; continue; }
                  if (ddr.carrierId) {
                    const p = (telecomCarriers || []).find((c: any) => c.id === Number(ddr.carrierId));
                    linha.carrierId = Number(ddr.carrierId);
                    linha.carrier = p ? (ENUMV.includes((p.nome || '').toUpperCase()) ? (p.nome || '').toUpperCase() : 'Outro') : linha.carrier;
                  }
                  if (ddr.hostCarrierId) {
                    const h = (telecomCarriers || []).find((c: any) => c.id === Number(ddr.hostCarrierId));
                    linha.hostCarrierId = Number(ddr.hostCarrierId);
                    linha.hostCarrier = h ? h.nome : linha.hostCarrier;
                  }
                  // Cliente final da linha. O valor carrega a origem: "cli:<id>"
                  // veio da base de clientes, "ddr:<chave>" veio dos clientes
                  // finais já usados em outros DDRs (que não são clientes nossos).
                  if (ddr.endClient) {
                    const [origem, chave] = String(ddr.endClient).split(':');
                    if (origem === 'cli') {
                      const f = clients.find((c: any) => String(c.id) === chave);
                      if (f) {
                        linha.endClientName = f.name || f.tradeName || f.companyName || linha.endClientName;
                        linha.endClientCnpj = f.cnpj ? maskCNPJ(f.cnpj) : linha.endClientCnpj;
                      }
                    } else {
                      const f = finaisUsados.find((x) => (x.cnpj || x.nome).toLowerCase() === chave);
                      if (f) {
                        linha.endClientName = f.nome;
                        linha.endClientCnpj = f.cnpj || linha.endClientCnpj;
                      }
                    }
                  }
                  await clientDDRsService.create(linha);
                  created++;
                } catch (e) { recusas.push({ numero: ddr.phoneNumber, motivo: mensagemDoErroDeCarga(e) }); linhasRecusadas.push(ddr); anotar(e, ddr.phoneNumber); }
              }
              setRecusasDoDdr(comDono);
              const resumo = resumoDoLote(created, recusas);
              setToast({ message: resumo.mensagem, type: resumo.tom });
              if (recusas.length > 0) {
                // Só os recusados ficam no formulário, com o que cada linha tinha.
                setForm((f: any) => ({ ...f, ddrList: linhasRecusadas }));
                if (created > 0) loadData();
                setSaving(false);
                return;
              }
            }
            closeModal();
            loadData();
          } catch (e: any) {
            // Editar (update) e a faixa (bulk-create) caem aqui. Com a recusa do #506, o bloco do modal diz quem tem o
            // número e abre o registro; o toast fica curto, para não repetir a frase.
            const r = lerRecusaDoDdr(e, String(form.phoneNumber || ''));
            if (r) {
              setRecusasDoDdr([r]);
              setToast({ message: r.tipo === 'lote' ? 'Nenhum DDR foi criado: a faixa tem números já cadastrados.' : r.tipo === 'duplicado' ? `Número já cadastrado no DDR #${r.existente.id}.` : r.mensagem, type: 'error' });
            } else setToast({ message: e.response?.data?.message || 'Erro ao salvar', type: 'error' });
          }
          setSaving(false);
        };

        const nomeDoCliente = (id: number) => { const c = clients.find((x: any) => x.id === id); return c ? (c.name || c.tradeName || c.companyName) : null; };
        // Abre o DDR que já tem o número, no lugar deste modal. Ele pode ser de outro cliente e não estar na lista
        // em memória (inativo, cancelado): então relê do servidor.
        const abrirDdrExistente = async (id: number) => {
          const naLista = (clientDDRs || []).find((d: any) => d.id === id);
          try {
            openModal('ddr', naLista || await clientDDRsService.getById(id));
          } catch (e) { setToast({ message: `Não consegui abrir o DDR #${id}: ${mensagemDoErroDeCarga(e)}`, type: 'error' }); }
        };
        const botaoAbrir = (d: { id: number }) => (
          <button type='button' onClick={() => abrirDdrExistente(d.id)} className={`shrink-0 px-2.5 py-1 rounded border text-xs font-medium ${TONE_BORDER.danger} hover:bg-red-500/10`}>Abrir DDR #{d.id}</button>
        );

        return (
        // DUAS COLUNAS, não abas: o cadastro do DDR tem uma dúzia de campos e
        // quase todos se conferem juntos (o número, de onde ele é, quem fornece e
        // em que endereço de acesso termina). A grade vive no corpo da casca. Não fecha ao clicar
        // fora (editor, como já era).
        <CascaDeModal
          largura='xl'
          titulo={editing ? 'Editar DDR' : 'Novo DDR'}
          subtitulo={editing && form.phoneNumber ? form.phoneNumber : undefined}
          onClose={closeModal}
          corpoClassName='p-6 grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-4 content-start'
          rodape={
            <>
              <button onClick={closeModal} disabled={saving} className='flex-1 px-6 py-3 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'>Cancelar</button>
              <button onClick={saveDDRs} disabled={saving || !form.clientId || (editing ? !form.phoneNumber : (isPasteMode ? !ddrPasteText.split(/[\n,;\s]+/).some(n => n.replace(/\D/g, '').length >= 8) : (isRangeMode ? (rangeCount === 0 || rangeCount > 1000) : !ddrList.some(d => d.phoneNumber.trim()))))} className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{saving ? 'Salvando...' : (editing ? 'Salvar' : (isPasteMode ? (() => { const c = ddrPasteText.split(/[\n,;\s]+/).filter(n => n.replace(/\D/g, '').length >= 8).length; return c > 1 ? `Criar ${c} DDRs` : 'Salvar'; })() : (isRangeMode && rangeCount > 1 ? `Criar ${rangeCount} DDRs` : ddrList.filter(d => d.phoneNumber.trim()).length > 1 ? `Criar ${ddrList.filter(d => d.phoneNumber.trim()).length} DDRs` : 'Salvar')))}</button>
            </>
          }
        >
              {recusasDoDdr.length > 0 && (
                <div role='alert' className={`lg:col-span-2 px-4 py-3 rounded-lg border text-sm space-y-2 ${TONE_SURFACE.danger} ${TONE_BORDER.danger} ${TONE_TEXT.danger}`} data-recusa-do-ddr>
                  {recusasDoDdr.map((r, i) => r.tipo === 'duplicado' ? (
                    <div key={i} className='flex items-start justify-between gap-3' data-ddr-duplicado={r.existente.id}>
                      <p>{fraseDoDuplicado(r, nomeDoCliente)}</p>
                      {botaoAbrir(r.existente)}
                    </div>
                  ) : r.tipo === 'lote' ? (
                    <div key={i} data-ddr-duplicado-em-lote>
                      <p className='font-medium'>{fraseDoLote(r)}</p>
                      <ul className='mt-2 space-y-1 max-h-48 overflow-y-auto'>
                        {r.conflitos.map((c) => (
                          <li key={c.id} className='flex items-center justify-between gap-3'>
                            <span><span className='font-mono'>{c.phoneNumber}</span> → DDR #{c.id}, de {donoDoDdr(c, nomeDoCliente)}{c.status ? `, ${c.status}` : ''}</span>
                            {botaoAbrir(c)}
                          </li>
                        ))}
                      </ul>
                      {r.total > r.conflitos.length && <p className='mt-1 text-xs'>…e mais {r.total - r.conflitos.length}, que o servidor não listou.</p>}
                    </div>
                  ) : (
                    <p key={i} data-ddr-sem-digitos>{r.mensagem || `"${r.numeroDigitado}" não tem dígito nenhum e não pode virar um DDR.`}</p>
                  ))}
                </div>
              )}
              {/* Cliente */}
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Cliente *</label>
                <select value={form.clientId || ''} onChange={e => { const newClientId = parseInt(e.target.value); if (!isNaN(newClientId)) setForm({...form, clientId: newClientId}); }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                  <option value=''>Selecione o cliente</option>
                  {clients.filter((c: any) => c.status === 'Ativo').sort((a: any, b: any) => (a.name || a.tradeName || a.companyName || '').localeCompare(b.name || b.tradeName || b.companyName || '')).map((c: any) => <option key={c.id} value={c.id}>{c.name || c.tradeName || c.companyName}</option>)}
                </select>
                {selectedClient && (
                  <div className='mt-2 p-3 bg-central-elevado/50 rounded-lg border border-central-borda'>
                    <div className='flex items-center gap-4 text-sm'>
                      <div><span className='text-slate-500'>CNPJ:</span> <span className='text-slate-300 font-mono'>{fmtCNPJ(selectedClient.cnpj)}</span></div>
                      <div><span className='text-slate-500'>Razão:</span> <span className='text-slate-300'>{selectedClient.companyName}</span></div>
                    </div>
                  </div>
                )}
              </div>

              {/* Cliente Final — mesmo formato do bloco Cliente acima:
                  entrada em cima, resumo CNPJ/Razão embaixo */}
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Cliente Final{!editing && !isRangeMode && !isPasteMode && porLinha && <span className='text-slate-500 font-normal'> (padrão da lista)</span>}</label>
                <select
                  value=''
                  onChange={e => {
                    const id = parseInt(e.target.value);
                    if (isNaN(id)) return;
                    const c = clients.find((x: any) => x.id === id);
                    if (c) { setForm({ ...form, endClientName: (c.name || c.tradeName || c.companyName) || undefined, endClientCnpj: c.cnpj ? maskCNPJ(c.cnpj) : undefined }); setEndClientNameEdit(false); }
                  }}
                  className={`w-full mb-2 px-4 py-2.5 rounded-lg text-sm ${campo}`}
                >
                  <option value=''>Carregar cliente da base… (opcional)</option>
                  {clients.filter((c: any) => c.status === 'Ativo').sort((a: any, b: any) => (a.name || a.tradeName || a.companyName || '').localeCompare(b.name || b.tradeName || b.companyName || '')).map((c: any) => <option key={c.id} value={c.id}>{c.name || c.tradeName || c.companyName}</option>)}
                </select>
                {(() => {
                  // Busca a razão social na Receita e preenche o nome do cliente final.
                  // Sem o nome a linha "→ cliente final" não aparece na tabela e o DDR
                  // fica sem rastro do CNPJ a que o número está vinculado na operadora.
                  const buscarEndClient = async (cnpj: string, overwriteName: boolean) => {
                    const clean = (cnpj || '').replace(/\D/g, '');
                    if (clean.length !== 14) { showToast('CNPJ deve ter 14 dígitos', 'error'); return; }
                    setEndClientCnpjLoading(true);
                    try {
                      const data = await cnpjService.search(clean);
                      if (!data || data.error || data.status === 'ERROR') {
                        showToast(data?.message || 'CNPJ não encontrado na Receita', 'error');
                        return;
                      }
                      const nome = data.nome || data.fantasia || '';
                      setForm((prev: any) => ({
                        ...prev,
                        endClientCnpj: maskCNPJ(clean),
                        endClientName: (overwriteName || !prev.endClientName) ? (nome || prev.endClientName) : prev.endClientName,
                      }));
                      if (nome) { setEndClientNameEdit(false); showToast(`Cliente final: ${nome}`, 'success'); }
                    } catch {
                      showToast('Erro ao buscar CNPJ', 'error');
                    } finally {
                      setEndClientCnpjLoading(false);
                    }
                  };
                  return (
                    <div className='flex gap-2'>
                      <input
                        type='text'
                        value={form.endClientCnpj || ''}
                        onChange={e => {
                          const masked = maskCNPJ(e.target.value);
                          setForm({ ...form, endClientCnpj: masked || undefined });
                          // completou o CNPJ digitando/colando: preenche o nome se ainda estiver vazio
                          if (masked.replace(/\D/g, '').length === 14 && !form.endClientName) buscarEndClient(masked, false);
                        }}
                        placeholder='CNPJ do cliente final'
                        maxLength={18}
                        className={`flex-1 px-4 py-2.5 ${campo} rounded-lg`}
                      />
                      <button
                        type='button'
                        onClick={() => buscarEndClient(form.endClientCnpj || '', true)}
                        disabled={endClientCnpjLoading}
                        title='Buscar razão social na Receita'
                        className='px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong disabled:opacity-50 flex items-center justify-center'
                      >
                        {endClientCnpjLoading ? <Icon name='loader' className='w-4 h-4 animate-spin' /> : <Icon name='search' className='w-4 h-4' />}
                      </button>
                    </div>
                  );
                })()}
                {/* Resumo, igual ao do Cliente. Sem razão social ainda, cai no input
                    pra digitar à mão (CNPJ fora da Receita, nome diferente do registro). */}
                {form.endClientName && !endClientNameEdit ? (
                  <div className='mt-2 p-3 bg-central-elevado/50 rounded-lg border border-central-borda'>
                    <div className='flex items-center gap-4 text-sm'>
                      <div className='whitespace-nowrap'><span className='text-slate-500'>CNPJ:</span> <span className='text-slate-300 font-mono'>{form.endClientCnpj ? fmtCNPJ(form.endClientCnpj) : '—'}</span></div>
                      <div className='min-w-0 flex-1 truncate'><span className='text-slate-500'>Razão:</span> <span className='text-slate-300'>{form.endClientName}</span></div>
                      <button type='button' onClick={() => setEndClientNameEdit(true)} className='shrink-0 text-xs text-slate-400 hover:text-white'>editar</button>
                    </div>
                  </div>
                ) : ((form.endClientCnpj || '').replace(/\D/g, '').length === 14 || endClientNameEdit) ? (
                  <input
                    type='text'
                    autoFocus={endClientNameEdit}
                    value={form.endClientName || ''}
                    onChange={e => setForm({ ...form, endClientName: e.target.value || undefined })}
                    onBlur={() => { if (form.endClientName) setEndClientNameEdit(false); }}
                    placeholder='Razão social do cliente final'
                    className={`mt-2 w-full px-4 py-2.5 ${campo} rounded-lg`}
                  />
                ) : null}
              </div>

              {/* Modo de entrada DDR - apenas para criação */}
              {!editing && (
                <div className='lg:col-span-2'>
                  <label className='block text-sm font-medium text-slate-300 mb-2'>Modo de Entrada</label>
                  <div className='flex gap-2'>
                    <button type='button' onClick={() => setForm({...form, ddrRangeMode: false, ddrPasteMode: false})} className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${!isRangeMode && !isPasteMode ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}>
                      Lista de DDRs
                    </button>
                    <button type='button' onClick={() => setForm({...form, ddrRangeMode: true, ddrPasteMode: false})} className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${isRangeMode && !isPasteMode ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}>
                      Faixa de DDRs
                    </button>
                    <button type='button' onClick={() => setForm({...form, ddrRangeMode: false, ddrPasteMode: true})} className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${isPasteMode ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}>
                      Colar Números
                    </button>
                  </div>
                </div>
              )}

              {/* Números DDR */}
              {!editing && !isRangeMode && !isPasteMode && (
                <div className='lg:col-span-2'>
                  <div className='flex items-center justify-between mb-2 gap-3'>
                    <label className='block text-sm font-medium text-slate-300'>Números DDR *</label>
                    <div className='flex items-center gap-3'>
                      <button type='button' onClick={() => setForm({...form, ddrPorLinha: !porLinha})} className={`text-xs px-2.5 py-1 rounded-md border transition-colors ${porLinha ? 'border-slate-600 bg-slate-600 text-white font-semibold' : 'border-slate-700 text-slate-400 hover:text-slate-200'}`} title='Quando os números não são todos do mesmo fornecedor, operadora real ou cliente final.'>
                        {porLinha ? 'Usando valores por linha' : 'Valores diferentes por linha'}
                      </button>
                      <button type='button' onClick={() => setForm({...form, ddrList: [...ddrList, {phoneNumber: ''}]})} className='flex items-center gap-1 text-sm text-slate-300 hover:text-white'>
                        <Icon name='plus' className='w-4 h-4' /> Adicionar
                      </button>
                    </div>
                  </div>
                  {/* Cada linha carrega fornecedor e operadora real
                      próprios porque um mesmo cliente tem números de praças e de
                      provedores diferentes. Em branco, a linha herda o padrão
                      escolhido nos campos lá embaixo, que é o caso comum. */}
                  {porLinha && (
                    <div className='hidden md:flex gap-2 px-1 pb-1 text-[11px] text-slate-500'>
                      <span className='flex-1'>Número</span>
                      <span className='w-36'>Fornecedor</span>
                      <span className='w-36'>Operadora real</span>
                      <span className='w-44'>Cliente final</span>
                      <span className='w-9' />
                    </div>
                  )}
                  <div className='space-y-2 max-h-60 overflow-y-auto'>
                    {ddrList.map((ddr, idx) => {
                      const trocar = (campos: any) => {
                        const newList = [...ddrList];
                        newList[idx] = { ...newList[idx], ...campos };
                        setForm({...form, ddrList: newList});
                      };
                      const selectCls = `px-2 py-2.5 ${campo} rounded-lg text-xs`;
                      return (
                        <div key={idx} className='flex flex-wrap md:flex-nowrap gap-2'>
                          <input type='text' value={ddr.phoneNumber} onChange={e => trocar({ phoneNumber: e.target.value.replace(/\D/g, '') })} placeholder='Ex: 4532250210' className={`flex-1 min-w-[10rem] px-4 py-2.5 ${campo} rounded-lg`} />
                          {porLinha && (<>
                          <select value={ddr.carrierId || ''} onChange={e => trocar({ carrierId: e.target.value })} title='Fornecedor desta linha. Em branco usa o padrão.' className={`w-36 ${selectCls}`}>
                            <option value=''>padrão</option>
                            {opcaoDaPrestadoraAtual(ddr.carrierId)}
                            {(telecomCarriers || []).filter((c:any) => c.ativo).map((c:any) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                          </select>
                          <select value={ddr.hostCarrierId || ''} onChange={e => trocar({ hostCarrierId: e.target.value })} title='Operadora real (hospedagem) desta linha. Em branco usa o padrão.' className={`w-36 ${selectCls}`}>
                            <option value=''>padrão</option>
                            {opcaoDaPrestadoraAtual(ddr.hostCarrierId)}
                            {(telecomCarriers || []).filter((c:any) => c.ativo).map((c:any) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                          </select>
                          <select value={ddr.endClient || ''} onChange={e => trocar({ endClient: e.target.value })} title='Cliente final desta linha. Em branco usa o do formulário. Cliente final novo entra pelo campo de cima, que consulta a Receita.' className={`w-44 ${selectCls}`}>
                            <option value=''>padrão</option>
                            {finaisUsados.length > 0 && (
                              <optgroup label='Já usados em DDRs'>
                                {finaisUsados.map((f) => (
                                  <option key={`ddr:${f.cnpj || f.nome}`} value={`ddr:${(f.cnpj || f.nome).toLowerCase()}`}>{f.nome}</option>
                                ))}
                              </optgroup>
                            )}
                            <optgroup label='Clientes da base'>
                              {clients.filter((c: any) => c.status === 'Ativo').sort((a: any, b: any) => (a.name || a.tradeName || a.companyName || '').localeCompare(b.name || b.tradeName || b.companyName || '')).map((c: any) => (
                                <option key={`cli:${c.id}`} value={`cli:${c.id}`}>{c.name || c.tradeName || c.companyName}</option>
                              ))}
                            </optgroup>
                          </select>
                          </>)}
                          {ddrList.length > 1 ? (
                            <button type='button' onClick={() => { const newList = ddrList.filter((_, i) => i !== idx); setForm({...form, ddrList: newList}); }} className='w-9 flex items-center justify-center py-2.5 bg-slate-800 border border-slate-700 text-red-400 rounded-lg hover:bg-red-500/10'>
                              <Icon name='trash' className='w-4 h-4' />
                            </button>
                          ) : <span className='w-9' />}
                        </div>
                      );
                    })}
                  </div>
                  {ddrList.filter(d => d.phoneNumber.trim()).length > 1 && (
                    <p className='text-xs text-slate-500 mt-2'>
                      {ddrList.filter(d => d.phoneNumber.trim()).length} DDRs serão criados · cidade, UF e CNL saem do próprio número, um a um
                      {!porLinha && ' · fornecedor, operadora real e cliente final vêm dos campos abaixo'}
                    </p>
                  )}
                </div>
              )}

              {/* Faixa de DDRs */}
              {!editing && isRangeMode && (
                <div className='lg:col-span-2'>
                  <label className='block text-sm font-medium text-slate-300 mb-2'>Faixa de DDRs *</label>
                  <div className='grid grid-cols-2 gap-4'>
                    <div>
                      <label className='block text-xs text-slate-500 mb-1'>De (início)</label>
                      <input type='text' value={rangeStart} onChange={e => setForm({...form, ddrRangeStart: e.target.value.replace(/\D/g, '')})} placeholder='Ex: 4531225100' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                    <div>
                      <label className='block text-xs text-slate-500 mb-1'>Até (fim)</label>
                      <input type='text' value={rangeEnd} onChange={e => setForm({...form, ddrRangeEnd: e.target.value.replace(/\D/g, '')})} placeholder='Ex: 4531225149' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    </div>
                  </div>
                  {rangeCount > 0 && (
                    <p className='text-xs text-slate-500 mt-2'>{rangeCount} DDRs serão criados (de {rangeStart} até {rangeEnd})</p>
                  )}
                  {rangeCount > 1000 && (
                    <p className='text-xs text-red-400 mt-1'>Máximo de 1000 DDRs por vez</p>
                  )}
                </div>
              )}

              {/* Colar Números */}
              {!editing && isPasteMode && (() => {
                const parsedNumbers = ddrPasteText
                  .split(/[\n,;\s]+/)
                  .map(n => n.replace(/\D/g, '').trim())
                  .filter(n => n.length >= 8);
                return (
                  <div className='lg:col-span-2'>
                    <label className='block text-sm font-medium text-slate-300 mb-2'>Colar Números *</label>
                    <textarea
                      value={ddrPasteText}
                      onChange={e => setForm({...form, ddrPasteText: e.target.value})}
                      rows={5}
                      className={`w-full px-4 py-2.5 ${campo} rounded-lg font-mono text-sm`}
                      placeholder={'Cole os números aqui, separados por vírgula, espaço ou quebra de linha:\n\n4531225100\n4531225101\n4531225102\n\nou: 4531225100, 4531225101, 4531225102'}
                    />
                    {parsedNumbers.length > 0 && (
                      <p className='text-xs text-slate-500 mt-2'>{parsedNumbers.length} números identificados</p>
                    )}
                    {parsedNumbers.length > 1000 && (
                      <p className='text-xs text-red-400 mt-1'>Máximo de 1000 DDRs por vez</p>
                    )}
                  </div>
                );
              })()}

              {/* Número DDR único - apenas para edição */}
              {editing && (
                <div>
                  <label className='block text-sm font-medium text-slate-300 mb-1'>Número DDR *</label>
                  <input type='text' value={form.phoneNumber || ''} onChange={e => setForm({...form, phoneNumber: e.target.value.replace(/\D/g, '')})} placeholder='Ex: 4532250210' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                </div>
              )}

              {/* Localização — derivada da base ANATEL/STFC (read-only) */}
              {(() => {
                const dispCity = cnlPreview?.city ?? form.city ?? null;
                const dispState = cnlPreview?.state ?? form.state ?? null;
                const dispCnl = cnlPreview ? cnlPreview.cnl : (form.cnl ?? null);
                const dispCnlLoc = cnlPreview ? cnlPreview.cnlLocalidade : (form.cnlLocalidade ?? null);
                const dispAreaLocal = cnlPreview ? cnlPreview.areaLocal : ((form as any).areaLocal ?? null);
                const notFound = cnlPreview && !cnlPreview.found;
                // A prévia que falha diz (sumia calada); não grava nada.
                const ro = `w-full px-4 py-2.5 ${campoSomenteLeitura} rounded-lg`;
                return (
                  <div className='rounded-lg border border-central-borda bg-central-elevado/30 p-3 space-y-3'>
                    {cnlPreviewErro && <p role='status' className={`text-xs ${TONE_TEXT.warning}`}>Não consegui consultar a base ANATEL para este número: {cnlPreviewErro}.</p>}
                    <div className='flex items-center justify-between'>
                      <span className='text-xs font-medium text-slate-400'>Localização</span>
                      <span className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full ${TONE_BADGE.neutral} border ${TONE_BORDER.neutral}`}>
                        <Icon name='lock' className='w-3 h-3' /> derivado da base ANATEL
                      </span>
                    </div>
                    <div className='grid grid-cols-2 gap-4'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Cidade</label><input type='text' value={dispCity || ''} disabled readOnly placeholder={cnlPreviewLoading ? 'buscando…' : '—'} className={ro} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>UF</label><input type='text' value={dispState || ''} disabled readOnly placeholder={cnlPreviewLoading ? '…' : '—'} className={ro} /></div>
                    </div>
                    <div className='grid grid-cols-2 gap-4'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Área Local</label><input type='text' value={dispAreaLocal || ''} disabled readOnly placeholder={cnlPreviewLoading ? 'buscando…' : '—'} className={ro} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>CNL</label><input type='text' value={dispCnl ? `${dispCnl}${dispCnlLoc ? ' · ' + dispCnlLoc : ''}` : ''} disabled readOnly placeholder={cnlPreviewLoading ? 'buscando…' : '—'} className={ro} /></div>
                    </div>
                    {notFound
                      ? <p className='text-[11px] text-amber-400/90'>Prefixo não encontrado na base ANATEL local — cidade/UF/CNL/Área Local ficarão em branco até a consulta na ABR (fase seguinte).</p>
                      : <p className='text-[11px] text-slate-500'>Preenchido automaticamente pelo número. Para corrigir, atualize a base ANATEL — estes campos não são editáveis no cadastro.</p>}
                  </div>
                );
              })()}
              {/* Fornecedor e Status — cada um vira uma célula da grade externa. A Tecnologia saiu em 21/10/2026
                  (Heitor: "todas nossas contas são trunk"); o DDR novo vai como Trunk. */}
              <>
                {erroDasPrestadoras && (
                  <p role='alert' className='lg:col-span-2 px-3 py-2 rounded-lg border border-amber-600/50 bg-amber-500/10 text-xs text-amber-200' data-prestadoras='nao-carregaram'>
                    A lista de prestadoras não carregou ({erroDasPrestadoras}). As já escolhidas aparecem com o que se sabe delas;
                    escolher outra só depois que a lista carregar.
                    <button type='button' onClick={recarregarPrestadoras} className='ml-2 px-2 py-0.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 font-medium'>Tentar de novo</button>
                  </p>
                )}
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Fornecedor *</label>
                  <select value={form.carrierId || ''} onChange={e => {
                    const id = e.target.value ? Number(e.target.value) : null;
                    const p = (telecomCarriers || []).find((c:any) => c.id === id);
                    const ENUMV = ['TIP','ALGAR','SYSSVOIP','DATORA','VIVO','CLARO','OI'];
                    const enumc = p ? (ENUMV.includes((p.nome||'').toUpperCase()) ? (p.nome||'').toUpperCase() : 'Outro') : (form.carrier || 'Outro');
                    setForm({...form, carrierId: id, carrier: enumc});
                  }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                    <option value=''>— Selecione —</option>
                    {opcaoDaPrestadoraAtual(form.carrierId, form.carrier)}
                    {(telecomCarriers || []).filter((c:any) => c.ativo).map((c:any) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                  </select>
                  <p className='text-[11px] text-slate-500 mt-1'>Com quem a IPCOM contrata/fatura · cadastre em "Prestadoras"</p>
                </div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Status</label>
                  <select value={form.status || 'Ativo'} onChange={e => setForm({...form, status: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                    <option value='Ativo'>Ativo</option>
                    <option value='Inativo'>Inativo</option>
                    <option value='Portabilidade'>Portabilidade</option>
                    <option value='Cancelado'>Cancelado</option>
                  </select>
                </div>
              </>
              {/* Operadora Real (hospedagem / ABR Telecom) */}
              <div className='lg:col-span-2'>
                <div className='flex items-center justify-between mb-1'>
                  <label className='block text-sm font-medium text-slate-300'>Operadora Real (hospedagem){!editing && !isRangeMode && !isPasteMode && porLinha && <span className='text-slate-500 font-normal'> (padrão da lista)</span>}</label>
                  <button type='button' disabled={consultingAbr} onClick={async () => {
                    const num = (form.phoneNumber || '').replace(/\D/g, '');
                    if (num.length !== 10 && num.length !== 11) { showToast('Informe o número (10 ou 11 dígitos) para consultar', 'warning'); return; }
                    setConsultingAbr(true);
                    try {
                      const r = await clientDDRsService.consultarOperadora(num);
                      if (r.found && r.prestadora) {
                        const nome = r.prestadora.trim();
                        const match = (telecomCarriers || []).find((c:any) => (c.nome||'').trim().toUpperCase() === nome.toUpperCase() || (c.razaoSocial||'').trim().toUpperCase() === (r.razaoSocial||'').trim().toUpperCase());
                        setForm((f:any) => ({ ...f, hostCarrierId: match ? match.id : (f.hostCarrierId ?? null), hostCarrier: nome }));
                        showToast(
                          match ? `Operadora real: ${match.nome}`
                            : erroDasPrestadoras ? `Operadora real: ${nome}. A lista de prestadoras não carregou (${erroDasPrestadoras}): não sei se "${nome}" já está cadastrada.`
                            : `Operadora real: ${nome} (cadastre a prestadora "${nome}" para vincular)`,
                          match ? 'success' : 'info',
                        );
                      } else {
                        showToast('ABR não retornou operadora para este número', 'warning');
                      }
                    } catch (e:any) {
                      showToast('Falha ao consultar a ABR: ' + (e?.response?.data?.message || e?.message || 'erro'), 'error');
                    } finally { setConsultingAbr(false); }
                  }} className='inline-flex items-center gap-1 text-[11px] text-slate-300 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed' title='Consulta a operadora real na ABR (portabilidade) e preenche automaticamente — leva ~1 min'>
                    <Icon name='search' className='w-3 h-3' /> {consultingAbr ? 'Consultando ABR… (~1 min)' : 'Consultar operadora (ABR)'}
                  </button>
                </div>
                <select value={form.hostCarrierId || ''} onChange={e => {
                  const id = e.target.value ? Number(e.target.value) : null;
                  const p = (telecomCarriers || []).find((c:any) => c.id === id);
                  setForm({...form, hostCarrierId: id, hostCarrier: p ? p.nome : null});
                }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                  <option value=''>— Não verificado —</option>
                  {opcaoDaPrestadoraAtual(form.hostCarrierId, form.hostCarrier)}
                  {(telecomCarriers || []).filter((c:any) => c.ativo).map((c:any) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                </select>
                <p className='text-[11px] text-slate-500 mt-1'>Onde o número realmente termina, considerando portabilidade (o STFC só sabe o dono original da faixa). <strong>Consultar operadora (ABR)</strong> consulta e preenche automaticamente (leva ~1 min). Deixe em branco se ainda não verificou.</p>
              </div>
              {/* Endereço de acesso (o host do PABX/SBC do cliente, era "URL App") e o Tech prefix, que é do mesmo tronco */}
              <>
                {(() => {
                  // F1 (Heitor, 21/10/2026): o endereço do DDR é um dos endereços do CLIENTE dele, cadastrados só na aba
                  // Infraestrutura. Enquanto o cliente não tem nenhum (as tabelas do E1 nasceram vazias; o backfill espera a
                  // palavra do Heitor), o campo segue o texto de antes, para não travar o cadastro. Escolher na lista grava o
                  // vínculo (accessAddressId) e repete o host no appUrl, que o backend ainda mantém por um ciclo.
                  const cli = clients.find((c: any) => c.id === Number(form.clientId));
                  const lista: Array<{ id: number; host: string }> | undefined = Array.isArray(cli?.accessAddresses) ? cli.accessAddresses : undefined;
                  const atualId = form.accessAddressId ?? null;
                  const atual = atualId != null ? (lista || []).find((e) => e.id === atualId) || form.accessAddress : null;
                  if (!lista || lista.length === 0) {
                    return (
                      <div data-endereco-do-ddr='texto'>
                        <label htmlFor='ddr-endereco' className='block text-sm font-medium text-slate-300 mb-1'>Endereço de acesso</label>
                        <input id='ddr-endereco' type='text' value={form.appUrl || ''} onChange={e => setForm({...form, appUrl: e.target.value})} placeholder='ex.: sbc.ipcom.app.br' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                        <p className='text-[11px] text-slate-500 mt-1'>
                          {!form.clientId ? 'Endereço do PABX/SBC onde o tronco do número termina.'
                            : !lista ? 'Não consegui ler os endereços deste cliente: por ora, o endereço fica como texto.'
                            : 'Este cliente ainda não tem endereço cadastrado (aba Infraestrutura do cliente). Até lá, o endereço fica como texto.'}
                        </p>
                      </div>
                    );
                  }
                  return (
                    <div data-endereco-do-ddr='lista'>
                      <label htmlFor='ddr-endereco' className='block text-sm font-medium text-slate-300 mb-1'>Endereço de acesso</label>
                      <select id='ddr-endereco' value={atualId != null ? String(atualId) : ''} onChange={e => {
                        const id = e.target.value ? Number(e.target.value) : null;
                        const host = id != null ? lista.find((x) => x.id === id)?.host || null : null;
                        setForm({...form, accessAddressId: id, appUrl: host || ''});
                      }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                        <option value=''>— sem endereço —</option>
                        {opcaoAtualForaDaLista(lista, atualId, `${atual?.host || `#${atualId}`} (não é deste cliente)`, false)}
                        {lista.map((x) => <option key={x.id} value={String(x.id)}>{x.host}</option>)}
                      </select>
                      <p className='text-[11px] text-slate-500 mt-1'>
                        {atual && !lista.some((x) => x.id === atualId)
                          ? <span className={TONE_TEXT.warning}>O endereço deste DDR não está vinculado ao cliente: escolha um da lista ou deixe sem endereço.</span>
                          : atualId == null && form.appUrl ? `Texto de antes: ${form.appUrl}. Escolha o endereço na lista.`
                          : 'Os endereços vêm do cadastro do cliente (aba Infraestrutura).'}
                      </p>
                    </div>
                  );
                })()}
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Tech Prefix</label><input type='text' value={form.techPrefix || ''} onChange={e => setForm({...form, techPrefix: e.target.value})} placeholder='Ex: 55045' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              </>
              {/* Canais e Contrato */}
              <>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Canais</label><input type='number' value={form.channels || ''} onChange={e => setForm({...form, channels: parseInt(e.target.value) || undefined})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Nº Contrato</label><input type='text' value={form.contractNumber || ''} onChange={e => setForm({...form, contractNumber: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              </>
              {/* Observações */}
              <div className='lg:col-span-2'><label className='block text-sm font-medium text-slate-300 mb-1'>Observações</label><textarea value={form.notes || ''} onChange={e => setForm({...form, notes: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} rows={2} /><p className='text-xs text-slate-500 mt-1'>Uso interno (não sai na fatura nem na NF) — particularidades do CLIENTE, ex.: convenções de contato, forma de peticionamento.</p></div>
        </CascaDeModal>
      ); })()}

      {modal === 'product' && (
        // Editor: não fecha ao clicar fora (como já era). Sai a altura chumbada do
        // corpo (max-h-[calc(90vh-180px)]): a casca dá ao corpo o que sobra.
        <CascaDeModal
          largura='base'
          titulo={editing ? 'Editar Produto' : 'Novo Produto'}
          subtitulo={editing && form.code ? form.code : undefined}
          onClose={closeModal}
          corpoClassName='p-6 space-y-4'
          rodape={
            <>
              <button onClick={closeModal} disabled={saving} className='flex-1 px-6 py-3 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'>Cancelar</button>
              <button onClick={save} disabled={saving} className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{saving ? 'Salvando...' : 'Salvar'}</button>
            </>
          }
        >
              <div className='grid grid-cols-2 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Código *</label><input type='text' value={form.code || ''} onChange={e => setForm({...form, code: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Tipo *</label><select value={form.type || 'MRR'} onChange={e => setForm({...form, type: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='MRR'>MRR</option><option value='Serviço'>Serviço</option></select></div>
              </div>
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Nome *</label><input type='text' value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Descrição</label><textarea value={form.description || ''} onChange={e => setForm({...form, description: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} rows={2} /></div>
              <div className='grid grid-cols-2 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Categoria</label><input type='text' value={form.category || ''} onChange={e => setForm({...form, category: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Recorrência</label><select value={form.recurrence || 'Mensal'} onChange={e => setForm({...form, recurrence: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='Mensal'>Mensal</option><option value='Anual'>Anual</option><option value='Único'>Único</option></select></div>
              </div>
              <div className='grid grid-cols-3 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Valor *</label><input type='number' step='0.01' value={form.value || ''} onChange={e => setForm({...form, value: parseFloat(e.target.value) || 0})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Custo</label><input type='number' step='0.01' value={form.cost || ''} onChange={e => setForm({...form, cost: parseFloat(e.target.value) || 0})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Tipo Fiscal</label><select value={form.fiscalType || 'nfse'} onChange={e => setForm({...form, fiscalType: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='nfse'>NFS-e (ISS)</option><option value='nfcom'>NFCom (ICMS)</option><option value='isento'>Isento</option></select></div>
              </div>
              <div className='flex items-center gap-3'><input type='checkbox' checked={form.status !== false} onChange={e => setForm({...form, status: e.target.checked})} className='w-4 h-4 rounded bg-slate-800 border-slate-600' /><span className='text-sm font-medium text-slate-300'>Produto ativo</span></div>
              {(form.type || 'MRR') === 'MRR' && (
                <div className='bg-central-elevado/50 border border-central-borda rounded-xl p-4 space-y-3'>
                  <div className='flex items-center justify-between gap-3'>
                    <div>
                      <p className='text-sm font-medium text-slate-300'>Faixas de preço por volume</p>
                      <p className='text-xs text-slate-500'>A faixa vale para todas as unidades. Sem faixa, o Valor acima vale para qualquer quantidade.</p>
                    </div>
                    <div className='flex items-center gap-2 shrink-0'>
                      <label className='text-xs text-slate-400'>Mínimo comercial</label>
                      <input type='number' min='1' value={form.minQuantity ?? 1} onChange={e => setForm({...form, minQuantity: Math.max(1, parseInt(e.target.value) || 1)})} className={`w-16 px-2 py-1.5 ${campo} rounded-lg text-sm text-center`} />
                    </div>
                  </div>
                  {(form.priceTiers || []).length > 0 && (
                    <div className='space-y-2'>
                      {(form.priceTiers as any[]).map((t: any, idx: number) => (
                        <div key={idx} className='flex items-center gap-2 text-sm'>
                          <span className='text-slate-400 w-20 shrink-0'>{idx === 0 ? 'até' : 'a partir de'}</span>
                          {idx === 0 ? (
                            <span className='w-20 text-center text-slate-300'>{(form.priceTiers[1]?.minQuantity || 2) - 1}</span>
                          ) : (
                            <input type='number' min='2' value={t.minQuantity}
                              onChange={e => { const tiers = [...form.priceTiers]; tiers[idx] = { ...t, minQuantity: parseInt(e.target.value) || 2 }; setForm({...form, priceTiers: tiers}); }}
                              className={`w-20 px-2 py-1.5 ${campo} rounded-lg text-sm text-center`} />
                          )}
                          <span className='text-slate-500 text-xs'>unid.</span>
                          <span className='text-slate-400 ml-auto'>R$</span>
                          <input type='number' step='0.01' min='0' value={t.unitPrice}
                            onChange={e => { const tiers = [...form.priceTiers]; tiers[idx] = { ...t, unitPrice: parseFloat(e.target.value) || 0 }; setForm({...form, priceTiers: tiers}); }}
                            className={`w-24 px-2 py-1.5 ${campo} rounded-lg text-sm text-right`} />
                          <span className='text-slate-500 text-xs w-12'>/ unid.</span>
                          <button type='button' disabled={idx === 0 && form.priceTiers.length > 1} onClick={() => setForm({...form, priceTiers: form.priceTiers.filter((_: any, i: number) => i !== idx)})} className='px-2 py-1 text-slate-500 hover:text-red-400 disabled:opacity-30' title={idx === 0 && form.priceTiers.length > 1 ? 'A primeira faixa sai por último' : 'Remover faixa'}>✕</button>
                        </div>
                      ))}
                    </div>
                  )}
                  <button type='button' onClick={() => {
                    const tiers = [...(form.priceTiers || [])];
                    const last = tiers[tiers.length - 1];
                    tiers.push(last ? { minQuantity: (Number(last.minQuantity) || 1) + 10, unitPrice: Number(last.unitPrice) || 0 } : { minQuantity: 1, unitPrice: Number(form.value) || 0 });
                    setForm({...form, priceTiers: tiers});
                  }} className='text-xs text-slate-300 hover:text-white'>+ Adicionar faixa</button>
                </div>
              )}
        </CascaDeModal>
      )}

      {modal === 'client' && (
        // Altura FIXA ('fixa' da casca), não ditada pelo conteúdo: cada aba tem um
        // tamanho, e com a caixa centralizada o cabeçalho e as abas saltavam de lugar
        // a cada troca. Cada aba segue com a PRÓPRIA rolagem (corpo flex-col, abas
        // flex-1 overflow-y-auto), como antes. Não fecha ao clicar fora (editor).
        <CascaDeModal
          largura='2xl'
          altura='fixa'
          temEdicaoNaoSalva={temEdicaoNaoSalva}
          endereco={editing?.id ? comParametro(window.location.pathname, window.location.search, 'cliente', editing.id) : undefined}
          titulo={editing ? (form.name || form.tradeName || form.companyName || 'Cliente') : 'Novo Cliente'}
          subtitulo={[
            editing?.code ? `#${editing.code}` : null,
            form.companyName && form.companyName !== form.name ? form.companyName : null,
            form.cnpj ? fmtCNPJ(form.cnpj) : null,
          ].filter(Boolean).join(' · ') || undefined}
          selos={
            <>
              {editing && form.status && <span className={`shrink-0 text-xs px-2.5 py-0.5 rounded-full ${form.status === 'Ativo' ? TONE_BADGE.open : TONE_BADGE.danger}`}>{form.status}</span>}
              <span className='shrink-0 text-xs px-2.5 py-0.5 rounded-full bg-slate-700 text-slate-300'>{editing ? 'editando' : 'novo'}</span>
            </>
          }
          onClose={closeModal}
          topo={leituraDoCliente?.estado === 'falhou' ? (
            <p role="alert" className={`mx-5 mt-3 px-3 py-2 rounded border text-sm ${TONE_SURFACE.danger} ${TONE_BORDER.danger} ${TONE_TEXT.danger}`} data-leitura-do-cliente="falhou">
              {porqueClienteTravado}
            </p>
          ) : undefined}
          abas={[
            { chave: 'dados', rotulo: 'Dados' },
            { chave: 'faturamento', rotulo: 'Faturamento' },
            {
              chave: 'infra',
              // O alerta mora na aba Infraestrutura, mas quem abre o cadastro cai em
              // Dados e não tem motivo para ir olhar lá. O ponto avisa que há algo dentro.
              rotulo: (
                <>
                  Infraestrutura
                  {infraTemAlerta && (
                    <span title='Instância EC2 cadastrada não existe mais na conta' className='ml-1.5 inline-block w-1.5 h-1.5 rounded-full bg-red-400 align-middle' />
                  )}
                </>
              ),
            },
            ...(editing
              ? [{
                  chave: 'contatos',
                  rotulo: (
                    <span className='inline-flex items-center gap-2'>
                      Contatos
                      {clientContacts.length > 0 && (
                        <span className='bg-slate-700 text-slate-200 text-xs px-1.5 py-0.5 rounded'>{clientContacts.length}</span>
                      )}
                    </span>
                  ),
                }]
              : []),
          ]}
          abaAtiva={clientModalTab}
          onAba={(k) => {
            setClientModalTab(k as any);
            if (k === 'contatos' && editing?.id) loadClientContacts(editing.id);
          }}
          corpoClassName='flex flex-col'
          rodape={
            <>
              <button onClick={closeModal} disabled={saving} className={`flex-1 px-6 py-3 rounded-lg disabled:opacity-50 ${acaoSecundaria}`}>{clientModalTab === 'contatos' ? 'Fechar' : 'Cancelar'}</button>
              {/* Salvar vale para TODAS as abas do formulário: elas editam o mesmo
                  `form` e um único submit. Só Contatos fica de fora — lá cada
                  contato tem gravação própria. */}
              {clientModalTab !== 'contatos' && (
                <button onClick={save} disabled={saving || !!porqueClienteTravado} title={porqueClienteTravado} className={`flex-1 px-6 py-3 rounded-lg disabled:opacity-50 ${acaoPrincipal}`}>{saving ? 'Salvando...' : 'Salvar'}</button>
              )}
            </>
          }
        >
            <div className={`flex-1 min-h-0 overflow-y-auto p-6 space-y-4 ${clientModalTab === 'dados' ? '' : 'hidden'}`}>
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Nome (Exibição) *</label>
                <input type='text' value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} placeholder='Nome para identificação no sistema' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                <p className='text-xs text-slate-500 mt-1'>Este nome será usado para exibição no sistema</p>
              </div>
              <div className='grid grid-cols-2 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Nome Fantasia <span className='text-slate-500'>(Receita)</span></label><input type='text' value={form.tradeName || ''} onChange={e => setForm({...form, tradeName: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Razão Social * <span className='text-slate-500'>(Receita)</span></label><input type='text' value={form.companyName || ''} onChange={e => setForm({...form, companyName: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              </div>
              <div className='grid grid-cols-4 gap-4'>
                <div className='col-span-2'>
                  <label className='block text-sm font-medium text-slate-300 mb-1'>CNPJ *</label>
                  <div className='flex gap-2'>
                    <input type='text' value={form.cnpj || ''} onChange={e => setForm({...form, cnpj: maskCNPJ(e.target.value)})} placeholder='00.000.000/0000-00' className={`flex-1 px-4 py-2.5 ${campo} rounded-lg`} />
                    <button type='button' onClick={async () => {
                      if (!form.cnpj || form.cnpj.replace(/\D/g, '').length < 14) { avisar('Digite um CNPJ válido', 'warning'); return; }
                      setSaving(true);
                      try {
                        const data = await cnpjService.search(form.cnpj);
                        if (data && !data.error && data.status !== 'ERROR') {
                          // Manter telefones existentes ou adicionar o da Receita
                          const existingPhones = form.phones?.filter((p: any) => p.phone?.trim()) || [];
                          const phones = existingPhones.length > 0
                            ? existingPhones
                            : (data.telefone ? [{ phone: (data.telefone.split('/')[0] || '').trim().replace(/\D/g, '').slice(0, 11), type: 'Comercial', isPrimary: true }] : [{ phone: '', type: 'Comercial', isPrimary: true }]);

                          // Manter emails financeiros existentes e adicionar email da Receita como "Geral"
                          const existingEmails = form.emails?.filter((e: any) => e.email?.trim()) || [];
                          let emails = [...existingEmails];

                          // Se tem email da Receita e não está duplicado, adiciona como "Geral"
                          if (data.email && !existingEmails.some((e: any) => e.email?.toLowerCase() === data.email?.toLowerCase())) {
                            emails.push({ email: data.email, type: 'Geral', isPrimary: false });
                          }

                          // Se não tem nenhum email, cria um vazio
                          if (emails.length === 0) {
                            emails = [{ email: '', type: 'Financeiro', isPrimary: true }];
                          }

                          setForm({
                            ...form,
                            name: form.name || data.fantasia || data.nome || '', // Só preenche se estiver vazio
                            companyName: data.nome || '',
                            tradeName: data.fantasia || '', // Deixa em branco se não tiver na Receita
                            phones,
                            emails,
                            segment: data.atividade_principal?.[0]?.text || form.segment || '',
                            street: data.logradouro || '',
                            number: data.numero || '',
                            complement: data.complemento || '',
                            neighborhood: data.bairro || '',
                            city: data.municipio || '',
                            state: data.uf || '',
                            zipCode: data.cep || '',
                            municipalCode: data.codigo_ibge || form.municipalCode || '',
                            inscricaoEstadual: data.inscricao_estadual || form.inscricaoEstadual || '',
                          });
                          showToast('Dados do CNPJ carregados!', 'success');
                        } else {
                          showToast(data?.message || 'CNPJ não encontrado', 'warning');
                        }
                      } catch (e) { showToast('Erro ao buscar CNPJ', 'error'); }
                      setSaving(false);
                    }} disabled={saving} className='px-3 py-2.5 bg-central-cartao border border-central-borda text-central-texto hover:bg-central-elevado rounded-lg disabled:opacity-50 flex items-center justify-center' title='Buscar CNPJ'>
                      <Icon name='search' className='w-4 h-4' />
                    </button>
                  </div>
                </div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Inscricao Estadual</label><input type='text' value={form.inscricaoEstadual || ''} onChange={e => setForm({...form, inscricaoEstadual: e.target.value})} placeholder='Isento' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Segmento</label><input type='text' value={form.segment || ''} onChange={e => setForm({...form, segment: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              </div>
              {/* Emails */}
              <div>
                <div className='flex items-center justify-between mb-2'>
                  <label className='text-sm font-medium text-slate-300'>Emails</label>
                  <button type='button' onClick={() => setForm({...form, emails: [...(form.emails || []), { email: '', type: 'Geral', isPrimary: false }]})} className='flex items-center gap-1 text-xs text-slate-300 hover:text-white'>
                    <Icon name='plus' className='w-3 h-3' /> Adicionar
                  </button>
                </div>
                <div className='space-y-2'>
                  {(form.emails?.length > 0 ? form.emails : [{ email: '', type: 'Financeiro', isPrimary: true }]).map((e: any, i: number) => (
                    <div key={i} className='flex gap-2 items-center'>
                      <input type='email' value={e.email || ''} onChange={ev => { const emails = [...(form.emails || [{ email: '', type: 'Financeiro', isPrimary: true }])]; emails[i] = {...emails[i], email: ev.target.value}; setForm({...form, emails}); }} placeholder='email@exemplo.com' className={`flex-1 px-3 py-2 ${campo} rounded-lg text-sm`} />
                      <select value={e.type || 'Geral'} onChange={ev => { const emails = [...(form.emails || [{ email: '', type: 'Financeiro', isPrimary: true }])]; emails[i] = {...emails[i], type: ev.target.value}; setForm({...form, emails}); }} className={`w-32 px-2 py-2 ${campo} rounded-lg text-sm`}>
                        <option value='Financeiro'>Financeiro</option>
                        <option value='Geral'>Geral</option>
                        <option value='Comercial'>Comercial</option>
                        <option value='Técnico'>Técnico</option>
                      </select>
                      {(form.emails?.length || 1) > 1 && (
                        <button type='button' onClick={() => { const emails = [...(form.emails || [])]; emails.splice(i, 1); setForm({...form, emails}); }} className='p-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg'>
                          <Icon name='trash' className='w-4 h-4' />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              {/* Telefones */}
              <div>
                <div className='flex items-center justify-between mb-2'>
                  <label className='text-sm font-medium text-slate-300'>Telefones</label>
                  <button type='button' onClick={() => setForm({...form, phones: [...(form.phones || []), { phone: '', type: 'Comercial', isPrimary: false }]})} className='flex items-center gap-1 text-xs text-slate-300 hover:text-white'>
                    <Icon name='plus' className='w-3 h-3' /> Adicionar
                  </button>
                </div>
                <div className='space-y-2'>
                  {(form.phones?.length > 0 ? form.phones : [{ phone: '', type: 'Comercial', isPrimary: true }]).map((p: any, i: number) => (
                    <div key={i} className='flex gap-2 items-center'>
                      <input type='tel' value={maskPhone(p.phone || '')} onChange={ev => { const phones = [...(form.phones || [{ phone: '', type: 'Comercial', isPrimary: true }])]; phones[i] = {...phones[i], phone: ev.target.value.replace(/\D/g, '')}; setForm({...form, phones}); }} placeholder='(00) 00000-0000' maxLength={15} className={`flex-1 px-3 py-2 ${campo} rounded-lg text-sm`} />
                      <select value={p.type || 'Comercial'} onChange={ev => { const phones = [...(form.phones || [{ phone: '', type: 'Comercial', isPrimary: true }])]; phones[i] = {...phones[i], type: ev.target.value}; setForm({...form, phones}); }} className={`w-32 px-2 py-2 ${campo} rounded-lg text-sm`}>
                        <option value='Comercial'>Comercial</option>
                        <option value='Pessoal'>Pessoal</option>
                        <option value='WhatsApp'>WhatsApp</option>
                        <option value='Outro'>Outro</option>
                      </select>
                      {(form.phones?.length || 1) > 1 && (
                        <button type='button' onClick={() => { const phones = [...(form.phones || [])]; phones.splice(i, 1); setForm({...form, phones}); }} className='p-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg'>
                          <Icon name='trash' className='w-4 h-4' />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              {/* Endereço */}
              <div className='border-t border-central-borda pt-4 mt-2'>
                <label className='block text-sm font-medium text-slate-300 mb-3'>Endereço</label>
                <div className='grid grid-cols-4 gap-3'>
                  <div className='col-span-2'>
                    <label className='block text-xs text-slate-400 mb-1'>CEP</label>
                    <input type='text' value={form.zipCode || ''} onChange={e => setForm({...form, zipCode: e.target.value})} placeholder='00000-000' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div className='col-span-2'>
                    <label className='block text-xs text-slate-400 mb-1'>UF</label>
                    <select value={form.state || ''} onChange={e => setForm({...form, state: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}>
                      <option value=''>Selecione</option>
                      {['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'].map(uf => <option key={uf} value={uf}>{uf}</option>)}
                    </select>
                  </div>
                </div>
                <div className='grid grid-cols-4 gap-3 mt-3'>
                  <div className='col-span-3'>
                    <label className='block text-xs text-slate-400 mb-1'>Rua/Logradouro</label>
                    <input type='text' value={form.street || ''} onChange={e => setForm({...form, street: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Número</label>
                    <input type='text' value={form.number || ''} onChange={e => setForm({...form, number: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                </div>
                <div className='grid grid-cols-3 gap-3 mt-3'>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Complemento</label>
                    <input type='text' value={form.complement || ''} onChange={e => setForm({...form, complement: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Bairro</label>
                    <input type='text' value={form.neighborhood || ''} onChange={e => setForm({...form, neighborhood: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Cidade</label>
                    <input type='text' value={form.city || ''} onChange={e => setForm({...form, city: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                </div>
                <div className='grid grid-cols-3 gap-3 mt-3'>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Código IBGE</label>
                    <input type='text' value={form.municipalCode || ''} onChange={e => setForm({...form, municipalCode: e.target.value})} placeholder='Ex: 4104808' maxLength={7} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                    <p className='text-xs text-slate-500 mt-1'>Código IBGE do município (7 dígitos). Usado na NFS-e.</p>
                  </div>
                </div>
              </div>
              {/* Responsável */}
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Responsavel</label>
                <select value={form.salesPersonId || ''} onChange={e => setForm({...form, salesPersonId: e.target.value ? parseInt(e.target.value) : null})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                  <option value=''>Sem responsavel atribuido</option>
                  {/* O responsável já escolhido é sempre opção. A lista de usuários só carrega para ADMIN (GET /users): para
                      editor o select mostrava "Sem responsavel atribuido" em TODA abertura de cliente que tem responsável,
                      não só quando algo falhava (08/10/2026, Fase 2 tela 3b). */}
                  {opcaoAtualForaDaLista(users.filter((u: any) => u.isActive), form.salesPersonId, `responsável #${form.salesPersonId}`, users.length === 0)}
                  {users.filter((u: any) => u.isActive).map((u: any) => (
                    <option key={u.id} value={u.id}>{u.name}</option>
                  ))}
                </select>
                <p className='text-xs text-slate-500 mt-1'>O responsavel so vera os clientes atribuidos a ele</p>
              </div>
              {/* Origem do cliente */}
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Origem (de onde veio)</label>
                <select value={form.referralSource || ''} onChange={e => setForm({...form, referralSource: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                  <option value=''>Não informado</option>
                  <option value='Segware'>Segware</option>
                  <option value='Movidesk'>Movidesk</option>
                  <option value='Google'>Google</option>
                  <option value='Indicação'>Indicação</option>
                  <option value='Site/Inbound'>Site/Inbound</option>
                  <option value='Prospecção'>Prospecção</option>
                  <option value='Evento/Feira'>Evento/Feira</option>
                  <option value='Outro'>Outro</option>
                </select>
                <input type='text' value={form.referralDetail || ''} onChange={e => setForm({...form, referralDetail: e.target.value})} placeholder='Detalhe (ex: parceiro/quem indicou)' className={`w-full mt-2 px-4 py-2.5 rounded-lg placeholder:text-slate-500 ${campo}`} />
              </div>
              {/* Status */}
              <div className='w-48'>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Status</label>
                <select value={form.status || 'Ativo'} onChange={e => setForm({...form, status: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='Ativo'>Ativo</option><option value='Inativo'>Inativo</option></select>
              </div>
            </div>
            <div className={`flex-1 min-h-0 overflow-y-auto p-6 space-y-4 ${clientModalTab === 'faturamento' ? '' : 'hidden'}`}>
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Dia Venc. {!form.paymentTermDays && <span className='text-red-400'>*</span>}</label><input type='number' min='1' max='31' placeholder={form.paymentTermDays ? '—' : 'ex: 10'} disabled={!!form.paymentTermDays} title={form.paymentTermDays ? 'Ignorado: o vencimento segue o Prazo em dias' : ''} value={form.paymentTermDays ? '' : (form.dueDay ?? '')} onChange={e => setForm({...form, dueDay: e.target.value === '' ? '' : parseInt(e.target.value)})} className={`w-full px-4 py-2.5 ${campo} rounded-lg disabled:opacity-40 disabled:cursor-not-allowed`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1' title='Em que mês a fatura vence. "Mês seguinte" é para quem fatura o mês corrente e recebe depois de prestado o serviço — sem isso, a fatura de setembro vence dentro de setembro, cobrando serviço que ainda não terminou. Órgão público costuma ser "Mesmo mês", porque lá o período faturado já é o mês anterior.'>Vence em</label><select disabled={!!form.paymentTermDays} title={form.paymentTermDays ? 'Ignorado: o vencimento segue o Prazo em dias' : ''} value={form.paymentTermDays ? 0 : (form.dueMonthOffset ?? 0)} onChange={e => setForm({...form, dueMonthOffset: parseInt(e.target.value)})} className={`w-full px-4 py-2.5 ${campo} rounded-lg disabled:opacity-40 disabled:cursor-not-allowed`}><option value={0}>Mesmo mês</option><option value={1}>Mês seguinte</option></select></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1' title='Quando preenchido, o vencimento da fatura = data de emissão + N dias corridos (substitui o Dia Venc.)'>Prazo (dias)</label><input type='number' min='1' max='120' value={form.paymentTermDays || ''} onChange={e => setForm({...form, paymentTermDays: e.target.value ? parseInt(e.target.value) : null})} placeholder='ex: 40 (opcional)' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Dia Inicio Ciclo</label><input type='number' min='1' max='28' value={form.billingCycleStartDay || ''} onChange={e => setForm({...form, billingCycleStartDay: e.target.value ? parseInt(e.target.value) : null})} placeholder='1 (padrao)' className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Forma Pagamento</label><select value={form.paymentMethod || 'boleto'} onChange={e => setForm({...form, paymentMethod: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='boleto'>Boleto</option><option value='pix'>PIX</option><option value='ted'>TED</option><option value='deposito'>Depósito</option></select></div>
              </div>
              {/* Os 8 interruptores de faturamento em 4 perguntas, com o resumo, os perfis e as travas (16/10/2026, fase 1 do
                  plano de empenho). Os campos e o payload são os de antes: ver components/clientes/ConfiguracaoDeFaturamento. */}
              <ConfiguracaoDeFaturamento form={form} setForm={setForm} campo={campo} />
            </div>
            <div className={`flex-1 min-h-0 overflow-y-auto p-6 space-y-4 ${clientModalTab === 'infra' ? '' : 'hidden'}`}>
              {/* ACESSO DO CLIENTE (C2, Heitor 21/10/2026): onde o cliente está, lado a lado. O Domínio SIP saiu do bloco AWS,
                  onde sumia com "Tem infraestrutura AWS" desligado: é convenção da IPCOM (siptrunk, sbc), não dado da instância.
                  Continua o MESMO campo ec2Domain, no Salvar da ficha: o relatório técnico do faturamento o lê
                  (backend common/technical-report.service). Os endereços de acesso gravam pela rota deles. */}
              <div data-secao='acesso-do-cliente'>
                <label className='block text-sm font-medium text-slate-300 mb-3'>Acesso do cliente</label>
                <div className='space-y-3'>
                  <div>
                    <label htmlFor='cliente-dominio-sip' className='block text-xs text-slate-400 mb-1'>Domínio SIP (registro dos ramais e troncos)</label>
                    <input id='cliente-dominio-sip' type='text' value={form.ec2Domain || ''} onChange={e => setForm({...form, ec2Domain: e.target.value})} placeholder='siptrunk.ipcom.com.br' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div>
                    <span className='block text-xs text-slate-400 mb-1'>Endereços de acesso (APP / PABX / SBC)</span>
                    <EnderecosDeAcesso
                      clientId={editing?.id}
                      vinculadosIniciais={editing ? form.accessAddresses : []}
                      dominioSip={form.ec2Domain}
                      ddrsDoCliente={(clientDDRs || []).filter((d: any) => d.clientId === editing?.id)}
                      podeEditar={user?.role === 'admin'}
                      onMudou={loadData}
                    />
                  </div>
                </div>
              </div>
              {/* Configuração CDR */}
              <div className='border-t border-central-borda pt-4 mt-2'>
                <label className='block text-sm font-medium text-slate-300 mb-3'>Configuração CDR</label>
                <div className='space-y-3'>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>TAG do CDR</label>
                    <input type='text' value={form.cdrTag || ''} onChange={e => setForm({...form, cdrTag: e.target.value})} placeholder='Ex: IFRN, CFQ, CREAES' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                    <p className='text-xs text-slate-500 mt-1'>TAG para identificar o cliente no processamento do CDR</p>
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-2'>Filtrar Status do CDR</label>
                    <p className='text-xs text-slate-500 mb-2'>Selecione os status que devem aparecer no CDR deste cliente:</p>
                    <div className='grid grid-cols-4 gap-3'>
                      {['ATENDIDA', 'OCUPADO', 'NAO ATENDIDA', 'FALHA'].map(status => (
                        <label key={status} className='flex items-center gap-2 cursor-pointer bg-central-elevado/50 px-3 py-2 rounded-lg border border-central-borda hover:border-slate-600'>
                          <input
                            type='checkbox'
                            checked={(form.cdrStatusFilter || []).includes(status)}
                            onChange={e => {
                              const current = form.cdrStatusFilter || [];
                              const updated = e.target.checked
                                ? [...current, status]
                                : current.filter((s: string) => s !== status);
                              setForm({...form, cdrStatusFilter: updated});
                            }}
                            className='w-4 h-4 rounded bg-slate-800 border-slate-600 accent-primary focus:ring-primary'
                          />
                          <span className='text-sm text-slate-300'>{status}</span>
                        </label>
                      ))}
                    </div>
                    <p className='text-xs text-slate-500 mt-2'>Se nenhum status for selecionado, todos serão exibidos</p>
                  </div>
                </div>
              </div>
              {/* Infraestrutura EC2/AWS (Relatório Técnico) */}
              <div className='border-t border-central-borda pt-4 mt-2'>
                {/* O toggle esconde o bloco de quem nunca teve EC2: servidor
                    local, só STFC pelo SBC, contrato encerrado. Cinco campos
                    vazios na tela não diziam se ninguém preencheu ainda ou se
                    não há o que preencher. Campo de cadastro puro: vai no
                    Salvar do modal, sem endpoint próprio. */}
                <div className='flex items-center justify-between gap-4 mb-3'>
                  <label className='block text-sm font-medium text-slate-300'>Infraestrutura AWS (Relatório Técnico)</label>
                  <div className='flex items-center gap-3 shrink-0'>
                    <label className='relative inline-flex items-center cursor-pointer'>
                      <input type='checkbox' checked={form.hasAwsInfra || false} onChange={e => setForm({...form, hasAwsInfra: e.target.checked})} className='sr-only peer' />
                      <div className="w-9 h-5 bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-orange-500"></div>
                    </label>
                    <span className='text-sm text-slate-300'>Tem infraestrutura AWS</span>
                  </div>
                </div>
                {!form.hasAwsInfra && (
                  <p className='text-xs text-slate-500'>Cliente sem infraestrutura na AWS: servidor local, só STFC pelo SBC ou contrato encerrado. Ligue a flag para preencher os dados da instância.</p>
                )}
                {form.hasAwsInfra && (
                <>
                <div className='mb-4'>
                  <label className='block text-xs text-slate-400 mb-1'>Instância EC2</label>
                  <select
                    value={form.ec2InstanceId || ''}
                    onChange={e => {
                      const inst = ec2Instances.find((i: any) => i.id === e.target.value);
                      // Preenche o que a AWS sabe. O Domínio SIP fica de fora
                      // porque é convenção da IPCOM (siptrunk x sbc), não dado
                      // da instância.
                      setForm({...form,
                        ec2InstanceId: e.target.value,
                        ...(inst ? { ec2InstanceName: inst.nome || '', ec2IpAddress: inst.ip || form.ec2IpAddress, awsRegion: inst.regiao } : {}),
                      });
                    }}
                    className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
                  >
                    <option value=''>(nenhuma selecionada)</option>
                    {/* A instância já escolhida é sempre opção: com a lista sem carregar, o select dizia "(nenhuma selecionada)"
                        num cliente que TEM instância (08/10/2026, Fase 2 tela 3b). */}
                    {opcaoAtualForaDaLista(ec2Instances, form.ec2InstanceId, form.ec2InstanceName || form.ec2InstanceId, !!erroDasInstancias)}
                    {ec2Instances.map((i: any) => (
                      <option key={i.id} value={i.id}>
                        {(i.nome || i.id)}{i.estado !== 'running' ? ` · ${i.estado}` : ''}{i.ip ? ` · ${i.ip}` : ''}
                      </option>
                    ))}
                  </select>
                  {infraTemAlerta && (
                    <p className='text-xs text-red-400 mt-1'>Instância <span className='font-mono'>{form.ec2InstanceId}</span> não existe mais na conta. Escolha a atual na lista — 45 clientes estão nessa situação porque a instância foi recriada.</p>
                  )}
                  <p className='text-xs text-slate-500 mt-1'>Escolher preenche ID, nome, IP e região automaticamente.</p>
                </div>
                <div className='grid grid-cols-2 gap-4'>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Instance ID</label>
                    <input type='text' value={form.ec2InstanceId || ''} onChange={e => setForm({...form, ec2InstanceId: e.target.value})} placeholder='i-0f34dd13e338e94a5' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm font-mono`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Nome da Instância</label>
                    <input type='text' value={form.ec2InstanceName || ''} onChange={e => setForm({...form, ec2InstanceName: e.target.value})} placeholder='sbc-1' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>IP Fixo</label>
                    <input type='text' value={form.ec2IpAddress || ''} onChange={e => setForm({...form, ec2IpAddress: e.target.value})} placeholder='15.229.220.211' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm font-mono`} />
                  </div>
                  <div>
                    <label className='block text-xs text-slate-400 mb-1'>Região AWS</label>
                    <select value={form.awsRegion || 'sa-east-1'} onChange={e => setForm({...form, awsRegion: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}>
                      <option value='sa-east-1'>São Paulo (sa-east-1)</option>
                      <option value='us-east-1'>N. Virginia (us-east-1)</option>
                      <option value='us-west-2'>Oregon (us-west-2)</option>
                    </select>
                  </div>
                </div>
                <p className='text-xs text-slate-500 mt-2'>Dados da instância EC2 usada para gerar relatório técnico de uptime</p>
                </>
                )}
              </div>
              {/* Retenção de áudios S3 — flag + linhas por pasta.
                  Fora do Salvar do modal de propósito: apagar acervo de cliente
                  não pode ser efeito colateral de editar outro campo da ficha. */}
              {/* Retenção NÃO depende de `hasAwsInfra`: são coisas distintas. Os
                  clientes do SBC precisam da infraestrutura preenchida para o
                  relatório técnico por sbc.ipcom.com.br, e ao mesmo tempo não
                  têm gravação para reter. Cada bloco tem a sua própria flag. */}
              <S3RetentionSection
                clientId={editing?.id}
                ec2InstanceName={form.ec2InstanceName}
                onSaved={loadData}
              />
            </div>

            {/* Aba Contatos — só visível em modo de edição (precisa de clientId existente) */}
            {editing && clientModalTab === 'contatos' && (
              <div className='flex-1 min-h-0 overflow-y-auto p-6 space-y-3'>
                <div className='flex items-center justify-between'>
                  <div>
                    <h3 className='text-sm font-semibold text-slate-200'>Contatos do Cliente</h3>
                    <p className='text-xs text-slate-500 mt-0.5'>Pessoas (suporte e financeiro). Não interfere no envio de NF/Fatura/Boleto — esses continuam usando a aba Dados → Emails.</p>
                  </div>
                  {cargaDosContatos.estado === 'pronto' && !clientContactsLoading && (
                  <button
                    type='button'
                    onClick={() => setClientContactDraft({ nome: '', email: '', telefone: '', type: 'Suporte', principal: false })}
                    className='flex items-center gap-1.5 px-3 py-2 bg-central-cartao border border-central-borda text-central-texto hover:bg-central-elevado text-sm rounded-lg'
                  >
                    <Icon name='plus' className='w-4 h-4' /> Adicionar
                  </button>
                  )}
                </div>

                {clientContactsLoading && (
                  <div className='text-center text-slate-500 text-sm py-4'>Carregando…</div>
                )}

                {!clientContactsLoading && cargaDosContatos.estado === 'erro' && (
                  <EstadoDaLista carga={cargaDosContatos} temDados={false} oQue='os contatos' onTentarDeNovo={() => editing?.id && loadClientContacts(editing.id)} vazio={null}>{null}</EstadoDaLista>
                )}
                {!clientContactsLoading && cargaDosContatos.estado === 'pronto' && clientContacts.length === 0 && !clientContactDraft && (
                  <div className='text-center text-slate-500 text-sm py-8 border border-dashed border-central-borda rounded-lg'>
                    Nenhum contato cadastrado. Use “Adicionar” para criar o primeiro.
                  </div>
                )}

                {/* Form draft (criar/editar) */}
                {clientContactDraft && (
                  <div className='p-3 bg-central-elevado/50 border border-central-borda rounded-lg space-y-2'>
                    <div className='grid grid-cols-12 gap-2'>
                      <input
                        type='text'
                        value={clientContactDraft.nome || ''}
                        onChange={e => setClientContactDraft({ ...clientContactDraft, nome: e.target.value })}
                        placeholder='Nome'
                        className={`col-span-4 px-3 py-2 ${campo} rounded-lg text-sm`}
                      />
                      <input
                        type='email'
                        value={clientContactDraft.email || ''}
                        onChange={e => setClientContactDraft({ ...clientContactDraft, email: e.target.value })}
                        placeholder='email@exemplo.com'
                        className={`col-span-4 px-3 py-2 ${campo} rounded-lg text-sm`}
                      />
                      <input
                        type='tel'
                        value={maskPhone(clientContactDraft.telefone || '')}
                        onChange={e => setClientContactDraft({ ...clientContactDraft, telefone: e.target.value.replace(/\D/g, '') })}
                        placeholder='(00) 00000-0000'
                        maxLength={15}
                        className={`col-span-4 px-3 py-2 ${campo} rounded-lg text-sm`}
                      />
                      <select
                        value={clientContactDraft.type || 'Suporte'}
                        onChange={e => setClientContactDraft({ ...clientContactDraft, type: e.target.value })}
                        className={`col-span-3 px-2 py-2 ${campo} rounded-lg text-sm`}
                      >
                        <option value='Suporte'>Suporte</option>
                        <option value='Financeiro'>Financeiro</option>
                      </select>
                      <label className='col-span-3 flex items-center gap-2 text-xs text-slate-300 px-2'>
                        <input
                          type='checkbox'
                          checked={!!clientContactDraft.principal}
                          onChange={e => setClientContactDraft({ ...clientContactDraft, principal: e.target.checked })}
                          className='w-4 h-4 rounded bg-slate-900 border-slate-600'
                        />
                        Principal
                      </label>
                      <div className='col-span-6 flex justify-end gap-2'>
                        <button
                          type='button'
                          onClick={() => setClientContactDraft(null)}
                          className='px-3 py-1.5 text-sm border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800'
                        >
                          Cancelar
                        </button>
                        <button
                          type='button'
                          onClick={() => saveClientContact(clientContactDraft, editing.id)}
                          className='px-3 py-1.5 text-sm bg-central-cartao border border-central-borda text-central-texto hover:bg-central-elevado rounded-lg'
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Lista de contatos */}
                {/* CONTATO FINANCEIRO NÃO RECEBE FATURA. São duas tabelas com o
                    mesmo rótulo "Financeiro": `client_contacts` (esta aba, que diz
                    com quem falar) e `client_emails` (aba Dados, que é a lista que
                    o envio lê — ver getFinancialEmails em invoices.controller.ts).
                    Em 19/09/2026 dois contatos financeiros foram cadastrados aqui
                    e o cliente seguiu sem receber fatura nem NF, com o alerta da
                    lista aceso e ninguém entendendo por quê. */}
                {!clientContactsLoading && (() => {
                  const naListaDeEnvio = (email: string) =>
                    (form.emails || []).some((e: any) => (e.email || '').trim().toLowerCase() === (email || '').trim().toLowerCase());
                  const foraDoEnvio = clientContacts.filter(
                    (c: any) => c.type === 'Financeiro' && c.ativo !== false && (c.email || '').trim() && !naListaDeEnvio(c.email),
                  );
                  if (foraDoEnvio.length === 0) return null;
                  return (
                    <div className='mb-3 rounded-lg border border-amber-600/40 bg-amber-500/10 px-3 py-2.5'>
                      <div className='flex items-start gap-2'>
                        <Icon name='mail' className='w-4 h-4 text-amber-400 mt-0.5 shrink-0' />
                        <div className='min-w-0'>
                          <p className='text-sm text-amber-200/90'>
                            {foraDoEnvio.length === 1 ? 'Um contato financeiro está' : `${foraDoEnvio.length} contatos financeiros estão`} fora do envio de faturas.
                            Contato diz com quem falar; quem recebe fatura e NF é a lista <b>Emails</b>, na aba Dados.
                          </p>
                          <div className='flex flex-wrap gap-1.5 mt-2'>
                            {foraDoEnvio.map((c: any) => (
                              <button
                                key={c.id}
                                type='button'
                                onClick={() => {
                                  setForm((prev: any) => ({
                                    ...prev,
                                    emails: [...(prev.emails || []), { email: c.email, type: 'Financeiro', isPrimary: false }],
                                  }));
                                  // Leva para a aba Dados de propósito: o rodapé da
                                  // aba Contatos não tem Salvar, e o e-mail só vira
                                  // registro quando o cadastro é salvo.
                                  setClientModalTab('dados');
                                  showToast(`${c.email} entrou na lista de Emails — clique em Salvar`, 'success');
                                }}
                                title='Inclui este e-mail na lista de envio de faturas. Salvar grava.'
                                className={`px-2 py-0.5 ${TONE_BADGE.warning} text-xs rounded hover:brightness-125 transition`}
                              >
                                + incluir {c.email}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {!clientContactsLoading && clientContacts.length > 0 && (
                  <div className='border border-central-borda rounded-lg overflow-hidden'>
                    <table className='w-full text-sm'>
                      <thead className='bg-central-elevado/60 text-slate-400 text-xs uppercase'>
                        <tr>
                          <th className='text-left px-3 py-2 w-8'></th>
                          <th className='text-left px-3 py-2'>Nome</th>
                          <th className='text-left px-3 py-2'>Email</th>
                          <th className='text-left px-3 py-2'>Telefone</th>
                          <th className='text-left px-3 py-2'>Tipo</th>
                          <th className='text-left px-3 py-2 w-20'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientContacts.map((c: any) => (
                          <tr key={c.id} className='border-t border-slate-800 hover:bg-slate-800/40'>
                            <td className='px-3 py-2'>
                              {c.principal && <Icon name='star' className={`w-4 h-4 ${TONE_TEXT.warning}`} />}
                            </td>
                            <td className='px-3 py-2 text-slate-200'>
                              {c.nome}
                              {c.source === 'movidesk' && (
                                <span className='ml-2 text-xs px-1.5 py-0.5 bg-slate-700 text-slate-400 rounded'>movidesk</span>
                              )}
                            </td>
                            <td className='px-3 py-2 text-slate-300'>{c.email || '—'}</td>
                            <td className='px-3 py-2 text-slate-300'>{c.telefone ? maskPhone(c.telefone) : '—'}</td>
                            <td className='px-3 py-2'>
                              <span className={`text-xs px-2 py-0.5 rounded ${c.type === 'Suporte' ? TONE_BADGE.progress : TONE_BADGE.open}`}>
                                {c.type}
                              </span>
                            </td>
                            <td className='px-3 py-2'>
                              <div className='flex gap-1'>
                                <button
                                  type='button'
                                  onClick={() => setClientContactDraft({ ...c })}
                                  className='p-1.5 text-slate-400 hover:text-white hover:bg-slate-700 rounded'
                                  title='Editar'
                                >
                                  <Icon name='edit' className='w-4 h-4' />
                                </button>
                                <button
                                  type='button'
                                  onClick={() => removeClientContact(c.id, editing.id)}
                                  className='p-1.5 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded'
                                  title='Remover'
                                >
                                  <Icon name='trash' className='w-4 h-4' />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
        </CascaDeModal>
      )}





      {/* Modal de Perfil / Alteração de Senha */}
      {profileModal && (
        // Sem rodapé: cada seção grava por conta própria. Senha digitada: não fecha
        // ao clicar fora (como já era). O avatar segue no título (PanelHeader aceita nó).
        <CascaDeModal
          largura='xs'
          titulo={
            <span className='inline-flex items-center gap-3'>
              <span className='w-9 h-9 rounded-full bg-gradient-to-br from-slate-500 to-slate-600 flex items-center justify-center shrink-0'>
                <span className='text-white font-bold'>{user?.name?.charAt(0).toUpperCase()}</span>
              </span>
              {user?.name}
            </span>
          }
          subtitulo={user?.email}
          onClose={() => setProfileModal(false)}
          corpoClassName=''
        >
            <CollapsibleSection
              icon={<Icon name='key' className='w-5 h-5' />}
              title='Senha'
              summary='Trocar a senha de acesso ao HUB'
            >
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Senha Atual</label>
                <input type='password' value={passwordForm.current} onChange={e => setPasswordForm({...passwordForm, current: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
              </div>
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Nova Senha</label>
                <input type='password' value={passwordForm.new} onChange={e => setPasswordForm({...passwordForm, new: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                {passwordForm.new && validatePassword(passwordForm.new) && (
                  <p className='mt-1 text-xs text-red-400'>{validatePassword(passwordForm.new)}</p>
                )}
              </div>
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>Confirmar Nova Senha</label>
                <input type='password' value={passwordForm.confirm} onChange={e => setPasswordForm({...passwordForm, confirm: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                {passwordForm.confirm && passwordForm.new !== passwordForm.confirm && (
                  <p className='mt-1 text-xs text-red-400'>As senhas não coincidem</p>
                )}
              </div>
              <p className='text-xs text-slate-500'>Trocar a senha encerra todas as sessões e revoga os dispositivos confiáveis.</p>
              <button onClick={changePassword} disabled={saving} className='w-full px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{saving ? 'Salvando...' : 'Alterar Senha'}</button>
            </CollapsibleSection>

            <CollapsibleSection
              icon={<Icon name='shield' className='w-5 h-5' />}
              title='Verificação em duas etapas'
              summary={mfaEnabled ? 'Aplicativo autenticador configurado' : 'Não configurado — sua conta está só com a senha'}
              badge={{ text: mfaEnabled ? 'Ativo' : 'Inativo', tone: mfaEnabled ? 'ok' : 'alerta' }}
              defaultOpen={!mfaEnabled}
            >
              {mfaSetupStep === 'idle' && !mfaEnabled && (
                <div>
                  <p className='text-sm text-slate-400 mb-3'>Adicione uma camada extra de seguranca usando um aplicativo autenticador (Google Authenticator, Authy, etc.)</p>
                  <button onClick={handleMfaSetup} disabled={mfaLoading} className='px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong text-sm font-medium disabled:opacity-50'>
                    {mfaLoading ? 'Carregando...' : 'Ativar MFA'}
                  </button>
                </div>
              )}

              {mfaSetupStep === 'qr' && (
                <div className='space-y-4'>
                  <p className='text-sm text-slate-400'>Escaneie o QR code com seu aplicativo autenticador:</p>
                  <div className='flex justify-center bg-white rounded-xl p-4 mx-auto w-fit'>
                    <img src={mfaQrDataUrl} alt='QR Code MFA' className='w-48 h-48' />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Digite o codigo de 6 digitos:</label>
                    <div className='flex gap-2'>
                      <input
                        type='text'
                        value={mfaSetupCode}
                        onChange={e => setMfaSetupCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                        placeholder='000000'
                        maxLength={6}
                        inputMode='numeric'
                        className={`flex-1 px-4 py-2.5 rounded-lg text-center text-xl tracking-[0.3em] font-mono ${campo}`}
                        autoFocus
                      />
                      <button onClick={handleMfaSetupVerify} disabled={mfaLoading || mfaSetupCode.length !== 6} className='px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong text-sm font-medium disabled:opacity-50'>
                        {mfaLoading ? '...' : 'Verificar'}
                      </button>
                    </div>
                  </div>
                  <button onClick={() => setMfaSetupStep('idle')} className='text-sm text-slate-400 hover:text-white'>Cancelar</button>
                </div>
              )}

              {mfaSetupStep === 'backup' && (
                <div className='space-y-4'>
                  <div className='bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4'>
                    <p className='text-yellow-400 text-sm font-medium mb-2'>Salve seus codigos de backup!</p>
                    <p className='text-yellow-400/70 text-xs'>Estes codigos so serao exibidos uma vez. Use-os para acessar sua conta caso perca o acesso ao aplicativo autenticador.</p>
                  </div>
                  <div className='grid grid-cols-2 gap-2'>
                    {mfaBackupCodes.map((code, i) => (
                      <div key={i} className='bg-central-elevado px-3 py-2 rounded text-center font-mono text-sm text-white tracking-wider'>{code}</div>
                    ))}
                  </div>
                  <div className='flex gap-2'>
                    <button onClick={() => { navigator.clipboard.writeText(mfaBackupCodes.join('\n')); avisar('Codigos copiados!', 'success'); }} className='flex-1 px-4 py-2 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 text-sm'>
                      Copiar
                    </button>
                    <button onClick={() => { setMfaSetupStep('idle'); setMfaBackupCodes([]); }} className='flex-1 px-4 py-2 bg-success text-white rounded-lg hover:bg-success-strong text-sm font-medium'>
                      Pronto, salvei os codigos
                    </button>
                  </div>
                </div>
              )}

              {mfaEnabled && mfaSetupStep === 'idle' && (
                <div>
                  {!mfaDisableAberto ? (
                    <button onClick={() => setMfaDisableAberto(true)} className='text-sm text-slate-400 hover:text-red-400 underline'>
                      Desativar verificação em duas etapas
                    </button>
                  ) : (
                    <div className='bg-red-500/10 border border-red-500/30 rounded-lg p-4 space-y-3'>
                      <p className='text-sm text-red-300'>Sua conta ficará protegida apenas pela senha. Confirme com o código do aplicativo autenticador:</p>
                      <div className='flex gap-2'>
                        <input
                          type='text'
                          value={mfaDisableCode}
                          onChange={e => setMfaDisableCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          placeholder='000000'
                          maxLength={6}
                          inputMode='numeric'
                          className='flex-1 px-4 py-2.5 bg-slate-800 border border-slate-700 text-white rounded-lg focus:border-red-500 text-center text-xl tracking-[0.3em] font-mono'
                        />
                        <button onClick={handleMfaDisable} disabled={mfaLoading || mfaDisableCode.length !== 6} className='px-4 py-2 bg-danger text-white rounded-lg hover:bg-danger-strong text-sm font-medium disabled:opacity-50'>
                          {mfaLoading ? '...' : 'Desativar'}
                        </button>
                      </div>
                      <button onClick={() => { setMfaDisableAberto(false); setMfaDisableCode(''); }} className='text-xs text-slate-400 hover:text-white'>Cancelar</button>
                    </div>
                  )}
                </div>
              )}
            </CollapsibleSection>

            {mfaEnabled && (
              <CollapsibleSection
                icon={<Icon name='server' className='w-5 h-5' />}
                title='Dispositivos confiáveis'
                summary={trustedCount > 0 ? `${trustedCount} navegador(es) sem código de MFA no login` : 'Nenhum — o código é pedido sempre'}
                badge={{ text: trustedCount > 0 ? `${trustedCount} ativo${trustedCount > 1 ? 's' : ''}` : 'Nenhum', tone: trustedCount > 0 ? 'ok' : 'neutro' }}
              >
                <TrustedDevicesSection onCountChange={setTrustedCount} />
              </CollapsibleSection>
            )}

            <CollapsibleSection
              icon={<Icon name='user' className='w-5 h-5' />}
              title='Passkeys'
              summary={passkeysErro
                ? `Não consegui ler as passkeys: ${passkeysErro}`
                : passkeyCredentials.length > 0
                ? passkeyCredentials.map((c: any) => c.deviceName || 'Passkey').join(', ')
                : 'Entrar com Touch ID, Face ID ou Windows Hello'}
              badge={{
                text: passkeysErro ? 'não lido' : passkeyCredentials.length > 0 ? `${passkeyCredentials.length} registrada${passkeyCredentials.length > 1 ? 's' : ''}` : 'Nenhuma',
                tone: passkeysErro ? 'alerta' : passkeyCredentials.length > 0 ? 'ok' : 'neutro',
              }}
            >
              <p className='text-sm text-slate-400'>Faca login com biometria (Touch ID, Face ID ou Windows Hello) sem digitar senha.</p>

              {passkeyCredentials.length > 0 && (
                <div className='space-y-2'>
                  {passkeyCredentials.map((cred: any) => (
                    <div key={cred.id} className='flex items-center justify-between bg-central-elevado/50 rounded-lg px-4 py-3'>
                      <div className='flex items-center gap-3'>
                        <svg className='w-5 h-5 text-blue-400' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4' />
                        </svg>
                        <div>
                          <p className='text-sm text-white font-medium'>{cred.deviceName || 'Passkey'}</p>
                          <p className='text-xs text-slate-500'>
                            Criada em {new Date(cred.createdAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                            {cred.lastUsedAt && ` · Ultimo uso: ${new Date(cred.lastUsedAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`}
                          </p>
                        </div>
                      </div>
                      <button onClick={() => handlePasskeyDelete(cred.id)} className='p-1.5 text-slate-500 hover:text-red-400 rounded' title='Remover passkey'>
                        <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <div className='flex gap-2'>
                <input
                  type='text'
                  value={passkeyDeviceName}
                  onChange={(e) => setPasskeyDeviceName(e.target.value)}
                  placeholder='Nome do dispositivo (ex: MacBook)'
                  className={`flex-1 px-4 py-2.5 rounded-lg text-sm ${campo}`}
                />
                <button
                  onClick={handlePasskeyRegister}
                  disabled={passkeyLoading}
                  className='px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong text-sm font-medium disabled:opacity-50 whitespace-nowrap'
                >
                  {passkeyLoading ? '...' : 'Adicionar Passkey'}
                </button>
              </div>
            </CollapsibleSection>

            <CollapsibleSection
              icon={<Icon name='mapPin' className='w-5 h-5' />}
              title='Sessões ativas'
              summary={sessionCount > 0 ? `${sessionCount} navegador(es) conectado(s) nesta conta` : 'Carregando...'}
              badge={{ text: `${sessionCount || '—'}`, tone: 'neutro' }}
            >
              <ActiveSessionsSection onCountChange={setSessionCount} />
            </CollapsibleSection>
        </CascaDeModal>
      )}

      {/* Ficha da assinatura (botão do olho). Ver components/FichaDaAssinatura.tsx. */}
      {viewItems && (() => {
        const isLocationView = viewItems._locationFilter !== undefined;
        // null = matriz (itens sem locationId); número = filial específica.
        const itensDaFicha = isLocationView
          ? (viewItems.items || []).filter((i: any) => (viewItems._locationFilter === null ? !i.locationId : i.locationId === viewItems._locationFilter))
          : viewItems.items || [];
        let ddrsDaFicha: any[] = [];
        // Empresas ligadas por parentClientId são do GRUPO econômico, não filiais (filial = local).
        const empresasDoGrupoIds = clients.filter((c: any) => c.parentClientId === viewItems.clientId).map((c: any) => c.id);
        if (isLocationView) {
          if (viewItems._locationFilter === null) {
            ddrsDaFicha = clientDDRs.filter((d: any) => d.clientId === viewItems.clientId && d.status === 'Ativo' && !empresasDoGrupoIds.includes(d.clientId));
          } else {
            const clienteDoLocal = clients.find((c: any) => c.locationId === viewItems._locationFilter);
            if (clienteDoLocal) ddrsDaFicha = clientDDRs.filter((d: any) => d.clientId === clienteDoLocal.id && d.status === 'Ativo');
          }
        } else {
          const allClientIds = [viewItems.clientId, ...empresasDoGrupoIds];
          ddrsDaFicha = clientDDRs.filter((d: any) => allClientIds.includes(d.clientId) && d.status === 'Ativo');
        }
        const nomeDoCliente = (id: number) => { const c = clients.find((x: any) => x.id === id); return c?.name || c?.tradeName || c?.companyName || `Cliente #${id}`; };
        const botao = 'px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2';
        return (
          <FichaDaAssinatura
            contract={viewItems}
            client={clients.find((c: any) => c.id === viewItems.clientId)}
            items={itensDaFicha}
            ddrs={ddrsDaFicha}
            products={products}
            rateio={rateioDaFicha}
            nomeDoCliente={nomeDoCliente}
            fmt={fmt}
            locationName={isLocationView ? viewItems._locationName || 'Local' : undefined}
            onClose={() => setViewItems(null)}
            contratos={contracts}
            clientes={clients}
            onAbrirGrupo={(matrizId: number) => { setViewItems(null); setGrupoParaAbrir(matrizId); setSection('locations'); }}
            // Rodapé (§8.1): uma primária laranja (Editar), anexos e navegação neutros,
            // suspender/reativar (raros, mudam o estado da assinatura) no ⋯.
            footer={
              <>
                <button onClick={() => setViewItems(null)} className={`${botao} bg-slate-800 text-slate-300 hover:bg-slate-700`}>Fechar</button>
                {isLocationView && (
                  <button onClick={() => setViewItems({ ...viewItems, _locationFilter: undefined, _locationName: undefined })} className={`${botao} bg-slate-700 text-slate-300 hover:bg-slate-600`}>
                    <Icon name='eye' className='w-4 h-4' />Ver contrato completo
                  </button>
                )}
                {!isLocationView && (
                  <>
                    {canEdit && <button onClick={() => { setAttachmentModal(viewItems); setViewItems(null); }} className={`${botao} bg-slate-700 text-slate-300 hover:bg-slate-600`}>
                      <Icon name='fileText' className='w-4 h-4' />Anexos{viewItems.attachments?.length > 0 ? ` (${viewItems.attachments.length})` : ''}
                    </button>}
                    {canEdit && <button onClick={() => { openModal('contract', viewItems); setViewItems(null); }} className={`${botao} bg-primary text-white hover:bg-primary-strong`}>
                      <Icon name='edit' className='w-4 h-4' />Editar
                    </button>}
                    {canEdit && (
                      <MaisAcoes
                        abrePara='cima'
                        itens={[
                          ...(viewItems.status === 'Ativo'
                            ? [{ label: 'Suspender assinatura', danger: true, onClick: () => { setSuspendModal(viewItems); setSuspendForm({ reason: '', reactivationDate: '' }); setViewItems(null); } }]
                            : []),
                          ...(viewItems.status === 'Suspenso'
                            ? [{
                                label: 'Reativar assinatura',
                                onClick: async () => {
                                  try {
                                    await contractsService.reactivateContract(viewItems.id);
                                    setToast({ message: 'Assinatura reativada!', type: 'success' });
                                    loadData();
                                    setViewItems(null);
                                  } catch {
                                    setToast({ message: 'Erro ao reativar assinatura', type: 'error' });
                                  }
                                },
                              }]
                            : []),
                        ]}
                      />
                    )}
                  </>
                )}
              </>
            }
          />
        );
      })()}

      {/* Modal de Edição de Itens por Localização */}
      {editLocationItems && (
        // Editor: não fecha ao clicar fora (como já era). A altura do corpo era
        // chumbada (max-h-[calc(90vh-200px)]); na casca o corpo recebe o que sobra.
        <CascaDeModal
          largura='lg'
          titulo={`Editar Itens · ${editLocationItems.locationName}`}
          subtitulo={`#${editLocationItems.contract.code || editLocationItems.contract.id}`}
          onClose={() => setEditLocationItems(null)}
          corpoClassName='p-6'
          rodape={
            <>
              <button onClick={() => { setEditLocationItems(null); setEditLocationForm([]); }} className='flex-1 px-6 py-3 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 font-medium'>
                Cancelar
              </button>
              <button
                onClick={async () => {
                  try {
                    // Pegar todos os itens do contrato que NÃO são desta localização
                    const otherItems = (editLocationItems.contract.items || []).filter((i: any) => {
                      if (editLocationItems.locationId === null) {
                        return i.locationId && i.locationId !== null;
                      }
                      return i.locationId !== editLocationItems.locationId;
                    });

                    // Garantir que todos os itens editados tenham o locationId correto
                    const updatedLocationItems = editLocationForm.map((i: any) => ({
                      ...i,
                      locationId: editLocationItems.locationId,
                    }));

                    // Combinar itens
                    const allItems = [...otherItems, ...updatedLocationItems];

                    // Recalcular MRR e P&S totais
                    const totalMRR = allItems.filter((i: any) => i.type === 'MRR').reduce((s: number, i: any) => s + (i.totalValue || 0), 0);
                    const totalPS = allItems.filter((i: any) => i.type !== 'MRR').reduce((s: number, i: any) => s + (i.totalValue || 0), 0);

                    // Atualizar contrato
                    await contractsService.update(editLocationItems.contract.id, {
                      items: allItems,
                      mrr: totalMRR,
                      totalPS: totalPS,
                    });

                    setToast({ message: `Itens de ${editLocationItems.locationName} atualizados!`, type: 'success' });
                    setEditLocationItems(null);
                    setEditLocationForm([]);
                    loadData();
                  } catch (err: any) {
                    setToast({ message: 'Erro ao salvar itens', type: 'error' });
                  }
                }}
                className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium flex items-center justify-center gap-2'
              >
                <Icon name='check' className='w-4 h-4' />Salvar Alterações
              </button>
            </>
          }
        >
              {editLocationForm.length === 0 ? (
                <p className='text-center text-slate-500 py-8'>Nenhum item para esta localização</p>
              ) : (
                <div className='space-y-4'>
                  {editLocationForm.map((item: any, idx: number) => {
                    const prod = products.find((p: any) => Number(p.id) === Number(item.productId));
                    return (
                      <div key={idx} className='bg-central-elevado/50 rounded-lg border border-central-borda p-4'>
                        <div className='flex items-start justify-between gap-4'>
                          <div className='flex-1'>
                            <div className='flex items-center gap-2 mb-2'>
                              <span className='font-mono text-xs bg-slate-700 px-2 py-1 rounded'>{prod?.code || item.productCode || '—'}</span>
                              <span className={`text-xs px-2 py-0.5 rounded-full ${item.type === 'MRR' ? TONE_BADGE.open : TONE_BADGE.ps}`}>
                                {item.type || 'MRR'}
                              </span>
                            </div>
                            <p className='text-white font-medium'>{prod?.name || item.name || '—'}</p>
                            <p className='text-slate-400 text-xs mt-1 whitespace-pre-line'>{prod?.description || ''}</p>
                          </div>
                          <button
                            onClick={() => setEditLocationForm(editLocationForm.filter((_: any, i: number) => i !== idx))}
                            className='p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg'
                            title='Remover item'
                          >
                            <Icon name='trash' className='w-4 h-4' />
                          </button>
                        </div>
                        <div className='grid grid-cols-3 gap-4 mt-4'>
                          <div>
                            <label className='block text-xs text-slate-500 mb-1'>Quantidade</label>
                            <input
                              type='number'
                              min='1'
                              value={item.quantity || 1}
                              onChange={(e) => {
                                const newForm = [...editLocationForm];
                                newForm[idx].quantity = parseInt(e.target.value) || 1;
                                newForm[idx].totalValue = newForm[idx].quantity * (newForm[idx].unitValue || 0);
                                setEditLocationForm(newForm);
                              }}
                              className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
                            />
                          </div>
                          <div>
                            <label className='block text-xs text-slate-500 mb-1'>Valor Unitário</label>
                            <input
                              type='number'
                              step='0.01'
                              min='0'
                              value={item.unitValue || 0}
                              onChange={(e) => {
                                const newForm = [...editLocationForm];
                                newForm[idx].unitValue = parseFloat(e.target.value) || 0;
                                newForm[idx].totalValue = (newForm[idx].quantity || 1) * newForm[idx].unitValue;
                                setEditLocationForm(newForm);
                              }}
                              className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
                            />
                          </div>
                          <div>
                            <label className='block text-xs text-slate-500 mb-1'>Total</label>
                            <div className='px-3 py-2 bg-central-elevado border border-central-borda rounded-lg text-green-400 font-semibold text-sm'>
                              R$ {fmt(item.totalValue || 0)}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Adicionar novo item */}
                  <div className='border-2 border-dashed border-central-borda rounded-lg p-4'>
                    <p className='text-slate-500 text-sm mb-3'>Adicionar novo produto</p>
                    <select
                      className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
                      value=''
                      onChange={(e) => {
                        const prodId = parseInt(e.target.value);
                        const prod = products.find((p: any) => p.id === prodId);
                        if (prod) {
                          const unitValue = parseFloat(prod.value) || 0;
                          setEditLocationForm([...editLocationForm, {
                            productId: prod.id,
                            productCode: prod.code,
                            productName: prod.name,
                            name: prod.name,
                            type: prod.type || 'MRR',
                            quantity: 1,
                            unitValue: unitValue,
                            totalValue: unitValue,
                            recurrence: prod.recurrence || 'Mensal',
                            detailedDescription: prod.description || '',
                            locationId: editLocationItems.locationId,
                            locationName: editLocationItems.locationName,
                          }]);
                        }
                      }}
                    >
                      <option value=''>Selecione um produto...</option>
                      {products.filter((p: any) => p.status === true || p.status === 'Ativo').map((p: any) => (
                        <option key={p.id} value={p.id}>{p.code} - {p.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Totais */}
              <div className='mt-6 pt-4 border-t border-central-borda'>
                <div className='bg-central-elevado rounded-lg p-4'>
                  <div className='grid grid-cols-3 gap-4 text-center'>
                    <div>
                      <p className='text-xs text-slate-500 uppercase mb-1'>Itens</p>
                      <p className='text-lg font-bold text-white'>{editLocationForm.length}</p>
                    </div>
                    <div>
                      <p className='text-xs text-slate-500 uppercase mb-1'>MRR Local</p>
                      <p className='text-lg font-bold text-green-400'>R$ {fmt(editLocationForm.filter((i: any) => i.type === 'MRR').reduce((s: number, i: any) => s + (i.totalValue || 0), 0))}</p>
                    </div>
                    <div>
                      <p className='text-xs text-slate-500 uppercase mb-1'>P&S Local</p>
                      <p className='text-lg font-bold text-white'>R$ {fmt(editLocationForm.filter((i: any) => i.type !== 'MRR').reduce((s: number, i: any) => s + (i.totalValue || 0), 0))}</p>
                    </div>
                  </div>
                </div>
              </div>
        </CascaDeModal>
      )}

      {/* Modal de Assinatura Digital */}
      {signatureModal && (
        // Signatário digitado: não fecha ao clicar fora (como já era). A caixa
        // CLIENTE vira a linha mono do cabeçalho (prévia "Uma Casca Só").
        <CascaDeModal
          largura='sm'
          titulo='Enviar para Assinatura'
          subtitulo={`#${signatureModal.code || signatureModal.id} · ${nomeDeExibicao(clients.find((c: any) => c.id === signatureModal.clientId), '—')}`}
          onClose={() => setSignatureModal(null)}
          corpoClassName='p-6 space-y-4'
          rodape={
            <>
              <button onClick={() => setSignatureModal(null)} className='flex-1 px-6 py-3 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 font-medium'>
                Cancelar
              </button>
              <button
                onClick={async () => {
                  if (!signatureForm.signerName || !signatureForm.signerEmail) {
                    setToast({ message: 'Preencha nome e email do signatário', type: 'warning' });
                    return;
                  }
                  setSendingSignature(true);
                  try {
                    await contractsService.sendForSignature(signatureModal.id, {
                      signerEmail: signatureForm.signerEmail,
                      signerName: signatureForm.signerName,
                      signerCpf: signatureForm.signerCpf || undefined,
                    });
                    setToast({ message: 'Assinatura enviada para validação!', type: 'success' });
                    // Refresh contracts
                    const updatedContracts = await contractsService.getAll();
                    setContracts(Array.isArray(updatedContracts) ? updatedContracts : []);
                    setSignatureModal(null);
                  } catch (err: any) {
                    setToast({ message: err.response?.data?.message || 'Erro ao enviar assinatura', type: 'error' });
                  } finally {
                    setSendingSignature(false);
                  }
                }}
                disabled={sendingSignature}
                className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2'
              >
                {sendingSignature ? (
                  <>
                    <svg className='animate-spin h-5 w-5' viewBox='0 0 24 24'>
                      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' fill='none' />
                      <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
                    </svg>
                    Enviando...
                  </>
                ) : (
                  <>
                    <Icon name='pen' className='w-5 h-5' />
                    Enviar para Assinatura
                  </>
                )}
              </button>
            </>
          }
        >
              <div>
                <label className='block text-sm font-medium text-slate-400 mb-2'>Nome do Signatário *</label>
                <input
                  type='text'
                  value={signatureForm.signerName}
                  onChange={e => setSignatureForm({ ...signatureForm, signerName: e.target.value })}
                  className={`w-full px-4 py-3 rounded-lg ${campo}`}
                  placeholder='Nome completo'
                />
              </div>
              <div>
                <label className='block text-sm font-medium text-slate-400 mb-2'>Email do Signatário *</label>
                <input
                  type='email'
                  value={signatureForm.signerEmail}
                  onChange={e => setSignatureForm({ ...signatureForm, signerEmail: e.target.value })}
                  className={`w-full px-4 py-3 rounded-lg ${campo}`}
                  placeholder='email@empresa.com.br'
                />
              </div>
              <div>
                <label className='block text-sm font-medium text-slate-400 mb-2'>CPF do Signatário (opcional)</label>
                <input
                  type='text'
                  value={signatureForm.signerCpf}
                  onChange={e => setSignatureForm({ ...signatureForm, signerCpf: e.target.value })}
                  className={`w-full px-4 py-3 rounded-lg ${campo}`}
                  placeholder='000.000.000-00'
                />
              </div>
              <div className={`border rounded-lg p-4 ${TONE_SURFACE.warning} ${TONE_BORDER.warning}`}>
                <div className='flex items-start gap-3'>
                  <Icon name='alertCircle' className={`w-5 h-5 mt-0.5 ${TONE_TEXT.warning}`} />
                  <div className='text-sm text-slate-200'>
                    <p className={`font-medium ${TONE_TEXT.warning}`}>Importante</p>
                    <p className='text-slate-300 mt-1'>A assinatura será enviada para validação digital via ClickSign. O signatário receberá um email com o link para assinar.</p>
                  </div>
                </div>
              </div>
        </CascaDeModal>
      )}

      {/* Modal de Suspensão de Contrato */}
      {suspendModal && (
        // Motivo digitado: não fecha ao clicar fora (como já era). O cabeçalho em
        // gradiente âmbar vira o PanelHeader; o aviso âmbar do corpo continua.
        <CascaDeModal
          largura='sm'
          titulo='Suspender Assinatura'
          subtitulo={`#${suspendModal.code || suspendModal.id} · ${nomeDeExibicao(clients.find((c: any) => c.id === suspendModal.clientId), '—')}`}
          onClose={() => setSuspendModal(null)}
          faixa={[{ k: 'MRR', v: fmt(suspendModal.mrr || 0), cls: TONE_TEXT.open }]}
          corpoClassName='p-6 space-y-4'
          rodape={
            <>
              <button onClick={() => setSuspendModal(null)} className='flex-1 px-6 py-3 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 font-medium'>
                Cancelar
              </button>
              <button
                onClick={async () => {
                  if (!suspendForm.reason) {
                    setToast({ message: 'Informe o motivo da suspensão', type: 'warning' });
                    return;
                  }
                  try {
                    await contractsService.suspendContract(suspendModal.id, {
                      reason: suspendForm.reason,
                      reactivationDate: suspendForm.reactivationDate || undefined,
                    });
                    setToast({ message: 'Assinatura suspensa!', type: 'success' });
                    loadData();
                    setSuspendModal(null);
                  } catch (err: any) {
                    setToast({ message: err.response?.data?.message || 'Erro ao suspender assinatura', type: 'error' });
                  }
                }}
                className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium flex items-center justify-center gap-2'
              >
                <Icon name='alertCircle' className='w-5 h-5' />
                Suspender Assinatura
              </button>
            </>
          }
        >
              <div>
                <label className='block text-sm font-medium text-slate-400 mb-2'>Motivo da Suspensão *</label>
                <textarea
                  value={suspendForm.reason}
                  onChange={e => setSuspendForm({ ...suspendForm, reason: e.target.value })}
                  className={`w-full px-4 py-3 rounded-lg ${campo}`}
                  placeholder='Descreva o motivo da suspensão...'
                  rows={3}
                />
              </div>
              <div>
                <label className='block text-sm font-medium text-slate-400 mb-2'>Data Prevista de Reativação (opcional)</label>
                <input
                  type='date'
                  value={suspendForm.reactivationDate}
                  onChange={e => setSuspendForm({ ...suspendForm, reactivationDate: e.target.value })}
                  className={`w-full px-4 py-3 rounded-lg ${campo}`}
                />
              </div>
              <div className={`border rounded-lg p-4 ${TONE_SURFACE.warning} ${TONE_BORDER.warning}`}>
                <div className='flex items-start gap-3'>
                  <Icon name='alertCircle' className={`w-5 h-5 mt-0.5 ${TONE_TEXT.warning}`} />
                  <div className='text-sm text-slate-200'>
                    <p className={`font-medium ${TONE_TEXT.warning}`}>Atenção</p>
                    <p className='text-slate-300 mt-1'>A assinatura será marcada como Suspensa e sai da geração mensal de faturas: enquanto estiver suspensa, não gera fatura sozinha. Também deixa de contar no MRR ativo. A reativação é manual; a data prevista fica só registrada.</p>
                  </div>
                </div>
              </div>
        </CascaDeModal>
      )}

      {/* Modal de Anexos da Assinatura */}
      {attachmentModal && (() => {
        const attLocations = (allLocations || []).filter((l: any) => l.clientId === attachmentModal.clientId);
        const categoryConfig: Record<string, { label: string; icon: string; color: string; bgColor: string }> = {
          contrato: { label: 'Contrato/Aditivos', icon: 'fileText', color: 'text-blue-400', bgColor: 'bg-blue-500/15' },
          aditivo: { label: 'Contrato/Aditivos', icon: 'fileText', color: 'text-blue-400', bgColor: 'bg-blue-500/15' },
          edital: { label: 'Edital/TR', icon: 'fileText', color: TONE_TEXT.info, bgColor: TONE_SURFACE.info },
          orcamento: { label: 'Orçamentos', icon: 'fileText', color: 'text-emerald-400', bgColor: 'bg-emerald-500/15' },
          oficio: { label: 'Ofícios', icon: 'mail', color: 'text-amber-400', bgColor: 'bg-amber-500/15' },
          portabilidade: { label: 'Portabilidade', icon: 'phone', color: 'text-slate-300', bgColor: 'bg-slate-500/15' },
          outro: { label: 'Outros', icon: 'paperclip', color: 'text-slate-400', bgColor: 'bg-slate-500/15' },
        };
        const categoryOrder = ['contrato', 'edital', 'orcamento', 'oficio', 'portabilidade', 'outro'];
        const inferCategory = (att: any): string => {
          if (att.category && att.category !== 'aditivo') return att.category;
          if (att.category === 'aditivo') return 'contrato';
          const name = (att.originalName || att.filename || '').toLowerCase();
          if (/contrato|aditivo/i.test(name)) return 'contrato';
          if (/orcamento|proposta|orcam/i.test(name)) return 'orcamento';
          if (/oficio|of-/i.test(name)) return 'oficio';
          if (/portabilidade|termo/i.test(name)) return 'portabilidade';
          return 'outro';
        };
        const attachments = attachmentModal.attachments || [];
        const grouped: Record<string, any[]> = {};
        categoryOrder.forEach(cat => { grouped[cat] = []; });
        attachments.forEach((att: any) => { const cat = inferCategory(att); (grouped[cat] || (grouped[cat] = [])).push(att); });

        return (
        // A altura do corpo era chumbada (max-h-[calc(90vh-200px)]); na casca o
        // corpo recebe o que sobra. Não fecha ao clicar fora (como já era).
        <CascaDeModal
          largura='base'
          titulo='Anexos da Assinatura'
          subtitulo={`#${attachmentModal.code || attachmentModal.id} · ${nomeDeExibicao(clients.find((c: any) => c.id === attachmentModal.clientId), '—')}`}
          onClose={() => setAttachmentModal(null)}
          corpoClassName='p-6 space-y-4'
          rodape={
            <button onClick={() => setAttachmentModal(null)} className='flex-1 px-6 py-3 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 font-medium'>
              Fechar
            </button>
          }
        >
              {/* Upload de Anexo com seleção de categoria */}
              {canEdit && (
                <div
                  className='bg-central-elevado/50 rounded-lg p-4 border border-dashed border-slate-600 hover:border-primary transition-colors'
                  onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('border-primary'); }}
                  onDragLeave={(e) => { e.currentTarget.classList.remove('border-primary'); }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.currentTarget.classList.remove('border-primary');
                    if (!uploadingAttachment) uploadContractAttachmentFiles(Array.from(e.dataTransfer?.files || []));
                  }}
                >
                  <div className='flex items-center gap-3 mb-3 flex-wrap'>
                    <label className='text-slate-400 text-sm'>Categoria:</label>
                    <select
                      id='attachment-category-select'
                      defaultValue='contrato'
                      onChange={(e) => {
                        const locSelect = document.getElementById('attachment-location-select') as HTMLSelectElement;
                        if (locSelect) locSelect.style.display = e.target.value === 'portabilidade' ? '' : 'none';
                      }}
                      className={`text-sm rounded-lg px-3 py-1.5 ${campo}`}
                    >
                      <option value='contrato'>Contrato/Aditivo</option>
                      <option value='edital'>Edital/TR</option>
                      <option value='orcamento'>Orçamento</option>
                      <option value='oficio'>Ofício</option>
                      <option value='portabilidade'>Portabilidade</option>
                      <option value='outro'>Outro</option>
                    </select>
                    {attLocations.length > 0 && (
                      <>
                        <label className='text-slate-400 text-sm'>Filial:</label>
                        <select
                          id='attachment-location-select'
                          defaultValue=''
                          style={{ display: 'none' }}
                          className={`text-sm rounded-lg px-3 py-1.5 ${campo}`}
                        >
                          <option value=''>Geral (todas)</option>
                          {attLocations.map((loc: any) => <option key={loc.id} value={loc.id}>{loc.code} - {loc.name}</option>)}
                        </select>
                      </>
                    )}
                  </div>
                  <div className='relative'>
                    <input
                      type='file'
                      multiple
                      accept='.pdf,.png,.jpg,.jpeg'
                      onChange={async (e) => {
                        await uploadContractAttachmentFiles(Array.from(e.target.files || []));
                        e.target.value = '';
                      }}
                      className='absolute inset-0 w-full h-full opacity-0 cursor-pointer'
                      disabled={uploadingAttachment}
                    />
                    <div className='flex items-center justify-center gap-4 pointer-events-none'>
                      <Icon name='upload' className='w-8 h-8 text-slate-500' />
                      <div className='text-center'>
                        <p className='text-slate-300 font-medium'>Clique ou arraste um arquivo aqui</p>
                        <p className='text-slate-500 text-sm'>PDF, PNG, JPG (máx. 20MB)</p>
                      </div>
                    </div>
                  </div>
                  {uploadingAttachment && (
                    <div className='mt-3 flex items-center justify-center gap-2 text-orange-400'>
                      <svg className='animate-spin h-5 w-5' viewBox='0 0 24 24'>
                        <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' fill='none' />
                        <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
                      </svg>
                      Enviando anexo...
                    </div>
                  )}
                </div>
              )}

              {/* Botão para sincronizar PDF assinado do ClickSign */}
              {attachmentModal.proposalId && canEdit && (
                <button
                  onClick={async () => {
                    setSaving(true);
                    try {
                      const result = await contractsService.syncSignedPdf(attachmentModal.id);
                      if (result.success) {
                        showToast('PDF assinado sincronizado com sucesso!', 'success');
                        const updated = await contractsService.getAll();
                        const refreshedContract = updated.find((c: any) => c.id === attachmentModal.id);
                        if (refreshedContract) setAttachmentModal(refreshedContract);
                        loadData();
                      } else {
                        showToast(result.error || 'Erro ao sincronizar', 'warning');
                      }
                    } catch (err: any) {
                      showToast(err.response?.data?.error || 'Erro ao sincronizar PDF', 'error');
                    } finally {
                      setSaving(false);
                    }
                  }}
                  disabled={saving}
                  className='w-full flex items-center justify-center gap-2 px-4 py-3 bg-success hover:bg-success-strong text-white rounded-lg font-medium disabled:opacity-50'
                >
                  <Icon name='download' className='w-5 h-5' />
                  {saving ? 'Sincronizando...' : 'Sincronizar PDF Assinado do ClickSign'}
                </button>
              )}

              {/* Botão para sincronizar Proposta Aprovada */}
              {attachmentModal.proposalId && canEdit && (
                <button
                  onClick={async () => {
                    setSaving(true);
                    try {
                      const result = await contractsService.syncProposalPdf(attachmentModal.id);
                      if (result.success) {
                        showToast('Proposta sincronizada com sucesso!', 'success');
                        const updated = await contractsService.getAll();
                        const refreshedContract = updated.find((c: any) => c.id === attachmentModal.id);
                        if (refreshedContract) setAttachmentModal(refreshedContract);
                        loadData();
                      } else {
                        showToast(result.error || 'Erro ao sincronizar', 'warning');
                      }
                    } catch (err: any) {
                      showToast(err.response?.data?.error || 'Erro ao sincronizar proposta', 'error');
                    } finally {
                      setSaving(false);
                    }
                  }}
                  disabled={saving}
                  className='w-full flex items-center justify-center gap-2 px-4 py-3 bg-primary hover:bg-primary-strong text-white rounded-lg font-medium disabled:opacity-50'
                >
                  <Icon name='fileText' className='w-5 h-5' />
                  {saving ? 'Sincronizando...' : 'Sincronizar Proposta Aprovada'}
                </button>
              )}

              {/* Lista de Anexos agrupados por Categoria */}
              {attachments.length === 0 ? (
                <div className='text-center py-8'>
                  <Icon name='fileText' className='w-12 h-12 text-slate-600 mx-auto mb-3' />
                  <p className='text-slate-500'>Nenhum anexo nesta assinatura</p>
                  <p className='text-slate-600 text-sm mt-1'>Faça upload de PDFs de licitações, documentos externos, etc.</p>
                </div>
              ) : (
                <div className='space-y-2'>
                  {categoryOrder.map(catKey => {
                    const catAtts = grouped[catKey] || [];
                    if (catAtts.length === 0) return null;
                    const cfg = categoryConfig[catKey] || categoryConfig.outro;

                    // Render a single attachment row
                    const renderAttRow = (att: any) => (
                            <div key={att.id} className='flex items-center gap-3 p-2.5 bg-central-elevado rounded-lg border border-central-borda/50 hover:border-slate-600'>
                              <div className={`p-1.5 rounded-lg ${att.mimeType === 'application/pdf' ? 'bg-red-500/20' : 'bg-blue-500/20'}`}>
                                <Icon name={att.mimeType === 'application/pdf' ? 'fileText' : 'image'} className={`w-4 h-4 ${att.mimeType === 'application/pdf' ? 'text-red-400' : 'text-blue-400'}`} />
                              </div>
                              <div className='flex-1 min-w-0'>
                                <p className='text-white text-sm font-medium truncate'>{att.originalName}</p>
                                <div className='flex items-center gap-2 text-xs text-slate-500'>
                                  <span>{(att.size / 1024).toFixed(1)} KB</span>
                                  <span>·</span>
                                  <span>{new Date(att.uploadedAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</span>
                                  {att.uploadedBy && (<><span>·</span><span>{att.uploadedBy}</span></>)}
                                </div>
                              </div>
                              <div className='flex items-center gap-0.5'>
                                {canEdit && (
                                  <select
                                    value={att.category || catKey}
                                    onChange={async (ev) => {
                                      const newCat = ev.target.value;
                                      try {
                                        await contractsService.updateAttachmentCategory(attachmentModal.id, att.id, newCat);
                                        showToast('Categoria atualizada!', 'success');
                                        const updated = await contractsService.getAll();
                                        const r = updated.find((c: any) => c.id === attachmentModal.id);
                                        if (r) setAttachmentModal(r);
                                      } catch { showToast('Erro ao atualizar categoria', 'error'); }
                                    }}
                                    className={`text-xs rounded px-1.5 py-1 cursor-pointer outline-none ${campo}`}
                                    title='Mover para outra categoria'
                                  >
                                    <option value='contrato'>Contrato</option>
                                    <option value='edital'>Edital/TR</option>
                                    <option value='orcamento'>Orçamento</option>
                                    <option value='oficio'>Ofício</option>
                                    <option value='portabilidade'>Portabilidade</option>
                                    <option value='outro'>Outro</option>
                                  </select>
                                )}
                                <button onClick={async () => { try { await contractsService.viewAttachment(attachmentModal.id, att.id); } catch { showToast('Erro ao visualizar anexo', 'error'); } }} className='p-1.5 text-slate-400 hover:text-green-400 hover:bg-green-500/10 rounded-lg' title='Visualizar'>
                                  <Icon name='eye' className='w-4 h-4' />
                                </button>
                                <button onClick={async () => { try { await contractsService.downloadAttachment(attachmentModal.id, att.id, att.originalName || att.filename); } catch { showToast('Erro ao baixar anexo', 'error'); } }} className='p-1.5 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg' title='Download'>
                                  <Icon name='download' className='w-4 h-4' />
                                </button>
                                {canEdit && (
                                  <button onClick={async () => { if (!(await confirmar({ title: 'Remover este anexo?', danger: true, confirmLabel: 'Remover' }))) return; try { await contractsService.removeAttachment(attachmentModal.id, att.id); showToast('Anexo removido!', 'success'); loadData(); const updated = await contractsService.getAll(); const r = updated.find((c: any) => c.id === attachmentModal.id); if (r) setAttachmentModal(r); } catch (err: any) { showToast(err.response?.data?.message || 'Erro ao remover anexo', 'error'); } }} className='p-1.5 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg' title='Remover'>
                                    <Icon name='trash' className='w-4 h-4' />
                                  </button>
                                )}
                              </div>
                            </div>
                    );

                    // Sub-group portabilidade by location
                    const hasLocationAtts = catKey === 'portabilidade' && catAtts.some((a: any) => a.locationId || a.locationCode);

                    return (
                      <details key={catKey} open className='group'>
                        <summary className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer select-none ${cfg.bgColor} border border-central-borda/50 hover:border-slate-600`}>
                          <Icon name={cfg.icon} className={`w-5 h-5 ${cfg.color}`} />
                          <span className={`font-medium ${cfg.color}`}>{cfg.label}</span>
                          <span className='text-slate-500 text-sm'>({catAtts.length})</span>
                          <svg className='w-4 h-4 text-slate-500 ml-auto transition-transform group-open:rotate-180' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' /></svg>
                        </summary>
                        <div className='mt-1 ml-2 space-y-1'>
                          {hasLocationAtts ? (() => {
                            // Group by locationCode, "Geral" for those without
                            const byLoc: Record<string, any[]> = {};
                            catAtts.forEach((att: any) => {
                              const key = att.locationCode || 'geral';
                              (byLoc[key] || (byLoc[key] = [])).push(att);
                            });
                            const locKeys = Object.keys(byLoc).sort((a, b) => a === 'geral' ? -1 : b === 'geral' ? 1 : a.localeCompare(b));
                            return locKeys.map(locKey => (
                              <details key={locKey} open className='ml-1'>
                                <summary className='flex items-center gap-2 p-1.5 rounded cursor-pointer select-none text-sm text-slate-300 hover:bg-slate-800/50'>
                                  <span className={`px-1.5 py-0.5 rounded ${TONE_BADGE.group} text-xs font-medium`}>{locKey === 'geral' ? 'Geral' : locKey}</span>
                                  <span className='text-slate-500 text-xs'>({byLoc[locKey].length})</span>
                                </summary>
                                <div className='ml-2 space-y-1 mt-1'>
                                  {byLoc[locKey].map(renderAttRow)}
                                </div>
                              </details>
                            ));
                          })() : catAtts.map(renderAttRow)}
                        </div>
                      </details>
                    );
                  })}
                </div>
              )}
        </CascaDeModal>
        );
      })()}

      {modal === 'contract' && (() => {
        // A EDIÇÃO falando a língua da ficha (prévia https://claude.ai/artifact/LGx85pETYBgDmYz8zmmaFP):
        // mesma casca, cabeçalho com nome, razão social e CNPJ, e os números numa
        // faixa VIVA no topo. Nenhum comportamento muda; a grade é a mesma.
        const cl = clients.find((c: any) => c.id === form.clientId);
        const nome = cl?.name || cl?.tradeName || cl?.companyName;
        const ehMrr = (i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const t = i.type || p?.type || 'MRR'; return t === 'MRR' || !i.productId || i.productId === 0; };
        const itens = form.items || [];
        const soma = itens.filter(ehMrr).reduce((s: number, i: any) => s + (Number(i.totalValue) || 0), 0);
        const mrr = parseFloat(String(form.mrr)) || 0;
        const bate = Math.abs(soma - mrr) < 0.005;
        const papeis = resumoPorPapel(itens, ehMrr, rateadosDaAssinatura);
        const nLocais = deveAgrupar(itens) ? agruparItensPorLocal(itens, clientLocations, ehMrr).filter((g) => g.tipo === 'local').length : 0;
        const faixaDaEdicao: NumeroDaFaixa[] = [
          { k: 'MRR', v: fmt(mrr), cls: TONE_TEXT.open },
          ...(papeis.temPapelEspecial
            ? [
                { k: 'Rateado', v: fmt(papeis.rateado), dica: 'Fatia desta empresa no que o grupo compartilha' },
                { k: 'Próprio', v: fmt(papeis.proprio) },
                ...(papeis.desconto ? [{ k: 'Descontos', v: fmt(papeis.desconto), cls: TONE_TEXT.danger }] : []),
              ]
            : []),
          ...(nLocais > 0 ? [{ k: 'Locais', v: `matriz + ${nLocais}` }] : []),
          { k: 'Itens', v: itens.length },
          // O "bate com o MRR" era a melhor coisa do editor e passava em cinza no rodapé.
          {
            k: 'Confere',
            v: itens.length === 0 ? '—' : bate ? '✓ bate' : `≠ ${fmt(soma)}`,
            cls: itens.length === 0 ? TONE_TEXT.neutral : bate ? TONE_TEXT.open : TONE_TEXT.danger,
            dica: bate ? 'A soma dos itens MRR bate com o MRR da assinatura' : `A soma dos itens MRR (R$ ${fmt(soma)}) difere do MRR (R$ ${fmt(mrr)}). Item com vigência começando ou terminando no período explica a diferença; fora isso, confira antes de salvar.`,
          },
        ];
        return (
        <CascaDeModal
          altura='tela'
          largura='2xl'
          onClose={closeModal}
          temEdicaoNaoSalva={temEdicaoNaoSalva}
          titulo={editing ? (nome || 'Assinatura') : (nome ? `Nova assinatura · ${nome}` : 'Nova assinatura')}
          subtitulo={[
            editing ? `#${form.code || editing.code || editing.id}` : null,
            cl?.companyName && cl.companyName !== nome ? cl.companyName : null,
            cl?.cnpj ? fmtCNPJ(cl.cnpj) : null,
          ].filter(Boolean).join(' · ') || undefined}
          selos={
            <>
              {editing && form.status && <span className={`shrink-0 text-xs px-2.5 py-0.5 rounded-full ${form.status === 'Ativo' ? TONE_BADGE.open : form.status === 'Suspenso' ? TONE_BADGE.warning : TONE_BADGE.danger}`}>{form.status}</span>}
              <span className='shrink-0 text-xs px-2.5 py-0.5 rounded-full bg-slate-700 text-slate-300'>{editing ? 'editando' : 'nova'}</span>
            </>
          }
          abas={[
            { chave: 'produtos', rotulo: 'Produtos' },
            { chave: 'contrato', rotulo: 'Contrato e reajuste' },
            // O aditivo do Sicoob (digital_contracts #54) existia no banco e não aparecia em
            // lugar nenhum. Só faz sentido num contrato já salvo, que tem id para a rota.
            ...(editing ? [{ chave: 'aditivos', rotulo: 'Aditivos' }] : []),
            { chave: 'consumo', rotulo: 'Consumo (CDR)' },
          ]}
          abaAtiva={contractModalTab}
          onAba={(k) => setContractModalTab(k as any)}
          aviso={(leituraDaAssinatura?.estado === 'falhou' || assinaturaMudouPorFora) ? (
            <div role='alert' className={`flex items-start gap-3 px-5 py-2.5 text-sm border-b ${TONE_BORDER.warning} ${TONE_SURFACE.warning} ${TONE_TEXT.warning}`} data-testid='aviso-assinatura-relida'>
              <span className='flex-1'>{porqueAssinaturaTravada}</span>
              {assinaturaMudouPorFora && editing?.id && (
                <button type='button' onClick={() => lerAssinatura(Number(editing.id))} className='shrink-0 px-3 py-1 rounded-lg border border-current text-xs'>
                  Recarregar (descarta o que foi digitado aqui)
                </button>
              )}
            </div>
          ) : undefined}
          faixa={faixaDaEdicao}
          corpoClassName=''
          rodape={
            <>
              <button onClick={closeModal} disabled={saving} className='px-5 py-2.5 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'>Cancelar</button>
              <button onClick={save} disabled={saving || !!porqueAssinaturaTravada} title={porqueAssinaturaTravada} className='px-5 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{saving ? 'Salvando...' : 'Salvar'}</button>
              {itens.length > 0 && (
                <span className={`ml-auto font-mono text-sm font-semibold whitespace-nowrap ${bate ? TONE_TEXT.open : TONE_TEXT.danger}`} title={faixaDaEdicao[faixaDaEdicao.length - 1].dica}>
                  R$ {fmt(soma)} {bate ? '✓' : `≠ MRR R$ ${fmt(mrr)}`}
                </span>
              )}
            </>
          }
        >

            {/* As três abas ficam MONTADAS e escondidas com `hidden`, não
                desmontadas: o formulário é um estado só e remontar perderia o
                que está sendo digitado na aba que saiu de vista. */}
            <div className={`p-6 space-y-4 ${contractModalTab === 'produtos' ? '' : 'hidden'}`}>
              {/* Editando, a caixa CLIENTE saiu: o cabeçalho já diz nome, razão social e CNPJ. */}
              {editing ? null : (
                <div>
                  <label className='block text-sm font-medium text-slate-300 mb-1'>Cliente *</label>
                  <select value={form.clientId || ''} onChange={async e => { const clientId = parseInt(e.target.value); const selectedClient = clients.find((c: any) => c.id === clientId); const updates: any = { ...form, clientId }; if (selectedClient && !form.paymentMethod) { updates.paymentMethod = selectedClient.paymentMethod || ''; } setForm(updates); setFiliaisErro(null); if (clientId) { try { const locs = await clientLocationsService.getByClient(clientId); setClientLocations(locs || []); } catch (err) { setClientLocations([]); setFiliaisErro(mensagemDoErroDeCarga(err)); } } else { setClientLocations([]); } }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                    <option value=''>Selecione</option>
                    {clients.filter((c: any) => c.status === 'Ativo').sort((a: any, b: any) => (a.name || a.tradeName || '').localeCompare(b.name || b.tradeName || '')).map((c: any) => <option key={c.id} value={c.id}>{c.name || c.tradeName}</option>)}
                  </select>
                </div>
              )}
              
              {/* D11: rateio e filiais que não leram dizem (sumiam calados; o item novo ia sem filial). */}
              {(rateioErro || filiaisErro) && (
                <div role='status' className={`text-xs space-y-1 ${TONE_TEXT.warning}`} data-testid='assinatura-leituras'>
                  {rateioErro && <p>Não consegui ler o rateio do grupo ({rateioErro}): a faixa e os selos de rateio não aparecem.</p>}
                  {filiaisErro && <p>Não consegui ler as filiais do cliente ({filiaisErro}): o item novo vai sem filial, e a fatura por local sai sem ela.</p>}
                </div>
              )}
              {/* RATEIO: o mesmo componente da ficha (olho). Ver FaixaDoRateio. */}
              <FaixaDoRateio
                rateio={rateioDaAssinatura}
                clientId={form.clientId}
                nome={(id: number) => { const c = clients.find((x: any) => x.id === id); return c?.name || c?.tradeName || c?.companyName || `Cliente #${id}`; }}
                fmt={fmt}
              />

              {/* Seção de Itens/Produtos - Layout em Tabela similar à visualização */}
              <div className='border border-central-borda rounded-lg overflow-hidden'>
                <div className='flex items-center justify-between p-4 bg-gradient-to-r from-central-elevado to-central-elevado/80 border-b border-central-borda'>
                  <div className='flex items-center gap-2'>
                    <Icon name='package' className='w-5 h-5 text-slate-400' />
                    <label className='text-sm font-semibold text-white'>Produtos da Assinatura</label>
                    {form.items?.length > 0 && <span className='text-xs text-slate-400'>({form.items.length} {form.items.length === 1 ? 'item' : 'itens'})</span>}
                  </div>
                  <button type='button' onClick={() => setForm({...form, items: [...(form.items || []), { productId: 0, quantity: 1, unitValue: 0, discount: 0, observation: '', totalValue: 0 }]})} className='flex items-center gap-1.5 px-4 py-2 bg-slate-700 text-slate-100 text-sm rounded-lg hover:bg-slate-600 transition-colors'><Icon name='plus' className='w-4 h-4' />Adicionar Produto</button>
                </div>

                {(!form.items || form.items.length === 0) ? (
                  <div className='text-center py-12 bg-central-elevado/30'>
                    <Icon name='package' className='w-12 h-12 text-slate-600 mx-auto mb-3' />
                    <p className='text-slate-500'>Nenhum produto adicionado</p>
                    <p className='text-slate-600 text-sm mt-1'>Clique em "Adicionar Produto" para começar</p>
                  </div>
                ) : (
                  <div className='bg-central-elevado/30'>
                    {/* Seção P&S (Serviços) */}
                    {form.items.filter((i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const itemType = i.type || p?.type || 'MRR'; return itemType !== 'MRR'; }).length > 0 && (
                      <div className='p-4'>
                        <div className='flex items-center gap-2 mb-3'>
                          <div className='w-1 h-5 bg-teal-500 rounded-full'></div>
                          <h3 className={`font-semibold ${TONE_TEXT.ps} text-sm`}>Serviços (P&S)</h3>
                        </div>
                        <div className='bg-central-elevado/50 rounded-lg border border-central-borda overflow-hidden'>
                          <table className='w-full'>
                            <thead>
                              <tr className='bg-central-elevado text-slate-400 text-xs uppercase'>
                                <th className='text-left p-3 font-medium w-[280px]'>Produto</th>
                                <th className='text-center p-3 font-medium w-24'>Filial</th>
                                <th className='text-center p-3 font-medium w-16'>Qtd</th>
                                <th className='text-center p-3 font-medium w-28'>Valor Unit.</th>
                                <th className='text-center p-3 font-medium w-20'>Desc %</th>
                                <th className='text-center p-3 font-medium w-28' title='Controle de cobrança: Pagas/Total'>Parcelas</th>
                                <th className='text-center p-3 font-medium w-28'>Total</th>
                                <th className='text-center p-3 font-medium w-12'></th>
                              </tr>
                            </thead>
                            <tbody className='divide-y divide-slate-700/50'>
                              {form.items.map((item: any, idx: number) => {
                                const prod = products.find((p: any) => Number(p.id) === Number(item.productId));
                                const itemType = item.type || prod?.type || 'MRR';
                                if (itemType === 'MRR') return null;
                                const guardada = vigenciaGuardada[idx];
                                return (<React.Fragment key={idx}>
                                  <tr className='text-slate-300 hover:bg-slate-800/50'>
                                    <td className='p-3'>
                                      <select value={String(item.productId || '')} onChange={e => { const p = products.find((x: any) => String(x.id) === e.target.value); const newItems = [...form.items]; const pValue = parseFloat(p?.value) || 0; newItems[idx] = { ...item, productId: parseInt(e.target.value) || 0, productCode: p?.code || "", name: p?.name || "", description: p?.description || "", detailedDescription: p?.description || "", type: p?.type || "MRR", unitValue: pValue, totalValue: pValue * (item.quantity || 1) * (1 - (item.discount || 0)/100), installments: p?.type !== 'MRR' ? (item.installments || 1) : 0, paidInstallments: p?.type !== 'MRR' ? (item.paidInstallments || 0) : 0 }; ajustarVigenciaNaTroca(newItems, idx); const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}>
                                        <option value=''>Selecione...</option>
                                        {products.filter((p: any) => p.status).sort((a: any, b: any) => (a.code || '').localeCompare(b.code || '')).map((p: any) => <option key={p.id} value={String(p.id)}>{p.code} - {p.name} ({p.type})</option>)}
                                      </select>
                                      <textarea
                                        value={item.description || ''}
                                        onChange={e => {
                                          const newItems = [...form.items];
                                          newItems[idx] = { ...item, description: e.target.value, detailedDescription: e.target.value };
                                          setForm({...form, items: newItems});
                                        }}
                                        placeholder={prod?.description || 'Descrição do item...'}
                                        rows={2}
                                        className={`w-full mt-1.5 px-2 py-1 ${campo} text-xs rounded leading-relaxed resize-none`}
                                      />
                                    </td>
                                    <td className='p-3'>
                                      <select value={item.locationId || ''} onChange={e => { const loc = clientLocations.find((l: any) => l.id === parseInt(e.target.value)); const newItems = [...form.items]; newItems[idx] = { ...item, locationId: parseInt(e.target.value) || null, locationName: loc?.name || '', locationCnpj: loc?.cnpj || '' }; setForm({...form, items: newItems}); }} className={`w-full px-2 py-2 ${campo} rounded-lg text-xs`}>
                                        <option value=''>Matriz</option>
                                        {clientLocations.map((loc: any) => <option key={loc.id} value={loc.id}>{loc.code}</option>)}
                                      </select>
                                    </td>
                                    <td className='p-3'>
                                      <input type='number' min='1' value={item.quantity || 1} onChange={e => { const qty = parseInt(e.target.value) || 1; const newItems = [...form.items]; newItems[idx] = { ...item, quantity: qty, totalValue: (item.unitValue || 0) * qty * (1 - (item.discount || 0)/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className={`w-full px-2 py-2 ${campo} rounded-lg text-sm text-center`} />
                                    </td>
                                    <td className='p-3'>
                                      <input type='number' step='0.01' value={item.unitValue || 0} onChange={e => { const val = parseFloat(e.target.value) || 0; const newItems = [...form.items]; newItems[idx] = { ...item, unitValue: val, totalValue: val * (item.quantity || 1) * (1 - (item.discount || 0)/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className={`w-full px-2 py-2 ${campo} rounded-lg text-sm text-right`} />
                                    </td>
                                    <td className='p-3'>
                                      <input type='number' min='0' max='100' value={item.discount || 0} onChange={e => { const disc = parseFloat(e.target.value) || 0; const newItems = [...form.items]; newItems[idx] = { ...item, discount: disc, totalValue: (item.unitValue || 0) * (item.quantity || 1) * (1 - disc/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className={`w-full px-2 py-2 ${campo} rounded-lg text-sm text-center`} />
                                    </td>
                                    <td className='p-3'>
                                      <div className='flex flex-col items-center gap-1'>
                                        <div className='flex items-center gap-1 text-[11px] text-slate-500'>
                                          <span className='w-10 text-center'>Pagas</span>
                                          <span className='w-2'></span>
                                          <span className='w-10 text-center'>Total</span>
                                        </div>
                                        <div className='flex items-center justify-center gap-1'>
                                          <input type='number' min='0' value={item.paidInstallments || 0} onChange={e => { const newItems = [...form.items]; newItems[idx] = { ...item, paidInstallments: parseInt(e.target.value) || 0 }; setForm({...form, items: newItems}); }} className={`w-10 px-1 py-2 ${campo} rounded text-xs text-center`} title='Parcelas já cobradas' />
                                          <span className='text-slate-500 text-xs'>/</span>
                                          <input type='number' min='1' value={item.installments || 1} onChange={e => { const newItems = [...form.items]; newItems[idx] = { ...item, installments: parseInt(e.target.value) || 1 }; setForm({...form, items: newItems}); }} className={`w-10 px-1 py-2 ${campo} rounded text-xs text-center`} title='Total de parcelas' />
                                        </div>
                                      </div>
                                    </td>
                                    <td className='p-3 text-right'>
                                      <span className={`font-semibold ${TONE_TEXT.ps} whitespace-nowrap`}>R$ {fmt(item.totalValue || 0)}</span>
                                    </td>
                                    <td className='p-3'>
                                      <button type='button' onClick={() => { setVigenciaGuardada({}); const newItems = form.items.filter((_: any, i: number) => i !== idx); const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className='p-1.5 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors' title='Remover'><Icon name='trash' className='w-4 h-4' /></button>
                                    </td>
                                  </tr>
                                  {guardada && (
                                    <tr className='!border-t-0'>
                                      <td colSpan={8} className='px-3 pt-0 pb-3'>
                                        <p className={`text-xs ${TONE_TEXT.warning}`}>
                                          Vigência removida ({[guardada.vigenciaInicio && `começava em ${fmtDate(guardada.vigenciaInicio)}`, guardada.vigenciaFim && `último dia ${fmtDate(guardada.vigenciaFim)}`].filter(Boolean).join(', ')}): item P&S não tem vigência. Volte para um produto recorrente para recuperá-la.
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>);
                              })}
                            </tbody>
                            <tfoot>
                              <tr className={`${TONE_SURFACE.ps} border-t ${TONE_BORDER.ps}`}>
                                <td colSpan={6} className={`p-3 text-right font-medium ${TONE_TEXT.ps}`}>Subtotal P&S:</td>
                                <td className={`p-3 text-right font-bold ${TONE_TEXT.ps} whitespace-nowrap`}>R$ {fmt(form.items.filter((i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const itemType = i.type || p?.type || 'MRR'; return itemType !== 'MRR'; }).reduce((s: number, i: any) => s + (i.totalValue || 0), 0))}</td>
                                <td></td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Seção MRR (Recorrentes) - inclui itens sem produto selecionado */}
                    {form.items.filter((i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const itemType = i.type || p?.type || 'MRR'; return itemType === 'MRR' || !i.productId || i.productId === 0; }).length > 0 && (
                      <div className='p-4 pt-0'>
                        <div className='flex items-center gap-2 mb-3'>
                          <div className='w-1 h-5 bg-green-500 rounded-full'></div>
                          <h3 className='font-semibold text-green-400 text-sm'>Recorrentes (MRR)</h3>
                          {/* Abrir/recolher só existe quando há grupos. O conferidor que
                              morava aqui foi para o rodapé fixo do modal. */}
                          {deveAgrupar(form.items) && (() => {
                            const ehLinhaMrr = (i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const t = i.type || p?.type || 'MRR'; return t === 'MRR' || !i.productId || i.productId === 0; };
                            const chaves = agruparItensPorLocal(form.items, clientLocations, ehLinhaMrr, (() => { const cl = clients.find((c: any) => c.id === form.clientId); return cl?.name || cl?.tradeName || cl?.companyName || null; })(), rateadosDaAssinatura).filter((g) => g.tipo !== 'novos').map((g) => g.chave);
                            const todosAbertos = chaves.length > 0 && chaves.every((c) => gruposDeItensAbertos.has(c));
                            return (
                              <button
                                type='button'
                                onClick={() => setGruposDeItensAbertos(todosAbertos ? new Set() : new Set(chaves))}
                                className='ml-auto text-xs text-slate-400 hover:text-white'
                              >
                                {todosAbertos ? 'Recolher todos' : 'Abrir todos'}
                              </button>
                            );
                          })()}
                        </div>
                        {/* Os dois desencontros do rateio (prévia de 05/10/2026): versão × base e
                            itens × versão. Os itens rateados não se digitam; o caminho é o rateio. */}
                        <AvisosDoRateioNaAssinatura
                          desencontros={desencontrosDoRateio(rateioDaAssinatura, form.clientId)}
                          fmt={fmt}
                          onAbrirRateio={rateioDaAssinatura && rateioDaAssinatura.temRateio ? async () => {
                            const matriz = rateioDaAssinatura.matrizId;
                            if (!(await confirmar({ title: 'Abrir o rateio do grupo?', message: 'A edição desta assinatura será fechada sem salvar.', confirmLabel: 'Fechar e abrir o rateio' }))) return;
                            closeModal();
                            setGrupoParaAbrir(matriz);
                            setSection('locations');
                          } : undefined}
                        />
                        <div className='bg-central-elevado/50 rounded-lg border border-green-500/20 overflow-hidden'>
                          <table className='w-full'>
                            <thead>
                              <tr className='bg-central-elevado text-slate-400 text-xs uppercase'>
                                <th className='text-left px-3 py-2 font-medium'>Produto</th>
                                {clientLocations.length > 0 && <th className='text-center px-2 py-2 font-medium w-24'>Filial</th>}
                                <th className='text-center px-2 py-2 font-medium w-20'>Qtd</th>
                                <th className='text-center px-2 py-2 font-medium w-28'>Unitário</th>
                                <th className='text-right px-3 py-2 font-medium w-28'>Total</th>
                                <th className='text-left px-2 py-2 font-medium w-56'>De onde vem · abate em</th>
                                <th className='px-2 py-2 font-medium w-12'></th>
                              </tr>
                            </thead>
                            <tbody className='divide-y divide-slate-700/50'>
                              {(() => {
                                // Uma linha de item MRR. É o corpo que antes ia direto no
                                // form.items.map; agora o agrupamento por local o reusa.
                                // Filial só existe como coluna quando o cliente tem locais.
                                const nColsMrr = clientLocations.length > 0 ? 7 : 6;
                                const renderItemMrr = (item: any, idx: number) => {
                                const prod = products.find((p: any) => Number(p.id) === Number(item.productId));
                                const itemType = item.type || prod?.type || 'MRR';
                                // Mostrar itens MRR e itens sem produto selecionado
                                if (itemType !== 'MRR' && item.productId && item.productId !== 0) return null;
                                // Os campos de vigência só aparecem no item que tem vigência
                                // ou em que alguém clicou "definir vigência": nos outros 95%
                                // eles ficariam vazios para sempre, ocupando a tela.
                                const mostraVigencia = !!item.productId && (!!(item.vigenciaInicio || item.vigenciaFim) || vigenciaAberta.has(idx));
                                const mostraEmpenho = !!item.productId && (!!String(item.empenhoNumber || '').trim() || empenhoAberto.has(idx));
                                // Linha ENXUTA (02/10/2026): era um cartão com seletor largo, a
                                // descrição inteira repetida em 3 linhas, 5 caixas e dois links;
                                // um item ocupava quase um terço do modal. Agora é uma linha de
                                // tabela; a descrição abre na própria linha, e vigência/empenho
                                // viram ícones que acendem quando preenchidos.
                                const descAberta = descricaoAberta.has(idx);
                                const temVigencia = !!(item.vigenciaInicio || item.vigenciaFim);
                                const temEmpenho = !!String(item.empenhoNumber || '').trim();
                                const alternarSet = (set: Set<number>, setter: (s: Set<number>) => void) => { const n = new Set(set); if (n.has(idx)) n.delete(idx); else n.add(idx); setter(n); };
                                return (<React.Fragment key={idx}>
                                  <LinhaDoItemMrr
                                    item={item}
                                    idx={idx}
                                    natureza={naturezaDoItem(item, rateioDaAssinatura)}
                                    origem={origemDoValor(item, rateioDaAssinatura, form.clientId)}
                                    produtos={products.filter((p: any) => p.status).sort((a: any, b: any) => (a.code || '').localeCompare(b.code || ''))}
                                    itens={form.items}
                                    locais={clientLocations}
                                    fmt={fmt}
                                    descricaoAberta={descAberta}
                                    temVigencia={temVigencia}
                                    temEmpenho={temEmpenho}
                                    onProduto={(valor) => { const p = products.find((x: any) => String(x.id) === valor); const newItems = [...form.items]; const pValue = parseFloat(p?.value) || 0; newItems[idx] = { ...item, productId: parseInt(valor) || 0, productCode: p?.code || "", name: p?.name || "", description: p?.description || "", detailedDescription: p?.description || "", type: p?.type || "MRR", unitValue: pValue, totalValue: pValue * (item.quantity || 1) * (1 - (item.discount || 0)/100), installments: p?.type !== 'MRR' ? (item.installments || 1) : 0, paidInstallments: p?.type !== 'MRR' ? (item.paidInstallments || 0) : 0 }; ajustarVigenciaNaTroca(newItems, idx); const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }}
                                    onFilial={(valor) => { const loc = clientLocations.find((l: any) => l.id === parseInt(valor)); const newItems = [...form.items]; newItems[idx] = { ...item, locationId: parseInt(valor) || null, locationName: loc?.name || '', locationCnpj: loc?.cnpj || '' }; setForm({...form, items: newItems}); }}
                                    onQuantidade={(valor) => { const qty = parseInt(valor) || 1; const newItems = [...form.items]; newItems[idx] = { ...item, quantity: qty, totalValue: (item.unitValue || 0) * qty * (1 - (item.discount || 0)/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }}
                                    onUnitario={(valor) => { const val = parseFloat(valor) || 0; const newItems = [...form.items]; newItems[idx] = { ...item, unitValue: val, totalValue: val * (item.quantity || 1) * (1 - (item.discount || 0)/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }}
                                    onAlvo={(valor) => { const newItems = [...form.items]; newItems[idx] = { ...item, discountTargetProductId: parseInt(valor) || null }; setForm({...form, items: newItems}); }}
                                    acoes={{
                                      onDescricao: () => alternarSet(descricaoAberta, setDescricaoAberta),
                                      onVigencia: () => alternarSet(vigenciaAberta, setVigenciaAberta),
                                      onEmpenho: () => alternarSet(empenhoAberto, setEmpenhoAberto),
                                      onDescontoPct: () => alternarSet(descontoPctAberto, setDescontoPctAberto),
                                      onRemover: () => { setVigenciaAberta(new Set()); setEmpenhoAberto(new Set()); setVigenciaGuardada({}); setDescricaoAberta(new Set()); setDescontoPctAberto(new Set()); const newItems = form.items.filter((_: any, i: number) => i !== idx); const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); },
                                    }}
                                  />
                                  {descontoPctAberto.has(idx) && naturezaDoItem(item, rateioDaAssinatura) === 'proprio' && (
                                    <tr className='!border-t-0'>
                                      <td colSpan={nColsMrr} className='px-3 pt-0 pb-3'>
                                        <div className='rounded-md bg-central-fundo/40 border border-central-borda/50 px-3 py-2 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs'>
                                          <label className='flex items-center gap-1.5 text-slate-400'>
                                            Desconto %
                                            <input type='number' min='0' max='100' value={item.discount || 0} onChange={e => { const disc = parseFloat(e.target.value) || 0; const newItems = [...form.items]; newItems[idx] = { ...item, discount: disc, totalValue: (item.unitValue || 0) * (item.quantity || 1) * (1 - disc/100) }; const mrr = mrrVigenteDosItens(newItems); setForm({...form, items: newItems, mrr}); }} className={`w-20 px-2 py-0.5 ${campo} rounded text-xs text-center focus:border-green-500`} />
                                          </label>
                                          <span className='text-slate-500'>Abate do total deste item.</span>
                                          <button type='button' onClick={() => alternarSet(descontoPctAberto, setDescontoPctAberto)} className='ml-auto text-slate-500 hover:text-slate-300'>ocultar</button>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  {descAberta && (
                                    <tr className='!border-t-0'>
                                      <td colSpan={nColsMrr} className='px-3 pt-0 pb-2'>
                                        <textarea
                                          value={item.description || ''}
                                          onChange={e => {
                                            const newItems = [...form.items];
                                            newItems[idx] = { ...item, description: e.target.value, detailedDescription: e.target.value };
                                            const mrr = mrrVigenteDosItens(newItems);
                                            setForm({...form, items: newItems, mrr});
                                          }}
                                          placeholder={prod?.description || 'Descrição do item...'}
                                          rows={3}
                                          className={`w-full px-2 py-1 text-xs text-green-300/80 rounded leading-relaxed resize-y focus:border-green-500 focus:text-green-300 placeholder:text-slate-500 ${campo}`}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                  {/* Vigência do item: o faturamento recorta o período
                                      por estas datas (backend, vigencia-item.util). Sem
                                      elas, a defesa era alguém lembrar de lançar o item
                                      no dia certo e fazer o proporcional na mão. */}
                                  {mostraVigencia && (() => {
                                    const cl = clients.find((c: any) => c.id === form.clientId);
                                    const efeito = efeitoDaVigencia(item, { cycleDay: cl?.billingCycleStartDay, publico: !!cl?.isPublicSector });
                                    // Mantém a linha aberta enquanto se edita: apagar as duas
                                    // datas não pode fazer os campos sumirem debaixo do cursor.
                                    const setVig = (campo: 'vigenciaInicio' | 'vigenciaFim', valor: string) => { setVigenciaAberta(new Set(vigenciaAberta).add(idx)); const newItems = [...form.items]; newItems[idx] = { ...item, [campo]: valor || null }; setForm({ ...form, items: newItems }); };
                                    const semDatas = !item.vigenciaInicio && !item.vigenciaFim;
                                    return (
                                      // `!border-t-0`: o divide-y do tbody traçava uma linha
                                      // ENTRE o item e a vigência dele, e a sub-linha parecia
                                      // pertencer ao item de baixo.
                                      <tr className='!border-t-0'>
                                        <td colSpan={nColsMrr} className='px-3 pt-0 pb-3'>
                                          <div className='rounded-md bg-central-fundo/40 border border-central-borda/50 px-3 py-2'>
                                          <div className='flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs'>
                                            <span className='flex items-center gap-1 text-slate-500'><Icon name='clock' className='w-3.5 h-3.5' />Vigência do item</span>
                                            <label className='flex items-center gap-1.5 text-slate-400'>
                                              Começa em
                                              <input type='date' value={item.vigenciaInicio ? String(item.vigenciaInicio).slice(0, 10) : ''} onChange={e => setVig('vigenciaInicio', e.target.value)} className={`px-2 py-0.5 ${campo} rounded text-xs focus:border-green-500`} />
                                              {!item.vigenciaInicio && <span className='text-slate-600'>(vazio = sempre valeu)</span>}
                                            </label>
                                            <label className='flex items-center gap-1.5 text-slate-400'>
                                              Último dia
                                              <input type='date' value={item.vigenciaFim ? String(item.vigenciaFim).slice(0, 10) : ''} onChange={e => setVig('vigenciaFim', e.target.value)} className={`px-2 py-0.5 ${campo} rounded text-xs focus:border-green-500`} />
                                              {!item.vigenciaFim && <span className='text-slate-600'>(vazio = não termina)</span>}
                                            </label>
                                            {semDatas && (
                                              <button type='button' onClick={() => { const s = new Set(vigenciaAberta); s.delete(idx); setVigenciaAberta(s); }} className='ml-auto text-slate-500 hover:text-slate-300'>ocultar</button>
                                            )}
                                          </div>
                                          {efeito && (
                                            <div className={`mt-1.5 space-y-0.5 text-xs leading-relaxed ${efeito.aviso ? TONE_TEXT.warning : TONE_TEXT.future}`}>
                                              {efeito.linhas.map((l, i) => <p key={i}>{l}</p>)}
                                            </div>
                                          )}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })()}
                                  {/* Empenho do item (backend #271): vai para o item da fatura
                                      na geração mensal. Só empenho ESTÁVEL, como o 328/2026 da
                                      locação da FUNDETEC; o do serviço muda todo mês e continua
                                      no "Nº do Empenho desta fatura". Ver utils/empenhoPorItem. */}
                                  {mostraEmpenho && (() => {
                                    const setEmp = (valor: string) => { setEmpenhoAberto(new Set(empenhoAberto).add(idx)); const newItems = [...form.items]; newItems[idx] = { ...item, empenhoNumber: valor }; setForm({ ...form, items: newItems }); };
                                    const proprio = String(item.empenhoNumber || '').trim();
                                    const doContrato = String(form.empenhoNumber || '').trim();
                                    const quantos = itensComEmpenhoProprio(form.items);
                                    return (
                                      <tr className='!border-t-0'>
                                        <td colSpan={nColsMrr} className='px-3 pt-0 pb-3'>
                                          <div className='rounded-md bg-central-fundo/40 border border-central-borda/50 px-3 py-2'>
                                            <div className='flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs'>
                                              <span className='flex items-center gap-1 text-slate-500'><Icon name='fileText' className='w-3.5 h-3.5' />Empenho do item</span>
                                              <label className='flex items-center gap-1.5 text-slate-400'>
                                                Nº
                                                <input type='text' maxLength={60} value={item.empenhoNumber || ''} onChange={e => setEmp(e.target.value)} placeholder={doContrato ? `herda ${doContrato}` : 'ex.: 328/2026'} className={`w-40 px-2 py-0.5 rounded text-xs placeholder:text-slate-500 ${campo}`} />
                                              </label>
                                              <span className='text-slate-500'>
                                                {proprio
                                                  ? `Sai nas NFs deste item no lugar do empenho do contrato${doContrato ? ` (${doContrato})` : ''}.`
                                                  : `Vazio = herda o empenho do contrato${doContrato ? ` (${doContrato})` : ' (nenhum)'}.`}
                                              </span>
                                              {!proprio && (
                                                <button type='button' onClick={() => { const s = new Set(empenhoAberto); s.delete(idx); setEmpenhoAberto(s); }} className='ml-auto text-slate-500 hover:text-slate-300'>ocultar</button>
                                              )}
                                            </div>
                                            {quantos > 0 && (
                                              <p className={`mt-1 text-xs ${TONE_TEXT.info}`}>
                                                {quantos === 1 ? '1 item desta assinatura tem empenho próprio.' : `${quantos} itens desta assinatura têm empenho próprio.`} Confira que todos os itens daquele empenho estão preenchidos.
                                              </p>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })()}
                                </React.Fragment>);
                                };
                                // Agrupar só quando se paga: item por filial ou mais de 10 itens
                                // (deveAgrupar). Abaixo disso, lista simples, sem cabeçalho nenhum:
                                // é o caso de 141 das 142 assinaturas ativas.
                                if (!deveAgrupar(form.items)) {
                                  // Com rateio e item do grupo: três seções por natureza (prévia de
                                  // 05/10/2026). Sem isso (140 das 142 assinaturas), lista simples.
                                  const naturezas = form.items.map((it: any) => naturezaDoItem(it, rateioDaAssinatura));
                                  if (!naturezas.some((n: NaturezaDoItem) => n !== 'proprio')) return form.items.map((item: any, idx: number) => renderItemMrr(item, idx));
                                  const SECOES: Array<{ n: NaturezaDoItem; titulo: string; sub: string; cor: string }> = [
                                    { n: 'proprio', titulo: 'Próprios', sub: 'esta empresa contrata e paga sozinha · edite à vontade', cor: TONE_TEXT.neutral },
                                    { n: 'rateado', titulo: 'Rateados com o grupo', sub: 'a fatia desta empresa no que o grupo divide · vem do rateio, não se digita', cor: TONE_TEXT.group },
                                    { n: 'desconto_do_grupo', titulo: 'Descontos do grupo', sub: 'a fatia desta empresa no desconto do grupo · vem do rateio · abate num item próprio', cor: TONE_TEXT.danger },
                                  ];
                                  return SECOES.map((sec) => {
                                    const indices = naturezas.map((n: NaturezaDoItem, i: number) => (n === sec.n ? i : -1)).filter((i: number) => i >= 0);
                                    if (indices.length === 0) return null;
                                    return (<React.Fragment key={`natureza-${sec.n}`}>
                                      <tr className='bg-central-fundo/50' data-testid={`secao-${sec.n}`}>
                                        <td colSpan={nColsMrr} className='px-3 pt-2 pb-1.5'>
                                          <div className='flex items-baseline gap-2 text-xs'>
                                            <span className={`font-semibold ${sec.cor}`}>{sec.titulo}</span>
                                            <span className='text-slate-500'>{sec.sub}</span>
                                          </div>
                                        </td>
                                      </tr>
                                      {indices.map((idx: number) => renderItemMrr(form.items[idx], idx))}
                                    </React.Fragment>);
                                  });
                                }
                                const ehLinhaMrr = (i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const t = i.type || p?.type || 'MRR'; return t === 'MRR' || !i.productId || i.productId === 0; };
                                return agruparItensPorLocal(form.items, clientLocations, ehLinhaMrr, (() => { const cl = clients.find((c: any) => c.id === form.clientId); return cl?.name || cl?.tradeName || cl?.companyName || null; })(), rateadosDaAssinatura).map((g) => {
                                  // 'novos' fica sempre aberto: é onde aparece o produto recém-adicionado.
                                  const aberto = g.tipo === 'novos' || gruposDeItensAbertos.has(g.chave);
                                  const alternar = () => { const n = new Set(gruposDeItensAbertos); if (n.has(g.chave)) n.delete(g.chave); else n.add(g.chave); setGruposDeItensAbertos(n); };
                                  return (<React.Fragment key={`grupo-${g.chave}`}>
                                    <tr className={`cursor-pointer select-none ${g.tipo === 'matriz' ? `${TONE_SURFACE.group} hover:brightness-125` : g.tipo === 'local_desconhecido' ? `${TONE_SURFACE.warning} hover:brightness-125` : 'bg-slate-900/60 hover:bg-slate-800'}`} onClick={g.tipo === 'novos' ? undefined : alternar}>
                                      <td colSpan={nColsMrr} className='px-3 py-2'>
                                        <div className='flex items-center gap-2 text-xs'>
                                          {g.tipo !== 'novos' && <Icon name={aberto ? 'chevronDown' : 'chevronRight'} className='w-3.5 h-3.5 text-slate-400' />}
                                          <span className={`font-medium ${g.tipo === 'matriz' ? TONE_TEXT.group : g.tipo === 'local_desconhecido' ? TONE_TEXT.warning : 'text-slate-200'}`}>{g.rotulo}</span>
                                          <span className='text-slate-500'>{g.indices.length} {g.indices.length === 1 ? 'item' : 'itens'}</span>
                                          <span className='ml-auto font-semibold text-green-400 whitespace-nowrap'>R$ {fmt(g.subtotal)}</span>
                                        </div>
                                      </td>
                                    </tr>
                                    {aberto && (g.listas
                                      ? g.listas.map((l) => (
                                        <React.Fragment key={`lista-${l.tipo}`}>
                                          <tr className='bg-central-fundo/30'>
                                            <td colSpan={nColsMrr} className='pl-9 pr-3 pt-2 pb-1'>
                                              <div className='flex items-center gap-2 text-[10px] uppercase tracking-wide'>
                                                <span className={l.tipo === 'compartilhado' ? TONE_TEXT.group : l.tipo === 'descontos' ? TONE_TEXT.danger : TONE_TEXT.neutral}>{l.rotulo}</span>
                                                <span className='text-slate-500 normal-case tracking-normal'>{l.indices.length} {l.indices.length === 1 ? 'item' : 'itens'}</span>
                                                <span className='ml-auto normal-case tracking-normal font-semibold text-slate-300 tabular-nums'>R$ {fmt(l.subtotal)}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          {l.indices.map((idx) => renderItemMrr(form.items[idx], idx))}
                                        </React.Fragment>
                                      ))
                                      : g.indices.map((idx) => renderItemMrr(form.items[idx], idx)))}
                                  </React.Fragment>);
                                });
                              })()}
                            </tbody>
                            <tfoot>
                              {(() => {
                                // Mesmo rodapé da visualização (RodapeMrrDaAssinatura), com a
                                // coluna da lixeira a mais. O vigente é calculado UMA vez.
                                const contratado = form.items.filter((i: any) => { const pr = products.find((x: any) => Number(x.id) === Number(i.productId)); const iType = i.type || pr?.type || 'MRR'; return iType === 'MRR'; }).reduce((s: number, i: any) => s + (Number(i.totalValue) || 0), 0);
                                return <RodapeMrrDaAssinatura vigente={mrrVigenteDosItens(form.items)} contratado={contratado} fmt={fmt} colunasDoRotulo={clientLocations.length > 0 ? 4 : 3} colunasDepois={2} />;
                              })()}
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Totais Gerais */}
                    <div className='p-4 bg-central-elevado border-t border-central-borda'>
                      <div className='flex justify-end gap-8'>
                        <div className='text-right'>
                          <span className='text-xs text-slate-500 uppercase block mb-1'>Total P&S</span>
                          <p className={`text-xl font-bold ${TONE_TEXT.ps}`}>R$ {fmt(form.items.filter((i: any) => { const p = products.find((x: any) => Number(x.id) === Number(i.productId)); const itemType = i.type || p?.type || 'MRR'; return itemType !== 'MRR'; }).reduce((s: number, i: any) => s + (i.totalValue || 0), 0))}</p>
                        </div>
                        <div className='text-right'>
                          <span className='text-xs text-slate-500 uppercase block mb-1'>MRR Mensal</span>
                          <p className='text-xl font-bold text-green-400'>R$ {fmt(mrrVigenteDosItens(form.items))}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              
            </div>

            <div className={`p-6 space-y-4 ${contractModalTab === 'contrato' ? '' : 'hidden'}`}>
              <div className='grid grid-cols-3 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Data Início *</label><input type='date' value={form.startDate || ''} onChange={e => {
                  setForm({...form, startDate: e.target.value});
                }} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
                {/* Derivado das anualidades (backend): não se digita mais. Sem regra
                    conferida, é o chute de cadastro de sempre e o selo diz isso. */}
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Próx. Reajuste <span className='text-slate-500 font-normal'>(derivado)</span></label><div className='w-full px-4 py-2.5 bg-central-elevado/60 border border-central-borda text-slate-300 rounded-lg' title='Calculado pelas anualidades: a mais antiga pendente, ou a última + 1 ano, ou a data-base + 1 ano.'>{form.nextAdjustmentDate ? fmtDate(form.nextAdjustmentDate) : '—'}</div></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Data Fim (opcional)</label><input type='date' value={form.endDate || ''} onChange={e => setForm({...form, endDate: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              </div>
              <div className='grid grid-cols-4 gap-4'>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Índice</label><select value={form.adjustmentIndex || ''} onChange={e => setForm({...form, adjustmentIndex: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value=''>Sem reajuste</option><option value='IGPM'>IGPM</option><option value='IPCA'>IPCA</option><option value='INPC'>INPC</option><option value='ICTI'>ICTI (IPEA)</option><option value='IST'>IST (Anatel)</option></select></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Nº Contrato Externo</label><input type='text' value={form.contractNumber || ''} onChange={e => setForm({...form, contractNumber: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} placeholder='Ex: 07/2025' /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1' title='Empenho global do contrato: as faturas geradas saem com "— Nota de Empenho nº X" no nome dos itens (aparece na NFS-e/NFCom). Empenho por parcela = botão NF parcial.'>Nº do Empenho <span className='text-slate-500 font-normal'>(sai nas NFs)</span></label><input type='text' maxLength={60} value={form.empenhoNumber || ''} onChange={e => setForm({...form, empenhoNumber: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} placeholder='Ex: 238/2026 (opcional)' /></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Cobrança</label><select value={form.paymentMethod || ''} onChange={e => setForm({...form, paymentMethod: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value=''>Herdar do cliente</option><option value='boleto'>Boleto</option><option value='pix'>PIX</option><option value='ted'>TED</option><option value='deposito'>Depósito</option></select></div>
                <div><label className='block text-sm font-medium text-slate-300 mb-1'>Status</label><select value={form.status || 'Ativo'} onChange={e => setForm({...form, status: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}><option value='Ativo'>Ativo</option><option value='Suspenso'>Suspenso</option><option value='Cancelado'>Cancelado</option></select></div>
              </div>
              {/* As notas de empenho com saldo (16/10/2026, fase 2, aprovada pelo Heitor: "perto do campo de hoje"). */}
              <NotasDeEmpenho contractId={editing?.id ?? null} itens={form.items || []} podeEditar={user?.role === 'admin'} />
              {/* Regra do reajuste, lida NO DOCUMENTO. O contrato guarda só a regra;
                  cada anualidade (Clientes → Reajustes) guarda o fato. Em 09/2026,
                  5 de 9 cadastros conferidos estavam errados por assumir "assinatura"
                  quando o TR dizia "orçamento estimado". A situação ao lado é
                  DERIVADA das anualidades pelo backend, não se digita. */}
              <div className='border border-central-borda rounded-lg p-4 space-y-3'>
                <div className='flex items-start justify-between gap-3'>
                  <div>
                    <p className='text-sm font-medium text-slate-300'>Regra do reajuste</p>
                    <p className='text-xs text-slate-500'>Só o documento vale. A data-base costuma ser a do orçamento estimado, não a da assinatura. As anualidades nascem dela.</p>
                  </div>
                  <div className='text-right whitespace-nowrap'>
                    {(() => { const meta = adjustmentVerificationMeta(form.adjustmentVerificationStatus); return <span className={`text-xs px-1.5 py-0.5 rounded ${meta.badge}`} title={meta.hint}>{meta.label}</span>; })()}
                    {form.adjustmentVerifiedAt && <p className='text-[11px] text-slate-500 mt-1'>conferido em {fmtDate(form.adjustmentVerifiedAt)}</p>}
                  </div>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Data-base é a data de</label>
                    <select value={form.adjustmentBaseKind || ''} onChange={e => setForm({...form, adjustmentBaseKind: e.target.value || null})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                      <option value=''>—</option>
                      {ADJUSTMENT_BASE_KIND_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>
                    <p className='text-xs text-slate-500 mt-1'>{baseKindMeta(form.adjustmentBaseKind)?.hint || 'Leia a cláusula de reajuste do TR ou do contrato.'}</p>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Data-base</label>
                    <input type='date' value={(form.adjustmentBaseDate || '').slice(0, 10)} onChange={e => setForm({...form, adjustmentBaseDate: e.target.value || null})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} />
                    <p className='text-xs text-slate-500 mt-1'>A data REAL do documento, não o aniversário da vigência.</p>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Quem aplica</label>
                    <select value={form.adjustmentExOfficio === false ? 'pedido' : 'oficio'} onChange={e => setForm({...form, adjustmentExOfficio: e.target.value === 'oficio'})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`}>
                      <option value='oficio'>De ofício (o contratante aplica)</option>
                      <option value='pedido'>Mediante solicitação nossa</option>
                    </select>
                    <p className='text-xs text-slate-500 mt-1'>Muda o ofício: "instruir os autos" ou a solicitação em si.</p>
                  </div>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Onde está a regra</label>
                    <input
                      type='text'
                      value={form.adjustmentRuleSource || ''}
                      onChange={e => setForm({...form, adjustmentRuleSource: e.target.value})}
                      placeholder='Ex.: TR item 7.40 · Contrato cláusula 7.1 · SILENTE'
                      maxLength={200}
                      className={`w-full px-4 py-2.5 ${campo} rounded-lg`}
                    />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-slate-300 mb-1'>Nota da regra</label>
                    <input
                      type='text'
                      value={form.adjustmentRuleNote || ''}
                      onChange={e => setForm({...form, adjustmentRuleNote: e.target.value})}
                      placeholder='Ex.: cláusula adversa, o que falta para conferir'
                      maxLength={500}
                      className={`w-full px-4 py-2.5 ${campo} rounded-lg`}
                    />
                  </div>
                </div>
                <div className='flex flex-wrap items-center justify-between gap-3'>
                  <label className='flex items-center gap-2 text-sm text-slate-300 cursor-pointer' title='O backend recusa sem edital/TR ou contrato anexado nesta assinatura (categoria "edital" ou "contrato").'>
                    <input
                      type='checkbox'
                      checked={!!form.adjustmentVerifiedAt}
                      onChange={e => setForm({...form, adjustmentVerifiedAt: e.target.checked ? (form.adjustmentVerifiedAt || new Date().toISOString()) : null})}
                      className='w-4 h-4 rounded bg-slate-800 border-slate-600'
                    />
                    Regra lida no documento
                    <span className='text-xs text-slate-500'>(exige edital ou contrato anexado)</span>
                  </label>
                  {editing?.id && form.adjustmentVerifiedAt && form.adjustmentBaseDate && (() => {
                    // O servidor gera com a regra e os valores SALVOS (10/10/2026). O botão aparecia pelo form: quem mudava a
                    // data-base e clicava antes de salvar gerava com a regra VELHA, e o aviso estava só no title.
                    const porqueNaoGera = porqueAssinaturaTravada
                      || (temEdicaoNaoSalva() ? 'Há alterações não salvas nesta assinatura. O servidor gera as anualidades com a regra salva: salve antes de gerar.' : null);
                    return (<>
                    <button
                      type='button'
                      disabled={!!porqueNaoGera}
                      data-gerar-anualidades={porqueNaoGera ? 'travado' : 'livre'}
                      onClick={async () => {
                        try {
                          const r = await contractAdjustmentsService.generate(editing.id);
                          showToast(r?.saved?.length ? `${r.saved.length} anualidade(s) vencida(s) gerada(s). Veja em Clientes → Reajustes.` : 'Nenhuma anualidade nova: todas as vencidas já existem.', 'success');
                          await loadData();
                        } catch (err: any) {
                          showToast(err?.response?.data?.message || 'Erro ao gerar anualidades', 'error');
                        }
                      }}
                      className='px-3 py-1.5 text-sm bg-slate-700 hover:bg-slate-600 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
                      title='Gera as anualidades vencidas desde a data-base com o índice do cache.'
                    >
                      Gerar anualidades vencidas
                    </button>
                    {porqueNaoGera && <span className={`text-xs ${TONE_TEXT.warning}`} data-testid='porque-nao-gera'>{porqueNaoGera}</span>}
                    </>);
                  })()}
                </div>
              </div>
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Observações</label><textarea value={form.notes || ''} onChange={e => setForm({...form, notes: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} rows={8} /><p className='text-xs text-slate-500 mt-1'>Uso interno (não sai na fatura nem na NF) — dados DESTE contrato, ex.: processos SEI, empenho, dispensa/pregão de origem.</p></div>

            </div>

            {editing && (
              <div className={`p-6 ${contractModalTab === 'aditivos' ? '' : 'hidden'}`}>
                <AditivosDoContratoTab contrato={editing} canEdit={canEdit} />
              </div>
            )}
            <div className={`p-6 space-y-4 ${contractModalTab === 'consumo' ? '' : 'hidden'}`}>
              {/* Configuração de Consumo/CDR */}
              <div className='border border-central-borda rounded-lg overflow-hidden'>
                <div className='flex items-center gap-3 p-4 bg-central-elevado/50'>
                  <input
                    type='checkbox'
                    checked={form.includeUsageItems || false}
                    onChange={e => setForm({...form, includeUsageItems: e.target.checked})}
                    className='w-4 h-4 rounded bg-slate-800 border-slate-600'
                    id='includeUsageItems'
                  />
                  <label htmlFor='includeUsageItems' className='text-sm font-medium text-slate-300 cursor-pointer'>
                    Incluir tarifas de consumo (CDR) na fatura
                  </label>
                </div>

                {form.includeUsageItems && (
                  <div className='p-4 border-t border-central-borda'>
                    <p className='text-xs text-slate-400 mb-3'>Configure os valores e minutos de cada tarifa. Esses dados serão usados como base nas faturas geradas.</p>
                    <div className='overflow-x-auto'>
                      <table className='w-full'>
                        <thead>
                          <tr className='text-xs text-slate-400 uppercase'>
                            <th className='text-left p-2 font-medium'>Tarifa</th>
                            <th className='text-right p-2 font-medium'>Valor Unit. (R$)</th>
                            <th className='text-right p-2 font-medium'>Minutos</th>
                            <th className='text-right p-2 font-medium'>Total</th>
                          </tr>
                        </thead>
                        <tbody className='divide-y divide-slate-700/50'>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Celular LDN</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.celularLDN || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), celularLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.celularLDN || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), celularLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.celularLDN || 0) * (form.usageMinutes?.celularLDN || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Celular Local</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.celularLocal || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), celularLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.celularLocal || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), celularLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.celularLocal || 0) * (form.usageMinutes?.celularLocal || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Fixo LDN</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.fixoLDN || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), fixoLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.fixoLDN || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), fixoLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.fixoLDN || 0) * (form.usageMinutes?.fixoLDN || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Fixo Local</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.fixoLocal || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), fixoLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.fixoLocal || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), fixoLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.fixoLocal || 0) * (form.usageMinutes?.fixoLocal || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>LDI</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.ldi || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), ldi: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.ldi || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), ldi: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.ldi || 0) * (form.usageMinutes?.ldi || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className={`p-2 text-sm ${TONE_TEXT.info}`}>Especial</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.especial || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), especial: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.especial || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), especial: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.especial || 0) * (form.usageMinutes?.especial || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-red-300'>Emergencial</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRates?.emergencial || ''} onChange={e => setForm({...form, usageRates: {...(form.usageRates || {}), emergencial: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutes?.emergencial || ''} onChange={e => setForm({...form, usageMinutes: {...(form.usageMinutes || {}), emergencial: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right`} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-green-400 font-medium'>R$ {((form.usageRates?.emergencial || 0) * (form.usageMinutes?.emergencial || 0)).toFixed(2)}</td>
                          </tr>
                        </tbody>
                        <tfoot className='border-t border-slate-600'>
                          <tr>
                            <td colSpan={3} className='p-2 text-right text-sm font-semibold text-slate-300'>Total Consumo:</td>
                            <td className='p-2 text-right text-sm text-green-400 font-bold'>R$ {(
                              ((form.usageRates?.celularLDN || 0) * (form.usageMinutes?.celularLDN || 0)) +
                              ((form.usageRates?.celularLocal || 0) * (form.usageMinutes?.celularLocal || 0)) +
                              ((form.usageRates?.fixoLDN || 0) * (form.usageMinutes?.fixoLDN || 0)) +
                              ((form.usageRates?.fixoLocal || 0) * (form.usageMinutes?.fixoLocal || 0)) +
                              ((form.usageRates?.ldi || 0) * (form.usageMinutes?.ldi || 0)) +
                              ((form.usageRates?.especial || 0) * (form.usageMinutes?.especial || 0)) +
                              ((form.usageRates?.emergencial || 0) * (form.usageMinutes?.emergencial || 0))
                            ).toFixed(2)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

                {/* Seção Entrada Normal - apenas relatório */}
                <div className='flex items-center gap-3 p-4 bg-central-elevado/50 rounded-lg'>
                  <input
                    type='checkbox'
                    checked={form.hasNormalEntrada || false}
                    onChange={e => setForm({...form, hasNormalEntrada: e.target.checked})}
                    className='w-4 h-4 rounded border-slate-600 text-green-500 focus:ring-green-500 bg-slate-700'
                    id='hasNormalEntrada'
                  />
                  <label htmlFor='hasNormalEntrada' className='text-sm font-medium text-green-300 cursor-pointer'>
                    Incluir entrada normal (apenas relatório, R$ 0,00)
                  </label>
                </div>

                {form.hasNormalEntrada && (
                  <div className='p-4 border-t border-central-borda bg-green-900/10'>
                    <p className='text-xs text-green-400 mb-3'>Ligações de entrada normal aparecem no relatório mas não são cobradas (R$ 0,00).</p>
                    <div className='flex items-center gap-4'>
                      <span className='text-sm text-slate-300'>Minutos de Entrada Normal:</span>
                      <input
                        type='number'
                        step='0.01'
                        min='0'
                        value={form.usageMinutesEntradaNormal?.entrada || ''}
                        onChange={e => setForm({...form, usageMinutesEntradaNormal: {...(form.usageMinutesEntradaNormal || {}), entrada: parseFloat(e.target.value) || 0}})}
                        className='w-32 px-2 py-1.5 bg-slate-800 border border-green-700/50 text-white rounded text-sm text-right focus:border-green-500'
                        placeholder='0.00'
                      />
                      <span className='text-sm text-green-400'>min</span>
                    </div>
                  </div>
                )}

                {/* Seção 0800 - Tarifas de Entrada */}
                <div className='flex items-center gap-3 p-4 bg-central-elevado/50 rounded-lg'>
                  <input
                    type='checkbox'
                    checked={form.has0800Link || false}
                    onChange={e => setForm({...form, has0800Link: e.target.checked})}
                    className='w-4 h-4 rounded border-slate-600 accent-primary focus:ring-primary bg-slate-700'
                    id='has0800Link'
                  />
                  <label htmlFor='has0800Link' className='text-sm font-medium text-blue-300 cursor-pointer'>
                    Cliente possui Link 0800 (cobrar ligações de entrada)
                  </label>
                </div>

                {form.has0800Link && (
                  <div className='p-4 border-t border-central-borda bg-blue-900/10'>
                    <p className='text-xs text-blue-400 mb-3'>Configure os valores e minutos das tarifas de ENTRADA (0800). O cliente será cobrado pelas ligações recebidas.</p>
                    <div className='overflow-x-auto'>
                      <table className='w-full'>
                        <thead>
                          <tr className='text-xs text-blue-400 uppercase'>
                            <th className='text-left p-2 font-medium'>Tarifa Entrada</th>
                            <th className='text-right p-2 font-medium'>Valor Unit. (R$)</th>
                            <th className='text-right p-2 font-medium'>Minutos</th>
                            <th className='text-right p-2 font-medium'>Total</th>
                          </tr>
                        </thead>
                        <tbody className='divide-y divide-slate-700/50'>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Celular LDN</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRatesEntrada?.celularLDN || ''} onChange={e => setForm({...form, usageRatesEntrada: {...(form.usageRatesEntrada || {}), celularLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutesEntrada?.celularLDN || ''} onChange={e => setForm({...form, usageMinutesEntrada: {...(form.usageMinutesEntrada || {}), celularLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-blue-400 font-medium'>R$ {((form.usageRatesEntrada?.celularLDN || 0) * (form.usageMinutesEntrada?.celularLDN || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Celular Local</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRatesEntrada?.celularLocal || ''} onChange={e => setForm({...form, usageRatesEntrada: {...(form.usageRatesEntrada || {}), celularLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutesEntrada?.celularLocal || ''} onChange={e => setForm({...form, usageMinutesEntrada: {...(form.usageMinutesEntrada || {}), celularLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-blue-400 font-medium'>R$ {((form.usageRatesEntrada?.celularLocal || 0) * (form.usageMinutesEntrada?.celularLocal || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Fixo LDN</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRatesEntrada?.fixoLDN || ''} onChange={e => setForm({...form, usageRatesEntrada: {...(form.usageRatesEntrada || {}), fixoLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutesEntrada?.fixoLDN || ''} onChange={e => setForm({...form, usageMinutesEntrada: {...(form.usageMinutesEntrada || {}), fixoLDN: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-blue-400 font-medium'>R$ {((form.usageRatesEntrada?.fixoLDN || 0) * (form.usageMinutesEntrada?.fixoLDN || 0)).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td className='p-2 text-sm text-slate-300'>Fixo Local</td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageRatesEntrada?.fixoLocal || ''} onChange={e => setForm({...form, usageRatesEntrada: {...(form.usageRatesEntrada || {}), fixoLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2'>
                              <input type='number' step='0.01' min='0' value={form.usageMinutesEntrada?.fixoLocal || ''} onChange={e => setForm({...form, usageMinutesEntrada: {...(form.usageMinutesEntrada || {}), fixoLocal: parseFloat(e.target.value) || 0}})} className={`w-full px-2 py-1.5 ${campo} rounded text-sm text-right `} placeholder='0.00' />
                            </td>
                            <td className='p-2 text-right text-sm text-blue-400 font-medium'>R$ {((form.usageRatesEntrada?.fixoLocal || 0) * (form.usageMinutesEntrada?.fixoLocal || 0)).toFixed(2)}</td>
                          </tr>
                        </tbody>
                        <tfoot className='border-t border-blue-600/30'>
                          <tr>
                            <td colSpan={3} className='p-2 text-right text-sm font-semibold text-slate-300'>Total Entrada (0800):</td>
                            <td className='p-2 text-right text-sm text-blue-400 font-bold'>R$ {(
                              ((form.usageRatesEntrada?.celularLDN || 0) * (form.usageMinutesEntrada?.celularLDN || 0)) +
                              ((form.usageRatesEntrada?.celularLocal || 0) * (form.usageMinutesEntrada?.celularLocal || 0)) +
                              ((form.usageRatesEntrada?.fixoLDN || 0) * (form.usageMinutesEntrada?.fixoLDN || 0)) +
                              ((form.usageRatesEntrada?.fixoLocal || 0) * (form.usageMinutesEntrada?.fixoLocal || 0))
                            ).toFixed(2)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    {/* Configurações de classificação de entrada */}
                    <div className='mt-4 pt-4 border-t border-blue-700/30'>
                      <p className='text-xs text-blue-400 font-medium mb-3'>Configurações de Classificação (opcional)</p>
                      <div className='space-y-3'>
                        <div>
                          <label className='block text-xs text-slate-400 mb-1'>Padrões de Destino 0800 (separar por vírgula)</label>
                          <input
                            type='text'
                            value={form.entrada0800DestinationPatterns || ''}
                            onChange={e => setForm({...form, entrada0800DestinationPatterns: e.target.value})}
                            className={`w-full px-3 py-2 ${campo} rounded text-sm `}
                            placeholder='Ex: 8000004723, 08001234567'
                          />
                          <p className='text-xs text-slate-500 mt-1'>Identifica chamadas 0800 pelo número de destino quando o CDR não diferencia por TAG</p>
                        </div>
                        <div>
                          <label className='block text-xs text-slate-400 mb-1'>Código de Área Local (DDD)</label>
                          <input
                            type='text'
                            maxLength={2}
                            value={form.localAreaCode || ''}
                            onChange={e => setForm({...form, localAreaCode: e.target.value.replace(/\D/g, '').slice(0, 2)})}
                            className={`w-24 px-3 py-2 ${campo} rounded text-sm `}
                            placeholder='Ex: 66'
                          />
                          <p className='text-xs text-slate-500 mt-1'>Classifica origem: mesmo DDD = Local, DDD diferente = LDN</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
        </CascaDeModal>
        );
      })()}


      {modal === 'user' && (
        // Formulário: não fecha ao clicar fora (como já era).
        <CascaDeModal
          largura='sm'
          titulo={editing ? 'Editar Usuário' : 'Novo Usuário'}
          subtitulo={editing && form.email ? form.email : undefined}
          onClose={closeModal}
          corpoClassName='p-6 space-y-4'
          rodape={
            <>
              <button onClick={closeModal} disabled={saving} className='flex-1 px-6 py-3 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'>Cancelar</button>
              <button onClick={save} disabled={saving} className='flex-1 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium disabled:opacity-50'>{saving ? 'Salvando...' : 'Salvar'}</button>
            </>
          }
        >
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Nome *</label><input type='text' value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Email *</label><input type='email' value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} className={`w-full px-4 py-2.5 ${campo} rounded-lg`} /></div>
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-1'>{editing ? 'Nova Senha (vazio = manter)' : 'Senha (vazio = gerar automaticamente)'}</label>
                <div className='flex gap-2'>
                  <input type='text' value={form.password || ''} onChange={e => { setForm({...form, password: e.target.value}); setShowGenerated(''); }} className={`flex-1 px-4 py-2.5 ${campo} rounded-lg`} placeholder={editing ? 'Manter senha atual' : 'Vazio = senha gerada automaticamente'} />
                  <button type='button' onClick={() => { const pwd = generatePassword(); setForm({...form, password: pwd}); setShowGenerated(pwd); }} className='px-4 py-2.5 bg-slate-700 text-slate-300 rounded-lg hover:bg-slate-600 font-medium text-sm whitespace-nowrap'>Gerar Senha</button>
                </div>
                {showGenerated && (
                  <div className={`mt-2 p-3 border rounded-lg ${TONE_SURFACE.success} ${TONE_BORDER.success}`}>
                    <p className={`text-xs font-medium mb-1 ${TONE_TEXT.success}`}>Senha gerada (copie antes de salvar):</p>
                    <div className='flex items-center gap-2'>
                      <code className='flex-1 text-sm font-mono bg-central-elevado text-white px-2 py-1 rounded border border-central-borda'>{showGenerated}</code>
                      <button type='button' onClick={() => { navigator.clipboard.writeText(showGenerated); avisar('Senha copiada!', 'success'); }} className='px-3 py-1 bg-slate-700 text-slate-200 text-xs rounded hover:bg-slate-600'>Copiar</button>
                    </div>
                  </div>
                )}
                {form.password && !showGenerated && validatePassword(form.password) && (
                  <p className='mt-1 text-xs text-red-400'>{validatePassword(form.password)}</p>
                )}
              </div>
              {editing && form.password && <p className={`text-xs ${TONE_TEXT.warning}`} data-testid='frase-da-senha'>{FRASE_DA_SENHA_NOVA}</p>}
              <div><label className='block text-sm font-medium text-slate-300 mb-1'>Perfil *</label><select value={form.role || 'viewer'} disabled={!!porqueTravaPapelEAtivo(editing, user, users)} onChange={e => setForm({...form, role: e.target.value})} className={`w-full px-4 py-2.5 ${porqueTravaPapelEAtivo(editing, user, users) ? campoSomenteLeitura : campo} rounded-lg`}><option value='admin'>Administrador</option><option value='editor'>Suporte</option><option value='vendedor'>Vendedor</option><option value='viewer'>Visualizador</option></select></div>
              {editing && form.role !== editing.role && <p className={`text-xs ${TONE_TEXT.warning}`} data-testid='frase-do-perfil'>{FRASE_DO_PERFIL}</p>}
              <div className='flex items-center gap-3'><input type='checkbox' checked={form.isActive !== false} disabled={!!porqueTravaPapelEAtivo(editing, user, users)} onChange={e => setForm({...form, isActive: e.target.checked})} className='w-4 h-4 rounded bg-slate-800 border-slate-600 disabled:opacity-50' /><span className='text-sm font-medium text-slate-300'>Usuário ativo</span></div>
              {porqueTravaPapelEAtivo(editing, user, users) && <p className={`text-xs ${TONE_TEXT.warning}`} data-testid='trava-do-usuario'>{porqueTravaPapelEAtivo(editing, user, users)}</p>}
              {!editing && (
                <div className='flex items-center gap-3 p-3 bg-central-elevado/60 border border-central-borda rounded-lg'>
                  <input type='checkbox' checked={form.sendWelcomeEmail || false} onChange={e => setForm({...form, sendWelcomeEmail: e.target.checked})} className='w-4 h-4 rounded bg-slate-800 border-slate-600 accent-primary' />
                  <div>
                    <span className='text-sm font-medium text-slate-200'>Enviar credenciais por email</span>
                    <p className='text-xs text-slate-400 mt-0.5'>O usuario recebera um email com login, senha e link de acesso</p>
                  </div>
                </div>
              )}
        </CascaDeModal>
      )}

      {modal === 'lead' && (() => {
        // O cliente pode já estar na base antes de o lead fechar. Casa pelo CNPJ,
        // que é o único campo confiável (o nome do lead costuma ser o fantasia e o
        // do cliente a razão social, como em R A SERVICOS / FARMACIA DOS
        // TRABALHADORES DE GOIAS).
        const soDigitos = (v: any) => String(v || '').replace(/\D/g, '');
        const cnpjLead = soDigitos(form.cnpj);
        const clienteDoLead = cnpjLead.length === 14
          ? clients.find((c: any) => soDigitos(c.cnpj) === cnpjLead)
          : null;
        return (
        // Altura FIXA, não ditada pelo conteúdo — mesmo padrão do modal de cliente.
        // Cada aba tem um tamanho (Propostas cabe em meia tela, Histórico tem três
        // vezes isso) e, com a caixa centralizada, trocar de aba fazia o cabeçalho e
        // as próprias abas saltarem de lugar. Só o miolo rola, por aba.
        // Formulário: não fecha ao clicar fora, como já era.
        <CascaDeModal
          largura='2xl'
          altura='fixa'
          endereco={editing?.id ? comParametro(window.location.pathname, window.location.search, 'lead', editing.id) : undefined}
          titulo={form.tradeName || form.companyName || 'Novo Lead'}
          subtitulo={[form.companyName && form.tradeName ? form.companyName : 'Oportunidade de venda', form.cnpj ? maskCNPJ(form.cnpj) : null].filter(Boolean).join(' · ')}
          selos={<>
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${badgeFor((editing ? editing.status : form.status) || 'Novo')}`} data-selo-do-lead>{(editing ? editing.status : form.status) || 'Novo'}</span>
            {/* A3: os desfechos saíram dos botões coloridos do rodapé para o ⋯ do selo, cada um com o seu confirm. */}
            {editing && canEdit && (
              <MaisAcoes
                title='Mudar o desfecho do lead'
                itens={[
                  ...(editing.status !== 'Ganho' ? [{ label: 'Marcar como Ganho', onClick: marcarGanhoDoLead }] : []),
                  ...(editing.status !== 'Perdido' ? [{ label: 'Marcar como Perdido', onClick: marcarPerdidoDoLead }] : []),
                  ...(funil.ativas.includes(editing.status) ? [{ label: 'Congelar', onClick: () => setCongelandoLead({ reason: '', frozenUntil: '' }) }] : []),
                ]}
              />
            )}
          </>}
          onClose={closeModal}
          topo={leituraDoLead?.estado === 'falhou' ? (
            <p role="alert" className={`mx-5 mt-3 px-3 py-2 rounded border text-sm ${TONE_SURFACE.danger} ${TONE_BORDER.danger} ${TONE_TEXT.danger}`} data-leitura-do-lead="falhou">
              {porqueLeadTravado}
            </p>
          ) : undefined}
          subCabecalho={
            // A1 (12/10/2026, bloco A): a barra azul de seis segmentos vira trilha de etapas, no molde da Central: feitas
            // com ✓ e apagadas, a atual em negrito com sublinhado, as próximas vazias. Lê o status SALVO; clicar numa
            // etapa pergunta e grava na hora. Lead novo (sem id) só mostra.
            <nav aria-label='Etapas do funil' className='flex flex-wrap items-center gap-x-4 gap-y-1 px-5 pt-3 pb-2 border-b border-central-borda text-sm'>
              {trilhaDoLead(editing ? editing.status : funil.ativas[0], funil.ativas).map(({ etapa, estado }) => (
                <button
                  key={etapa}
                  type='button'
                  aria-current={estado === 'atual' ? 'step' : undefined}
                  disabled={estado === 'atual' || !editing || !canEdit}
                  onClick={() => moverEtapaDoLead(etapa)}
                  title={estado === 'atual' ? 'Etapa atual' : editing ? `Mover para ${etapa}` : 'Salve o lead para mover de etapa'}
                  className={estado === 'atual'
                    ? 'font-bold text-white border-b-2 border-white pb-0.5 cursor-default'
                    : 'text-slate-500 hover:text-slate-200 disabled:hover:text-slate-500 disabled:cursor-default'}
                >
                  {estado === 'feita' ? '✓' : estado === 'atual' ? '●' : '○'} {etapa}
                </button>
              ))}
            </nav>
          }
          // O BRIEFING SAIU DAS ABAS (26/09/2026): como aba no mesmo nível de Dados,
          // Propostas e Histórico, parecia etapa obrigatória do lead — e não é: é
          // pré-requisito de UM caminho, o de gerar a proposta por IA. Vive dentro do
          // "Gerar com IA", na etapa Briefing. Propostas e Histórico pedem o lead salvo.
          abas={(() => {
            // Os rótulos dizem o estado sem abrir a aba. Com a aba aberta, o resumo vem dela (fresco depois de cada ação).
            const daAba = resumoDaAba && editing?.id && resumoDaAba.leadId === Number(editing.id) ? resumoDaAba : null;
            const doLead = (x: { leadId: number; lista: any[] | null } | null) => (x && editing?.id && x.leadId === Number(editing.id) ? x.lista : null);
            const r = resumoDaFicha(daAba ? daAba.propostas : doLead(propostasDoLead), daAba ? daAba.contratos : doLead(contratosDoLead));
            const selo = seloDoContrato(r);
            const contador = (t: React.ReactNode, tom: string) => <span className={`px-1.5 py-0.5 rounded-md text-xs tabular-nums ${tom}`}>{t}</span>;
            const pedeSalvo = (rotulo: string) => <span className={editing ? '' : 'opacity-50 cursor-not-allowed'} title={!editing ? 'Salve o lead primeiro' : ''}>{rotulo} {editing ? '' : '(salve primeiro)'}</span>;
            return [
              { chave: 'dados', rotulo: 'Dados do Lead' },
              { chave: 'propostas', rotulo: editing ? <span className='inline-flex items-center gap-2' data-rotulo-da-aba='propostas'>Propostas {r.vivas != null && contador(r.vivas, TONE_BADGE.neutral)}</span> : pedeSalvo('Propostas') },
              { chave: 'contrato', rotulo: editing ? <span className='inline-flex items-center gap-2' data-rotulo-da-aba='contrato'>Contrato {selo && contador(selo.texto, selo.pendente ? TONE_BADGE.warning : TONE_BADGE.neutral)}</span> : pedeSalvo('Contrato') },
              { chave: 'historico', rotulo: editing ? 'Histórico' : pedeSalvo('Histórico') },
            ];
          })()}
          abaAtiva={leadTab}
          onAba={(chave) => {
            if (chave !== 'dados' && !editing) return;
            if (editing?.id) abaDoLeadDecidida.current = Number(editing.id);
            setLeadTab(chave as AbaDoLead);
          }}
          corpoClassName='flex flex-col'
          rodape={
            <>
              <div>
                {editing && leadTab !== 'propostas' && leadTab !== 'contrato' && (
                  <button onClick={() => { setDelConfirm({type:'lead',item:editing}); closeModal(); }} className='px-4 py-2 text-red-400 hover:bg-red-500/10 rounded-lg text-sm font-medium'>
                    Excluir Lead
                  </button>
                )}
              </div>
              <div className='ml-auto flex gap-3'>
                {/* Com o lead já gravado não há o que cancelar — "Cancelar" ali
                    sugere desfazer o que acabou de ser salvo. */}
                <button onClick={closeModal} disabled={saving} className={`px-5 py-2 rounded-lg text-sm disabled:opacity-50 ${acaoSecundaria}`}>{editing ? 'Fechar' : 'Cancelar'}</button>
                {/* C7 (12/10/2026, bloco C): na aba Propostas o "Salvar" salvava o LEAD, não a proposta; ali fica só o Fechar. */}
                {leadTab !== 'propostas' && leadTab !== 'contrato' && <button onClick={save} disabled={saving || !!porqueLeadTravado} title={porqueLeadTravado} className={`px-5 py-2 rounded-lg text-sm disabled:opacity-50 ${acaoPrincipal}`}>{saving ? 'Salvando...' : 'Salvar'}</button>}
              </div>
            </>
          }
        >
            {leadTab === 'historico' && editing ? (
              <div className='flex-1 min-h-0 overflow-y-auto bg-central-fundo'>
                <LeadHistoryTab leadId={editing.id} />
              </div>
            ) : (leadTab === 'propostas' || leadTab === 'contrato') && editing ? (
              <div className='flex-1 min-h-0 overflow-y-auto p-5 bg-central-fundo'>
                <ProposalsTab leadId={editing.id} leadData={form} products={products} cargaDosProdutos={cargaPrincipal} canEdit={canEdit} onLeadUpdate={refreshLeadData}
                  secao={leadTab} onVerProposta={() => setLeadTab('propostas')} onVerContrato={() => setLeadTab('contrato')}
                  onResumo={(propostas, contratos) => setResumoDaAba({ leadId: Number(editing.id), propostas, contratos })} />
              </div>
            ) : (
            <div className='flex flex-1 overflow-hidden min-h-0'>
              {/* Coluna Esquerda - Dados */}
              <div className='flex-1 p-5 overflow-y-auto border-r border-central-borda min-h-0'>
                {/* CNPJ com busca */}
                <div className='bg-central-elevado p-3 rounded-lg border border-central-borda mb-4'>
                  <label className='block text-xs font-semibold text-slate-400 uppercase mb-1'>CNPJ</label>
                  <div className='flex gap-2'>
                    <input type='text' value={maskCNPJ(form.cnpj || '')} onChange={e => setForm({...form, cnpj: e.target.value.replace(/\D/g, '')})} className={`flex-1 px-3 py-2 ${campo} rounded-lg text-sm`} placeholder='00.000.000/0000-00' maxLength={18} />
                    <button type='button' onClick={async () => {
                      if (!form.cnpj) { avisar('Digite um CNPJ', 'warning'); return; }
                      setSaving(true);
                      const data = await cnpjService.search(form.cnpj);
                      setSaving(false);
                      if (data && data.status !== 'ERROR') {
                        setForm({ ...form,
                          companyName: data.nome || form.companyName,
                          tradeName: data.fantasia || form.tradeName,
                          email: data.email || form.email,
                          phone: ((data.telefone?.split('/')[0] || '').trim() || form.phone || '').replace(/\D/g, '').slice(0, 11),
                          inscricaoEstadual: data.inscricao_estadual || form.inscricaoEstadual || '',
                          street: data.logradouro || form.street || '',
                          number: data.numero || form.number || '',
                          complement: data.complemento || form.complement || '',
                          neighborhood: data.bairro || form.neighborhood || '',
                          city: data.municipio || form.city || '',
                          state: data.uf || form.state || '',
                          zipCode: data.cep || form.zipCode || '',
                          municipalCode: data.codigo_ibge || form.municipalCode || '',
                        });
                        avisar('Dados carregados!', 'success');
                      } else { avisar('CNPJ não encontrado', 'error'); }
                    }} disabled={saving} className='px-3 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong text-sm font-medium disabled:opacity-50'>
                      {saving ? '...' : 'Buscar'}
                    </button>
                  </div>
                  {/* Selecionar cliente da base */}
                  <div className='mt-2'>
                    {/* A2 (12/10/2026, bloco A da revisão): era o único campo da ficha com moldura própria (fundo e borda
                        verdes) e rótulo verde, com cara de link. Mesma moldura dos outros selects; o rótulo é texto. */}
                    <label className='block text-xs text-slate-400 mb-1'>Importar dados de cliente existente</label>
                    <select
                      className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
                      value=''
                      onChange={(e) => {
                        const clientId = parseInt(e.target.value);
                        if (!clientId) return;
                        const c = clients.find((cl: any) => cl.id === clientId);
                        if (!c) return;
                        setForm({
                          ...form,
                          cnpj: c.cnpj || '',
                          companyName: c.companyName || '',
                          tradeName: c.tradeName || '',
                          name: form.name || nomeDeExibicao(c),
                          email: c.emailFinancial || c.emailCommercial || form.email || '',
                          phone: c.phone || form.phone || '',
                          inscricaoEstadual: c.inscricaoEstadual || '',
                          street: c.street || '',
                          number: c.number || '',
                          complement: c.complement || '',
                          neighborhood: c.neighborhood || '',
                          city: c.city || '',
                          state: c.state || '',
                          zipCode: c.zipCode || '',
                          municipalCode: c.municipalCode || '',
                          contactName: c.contactName || form.contactName || '',
                        });
                        showToast(`Dados de ${nomeDeExibicao(c)} importados!`, 'success');
                        e.target.value = '';
                      }}
                    >
                      <option value=''>Selecione um cliente da base...</option>
                      {[...clients].sort((a: any, b: any) => (a.name || '').localeCompare(b.name || '')).map((c: any) => (
                        <option key={c.id} value={c.id}>{c.name || c.tradeName || c.companyName}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Dados da Empresa */}
                <div className='mb-4'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2 flex items-center gap-2'>
                    <Icon name='building' className='w-4 h-4' /> Empresa
                  </h3>
                  <div className='space-y-3'>
                    <div className='grid grid-cols-2 gap-3'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Razão Social *</label><input type='text' value={form.companyName || ''} onChange={e => setForm({...form, companyName: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Nome Fantasia</label><input type='text' value={form.tradeName || ''} onChange={e => setForm({...form, tradeName: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                    </div>
                    <div className='grid grid-cols-4 gap-3'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Inscrição Estadual</label><input type='text' value={form.inscricaoEstadual || ''} onChange={e => setForm({...form, inscricaoEstadual: e.target.value})} placeholder='Isento' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>CEP</label><input type='text' value={form.zipCode || ''} onChange={e => setForm({...form, zipCode: e.target.value})} placeholder='00000-000' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>UF</label><select value={form.state || ''} onChange={e => setForm({...form, state: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}><option value=''>Selecione</option>{['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'].map(uf => <option key={uf} value={uf}>{uf}</option>)}</select></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Código IBGE</label><input type='text' value={form.municipalCode || ''} onChange={e => setForm({...form, municipalCode: e.target.value})} placeholder='Ex: 4104808' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                    </div>
                    <div className='grid grid-cols-4 gap-3'>
                      <div className='col-span-3'><label className='block text-xs text-slate-500 mb-1'>Rua/Logradouro</label><input type='text' value={form.street || ''} onChange={e => setForm({...form, street: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Número</label><input type='text' value={form.number || ''} onChange={e => setForm({...form, number: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                    </div>
                    <div className='grid grid-cols-3 gap-3'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Complemento</label><input type='text' value={form.complement || ''} onChange={e => setForm({...form, complement: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Bairro</label><input type='text' value={form.neighborhood || ''} onChange={e => setForm({...form, neighborhood: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Cidade</label><input type='text' value={form.city || ''} onChange={e => setForm({...form, city: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                    </div>
                  </div>
                </div>

                {/* Dados do Contato */}
                <div className='mb-4'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2 flex items-center gap-2'>
                    <Icon name='user' className='w-4 h-4' /> Contato
                  </h3>
                  <div className='space-y-3'>
                    <div className='grid grid-cols-3 gap-3'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Nome *</label><input type='text' value={form.contactName || ''} onChange={e => setForm({...form, contactName: e.target.value})} className={`w-full px-3 py-2 rounded-lg text-sm ${campoComEstado(!form.contactName?.trim() && 'border-red-500/60')}`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Cargo</label><input type='text' value={form.position || ''} onChange={e => setForm({...form, position: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>Email *</label><input type='email' value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} className={`w-full px-3 py-2 rounded-lg text-sm ${campoComEstado(!form.email?.trim() && 'border-red-500/60')}`} /></div>
                    </div>
                    <div className='grid grid-cols-3 gap-3'>
                      <div><label className='block text-xs text-slate-500 mb-1'>Telefone</label><input type='text' value={maskPhone(form.phone || '')} onChange={e => setForm({...form, phone: e.target.value.replace(/\D/g, '')})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} placeholder='(00) 00000-0000' maxLength={15} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>WhatsApp</label><input type='text' value={maskPhone(form.whatsapp || '')} onChange={e => setForm({...form, whatsapp: e.target.value.replace(/\D/g, '')})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} placeholder='(00) 00000-0000' maxLength={15} /></div>
                      <div><label className='block text-xs text-slate-500 mb-1'>LinkedIn</label><input type='text' value={form.linkedin || ''} onChange={e => setForm({...form, linkedin: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} placeholder='linkedin.com/in/...' /></div>
                    </div>
                  </div>
                </div>

                {/* Segmento */}
                <div className='mb-4'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2 flex items-center gap-2'>
                    <Icon name='chart' className='w-4 h-4' /> Segmento
                  </h3>
                  <div className='flex flex-wrap gap-1.5'>
                    {['Tecnologia', 'Saúde', 'Educação', 'Varejo', 'Indústria', 'Serviços', 'Financeiro', 'Governo', 'Outro'].map(seg => (
                      <button key={seg} type='button' onClick={() => setForm({...form, segment: seg})} className={`px-2.5 py-1 rounded-full text-xs font-medium transition-all ${form.segment === seg ? 'bg-purple-500 text-white' : 'bg-slate-700 text-slate-300 hover:bg-slate-600'}`}>{seg}</button>
                    ))}
                  </div>
                </div>

                {/* Origem e Próximo Contato */}
                <div className='mb-4'>
                  <div className='grid grid-cols-2 gap-4'>
                    <div>
                      <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2'>Origem</h3>
                      <div className='flex flex-wrap gap-1.5'>
                        {leadSources.map(s => (
                          <button key={s} type='button' onClick={() => setForm({...form, source: s})} className={`px-2.5 py-1 rounded-full text-xs font-medium transition-all ${form.source === s ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-700 text-slate-300 hover:bg-slate-600'}`}>{s}</button>
                        ))}
                      </div>
                    </div>
                    <div>
                      <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2'>Próximo Contato</h3>
                      <input type='date' value={form.nextContactDate ? form.nextContactDate.split('T')[0] : ''} onChange={e => setForm({...form, nextContactDate: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                    </div>
                  </div>
                </div>

                {/* Observações */}
                <div>
                  <label className='block text-xs text-slate-500 mb-1'>Observações</label>
                  <textarea value={form.notes || ''} onChange={e => setForm({...form, notes: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} rows={3} placeholder='Anotações...' />
                </div>
              </div>

              {/* Coluna Direita - Valores e Ações */}
              <div className='w-80 shrink-0 p-5 bg-central-elevado/50 overflow-y-auto'>
                {/* Resumo Financeiro */}
                <div className='mb-5'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-3'>Valores Estimados</h3>
                  {(() => {
                    const v = editing ? valorEstimadoDoLead(propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.lista : null, propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.erro : null) : { editavel: true as const, frase: 'Sem proposta viva: valor manual.' };
                    return <p className={`text-xs mb-2 ${!v.editavel && 'motivo' in v && v.motivo === 'erro' ? 'text-red-400' : 'text-slate-400'}`} data-testid='fonte-do-valor'>{v.frase}</p>;
                  })()}
                  <div className='space-y-2'>
                    <div className='bg-central-elevado p-3 rounded-lg border border-central-borda'>
                      <label className='block text-xs text-slate-500 mb-1'>Valor P&S (Único)</label>
                      <div className='flex items-center gap-2'>
                        <span className='text-slate-400 font-bold'>R$</span>
                        <input type='number' step='0.01' readOnly={!!editing && !valorEstimadoDoLead(propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.lista : null, propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.erro : null).editavel} value={form.estimatedValuePS || ''} onChange={e => setForm({...form, estimatedValuePS: parseFloat(e.target.value) || 0})} className='flex-1 px-2 py-1 border-0 text-lg font-bold text-white bg-transparent focus:ring-0' placeholder='0,00' />
                      </div>
                    </div>
                    <div className='bg-central-elevado p-3 rounded-lg border border-central-borda'>
                      <label className='block text-xs text-slate-500 mb-1'>Valor MRR (Mensal)</label>
                      <div className='flex items-center gap-2'>
                        <span className='text-green-500 font-bold'>R$</span>
                        <input type='number' step='0.01' readOnly={!!editing && !valorEstimadoDoLead(propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.lista : null, propostasDoLead?.leadId === Number(editing.id) ? propostasDoLead.erro : null).editavel} value={form.estimatedValue || ''} onChange={e => setForm({...form, estimatedValue: parseFloat(e.target.value) || 0})} className='flex-1 px-2 py-1 border-0 text-lg font-bold text-green-400 bg-transparent focus:ring-0' placeholder='0,00' />
                      </div>
                    </div>
                  </div>
                  {/* Resumo calculado */}
                  <div className='mt-3 p-3 bg-central-fundo rounded-lg border border-slate-600'>
                    <div className='flex justify-between text-xs mb-1'>
                      <span className='text-slate-500'>MRR Anual (x12):</span>
                      <span className='text-green-400 font-semibold'>R$ {fmt(totaisDoLead(form.estimatedValuePS, form.estimatedValue).mrrAnual)}</span>
                    </div>
                    <div className='flex justify-between text-xs mb-2'>
                      <span className='text-slate-500'>Valor Total:</span>
                      <span className={`${TONE_TEXT.ps} font-semibold`}>R$ {fmt(totaisDoLead(form.estimatedValuePS, form.estimatedValue).total)}</span>
                    </div>
                    <div className='pt-2 border-t border-central-borda'>
                      <div className='flex justify-between text-sm'>
                        <span className='text-slate-400 font-medium'>Assinatura 12 meses:</span>
                        <span className='text-white font-bold'>R$ {fmt(totaisDoLead(form.estimatedValuePS, form.estimatedValue).total)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* E3 (12/10/2026): Temperatura e Probabilidade saíram. O backend não tem coluna nem campo no DTO: o PUT descartava
                    em silêncio, e o lead reabria vazio. */}
                {/* B1 (12/10/2026, #411 do backend): a próxima ação com prazo. Só aparece quando o servidor a conhece (a chave
                    vem no lead); com o backend de hoje, nada muda. Grava no Salvar; concluir é o PATCH próprio. */}
                {temProximaAcao(leads) && (
                  <div className='mb-5' data-proxima-acao>
                    <h3 className='text-xs font-semibold text-slate-400 uppercase mb-3'>Próxima ação</h3>
                    <input type='text' maxLength={255} value={form.nextActionText || ''} onChange={e => setForm({...form, nextActionText: e.target.value || null})} placeholder='Ex.: ligar para a Karem' aria-label='Próxima ação' className={`w-full px-3 py-2 mb-2 ${campo} rounded-lg text-sm`} />
                    <input type='date' value={form.nextActionAt || ''} onChange={e => setForm({...form, nextActionAt: e.target.value || null})} aria-label='Prazo da próxima ação' className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} />
                    {editing?.nextActionText && !editing?.nextActionDoneAt && (() => {
                      const atraso = atrasoDaProximaAcao(editing);
                      return (
                        <div className='mt-2 flex items-center justify-between gap-2 text-xs'>
                          <span className={atraso ? 'font-semibold text-white' : 'text-slate-400'}>{atraso ? `atrasada há ${atraso} ${atraso === 1 ? 'dia' : 'dias'}` : 'no prazo'}</span>
                          <button type='button' onClick={() => concluirProximaAcao(editing)} className={`px-3 py-1 rounded-lg ${acaoSecundaria}`}>Concluir</button>
                        </div>
                      );
                    })()}
                  </div>
                )}

                {/* Responsável */}
                <div className='mb-5'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-3'>Responsável</h3>
                  <select value={form.assignedToId || ''} onChange={e => setForm({...form, assignedToId: e.target.value ? Number(e.target.value) : null})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm font-medium`}>
                    <option value=''>Sem responsável</option>
                    {users.map((u: any) => <option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>
                </div>

                {/* Status Atual */}
                <div className='mb-5'>
                  <h3 className='text-xs font-semibold text-slate-400 uppercase mb-3'>Status</h3>
                  <select value={form.status || 'Novo'} onChange={e => setForm({...form, status: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm font-medium`}>
                    {leadStatuses.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>

                {/* Ações Rápidas: Marcar Ganho/Perdido foram para o ⋯ do selo (A3); aqui ficam só as da assinatura. */}
                {editing && (etapasDaAssinatura.includes(editing?.status) || etapasDaAssinatura.includes(form.status)) && (
                  <div className='space-y-2'>
                    <h3 className='text-xs font-semibold text-slate-400 uppercase mb-3'>Ações Rápidas</h3>
                    

                    {/* Lead GANHO com o cliente JÁ CADASTRADO: o caminho morria num
                        alerta "já existe um cliente com este CNPJ" e não havia como
                        chegar na assinatura. Acontece sempre que o cliente entrou
                        pela base antes do lead fechar, e é justamente aí que a
                        proposta aceita precisa virar contrato. */}
                    {etapasDaAssinatura.includes(editing?.status) && clienteDoLead && (
                      <button type='button' onClick={async () => {
                        setSaving(true);
                        try {
                          const proposals = await proposalsService.getByLead(editing.id);
                          const aceita = proposals?.find((p: any) => p.status === 'Aceita');
                          if (!aceita) {
                            avisar(`${nomeDeExibicao(clienteDoLead)} já está na base, mas este lead não tem proposta ACEITA.\n\nAceite a proposta na aba Propostas (ou pelo link público) e a assinatura sai daqui.`, 'warning');
                            setSaving(false);
                            return;
                          }
                          closeModal();
                          setContractFromProposal({ clientId: clienteDoLead.id, proposal: aceita });
                        } catch (e) {
                          console.error(e);
                          avisar('Erro ao buscar as propostas do lead', 'error');
                        }
                        setSaving(false);
                      }} disabled={saving} className='w-full px-3 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary-strong flex items-center justify-center gap-2'>
                        <Icon name='clipboard' className='w-4 h-4' /> Gerar assinatura
                      </button>
                    )}

                    {etapasDaAssinatura.includes(form.status) && !etapasDaAssinatura.includes(editing?.status) && (
                      <p className='text-xs text-slate-400' data-testid='ganho-nao-salvo'>Salve o lead em Geração Assinatura para converter em cliente ou gerar a assinatura.</p>
                    )}

                    {etapasDaAssinatura.includes(editing?.status) && !clienteDoLead && (
                      <button type='button' onClick={async () => {
                        if (!form.companyName || !form.email) { avisar('Preencha Razão Social e Email', 'warning'); return; }
                        setSaving(true);
                        try {
                          // Buscar dados completos do CNPJ (endereço, IE, etc)
                          let cnpjData: any = null;
                          if (form.cnpj && form.cnpj.replace(/\D/g, '').length === 14) {
                            try { cnpjData = await cnpjService.search(form.cnpj); } catch {}
                          }
                          const clientData: any = {
                            tradeName: form.tradeName || form.companyName,
                            companyName: form.companyName,
                            cnpj: form.cnpj || '',
                            dueDay: 10,
                            emailFinancial: form.email,
                            emailGeneral: form.email,
                            phone: form.phone || '',
                            segment: form.segment || form.source || '',
                            status: 'Ativo',
                            inscricaoEstadual: form.inscricaoEstadual || '',
                            street: form.street || '',
                            number: form.number || '',
                            complement: form.complement || '',
                            neighborhood: form.neighborhood || '',
                            city: form.city || '',
                            state: form.state || '',
                            zipCode: form.zipCode || '',
                            municipalCode: form.municipalCode || '',
                          };
                          // Enriquecer com CNPJ se campos de endereço vazios
                          if (cnpjData && !cnpjData.error && cnpjData.status !== 'ERROR') {
                            if (!clientData.street) clientData.street = cnpjData.logradouro || '';
                            if (!clientData.number) clientData.number = cnpjData.numero || '';
                            if (!clientData.complement) clientData.complement = cnpjData.complemento || '';
                            if (!clientData.neighborhood) clientData.neighborhood = cnpjData.bairro || '';
                            if (!clientData.city) clientData.city = cnpjData.municipio || '';
                            if (!clientData.state) clientData.state = cnpjData.uf || '';
                            if (!clientData.zipCode) clientData.zipCode = cnpjData.cep || '';
                            if (!clientData.municipalCode) clientData.municipalCode = cnpjData.codigo_ibge || '';
                            if (!clientData.inscricaoEstadual) clientData.inscricaoEstadual = cnpjData.inscricao_estadual || '';
                            if (cnpjData.nome) clientData.companyName = cnpjData.nome;
                            if (cnpjData.fantasia && !clientData.tradeName) clientData.tradeName = cnpjData.fantasia;
                          }
                          // P3 (11/10/2026): criava o cliente sem perguntar, com a razão da Receita por cima da digitada,
                          // vencimento dia 10 e o e-mail do contato nos dois campos. Agora mostra o que vai gravar.
                          if (!(await confirmar(confirmacaoDeConverter(clientData, form.companyName)))) { setSaving(false); return; }
                          const newClient = await clientsService.create(clientData);

                          // Buscar propostas aceitas do lead
                          const proposals = await proposalsService.getByLead(editing.id);
                          const acceptedProposal = proposals?.find((p: any) => p.status === 'Aceita');

                          if (acceptedProposal && newClient?.id) {
                            // Tem proposta aceita - perguntar se quer criar contrato
                            await loadData();
                            closeModal();
                            setContractFromProposal({ clientId: newClient.id, proposal: acceptedProposal });
                          } else {
                            // Sem proposta aceita - apenas avisar que cliente foi criado
                            showToast('Cliente criado com sucesso!', 'success');
                            await loadData();
                            closeModal();
                          }
                        } catch (e) {
                          avisar(`Não criei o cliente: ${motivoDoServidor(e)}`, 'error');
                        }
                        setSaving(false);
                      }} disabled={saving} className='w-full px-3 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary-strong flex items-center justify-center gap-2'>
                        <Icon name='arrowRight' className='w-4 h-4' /> Converter em Cliente
                      </button>
                    )}

                    {form.status === 'Perdido' && (
                      <>
                        <div className='mb-2'>
                          <label className='block text-xs text-slate-500 mb-1'>Motivo da Perda</label>
                          <input type='text' value={form.lostReason || ''} onChange={e => setForm({...form, lostReason: e.target.value})} className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`} placeholder='Ex: Preço, Concorrência...' />
                        </div>
                        <button type='button' onClick={() => setForm({...form, status: 'Novo', lostReason: ''})} className='w-full px-3 py-2 bg-slate-700 text-slate-200 rounded-lg hover:bg-slate-600 text-sm font-medium flex items-center justify-center gap-2'>
                          <Icon name='arrowRight' className='w-4 h-4' /> Reativar Lead
                        </button>
                      </>
                    )}
                  </div>
                )}

                {/* Info de criação */}
                {editing && (
                  <div className='mt-5 pt-4 border-t border-central-borda'>
                    <h3 className='text-xs font-semibold text-slate-400 uppercase mb-2'>Informações</h3>
                    <div className='bg-central-fundo rounded-lg p-3 space-y-2 text-xs'>
                      {form.createdAt && (
                        <div className='flex justify-between'>
                          <span className='text-slate-500'>Criado em:</span>
                          <span className='text-slate-300'>{new Date(form.createdAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })} às {new Date(form.createdAt).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo'})}</span>
                        </div>
                      )}
                      {form.updatedAt && (
                        <div className='flex justify-between'>
                          <span className='text-slate-500'>Atualizado:</span>
                          <span className='text-slate-300'>{new Date(form.updatedAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })} às {new Date(form.updatedAt).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo'})}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            )}
        </CascaDeModal>
        );
      })()}


      {/* Modal de confirmação de inativação de cliente */}
      {/* A3: Congelar pela ficha do lead, com os mesmos campos do board (motivo e data, os dois opcionais). Acima da ficha. */}
      {congelandoLead && editing && (
        <CascaDeModal
          largura='xs'
          zIndex='z-[60]'
          titulo='❄️ Congelar Lead'
          subtitulo={nomeDoLead(editing)}
          onClose={() => setCongelandoLead(null)}
          temEdicaoNaoSalva={() => !!(congelandoLead.reason.trim() || congelandoLead.frozenUntil)}
          corpoClassName='p-6 space-y-4'
          rodape={
            <div className='ml-auto flex gap-2'>
              <button onClick={() => setCongelandoLead(null)} className={`px-4 py-2 rounded-lg text-sm ${acaoSecundaria}`}>Cancelar</button>
              <button onClick={congelarDaFicha} className={`px-4 py-2 rounded-lg text-sm ${acaoPrincipal}`}>Congelar</button>
            </div>
          }
        >
          <div>
            <label className='block text-xs font-medium text-slate-400 mb-1'>Motivo (opcional)</label>
            <input
              type='text'
              value={congelandoLead.reason}
              onChange={e => setCongelandoLead(c => (c ? { ...c, reason: e.target.value } : c))}
              placeholder='Ex.: cliente pediu para retomar em Q3'
              className={`w-full px-3 py-2 placeholder-slate-500 rounded-lg text-sm ${campo}`}
            />
          </div>
          <div>
            <label className='block text-xs font-medium text-slate-400 mb-1'>Descongelar em (opcional)</label>
            <input
              type='date'
              value={congelandoLead.frozenUntil}
              onChange={e => setCongelandoLead(c => (c ? { ...c, frozenUntil: e.target.value } : c))}
              className={`w-full px-3 py-2 ${campo} rounded-lg text-sm`}
            />
            <p className='text-[11px] text-slate-500 mt-1'>Deixe vazio pra congelar sem prazo — descongela manualmente.</p>
          </div>
        </CascaDeModal>
      )}

      {inactivateClientModal && (
        // Confirmação destrutiva: não fecha ao clicar fora (como já era). O vermelho
        // do Confirmar é o de confirmação de perigo (como o useConfirm danger), não
        // uma primária de gravação.
        <CascaDeModal
          largura='sm'
          titulo='Inativar Cliente'
          subtitulo={nomeDeExibicao(inactivateClientModal.client)}
          onClose={() => setInactivateClientModal(null)}
          faixa={[
            { k: 'Assinaturas ativas', v: inactivateClientModal.activeContracts.length },
            { k: 'DDRs ativos', v: inactivateClientModal.activeDDRs.length },
          ]}
          corpoClassName='p-5 space-y-4'
          rodape={
            <>
              <button
                onClick={() => setInactivateClientModal(null)}
                disabled={processingInactivation}
                className='flex-1 px-4 py-2.5 border border-slate-600 text-slate-300 rounded-lg hover:bg-slate-800 font-medium disabled:opacity-50'
              >
                Cancelar
              </button>
              <button
                onClick={confirmInactivateClient}
                disabled={processingInactivation}
                className='flex-1 px-4 py-2.5 bg-danger text-white rounded-lg hover:bg-danger-strong font-medium disabled:opacity-50'
              >
                {processingInactivation ? 'Processando...' : 'Confirmar Inativação'}
              </button>
            </>
          }
        >
              <p className='text-sm text-slate-400'>
                Você está prestes a inativar <strong className='text-white'>{nomeDeExibicao(inactivateClientModal.client)}</strong>
              </p>
              <div className='bg-central-elevado rounded-lg p-4 space-y-2'>
                <p className='text-sm text-slate-300 font-medium'>O que será feito:</p>
                <ul className='text-sm text-slate-400 space-y-1'>
                  <li className='flex items-center gap-2'>
                    <span className='text-red-400'>✕</span>
                    Assinaturas serão <strong className='text-red-400'>canceladas</strong> (data fim = hoje)
                  </li>
                  <li className='flex items-center gap-2'>
                    <span className={TONE_TEXT.warning}>○</span>
                    DDRs serão marcados como <strong className={TONE_TEXT.warning}>inativos</strong> (mantém vínculo)
                  </li>
                </ul>
              </div>
        </CascaDeModal>
      )}

      {/* Modal de criar contrato a partir da proposta */}
      {contractFromProposal && (
        // Não tinha ×: o × da casca faz o mesmo que "Não, depois faço manualmente".
        <CascaDeModal
          largura='sm'
          titulo='Criar Assinatura Automaticamente?'
          subtitulo={contractFromProposal.proposal.code}
          onClose={() => {
            showToast('Cliente criado! Você pode criar a assinatura manualmente.', 'success');
            setContractFromProposal(null);
          }}
          faixa={[
            { k: 'Itens', v: contractFromProposal.proposal.items?.length || 0 },
            { k: 'MRR', v: fmt(contractFromProposal.proposal.totalMRR || 0), cls: TONE_TEXT.open },
            ...(contractFromProposal.proposal.totalPS > 0
              ? [{ k: 'Total P&S', v: fmt(contractFromProposal.proposal.totalPS), cls: TONE_TEXT.ps }]
              : []),
          ]}
          corpoClassName='px-5 py-4 space-y-2'
          rodape={
            <>
              <button
                onClick={() => {
                  showToast('Cliente criado! Você pode criar a assinatura manualmente.', 'success');
                  setContractFromProposal(null);
                }}
                className='px-4 py-2 bg-slate-700 text-slate-300 rounded-lg hover:bg-slate-600'
              >
                Não, depois faço manualmente
              </button>
              <button
                onClick={async () => {
                  try {
                    const proposal = contractFromProposal.proposal;
                    // Parse items corretamente (pode ser string JSON ou array)
                    let rawItems = proposal.items;
                    if (typeof rawItems === 'string') {
                      try { rawItems = JSON.parse(rawItems); } catch { rawItems = []; }
                    }
                    // Flatten arrays aninhados e filtrar válidos
                    const items = (Array.isArray(rawItems) ? rawItems.flat(10) : [])
                      .filter((i: any) => i && typeof i === 'object' && (i.name || i.productId));

                    // Buscar contrato digital assinado desta proposta.
                    // ⛔ FALHA FECHADA (08/10/2026): a leitura que falhava virava "não há contrato", e a assinatura era
                    // GRAVADA sem o PDF assinado, com o toast de sucesso. Sem a leitura, não cria nada, e o modal fica
                    // aberto para tentar de novo (utils/contratoDigitalDaProposta, a mesma peça da aba de propostas).
                    const leitura = await lerContratoDigitalAssinado(proposal);
                    if ('motivo' in leitura) {
                      showToast(recusaSemContratoDigital(proposal.code, leitura.motivo), 'error');
                      return;
                    }
                    const attachments: any[] = leitura.anexo ? [leitura.anexo] : [];

                    // Criar contrato com dados da proposta
                    // Proposta usa unitPrice/subtotal, contrato usa unitValue/totalValue
                    // Proposta usa "Serviço" para P&S, contrato usa "PS"
                    const contractPayload = {
                      clientId: contractFromProposal.clientId,
                      proposalId: proposal.id,
                      items: items.map((i: any) => {
                        const isPS = i.type === 'Serviço' || i.type === 'PS';
                        return {
                          productId: Number(i.productId) || 0,
                          productCode: i.productCode || '',
                          name: i.name || '',
                          description: i.description || '',
                          detailedDescription: i.detailedDescription || i.description || '',
                          type: isPS ? 'PS' : 'MRR',
                          quantity: Number(i.quantity) || 1,
                          unitValue: Number(i.unitPrice || i.unitValue) || 0,
                          discount: Number(i.discount) || 0,
                          totalValue: Number(i.subtotal || i.totalValue) || 0,
                          observation: i.observation || '',
                          locationId: i.locationId ? Number(i.locationId) : null,
                          locationName: i.locationName || '',
                          locationCnpj: i.locationCnpj || '',
                          // Parcelas P&S da proposta vão pros itens de setup (senão sai "Total 1").
                          ...(isPS ? { installments: Number(proposal.installments) || 1, paidInstallments: 0 } : {}),
                        };
                      }),
                      mrr: proposal.totalMRR || 0,
                      totalPS: proposal.totalPS || 0,
                      activationInstallments: Number(proposal.installments) || 1,
                      status: 'Ativo',
                      contractStartDate: getTodayStr(),
                      contractMonths: 12,
                      // Reajuste padrão: IPCA, próximo reajuste 1 ano após o início.
                      adjustmentIndex: 'IPCA',
                      nextAdjustmentDate: addYearsStr(getTodayStr(), 1),
                      attachments: attachments.length > 0 ? attachments : undefined,
                    };
                    console.log('Creating contract from proposal:', JSON.stringify(contractPayload, null, 2));

                    await contractsService.create(contractPayload);
                    showToast(attachments.length > 0 ? 'Cliente e assinatura criados com contrato anexado!' : 'Cliente e assinatura criados com sucesso!', 'success');
                    await loadData();
                  } catch (e) {
                    console.error(e);
                    showToast('Erro ao criar assinatura', 'error');
                  }
                  setContractFromProposal(null);
                }}
                className='ml-auto px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-strong font-medium'
              >
                Sim, criar assinatura
              </button>
            </>
          }
        >
          <p className='text-sm text-slate-300'>O cliente foi criado com sucesso! Encontramos uma proposta aceita.</p>
          <p className='text-xs text-slate-500'>
            A assinatura será criada com os mesmos itens e valores da proposta aceita.
          </p>
        </CascaDeModal>
      )}

      {/* Toast Notification */}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};

export default BillingManagementSystem;
